[
  {
    "id": "std_andorra_2014_1cent",
    "country": "Andorra",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Cent (2014) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 60000,
    "mintageFormatted": "60,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2014_2cent",
    "country": "Andorra",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Cents (2014) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 60000,
    "mintageFormatted": "60,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2014_5cent",
    "country": "Andorra",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 5 Cents (2014) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 860000,
    "mintageFormatted": "860,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2014_10cent",
    "country": "Andorra",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2014) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 860000,
    "mintageFormatted": "860,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2014_20cent",
    "country": "Andorra",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2014) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 860000,
    "mintageFormatted": "860,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2014_50cent",
    "country": "Andorra",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2014) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 360000,
    "mintageFormatted": "360,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2014_1euro",
    "country": "Andorra",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Euro (2014) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 511842,
    "mintageFormatted": "511,842",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2014",
    "country": "Andorra",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2014) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 360000,
    "mintageFormatted": "360,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2014_cc1",
    "country": "Andorra",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2014) - Council of Europe",
    "subject": "Council of Europe",
    "description": "Andorra 2 Euro Commemorative coin issued in 2014: Council of Europe.",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2014_2euro_0.jpg",
    "image_key": "ad_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2015_1cent",
    "country": "Andorra",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Cent (2015) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2015_2cent",
    "country": "Andorra",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2 Cents (2015) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2015_5cent",
    "country": "Andorra",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 5 Cents (2015) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2015_10cent",
    "country": "Andorra",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 10 Cents (2015) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2015_20cent",
    "country": "Andorra",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 20 Cents (2015) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2015_50cent",
    "country": "Andorra",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 50 Cents (2015) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2015_1euro",
    "country": "Andorra",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Euro (2015) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2015",
    "country": "Andorra",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2015) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 1072400,
    "mintageFormatted": "1,072,400",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2015_cc1",
    "country": "Andorra",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2015) - Customs Union with the EU",
    "subject": "Customs Union with the EU",
    "description": "Andorra 2 Euro Commemorative coin issued in 2015: Customs Union with the EU.",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2015_2euro_0.jpg",
    "image_key": "ad_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2015_cc2",
    "country": "Andorra",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2015) - 18 chosen as Age of Majority",
    "subject": "18 chosen as Age of Majority",
    "description": "Andorra 2 Euro Commemorative coin issued in 2015: 18 chosen as Age of Majority.",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2015_2euro_1.jpg",
    "image_key": "ad_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2016_1cent",
    "country": "Andorra",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Cent (2016) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2016_2cent",
    "country": "Andorra",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2 Cents (2016) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2016_5cent",
    "country": "Andorra",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 5 Cents (2016) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2016_10cent",
    "country": "Andorra",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 10 Cents (2016) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2016_20cent",
    "country": "Andorra",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 20 Cents (2016) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2016_50cent",
    "country": "Andorra",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 50 Cents (2016) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2016_1euro",
    "country": "Andorra",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Euro (2016) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 2339200,
    "mintageFormatted": "2,339,200",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2016",
    "country": "Andorra",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2 Euros (2016) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2016_cc1",
    "country": "Andorra",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2016) - Radio and Television of Andorra",
    "subject": "Radio and Television of Andorra",
    "description": "Andorra 2 Euro Commemorative coin issued in 2016: Radio and Television of Andorra.",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2016_2euro_0.jpg",
    "image_key": "ad_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2016_cc2",
    "country": "Andorra",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2016) - New Reform of 1866",
    "subject": "New Reform of 1866",
    "description": "Andorra 2 Euro Commemorative coin issued in 2016: New Reform of 1866.",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2016_2euro_1.jpg",
    "image_key": "ad_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2017_1cent",
    "country": "Andorra",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Cent (2017) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2582395,
    "mintageFormatted": "2,582,395",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2017_2cent",
    "country": "Andorra",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Cents (2017) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1515000,
    "mintageFormatted": "1,515,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2017_5cent",
    "country": "Andorra",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 5 Cents (2017) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2191421,
    "mintageFormatted": "2,191,421",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2017_10cent",
    "country": "Andorra",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2017) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1103000,
    "mintageFormatted": "1,103,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2017_20cent",
    "country": "Andorra",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2017) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1213000,
    "mintageFormatted": "1,213,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2017_50cent",
    "country": "Andorra",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2017) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 968800,
    "mintageFormatted": "968,800",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2017_1euro",
    "country": "Andorra",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Euro (2017) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 13000,
    "mintageFormatted": "13,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2017",
    "country": "Andorra",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2017) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 794588,
    "mintageFormatted": "794,588",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2017_cc1",
    "country": "Andorra",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2017) - Anthem of Andorra",
    "subject": "Anthem of Andorra",
    "description": "Andorra 2 Euro Commemorative coin issued in 2017: Anthem of Andorra.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2017_2euro_0.jpg",
    "image_key": "ad_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2017_cc2",
    "country": "Andorra",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2017) - Andorra, Country of the Pyrenees",
    "subject": "Andorra, Country of the Pyrenees",
    "description": "Andorra 2 Euro Commemorative coin issued in 2017: Andorra, Country of the Pyrenees.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2017_2euro_1.jpg",
    "image_key": "ad_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2018_1cent",
    "country": "Andorra",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Cent (2018) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 3430000,
    "mintageFormatted": "3,430,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2018_2cent",
    "country": "Andorra",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Cents (2018) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2550000,
    "mintageFormatted": "2,550,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2018_5cent",
    "country": "Andorra",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 5 Cents (2018) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1800000,
    "mintageFormatted": "1,800,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2018_10cent",
    "country": "Andorra",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2018) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 980000,
    "mintageFormatted": "980,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2018_20cent",
    "country": "Andorra",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2018) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1014000,
    "mintageFormatted": "1,014,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2018_50cent",
    "country": "Andorra",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2018) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 890000,
    "mintageFormatted": "890,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2018_1euro",
    "country": "Andorra",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Euro (2018) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2018",
    "country": "Andorra",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2018) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 868000,
    "mintageFormatted": "868,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2018_cc1",
    "country": "Andorra",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2018) - Constitution of Andorra",
    "subject": "Constitution of Andorra",
    "description": "Andorra 2 Euro Commemorative coin issued in 2018: Constitution of Andorra.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2018_2euro_1.jpg",
    "image_key": "ad_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2018_cc2",
    "country": "Andorra",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2018) - Universal Declaration of Human Rights",
    "subject": "Universal Declaration of Human Rights",
    "description": "Andorra 2 Euro Commemorative coin issued in 2018: Universal Declaration of Human Rights.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2018_2euro_0.jpg",
    "image_key": "ad_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2019_1cent",
    "country": "Andorra",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Cent (2019) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2447000,
    "mintageFormatted": "2,447,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2019_2cent",
    "country": "Andorra",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Cents (2019) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1727000,
    "mintageFormatted": "1,727,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2019_5cent",
    "country": "Andorra",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 5 Cents (2019) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2100000,
    "mintageFormatted": "2,100,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2019_10cent",
    "country": "Andorra",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2019) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1610000,
    "mintageFormatted": "1,610,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2019_20cent",
    "country": "Andorra",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2019) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1570000,
    "mintageFormatted": "1,570,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2019_50cent",
    "country": "Andorra",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2019) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 930000,
    "mintageFormatted": "930,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2019_1euro",
    "country": "Andorra",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Euro (2019) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2019",
    "country": "Andorra",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2019) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 1058310,
    "mintageFormatted": "1,058,310",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2019_cc1",
    "country": "Andorra",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2019) - Alpine Skiing World Cup Finale",
    "subject": "Alpine Skiing World Cup Finale",
    "description": "Andorra 2 Euro Commemorative coin issued in 2019: Alpine Skiing World Cup Finale.",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2019_2euro_1.jpg",
    "image_key": "ad_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2019_cc2",
    "country": "Andorra",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2019) - Earth Council",
    "subject": "Earth Council",
    "description": "Andorra 2 Euro Commemorative coin issued in 2019: Earth Council.",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2019_2euro_0.jpg",
    "image_key": "ad_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2020_1cent",
    "country": "Andorra",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Cent (2020) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2020_2cent",
    "country": "Andorra",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2 Cents (2020) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2020_5cent",
    "country": "Andorra",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 5 Cents (2020) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2020_10cent",
    "country": "Andorra",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2020) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 860000,
    "mintageFormatted": "860,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2020_20cent",
    "country": "Andorra",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2020) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 175000,
    "mintageFormatted": "175,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2020_50cent",
    "country": "Andorra",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2020) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 740000,
    "mintageFormatted": "740,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2020_1euro",
    "country": "Andorra",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Euro (2020) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2020",
    "country": "Andorra",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2020) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2020_cc1",
    "country": "Andorra",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2020) - 27th Ibero-American Summit",
    "subject": "27th Ibero-American Summit",
    "description": "Andorra 2 Euro Commemorative coin issued in 2020: 27th Ibero-American Summit.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2020_2euro_1.jpg",
    "image_key": "ad_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2020_cc2",
    "country": "Andorra",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2020) - Universal Female Suffrage",
    "subject": "Universal Female Suffrage",
    "description": "Andorra 2 Euro Commemorative coin issued in 2020: Universal Female Suffrage.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2020_2euro_0.jpg",
    "image_key": "ad_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2021_1cent",
    "country": "Andorra",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Cent (2021) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2021_2cent",
    "country": "Andorra",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Cents (2021) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2021_5cent",
    "country": "Andorra",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 5 Cents (2021) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2021_10cent",
    "country": "Andorra",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2021) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1400000,
    "mintageFormatted": "1,400,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2021_20cent",
    "country": "Andorra",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2021) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1420000,
    "mintageFormatted": "1,420,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2021_50cent",
    "country": "Andorra",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2021) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2021_1euro",
    "country": "Andorra",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Euro (2021) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2021",
    "country": "Andorra",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2021) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 1474500,
    "mintageFormatted": "1,474,500",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2021_cc1",
    "country": "Andorra",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2021) - Our Lady of Meritxell",
    "subject": "Our Lady of Meritxell",
    "description": "Andorra 2 Euro Commemorative coin issued in 2021: Our Lady of Meritxell.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2021_2euro_1.jpg",
    "image_key": "ad_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2021_cc2",
    "country": "Andorra",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2021) - We take care of our seniors",
    "subject": "We take care of our seniors",
    "description": "Andorra 2 Euro Commemorative coin issued in 2021: We take care of our seniors.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2021_2euro_0.jpg",
    "image_key": "ad_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2022_1cent",
    "country": "Andorra",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Cent (2022) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2022_2cent",
    "country": "Andorra",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Cents (2022) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 450000,
    "mintageFormatted": "450,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2022_5cent",
    "country": "Andorra",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 5 Cents (2022) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2022_10cent",
    "country": "Andorra",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2022) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2022_20cent",
    "country": "Andorra",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2022) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2022_50cent",
    "country": "Andorra",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2022) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 380000,
    "mintageFormatted": "380,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2022_1euro",
    "country": "Andorra",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Euro (2022) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2022",
    "country": "Andorra",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2022) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 1708000,
    "mintageFormatted": "1,708,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2022_cc1",
    "country": "Andorra",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2022) - EU-Andorra Monetary Agreement",
    "subject": "EU-Andorra Monetary Agreement",
    "description": "Andorra 2 Euro Commemorative coin issued in 2022: EU-Andorra Monetary Agreement.",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2022_2euro_0.jpg",
    "image_key": "ad_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2022_cc2",
    "country": "Andorra",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2022) - Legend of Charlemagne",
    "subject": "Legend of Charlemagne",
    "description": "Andorra 2 Euro Commemorative coin issued in 2022: Legend of Charlemagne.",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2022_2euro_1.jpg",
    "image_key": "ad_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2023_1cent",
    "country": "Andorra",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Cent (2023) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2023_2cent",
    "country": "Andorra",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2 Cents (2023) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2023_5cent",
    "country": "Andorra",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 5 Cents (2023) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2023_10cent",
    "country": "Andorra",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 10 Cents (2023) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2023_20cent",
    "country": "Andorra",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 20 Cents (2023) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2023_50cent",
    "country": "Andorra",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 50 Cents (2023) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2023_1euro",
    "country": "Andorra",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Euro (2023) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2023",
    "country": "Andorra",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2023) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 2075250,
    "mintageFormatted": "2,075,250",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2023_cc1",
    "country": "Andorra",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2023) - Andorran UN Admission",
    "subject": "Andorran UN Admission",
    "description": "Andorra 2 Euro Commemorative coin issued in 2023: Andorran UN Admission.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2023_2euro_0.jpg",
    "image_key": "ad_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2023_cc2",
    "country": "Andorra",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2023) - Summer Solstice Festival",
    "subject": "Summer Solstice Festival",
    "description": "Andorra 2 Euro Commemorative coin issued in 2023: Summer Solstice Festival.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2023_2euro_1.jpg",
    "image_key": "ad_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2024_1cent",
    "country": "Andorra",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 1 Cent (2024) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2024_2cent",
    "country": "Andorra",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Cents (2024) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 900300,
    "mintageFormatted": "900,300",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2024_5cent",
    "country": "Andorra",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 5 Cents (2024) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1950000,
    "mintageFormatted": "1,950,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2024_10cent",
    "country": "Andorra",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2024) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2024_20cent",
    "country": "Andorra",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2024) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2024_50cent",
    "country": "Andorra",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2024) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2024_1euro",
    "country": "Andorra",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Euro (2024) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2024",
    "country": "Andorra",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2024) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 1601200,
    "mintageFormatted": "1,601,200",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2024_cc1",
    "country": "Andorra",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2024) - Skiing in Andorra",
    "subject": "Skiing in Andorra",
    "description": "Andorra 2 Euro Commemorative coin issued in 2024: Skiing in Andorra.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2024_2euro_0.jpg",
    "image_key": "ad_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2024_cc2",
    "country": "Andorra",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2024) - UCI Mountain Bike World Cup",
    "subject": "UCI Mountain Bike World Cup",
    "description": "Andorra 2 Euro Commemorative coin issued in 2024: UCI Mountain Bike World Cup.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2024_2euro_1.jpg",
    "image_key": "ad_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2025_1cent",
    "country": "Andorra",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Cent (2025) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 2208000,
    "mintageFormatted": "2,208,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1cent_0.jpg",
    "image_key": "ad_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2025_2cent",
    "country": "Andorra",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Cents (2025) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 1510000,
    "mintageFormatted": "1,510,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_2cent_0.jpg",
    "image_key": "ad_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2025_5cent",
    "country": "Andorra",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 5 Cents (2025) - Pyrenean Chamois and Golden Eagle",
    "subject": "Pyrenean Chamois and Golden Eagle",
    "description": "Fauna of Andorra: Pyrenean chamois (Rupicapra pyrenaica) and a golden eagle",
    "mintage": 680000,
    "mintageFormatted": "680,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_5cent_0.jpg",
    "image_key": "ad_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2025_10cent",
    "country": "Andorra",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 10 Cents (2025) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1200000,
    "mintageFormatted": "1,200,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_10cent_0.jpg",
    "image_key": "ad_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2025_20cent",
    "country": "Andorra",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 20 Cents (2025) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_20cent_0.jpg",
    "image_key": "ad_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2025_50cent",
    "country": "Andorra",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 50 Cents (2025) - Church of Santa Coloma",
    "subject": "Church of Santa Coloma",
    "description": "Romanesque Church of Santa Coloma d'Andorra",
    "mintage": 1120000,
    "mintageFormatted": "1,120,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_50cent_0.jpg",
    "image_key": "ad_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2025_1euro",
    "country": "Andorra",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 1 Euro (2025) - Casa de la Vall",
    "subject": "Casa de la Vall",
    "description": "Historical seat of the General Council of Andorra (Casa de la Vall)",
    "mintage": 4361000,
    "mintageFormatted": "4,361,000",
    "status": "circulating",
    "imagePath": "coins/ad_regular_2014_1euro_0.jpg",
    "image_key": "ad_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2025",
    "country": "Andorra",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2 Euros (2025) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2025_cc1",
    "country": "Andorra",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2025) - Bearded Vulture",
    "subject": "Bearded Vulture",
    "description": "Andorra 2 Euro Commemorative coin issued in 2025: Bearded Vulture.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2025_2euro_0.jpg",
    "image_key": "ad_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_andorra_2025_cc2",
    "country": "Andorra",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Andorra 2€ Commemorative (2025) - Games of the Small States of Europe",
    "subject": "Games of the Small States of Europe",
    "description": "Andorra 2 Euro Commemorative coin issued in 2025: Games of the Small States of Europe.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ad_commemorative_2025_2euro_1.jpg",
    "image_key": "ad_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_andorra_2026",
    "country": "Andorra",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Andorra 2 Euros (2026) - Coat of arms of Andorra",
    "subject": "Coat of arms of Andorra",
    "description": "Coat of arms of Andorra with the motto 'Virtus Unita Fortior'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ad_regular_2014_2euro_0.jpg",
    "image_key": "ad_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2002_1cent",
    "country": "Austria",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2002) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 378400000,
    "mintageFormatted": "378,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2002_2cent",
    "country": "Austria",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2002) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 326400000,
    "mintageFormatted": "326,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2002_5cent",
    "country": "Austria",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2002) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 217000000,
    "mintageFormatted": "217,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2002_10cent",
    "country": "Austria",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2002) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 441600000,
    "mintageFormatted": "441,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2002_20cent",
    "country": "Austria",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2002) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 203400000,
    "mintageFormatted": "203,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2002_50cent",
    "country": "Austria",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2002) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 169100000,
    "mintageFormatted": "169,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2002_1euro",
    "country": "Austria",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2002) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 223500000,
    "mintageFormatted": "223,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2002",
    "country": "Austria",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2002) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 196400000,
    "mintageFormatted": "196,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2003_1cent",
    "country": "Austria",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2003) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 10800000,
    "mintageFormatted": "10,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2003_2cent",
    "country": "Austria",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2003) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 118500000,
    "mintageFormatted": "118,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2003_5cent",
    "country": "Austria",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2003) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 108500000,
    "mintageFormatted": "108,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2003_10cent",
    "country": "Austria",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 10 Cents (2003) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 4800,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2003_20cent",
    "country": "Austria",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2003) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 50900000,
    "mintageFormatted": "50,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2003_50cent",
    "country": "Austria",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2003) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 9100000,
    "mintageFormatted": "9,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2003_1euro",
    "country": "Austria",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Euro (2003) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 4800,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2003",
    "country": "Austria",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2003) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 4700000,
    "mintageFormatted": "4,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2004_1cent",
    "country": "Austria",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2004) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 115000000,
    "mintageFormatted": "115,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2004_2cent",
    "country": "Austria",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2004) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 156400000,
    "mintageFormatted": "156,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2004_5cent",
    "country": "Austria",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2004) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 89300000,
    "mintageFormatted": "89,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2004_10cent",
    "country": "Austria",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2004) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 5200000,
    "mintageFormatted": "5,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2004_20cent",
    "country": "Austria",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2004) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 54800000,
    "mintageFormatted": "54,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2004_50cent",
    "country": "Austria",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2004) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 3100000,
    "mintageFormatted": "3,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2004_1euro",
    "country": "Austria",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2004) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 2600000,
    "mintageFormatted": "2,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2004",
    "country": "Austria",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2004) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2005_1cent",
    "country": "Austria",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2005) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 174700000,
    "mintageFormatted": "174,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2005_2cent",
    "country": "Austria",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2005) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 163200000,
    "mintageFormatted": "163,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2005_5cent",
    "country": "Austria",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2005) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 66100000,
    "mintageFormatted": "66,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2005_10cent",
    "country": "Austria",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2005) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 5200000,
    "mintageFormatted": "5,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2005_20cent",
    "country": "Austria",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2005) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2005_50cent",
    "country": "Austria",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2005) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 3100000,
    "mintageFormatted": "3,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2005_1euro",
    "country": "Austria",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2005) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 2600000,
    "mintageFormatted": "2,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2005_cc1",
    "country": "Austria",
    "year": 2005,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2005) - Austrian State Treaty",
    "subject": "Austrian State Treaty",
    "description": "Austria 2 Euro Commemorative coin issued in 2005: Austrian State Treaty.",
    "mintage": 6900000,
    "mintageFormatted": "6,900,000",
    "status": "circulating",
    "imagePath": "coins/at_commemorative_2005_2euro_0.jpg",
    "image_key": "at_commemorative_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2006_1cent",
    "country": "Austria",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2006) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 48300000,
    "mintageFormatted": "48,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2006_2cent",
    "country": "Austria",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2006) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 39800000,
    "mintageFormatted": "39,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2006_5cent",
    "country": "Austria",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2006) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 5600000,
    "mintageFormatted": "5,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2006_10cent",
    "country": "Austria",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2006) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2006_20cent",
    "country": "Austria",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2006) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 8200000,
    "mintageFormatted": "8,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2006_50cent",
    "country": "Austria",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2006) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 3200000,
    "mintageFormatted": "3,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2006_1euro",
    "country": "Austria",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2006) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 7700000,
    "mintageFormatted": "7,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2006",
    "country": "Austria",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2006) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 2300000,
    "mintageFormatted": "2,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2007_1cent",
    "country": "Austria",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2007) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 111900000,
    "mintageFormatted": "111,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2007_2cent",
    "country": "Austria",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2007) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 72200000,
    "mintageFormatted": "72,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2007_5cent",
    "country": "Austria",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2007) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 52700000,
    "mintageFormatted": "52,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2007_10cent",
    "country": "Austria",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2007) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 81300000,
    "mintageFormatted": "81,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2007_20cent",
    "country": "Austria",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2007) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 45000000,
    "mintageFormatted": "45,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2007_50cent",
    "country": "Austria",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2007) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2007_1euro",
    "country": "Austria",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2007) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 41100000,
    "mintageFormatted": "41,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2007_cc-common",
    "country": "Austria",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Austria 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 8900000,
    "mintageFormatted": "8,900,000",
    "status": "circulating",
    "imagePath": "coins/at_commemorative_2007_2euro_0.jpg",
    "image_key": "at_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_austria_2008_1cent",
    "country": "Austria",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2008) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 50900000,
    "mintageFormatted": "50,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2008_2cent",
    "country": "Austria",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2008) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 125100000,
    "mintageFormatted": "125,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2008_5cent",
    "country": "Austria",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2008) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 96700000,
    "mintageFormatted": "96,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2008_10cent",
    "country": "Austria",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2008) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 70200000,
    "mintageFormatted": "70,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2008_20cent",
    "country": "Austria",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2008) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 45300000,
    "mintageFormatted": "45,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2008_50cent",
    "country": "Austria",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2008) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2008_1euro",
    "country": "Austria",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2008) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 65500000,
    "mintageFormatted": "65,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2008",
    "country": "Austria",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2008) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 2600000,
    "mintageFormatted": "2,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2009_1cent",
    "country": "Austria",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2009) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 158900000,
    "mintageFormatted": "158,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2009_2cent",
    "country": "Austria",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2009) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 120400000,
    "mintageFormatted": "120,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2009_5cent",
    "country": "Austria",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2009) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 5800000,
    "mintageFormatted": "5,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2009_10cent",
    "country": "Austria",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2009) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 15900000,
    "mintageFormatted": "15,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2009_20cent",
    "country": "Austria",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2009) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 49800000,
    "mintageFormatted": "49,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2009_50cent",
    "country": "Austria",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2009) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 14700000,
    "mintageFormatted": "14,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2009_1euro",
    "country": "Austria",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2009) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 40300000,
    "mintageFormatted": "40,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2009_cc-common",
    "country": "Austria",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Austria 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 4900000,
    "mintageFormatted": "4,900,000",
    "status": "circulating",
    "imagePath": "coins/at_commemorative_2009_2euro_0.jpg",
    "image_key": "at_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_austria_2010_1cent",
    "country": "Austria",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2010) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 168500000,
    "mintageFormatted": "168,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2010_2cent",
    "country": "Austria",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2010) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 104200000,
    "mintageFormatted": "104,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2010_5cent",
    "country": "Austria",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2010) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 63700000,
    "mintageFormatted": "63,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2010_10cent",
    "country": "Austria",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2010) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 42800000,
    "mintageFormatted": "42,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2010_20cent",
    "country": "Austria",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2010) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2010_50cent",
    "country": "Austria",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2010) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2010_1euro",
    "country": "Austria",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2010) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 11200000,
    "mintageFormatted": "11,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2010",
    "country": "Austria",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2010) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2011_1cent",
    "country": "Austria",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2011) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 189600000,
    "mintageFormatted": "189,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2011_2cent",
    "country": "Austria",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2011) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 148600000,
    "mintageFormatted": "148,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2011_5cent",
    "country": "Austria",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2011) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 66600000,
    "mintageFormatted": "66,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2011_10cent",
    "country": "Austria",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2011) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 27600000,
    "mintageFormatted": "27,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2011_20cent",
    "country": "Austria",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2011) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 21300000,
    "mintageFormatted": "21,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2011_50cent",
    "country": "Austria",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2011) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2011_1euro",
    "country": "Austria",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2011) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2011",
    "country": "Austria",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2011) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 27700000,
    "mintageFormatted": "27,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2012_1cent",
    "country": "Austria",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2012) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 169300000,
    "mintageFormatted": "169,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2012_2cent",
    "country": "Austria",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2012) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 78100000,
    "mintageFormatted": "78,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2012_5cent",
    "country": "Austria",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2012) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 35300000,
    "mintageFormatted": "35,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2012_10cent",
    "country": "Austria",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2012) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2012_20cent",
    "country": "Austria",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2012) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 10800000,
    "mintageFormatted": "10,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2012_50cent",
    "country": "Austria",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 50 Cents (2012) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2012_1euro",
    "country": "Austria",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Euro (2012) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2012",
    "country": "Austria",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2012) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 21200000,
    "mintageFormatted": "21,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2012_cc-common",
    "country": "Austria",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Austria 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 11000000,
    "mintageFormatted": "11,000,000",
    "status": "circulating",
    "imagePath": "coins/at_commemorative_2012_2euro_0.jpg",
    "image_key": "at_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_austria_2013_1cent",
    "country": "Austria",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2013) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 179200000,
    "mintageFormatted": "179,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2013_2cent",
    "country": "Austria",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2013) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 121500000,
    "mintageFormatted": "121,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2013_5cent",
    "country": "Austria",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2013) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 36100000,
    "mintageFormatted": "36,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2013_10cent",
    "country": "Austria",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2013) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 30100000,
    "mintageFormatted": "30,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2013_20cent",
    "country": "Austria",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2013) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 25200000,
    "mintageFormatted": "25,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2013_50cent",
    "country": "Austria",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 50 Cents (2013) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2013_1euro",
    "country": "Austria",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Euro (2013) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2013",
    "country": "Austria",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2013) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 10100000,
    "mintageFormatted": "10,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2014_1cent",
    "country": "Austria",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2014) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 185500000,
    "mintageFormatted": "185,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2014_2cent",
    "country": "Austria",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2014) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 116100000,
    "mintageFormatted": "116,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2014_5cent",
    "country": "Austria",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2014) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 48000000,
    "mintageFormatted": "48,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2014_10cent",
    "country": "Austria",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2014) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 27600000,
    "mintageFormatted": "27,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2014_20cent",
    "country": "Austria",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2014) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 10500000,
    "mintageFormatted": "10,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2014_50cent",
    "country": "Austria",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 50 Cents (2014) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2014_1euro",
    "country": "Austria",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Euro (2014) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2014",
    "country": "Austria",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2014) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 20100000,
    "mintageFormatted": "20,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2015_1cent",
    "country": "Austria",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2015) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 118000000,
    "mintageFormatted": "118,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2015_2cent",
    "country": "Austria",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2015) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 45400000,
    "mintageFormatted": "45,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2015_5cent",
    "country": "Austria",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2015) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 61000000,
    "mintageFormatted": "61,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2015_10cent",
    "country": "Austria",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2015) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 63100000,
    "mintageFormatted": "63,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2015_20cent",
    "country": "Austria",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2015) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2015_50cent",
    "country": "Austria",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 50 Cents (2015) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2015_1euro",
    "country": "Austria",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Euro (2015) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2015",
    "country": "Austria",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2015) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 12300000,
    "mintageFormatted": "12,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2015_cc-common",
    "country": "Austria",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Austria 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/at_commemorative_2015_2euro_0.jpg",
    "image_key": "at_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_austria_2016_1cent",
    "country": "Austria",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Cent (2016) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2016_2cent",
    "country": "Austria",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 2 Cents (2016) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2016_5cent",
    "country": "Austria",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 5 Cents (2016) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2016_10cent",
    "country": "Austria",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2016) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 12300000,
    "mintageFormatted": "12,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2016_20cent",
    "country": "Austria",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2016) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2016_50cent",
    "country": "Austria",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2016) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2016_1euro",
    "country": "Austria",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2016) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 5200000,
    "mintageFormatted": "5,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2016_cc1",
    "country": "Austria",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2016) - Austrian National Bank",
    "subject": "Austrian National Bank",
    "description": "Austria 2 Euro Commemorative coin issued in 2016: Austrian National Bank.",
    "mintage": 16000000,
    "mintageFormatted": "16,000,000",
    "status": "circulating",
    "imagePath": "coins/at_commemorative_2016_2euro_0.jpg",
    "image_key": "at_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2017_1cent",
    "country": "Austria",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2017) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 37700000,
    "mintageFormatted": "37,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2017_2cent",
    "country": "Austria",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2017) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 57200000,
    "mintageFormatted": "57,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2017_5cent",
    "country": "Austria",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2017) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 35200000,
    "mintageFormatted": "35,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2017_10cent",
    "country": "Austria",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2017) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 39500000,
    "mintageFormatted": "39,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2017_20cent",
    "country": "Austria",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2017) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2017_50cent",
    "country": "Austria",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2017) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2017_1euro",
    "country": "Austria",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2017) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2017",
    "country": "Austria",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2017) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 17700000,
    "mintageFormatted": "17,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2018_1cent",
    "country": "Austria",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2018) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 138500000,
    "mintageFormatted": "138,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2018_2cent",
    "country": "Austria",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2018) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 85650000,
    "mintageFormatted": "85,650,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2018_5cent",
    "country": "Austria",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2018) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 22600000,
    "mintageFormatted": "22,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2018_10cent",
    "country": "Austria",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2018) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 30200000,
    "mintageFormatted": "30,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2018_20cent",
    "country": "Austria",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2018) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 20400000,
    "mintageFormatted": "20,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2018_50cent",
    "country": "Austria",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2018) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 17100000,
    "mintageFormatted": "17,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2018_1euro",
    "country": "Austria",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2018) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 5100000,
    "mintageFormatted": "5,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2018_cc1",
    "country": "Austria",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2018) - Declaration of the Republic",
    "subject": "Declaration of the Republic",
    "description": "Austria 2 Euro Commemorative coin issued in 2018: Declaration of the Republic.",
    "mintage": 12600000,
    "mintageFormatted": "12,600,000",
    "status": "circulating",
    "imagePath": "coins/at_commemorative_2018_2euro_0.jpg",
    "image_key": "at_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2019_1cent",
    "country": "Austria",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2019) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 130900000,
    "mintageFormatted": "130,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2019_2cent",
    "country": "Austria",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2019) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 91200000,
    "mintageFormatted": "91,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2019_5cent",
    "country": "Austria",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2019) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2019_10cent",
    "country": "Austria",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2019) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 15100000,
    "mintageFormatted": "15,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2019_20cent",
    "country": "Austria",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2019) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 25600000,
    "mintageFormatted": "25,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2019_50cent",
    "country": "Austria",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2019) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 2800000,
    "mintageFormatted": "2,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2019_1euro",
    "country": "Austria",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2019) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 2700000,
    "mintageFormatted": "2,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2019",
    "country": "Austria",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2019) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 15800000,
    "mintageFormatted": "15,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2020_1cent",
    "country": "Austria",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2020) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 85500000,
    "mintageFormatted": "85,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2020_2cent",
    "country": "Austria",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2020) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 57300000,
    "mintageFormatted": "57,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2020_5cent",
    "country": "Austria",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2020) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 5600000,
    "mintageFormatted": "5,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2020_10cent",
    "country": "Austria",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2020) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 12100000,
    "mintageFormatted": "12,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2020_20cent",
    "country": "Austria",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2020) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 19800000,
    "mintageFormatted": "19,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2020_50cent",
    "country": "Austria",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2020) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 14900000,
    "mintageFormatted": "14,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2020_1euro",
    "country": "Austria",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2020) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2020",
    "country": "Austria",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2020) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 12700000,
    "mintageFormatted": "12,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2021_1cent",
    "country": "Austria",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2021) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 73400000,
    "mintageFormatted": "73,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2021_2cent",
    "country": "Austria",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2021) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 64600000,
    "mintageFormatted": "64,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2021_5cent",
    "country": "Austria",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2021) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 20200000,
    "mintageFormatted": "20,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2021_10cent",
    "country": "Austria",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2021) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 12100000,
    "mintageFormatted": "12,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2021_20cent",
    "country": "Austria",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2021) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 21000000,
    "mintageFormatted": "21,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2021_50cent",
    "country": "Austria",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2021) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 7400000,
    "mintageFormatted": "7,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2021_1euro",
    "country": "Austria",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2021) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 5400000,
    "mintageFormatted": "5,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2021",
    "country": "Austria",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2021) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 9900000,
    "mintageFormatted": "9,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2022_1cent",
    "country": "Austria",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2022) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 38000000,
    "mintageFormatted": "38,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2022_2cent",
    "country": "Austria",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2022) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 58400000,
    "mintageFormatted": "58,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2022_5cent",
    "country": "Austria",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2022) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 16700000,
    "mintageFormatted": "16,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2022_10cent",
    "country": "Austria",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2022) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 15700000,
    "mintageFormatted": "15,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2022_20cent",
    "country": "Austria",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2022) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 25300000,
    "mintageFormatted": "25,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2022_50cent",
    "country": "Austria",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2022) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 8400000,
    "mintageFormatted": "8,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2022_1euro",
    "country": "Austria",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2022) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2022",
    "country": "Austria",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2022) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 9100000,
    "mintageFormatted": "9,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2022_cc-common",
    "country": "Austria",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Austria 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 2540000,
    "mintageFormatted": "2,540,000",
    "status": "circulating",
    "imagePath": "coins/at_commemorative_2022_2euro_0.jpg",
    "image_key": "at_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_austria_2023_1cent",
    "country": "Austria",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2023) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 28400000,
    "mintageFormatted": "28,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2023_2cent",
    "country": "Austria",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2023) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 36100000,
    "mintageFormatted": "36,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2023_5cent",
    "country": "Austria",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2023) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 13700000,
    "mintageFormatted": "13,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2023_10cent",
    "country": "Austria",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2023) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 26500000,
    "mintageFormatted": "26,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2023_20cent",
    "country": "Austria",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2023) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 38000000,
    "mintageFormatted": "38,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2023_50cent",
    "country": "Austria",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2023) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 8400000,
    "mintageFormatted": "8,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2023_1euro",
    "country": "Austria",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2023) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2023",
    "country": "Austria",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2023) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 38300000,
    "mintageFormatted": "38,300,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2024_1cent",
    "country": "Austria",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2024) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 28600000,
    "mintageFormatted": "28,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2024_2cent",
    "country": "Austria",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2024) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 32600000,
    "mintageFormatted": "32,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2024_5cent",
    "country": "Austria",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2024) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 14200000,
    "mintageFormatted": "14,200,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2024_10cent",
    "country": "Austria",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2024) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 22500000,
    "mintageFormatted": "22,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2024_20cent",
    "country": "Austria",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2024) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 23100000,
    "mintageFormatted": "23,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2024_50cent",
    "country": "Austria",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2024) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 5700000,
    "mintageFormatted": "5,700,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2024_1euro",
    "country": "Austria",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2024) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2024",
    "country": "Austria",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2024) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 25500000,
    "mintageFormatted": "25,500,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2025_1cent",
    "country": "Austria",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Cent (2025) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 9400000,
    "mintageFormatted": "9,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2025_2cent",
    "country": "Austria",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Cents (2025) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 10600000,
    "mintageFormatted": "10,600,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2025_5cent",
    "country": "Austria",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2025) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 1900000,
    "mintageFormatted": "1,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2025_10cent",
    "country": "Austria",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 10 Cents (2025) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 4400000,
    "mintageFormatted": "4,400,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2025_20cent",
    "country": "Austria",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2025) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 14800000,
    "mintageFormatted": "14,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2025_50cent",
    "country": "Austria",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 50 Cents (2025) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 5100000,
    "mintageFormatted": "5,100,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2025_1euro",
    "country": "Austria",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 1 Euro (2025) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 3800000,
    "mintageFormatted": "3,800,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2025",
    "country": "Austria",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2025) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 14900000,
    "mintageFormatted": "14,900,000",
    "status": "circulating",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2026_1cent",
    "country": "Austria",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Cent (2026) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2026_2cent",
    "country": "Austria",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 2 Cents (2026) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2026_5cent",
    "country": "Austria",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 5 Cents (2026) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2026_10cent",
    "country": "Austria",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 10 Cents (2026) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2026_20cent",
    "country": "Austria",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 20 Cents (2026) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2026_50cent",
    "country": "Austria",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 50 Cents (2026) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2026_1euro",
    "country": "Austria",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Euro (2026) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2026",
    "country": "Austria",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Austria 2 Euros (2026) - Bertha von Suttner",
    "subject": "Bertha von Suttner",
    "description": "Radical pacifist and Nobel Peace Prize laureate Bertha von Suttner (1843–1914)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/at_regular_1999_2euro_0.jpg",
    "image_key": "at_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2027_1cent",
    "country": "Austria",
    "year": 2027,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Cent (2027) - Gentian (Enzian)",
    "subject": "Gentian (Enzian)",
    "description": "Alpine flower gentian (Gentiana), symbol of environmental protection",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_1cent_0.jpg",
    "image_key": "at_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2027_2cent",
    "country": "Austria",
    "year": 2027,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 2 Cents (2027) - Edelweiss",
    "subject": "Edelweiss",
    "description": "Alpine flower edelweiss (Leontopodium nivale), symbol of Austrian alpine nature",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_2cent_0.jpg",
    "image_key": "at_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2027_5cent",
    "country": "Austria",
    "year": 2027,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 5 Cents (2027) - Alpine Primrose",
    "subject": "Alpine Primrose",
    "description": "Alpine flower primrose (Primula auricula)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_5cent_0.jpg",
    "image_key": "at_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2027_10cent",
    "country": "Austria",
    "year": 2027,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 10 Cents (2027) - St. Stephen's Cathedral, Vienna",
    "subject": "St. Stephen's Cathedral, Vienna",
    "description": "Stephansdom, iconic Gothic cathedral in Vienna",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_10cent_0.jpg",
    "image_key": "at_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2027_20cent",
    "country": "Austria",
    "year": 2027,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 20 Cents (2027) - Belvedere Palace",
    "subject": "Belvedere Palace",
    "description": "Baroque Belvedere Palace in Vienna, symbol of Austrian freedom and sovereignty",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_20cent_0.jpg",
    "image_key": "at_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2027_50cent",
    "country": "Austria",
    "year": 2027,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 50 Cents (2027) - Secession Hall, Vienna",
    "subject": "Secession Hall, Vienna",
    "description": "Art Nouveau Secession building in Vienna, symbolizing modernism and architectural heritage",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_50cent_0.jpg",
    "image_key": "at_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_austria_2027_1euro",
    "country": "Austria",
    "year": 2027,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Austria 1 Euro (2027) - Wolfgang Amadeus Mozart",
    "subject": "Wolfgang Amadeus Mozart",
    "description": "Renowned Austrian composer Wolfgang Amadeus Mozart (1756–1791)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/at_regular_1999_1euro_0.jpg",
    "image_key": "at_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_austria_2027_cc1",
    "country": "Austria",
    "year": 2027,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Austria 2€ Commemorative (2027) - Ludwig van Beethoven",
    "subject": "Ludwig van Beethoven",
    "description": "Austria 2 Euro Commemorative coin issued in 2027: Ludwig van Beethoven.",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_1999_1cent",
    "country": "Belgium",
    "year": 1999,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (1999) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 235200000,
    "mintageFormatted": "235,200,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_1999_2cent",
    "country": "Belgium",
    "year": 1999,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (1999) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_1999_5cent",
    "country": "Belgium",
    "year": 1999,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (1999) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 300000000,
    "mintageFormatted": "300,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_1999_10cent",
    "country": "Belgium",
    "year": 1999,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (1999) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 180950000,
    "mintageFormatted": "180,950,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_1999_20cent",
    "country": "Belgium",
    "year": 1999,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (1999) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_1999_50cent",
    "country": "Belgium",
    "year": 1999,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (1999) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 197000000,
    "mintageFormatted": "197,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_1999_1euro",
    "country": "Belgium",
    "year": 1999,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Euro (1999) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 160000000,
    "mintageFormatted": "160,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_1999",
    "country": "Belgium",
    "year": 1999,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (1999) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2000_1cent",
    "country": "Belgium",
    "year": 2000,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2000) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2000_2cent",
    "country": "Belgium",
    "year": 2000,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2000) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 337000000,
    "mintageFormatted": "337,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2000_5cent",
    "country": "Belgium",
    "year": 2000,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2000) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2000_10cent",
    "country": "Belgium",
    "year": 2000,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2000) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2000_20cent",
    "country": "Belgium",
    "year": 2000,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2000) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 181000000,
    "mintageFormatted": "181,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2000_50cent",
    "country": "Belgium",
    "year": 2000,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2000) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2000_1euro",
    "country": "Belgium",
    "year": 2000,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2000) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2000",
    "country": "Belgium",
    "year": 2000,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2000) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 120000000,
    "mintageFormatted": "120,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2001_1cent",
    "country": "Belgium",
    "year": 2001,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2001) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 99800000,
    "mintageFormatted": "99,800,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2001_2cent",
    "country": "Belgium",
    "year": 2001,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2001) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2001_5cent",
    "country": "Belgium",
    "year": 2001,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2001) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2001_10cent",
    "country": "Belgium",
    "year": 2001,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2001) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 145750000,
    "mintageFormatted": "145,750,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2001_20cent",
    "country": "Belgium",
    "year": 2001,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2001) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2001_50cent",
    "country": "Belgium",
    "year": 2001,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2001) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2001_1euro",
    "country": "Belgium",
    "year": 2001,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2001) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2001",
    "country": "Belgium",
    "year": 2001,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2001) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2002_1cent",
    "country": "Belgium",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2002) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2002_2cent",
    "country": "Belgium",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2002) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2002_5cent",
    "country": "Belgium",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2002) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2002_10cent",
    "country": "Belgium",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2002) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 90803,
    "mintageFormatted": "90,803",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2002_20cent",
    "country": "Belgium",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2002) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 104000000,
    "mintageFormatted": "104,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2002_50cent",
    "country": "Belgium",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2002) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 50019648,
    "mintageFormatted": "50,019,648",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2002_1euro",
    "country": "Belgium",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Euro (2002) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 84526660,
    "mintageFormatted": "84,526,660",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2002",
    "country": "Belgium",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2002) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2003_1cent",
    "country": "Belgium",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2003) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 10030404,
    "mintageFormatted": "10,030,404",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2003_2cent",
    "country": "Belgium",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2003) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 40010808,
    "mintageFormatted": "40,010,808",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2003_5cent",
    "country": "Belgium",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2003) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 30056908,
    "mintageFormatted": "30,056,908",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2003_10cent",
    "country": "Belgium",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2003) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2003_20cent",
    "country": "Belgium",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2003) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 30006146,
    "mintageFormatted": "30,006,146",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2003_50cent",
    "country": "Belgium",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2003) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2003_1euro",
    "country": "Belgium",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Euro (2003) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2003",
    "country": "Belgium",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2003) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 30030404,
    "mintageFormatted": "30,030,404",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2004_1cent",
    "country": "Belgium",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2004) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 180000000,
    "mintageFormatted": "180,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2004_2cent",
    "country": "Belgium",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2004) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 159250000,
    "mintageFormatted": "159,250,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2004_5cent",
    "country": "Belgium",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2004) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 80000000,
    "mintageFormatted": "80,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2004_10cent",
    "country": "Belgium",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2004) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2004_20cent",
    "country": "Belgium",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2004) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2004_50cent",
    "country": "Belgium",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2004) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2004_1euro",
    "country": "Belgium",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Euro (2004) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2004",
    "country": "Belgium",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2004) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 59976988,
    "mintageFormatted": "59,976,988",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2005_1cent",
    "country": "Belgium",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2005) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2005_2cent",
    "country": "Belgium",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2005) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2005_5cent",
    "country": "Belgium",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2005) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 110000000,
    "mintageFormatted": "110,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2005_10cent",
    "country": "Belgium",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2005) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2005_20cent",
    "country": "Belgium",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2005) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2005_50cent",
    "country": "Belgium",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2005) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2005_1euro",
    "country": "Belgium",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2005) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2005",
    "country": "Belgium",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2005) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 10500000,
    "mintageFormatted": "10,500,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2005_cc1",
    "country": "Belgium",
    "year": 2005,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2005) - Renewal of the BE-LUX Economic Union",
    "subject": "Renewal of the BE-LUX Economic Union",
    "description": "Belgium 2 Euro Commemorative coin issued in 2005: Renewal of the BE-LUX Economic Union.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2005_2euro_0.jpg",
    "image_key": "be_commemorative_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2006_1cent",
    "country": "Belgium",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2006) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2006_2cent",
    "country": "Belgium",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2006) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2006_5cent",
    "country": "Belgium",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2006) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2006_10cent",
    "country": "Belgium",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2006) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2006_20cent",
    "country": "Belgium",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2006) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2006_50cent",
    "country": "Belgium",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2006) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2006_1euro",
    "country": "Belgium",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2006) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2006",
    "country": "Belgium",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2006) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2006_cc1",
    "country": "Belgium",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2006) - Renovation of the Atomium",
    "subject": "Renovation of the Atomium",
    "description": "Belgium 2 Euro Commemorative coin issued in 2006: Renovation of the Atomium.",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2006_2euro_0.jpg",
    "image_key": "be_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2007_1cent",
    "country": "Belgium",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2007) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 60000000,
    "mintageFormatted": "60,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_1cent_0.jpg",
    "image_key": "be_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2007_2cent",
    "country": "Belgium",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2007) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2cent_0.jpg",
    "image_key": "be_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2007_5cent",
    "country": "Belgium",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2007) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_5cent_0.jpg",
    "image_key": "be_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2007_10cent",
    "country": "Belgium",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2007) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_10cent_0.jpg",
    "image_key": "be_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2007_20cent",
    "country": "Belgium",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2007) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 25060281,
    "mintageFormatted": "25,060,281",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_20cent_0.jpg",
    "image_key": "be_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2007_50cent",
    "country": "Belgium",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2007) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_50cent_0.jpg",
    "image_key": "be_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2007_1euro",
    "country": "Belgium",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2007) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_1999_1euro_0.jpg",
    "image_key": "be_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2007",
    "country": "Belgium",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2007) - King Albert II (1st Portrait)",
    "subject": "King Albert II (1st Portrait)",
    "description": "Effigy of King Albert II of Belgium",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_1999_2euro_0.jpg",
    "image_key": "be_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2007_cc-common",
    "country": "Belgium",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Belgium 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2007_2euro_0.jpg",
    "image_key": "be_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_belgium_2008_1cent",
    "country": "Belgium",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2008) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_1cent_0.jpg",
    "image_key": "be_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2008_2cent",
    "country": "Belgium",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2008) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_2cent_0.jpg",
    "image_key": "be_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2008_5cent",
    "country": "Belgium",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2008) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_5cent_0.jpg",
    "image_key": "be_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2008_10cent",
    "country": "Belgium",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2008) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_10cent_0.jpg",
    "image_key": "be_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2008_20cent",
    "country": "Belgium",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2008) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 20020000,
    "mintageFormatted": "20,020,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_20cent_0.jpg",
    "image_key": "be_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2008_50cent",
    "country": "Belgium",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2008) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_50cent_0.jpg",
    "image_key": "be_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2008_1euro",
    "country": "Belgium",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Euro (2008) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1euro_0.jpg",
    "image_key": "be_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2008",
    "country": "Belgium",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2008) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_2euro_0.jpg",
    "image_key": "be_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2008_cc1",
    "country": "Belgium",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2008) - Universal Declaration of Human Rights",
    "subject": "Universal Declaration of Human Rights",
    "description": "Belgium 2 Euro Commemorative coin issued in 2008: Universal Declaration of Human Rights.",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2008_2euro_0.jpg",
    "image_key": "be_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2009_1cent",
    "country": "Belgium",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2009) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1cent_0.jpg",
    "image_key": "be_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2009_2cent",
    "country": "Belgium",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2009) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_2cent_0.jpg",
    "image_key": "be_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2009_5cent",
    "country": "Belgium",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2009) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_5cent_0.jpg",
    "image_key": "be_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2009_10cent",
    "country": "Belgium",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2009) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_10cent_0.jpg",
    "image_key": "be_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2009_20cent",
    "country": "Belgium",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2009) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_20cent_0.jpg",
    "image_key": "be_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2009_50cent",
    "country": "Belgium",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2009) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 42500000,
    "mintageFormatted": "42,500,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_50cent_0.jpg",
    "image_key": "be_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2009_1euro",
    "country": "Belgium",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Euro (2009) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 12800000,
    "mintageFormatted": "12,800,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1euro_0.jpg",
    "image_key": "be_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2009",
    "country": "Belgium",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2009) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_2euro_0.jpg",
    "image_key": "be_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2009_cc1",
    "country": "Belgium",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2009) - Louis Braille",
    "subject": "Louis Braille",
    "description": "Belgium 2 Euro Commemorative coin issued in 2009: Louis Braille.",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2009_2euro_0.jpg",
    "image_key": "be_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2009_cc-common",
    "country": "Belgium",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Belgium 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2009_2euro_1.jpg",
    "image_key": "be_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_belgium_2010_1cent",
    "country": "Belgium",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2010) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 30100000,
    "mintageFormatted": "30,100,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1cent_0.jpg",
    "image_key": "be_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2010_2cent",
    "country": "Belgium",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2010) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_2cent_0.jpg",
    "image_key": "be_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2010_5cent",
    "country": "Belgium",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2010) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_5cent_0.jpg",
    "image_key": "be_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2010_10cent",
    "country": "Belgium",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2010) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_10cent_0.jpg",
    "image_key": "be_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2010_20cent",
    "country": "Belgium",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2010) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 15050000,
    "mintageFormatted": "15,050,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_20cent_0.jpg",
    "image_key": "be_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2010_50cent",
    "country": "Belgium",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2010) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_50cent_0.jpg",
    "image_key": "be_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2010_1euro",
    "country": "Belgium",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2010) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_1euro_0.jpg",
    "image_key": "be_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2010",
    "country": "Belgium",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2010) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_2euro_0.jpg",
    "image_key": "be_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2010_cc1",
    "country": "Belgium",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2010) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Belgium 2 Euro Commemorative coin issued in 2010: Presidency of the EU Council.",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2010_2euro_0.jpg",
    "image_key": "be_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2011_1cent",
    "country": "Belgium",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2011) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 9975000,
    "mintageFormatted": "9,975,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1cent_0.jpg",
    "image_key": "be_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2011_2cent",
    "country": "Belgium",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2011) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_2cent_0.jpg",
    "image_key": "be_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2011_5cent",
    "country": "Belgium",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2011) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_5cent_0.jpg",
    "image_key": "be_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2011_10cent",
    "country": "Belgium",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2011) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_10cent_0.jpg",
    "image_key": "be_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2011_20cent",
    "country": "Belgium",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2011) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 40250000,
    "mintageFormatted": "40,250,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_20cent_0.jpg",
    "image_key": "be_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2011_50cent",
    "country": "Belgium",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2011) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_50cent_0.jpg",
    "image_key": "be_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2011_1euro",
    "country": "Belgium",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Euro (2011) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1euro_0.jpg",
    "image_key": "be_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2011",
    "country": "Belgium",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2011) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 32000000,
    "mintageFormatted": "32,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_2euro_0.jpg",
    "image_key": "be_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2011_cc1",
    "country": "Belgium",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2011) - International Women's Day",
    "subject": "International Women's Day",
    "description": "Belgium 2 Euro Commemorative coin issued in 2011: International Women's Day.",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2011_2euro_0.jpg",
    "image_key": "be_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2012_1cent",
    "country": "Belgium",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2012) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 19950000,
    "mintageFormatted": "19,950,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1cent_0.jpg",
    "image_key": "be_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2012_2cent",
    "country": "Belgium",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2012) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_2cent_0.jpg",
    "image_key": "be_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2012_5cent",
    "country": "Belgium",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2012) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 22500000,
    "mintageFormatted": "22,500,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_5cent_0.jpg",
    "image_key": "be_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2012_10cent",
    "country": "Belgium",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2012) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_10cent_0.jpg",
    "image_key": "be_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2012_20cent",
    "country": "Belgium",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2012) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 42350000,
    "mintageFormatted": "42,350,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_20cent_0.jpg",
    "image_key": "be_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2012_50cent",
    "country": "Belgium",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2012) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_50cent_0.jpg",
    "image_key": "be_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2012_1euro",
    "country": "Belgium",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Euro (2012) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1euro_0.jpg",
    "image_key": "be_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2012",
    "country": "Belgium",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2012) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_2euro_0.jpg",
    "image_key": "be_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2012_cc1",
    "country": "Belgium",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2012) - Queen Elisabeth Competition",
    "subject": "Queen Elisabeth Competition",
    "description": "Belgium 2 Euro Commemorative coin issued in 2012: Queen Elisabeth Competition.",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2012_2euro_0.jpg",
    "image_key": "be_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2012_cc-common",
    "country": "Belgium",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Belgium 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2012_2euro_1.jpg",
    "image_key": "be_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_belgium_2013_1cent",
    "country": "Belgium",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2013) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_1cent_0.jpg",
    "image_key": "be_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2013_2cent",
    "country": "Belgium",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2013) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 32625000,
    "mintageFormatted": "32,625,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_2cent_0.jpg",
    "image_key": "be_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2013_5cent",
    "country": "Belgium",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2013) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_5cent_0.jpg",
    "image_key": "be_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2013_10cent",
    "country": "Belgium",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2013) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2008_10cent_0.jpg",
    "image_key": "be_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2013_20cent",
    "country": "Belgium",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2013) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_20cent_0.jpg",
    "image_key": "be_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2013_50cent",
    "country": "Belgium",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2013) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_50cent_0.jpg",
    "image_key": "be_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2013_1euro",
    "country": "Belgium",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2013) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_1euro_0.jpg",
    "image_key": "be_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2013",
    "country": "Belgium",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2013) - King Albert II (2nd Portrait)",
    "subject": "King Albert II (2nd Portrait)",
    "description": "Updated effigy of King Albert II of Belgium",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2008_2euro_0.jpg",
    "image_key": "be_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2013_cc1",
    "country": "Belgium",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2013) - Royal Meteorological Institute",
    "subject": "Royal Meteorological Institute",
    "description": "Belgium 2 Euro Commemorative coin issued in 2013: Royal Meteorological Institute.",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2013_2euro_0.jpg",
    "image_key": "be_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2014_1cent",
    "country": "Belgium",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2014) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2014_2cent",
    "country": "Belgium",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2014) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 3125000,
    "mintageFormatted": "3,125,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2014_5cent",
    "country": "Belgium",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2014) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 14500000,
    "mintageFormatted": "14,500,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2014_10cent",
    "country": "Belgium",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2014) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2014_20cent",
    "country": "Belgium",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2014) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2014_50cent",
    "country": "Belgium",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2014) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2014_1euro",
    "country": "Belgium",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2014) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2014",
    "country": "Belgium",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2014) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2014_cc1",
    "country": "Belgium",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2014) - Beginning of WWI",
    "subject": "Beginning of WWI",
    "description": "Belgium 2 Euro Commemorative coin issued in 2014: Beginning of WWI.",
    "mintage": 1700000,
    "mintageFormatted": "1,700,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2014_2euro_1.jpg",
    "image_key": "be_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2014_cc2",
    "country": "Belgium",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2014) - Belgian Red Cross",
    "subject": "Belgian Red Cross",
    "description": "Belgium 2 Euro Commemorative coin issued in 2014: Belgian Red Cross.",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2014_2euro_0.jpg",
    "image_key": "be_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2015_1cent",
    "country": "Belgium",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2015) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2015_2cent",
    "country": "Belgium",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2015) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2015_5cent",
    "country": "Belgium",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2015) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2015_10cent",
    "country": "Belgium",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2015) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 11000000,
    "mintageFormatted": "11,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2015_20cent",
    "country": "Belgium",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2015) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2015_50cent",
    "country": "Belgium",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2015) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2015_1euro",
    "country": "Belgium",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2015) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2015",
    "country": "Belgium",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2015) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2015_cc1",
    "country": "Belgium",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2015) - European Year for Development",
    "subject": "European Year for Development",
    "description": "Belgium 2 Euro Commemorative coin issued in 2015: European Year for Development.",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2015_2euro_1.jpg",
    "image_key": "be_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2015_cc-common",
    "country": "Belgium",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Belgium 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2015_2euro_0.jpg",
    "image_key": "be_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_belgium_2016_1cent",
    "country": "Belgium",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2016) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 29750000,
    "mintageFormatted": "29,750,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2016_2cent",
    "country": "Belgium",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Cents (2016) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 16250000,
    "mintageFormatted": "16,250,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2016_5cent",
    "country": "Belgium",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2016) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 28500000,
    "mintageFormatted": "28,500,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2016_10cent",
    "country": "Belgium",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2016) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2016_20cent",
    "country": "Belgium",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2016) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2016_50cent",
    "country": "Belgium",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2016) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2016_1euro",
    "country": "Belgium",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2016) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2016",
    "country": "Belgium",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2016) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2016_cc1",
    "country": "Belgium",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2016) - 2016 Summer Olympics",
    "subject": "2016 Summer Olympics",
    "description": "Belgium 2 Euro Commemorative coin issued in 2016: 2016 Summer Olympics.",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2016_2euro_1.jpg",
    "image_key": "be_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2016_cc2",
    "country": "Belgium",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2016) - Child Focus",
    "subject": "Child Focus",
    "description": "Belgium 2 Euro Commemorative coin issued in 2016: Child Focus.",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2016_2euro_0.jpg",
    "image_key": "be_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2017_1cent",
    "country": "Belgium",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 1 Cent (2017) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1634500,
    "mintageFormatted": "1,634,500",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2017_2cent",
    "country": "Belgium",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2017) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2017_5cent",
    "country": "Belgium",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2017) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 48444500,
    "mintageFormatted": "48,444,500",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2017_10cent",
    "country": "Belgium",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2017) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2017_20cent",
    "country": "Belgium",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2017) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2017_50cent",
    "country": "Belgium",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2017) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2017_1euro",
    "country": "Belgium",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2017) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2017",
    "country": "Belgium",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2017) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2017_cc1",
    "country": "Belgium",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2017) - University of Liège",
    "subject": "University of Liège",
    "description": "Belgium 2 Euro Commemorative coin issued in 2017: University of Liège.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2017_2euro_1.jpg",
    "image_key": "be_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2017_cc2",
    "country": "Belgium",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2017) - University of Ghent",
    "subject": "University of Ghent",
    "description": "Belgium 2 Euro Commemorative coin issued in 2017: University of Ghent.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2017_2euro_0.jpg",
    "image_key": "be_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2018_1cent",
    "country": "Belgium",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2018) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2018_2cent",
    "country": "Belgium",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2018) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2018_5cent",
    "country": "Belgium",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2018) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 5300000,
    "mintageFormatted": "5,300,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2018_10cent",
    "country": "Belgium",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2018) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 12300000,
    "mintageFormatted": "12,300,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2018_20cent",
    "country": "Belgium",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2018) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2018_50cent",
    "country": "Belgium",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2018) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2018_1euro",
    "country": "Belgium",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2018) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2018",
    "country": "Belgium",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2018) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2018_cc1",
    "country": "Belgium",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2018) - May 1968 events in Belgium",
    "subject": "May 1968 events in Belgium",
    "description": "Belgium 2 Euro Commemorative coin issued in 2018: May 1968 events in Belgium.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2018_2euro_1.jpg",
    "image_key": "be_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2018_cc2",
    "country": "Belgium",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2018) - ESRO-2B Satellite Launch",
    "subject": "ESRO-2B Satellite Launch",
    "description": "Belgium 2 Euro Commemorative coin issued in 2018: ESRO-2B Satellite Launch.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2018_2euro_0.jpg",
    "image_key": "be_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2019_1cent",
    "country": "Belgium",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2019) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2019_2cent",
    "country": "Belgium",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2019) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2019_5cent",
    "country": "Belgium",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2019) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2019_10cent",
    "country": "Belgium",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2019) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2019_20cent",
    "country": "Belgium",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2019) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 21000000,
    "mintageFormatted": "21,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2019_50cent",
    "country": "Belgium",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2019) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2019_1euro",
    "country": "Belgium",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2019) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2019",
    "country": "Belgium",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 2 Euros (2019) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 3200000,
    "mintageFormatted": "3,200,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2019_cc1",
    "country": "Belgium",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2019) - Pieter Bruegel the Elder",
    "subject": "Pieter Bruegel the Elder",
    "description": "Belgium 2 Euro Commemorative coin issued in 2019: Pieter Bruegel the Elder.",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2019_2euro_1.jpg",
    "image_key": "be_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2019_cc2",
    "country": "Belgium",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2019) - European Monetary Institute (EMI)",
    "subject": "European Monetary Institute (EMI)",
    "description": "Belgium 2 Euro Commemorative coin issued in 2019: European Monetary Institute (EMI).",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2019_2euro_0.jpg",
    "image_key": "be_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2020_1cent",
    "country": "Belgium",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2020) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2020_2cent",
    "country": "Belgium",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2020) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2020_5cent",
    "country": "Belgium",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2020) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2020_10cent",
    "country": "Belgium",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2020) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2020_20cent",
    "country": "Belgium",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2020) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2020_50cent",
    "country": "Belgium",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2020) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2020_1euro",
    "country": "Belgium",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2020) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2020",
    "country": "Belgium",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2020) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2020_cc1",
    "country": "Belgium",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2020) - International Year of Plant Health",
    "subject": "International Year of Plant Health",
    "description": "Belgium 2 Euro Commemorative coin issued in 2020: International Year of Plant Health.",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2020_2euro_1.jpg",
    "image_key": "be_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2020_cc2",
    "country": "Belgium",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2020) - Jan van Eyck",
    "subject": "Jan van Eyck",
    "description": "Belgium 2 Euro Commemorative coin issued in 2020: Jan van Eyck.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2020_2euro_0.jpg",
    "image_key": "be_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2021_1cent",
    "country": "Belgium",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2021) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2021_2cent",
    "country": "Belgium",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2021) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2021_5cent",
    "country": "Belgium",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2021) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2021_10cent",
    "country": "Belgium",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2021) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2021_20cent",
    "country": "Belgium",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2021) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2021_50cent",
    "country": "Belgium",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2021) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2021_1euro",
    "country": "Belgium",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2021) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2021",
    "country": "Belgium",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2021) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2021_cc1",
    "country": "Belgium",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2021) - Belgium-Luxembourg Economic Union",
    "subject": "Belgium-Luxembourg Economic Union",
    "description": "Belgium 2 Euro Commemorative coin issued in 2021: Belgium-Luxembourg Economic Union.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2021_2euro_1.jpg",
    "image_key": "be_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2021_cc2",
    "country": "Belgium",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2021) - Karlsgulden issued under Charles V",
    "subject": "Karlsgulden issued under Charles V",
    "description": "Belgium 2 Euro Commemorative coin issued in 2021: Karlsgulden issued under Charles V.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2021_2euro_0.jpg",
    "image_key": "be_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2022_1cent",
    "country": "Belgium",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2022) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2022_2cent",
    "country": "Belgium",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2022) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2022_5cent",
    "country": "Belgium",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2022) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2022_10cent",
    "country": "Belgium",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2022) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2022_20cent",
    "country": "Belgium",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2022) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2022_50cent",
    "country": "Belgium",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2022) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2022_1euro",
    "country": "Belgium",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2022) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2022",
    "country": "Belgium",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2022) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2022_cc1",
    "country": "Belgium",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2022) - Healthcare in COVID",
    "subject": "Healthcare in COVID",
    "description": "Belgium 2 Euro Commemorative coin issued in 2022: Healthcare in COVID.",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2022_2euro_0.jpg",
    "image_key": "be_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2022_cc-common",
    "country": "Belgium",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Belgium 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 895000,
    "mintageFormatted": "895,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2022_2euro_1.jpg",
    "image_key": "be_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_belgium_2023_1cent",
    "country": "Belgium",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2023) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2023_2cent",
    "country": "Belgium",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2023) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2023_5cent",
    "country": "Belgium",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2023) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2023_10cent",
    "country": "Belgium",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2023) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 7500000,
    "mintageFormatted": "7,500,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2023_20cent",
    "country": "Belgium",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2023) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2023_50cent",
    "country": "Belgium",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2023) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2023_1euro",
    "country": "Belgium",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2023) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2023",
    "country": "Belgium",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2023) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2023_cc1",
    "country": "Belgium",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2023) - Art Nouveau",
    "subject": "Art Nouveau",
    "description": "Belgium 2 Euro Commemorative coin issued in 2023: Art Nouveau.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2023_2euro_0.jpg",
    "image_key": "be_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2023_cc2",
    "country": "Belgium",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2023) - Women's Suffrage",
    "subject": "Women's Suffrage",
    "description": "Belgium 2 Euro Commemorative coin issued in 2023: Women's Suffrage.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2023_2euro_1.jpg",
    "image_key": "be_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2024_1cent",
    "country": "Belgium",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2024) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2024_2cent",
    "country": "Belgium",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2024) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2024_5cent",
    "country": "Belgium",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2024) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 13900000,
    "mintageFormatted": "13,900,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2024_10cent",
    "country": "Belgium",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2024) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2024_20cent",
    "country": "Belgium",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2024) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2024_50cent",
    "country": "Belgium",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2024) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 3200000,
    "mintageFormatted": "3,200,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2024_1euro",
    "country": "Belgium",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2024) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2024",
    "country": "Belgium",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2024) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2024_cc1",
    "country": "Belgium",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2024) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Belgium 2 Euro Commemorative coin issued in 2024: Presidency of the EU Council.",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2024_2euro_0.jpg",
    "image_key": "be_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2024_cc2",
    "country": "Belgium",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2024) - Fight Against Cancer",
    "subject": "Fight Against Cancer",
    "description": "Belgium 2 Euro Commemorative coin issued in 2024: Fight Against Cancer.",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2024_2euro_1.jpg",
    "image_key": "be_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2025_1cent",
    "country": "Belgium",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2025) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2025_2cent",
    "country": "Belgium",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2025) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2025_5cent",
    "country": "Belgium",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 5 Cents (2025) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 36400000,
    "mintageFormatted": "36,400,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2025_10cent",
    "country": "Belgium",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 10 Cents (2025) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2025_20cent",
    "country": "Belgium",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 20 Cents (2025) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 30570000,
    "mintageFormatted": "30,570,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2025_50cent",
    "country": "Belgium",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Belgium 50 Cents (2025) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2025_1euro",
    "country": "Belgium",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2025) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2025",
    "country": "Belgium",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2025) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2025_cc1",
    "country": "Belgium",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Belgium 2€ Commemorative (2025) - National Lottery",
    "subject": "National Lottery",
    "description": "Belgium 2 Euro Commemorative coin issued in 2025: National Lottery.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/be_commemorative_2025_2euro_0.jpg",
    "image_key": "be_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2025_cc2",
    "country": "Belgium",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2025) - Circuit of Spa-Francorchamps",
    "subject": "Circuit of Spa-Francorchamps",
    "description": "Belgium 2 Euro Commemorative coin issued in 2025: Circuit of Spa-Francorchamps.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/be_commemorative_2025_2euro_1.jpg",
    "image_key": "be_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2026_1cent",
    "country": "Belgium",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Cent (2026) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/be_regular_2014_1cent_0.jpg",
    "image_key": "be_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2026_2cent",
    "country": "Belgium",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Cents (2026) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/be_regular_2014_2cent_0.jpg",
    "image_key": "be_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2026_5cent",
    "country": "Belgium",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 5 Cents (2026) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/be_regular_2014_5cent_0.jpg",
    "image_key": "be_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2026_10cent",
    "country": "Belgium",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 10 Cents (2026) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/be_regular_2014_10cent_0.jpg",
    "image_key": "be_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2026_20cent",
    "country": "Belgium",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 20 Cents (2026) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/be_regular_2014_20cent_0.jpg",
    "image_key": "be_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2026_50cent",
    "country": "Belgium",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 50 Cents (2026) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/be_regular_2014_50cent_0.jpg",
    "image_key": "be_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2026_1euro",
    "country": "Belgium",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 1 Euro (2026) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/be_regular_2014_1euro_0.jpg",
    "image_key": "be_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_belgium_2026",
    "country": "Belgium",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2 Euros (2026) - King Philippe",
    "subject": "King Philippe",
    "description": "Effigy of King Philippe of Belgium",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/be_regular_2014_2euro_0.jpg",
    "image_key": "be_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2026_cc1",
    "country": "Belgium",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2026) - NMBS/SNCB",
    "subject": "NMBS/SNCB",
    "description": "Belgium 2 Euro Commemorative coin issued in 2026: NMBS/SNCB.",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_belgium_2026_cc2",
    "country": "Belgium",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Belgium 2€ Commemorative (2026) - Geographic Institute/Observatory",
    "subject": "Geographic Institute/Observatory",
    "description": "Belgium 2 Euro Commemorative coin issued in 2026: Geographic Institute/Observatory.",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_bulgaria_2026_1cent",
    "country": "Bulgaria",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Bulgaria 1 Cent (2026) - Madara Rider",
    "subject": "Madara Rider",
    "description": "Early medieval rock relief Madara Rider (Madarski konnik)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/bg_regular_2025_1cent_0.jpg",
    "image_key": "bg_regular_2025_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_bulgaria_2026_2cent",
    "country": "Bulgaria",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Bulgaria 2 Cents (2026) - Madara Rider",
    "subject": "Madara Rider",
    "description": "Early medieval rock relief Madara Rider (Madarski konnik)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/bg_regular_2025_2cent_0.jpg",
    "image_key": "bg_regular_2025_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_bulgaria_2026_5cent",
    "country": "Bulgaria",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Bulgaria 5 Cents (2026) - Madara Rider",
    "subject": "Madara Rider",
    "description": "Early medieval rock relief Madara Rider (Madarski konnik)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/bg_regular_2025_5cent_0.jpg",
    "image_key": "bg_regular_2025_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_bulgaria_2026_10cent",
    "country": "Bulgaria",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Bulgaria 10 Cents (2026) - Madara Rider",
    "subject": "Madara Rider",
    "description": "Early medieval rock relief Madara Rider (Madarski konnik)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/bg_regular_2025_10cent_0.jpg",
    "image_key": "bg_regular_2025_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_bulgaria_2026_20cent",
    "country": "Bulgaria",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Bulgaria 20 Cents (2026) - Madara Rider",
    "subject": "Madara Rider",
    "description": "Early medieval rock relief Madara Rider (Madarski konnik)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/bg_regular_2025_20cent_0.jpg",
    "image_key": "bg_regular_2025_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_bulgaria_2026_50cent",
    "country": "Bulgaria",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Bulgaria 50 Cents (2026) - Madara Rider",
    "subject": "Madara Rider",
    "description": "Early medieval rock relief Madara Rider (Madarski konnik)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/bg_regular_2025_50cent_0.jpg",
    "image_key": "bg_regular_2025_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_bulgaria_2026_1euro",
    "country": "Bulgaria",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Bulgaria 1 Euro (2026) - Saint John of Rila",
    "subject": "Saint John of Rila",
    "description": "Saint John of Rila (Ivan Rilski), patron saint of Bulgaria",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/bg_regular_2025_1euro_0.jpg",
    "image_key": "bg_regular_2025_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_bulgaria_2026",
    "country": "Bulgaria",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Bulgaria 2 Euros (2026) - Paisius of Hilendar",
    "subject": "Paisius of Hilendar",
    "description": "Saint Paisius of Hilendar (Paisiy Hilendarski), key figure of Bulgarian National Revival",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/bg_regular_2025_2euro_0.jpg",
    "image_key": "bg_regular_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2023_1cent",
    "country": "Croatia",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 1 Cent (2023) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 93006050,
    "mintageFormatted": "93,006,050",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_1cent_0.jpg",
    "image_key": "hr_regular_2023_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2023_2cent",
    "country": "Croatia",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 2 Cents (2023) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 69313000,
    "mintageFormatted": "69,313,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_2cent_0.jpg",
    "image_key": "hr_regular_2023_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2023_5cent",
    "country": "Croatia",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 5 Cents (2023) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 94144500,
    "mintageFormatted": "94,144,500",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_5cent_0.jpg",
    "image_key": "hr_regular_2023_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2023_10cent",
    "country": "Croatia",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 10 Cents (2023) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 102879740,
    "mintageFormatted": "102,879,740",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_10cent_0.jpg",
    "image_key": "hr_regular_2023_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2023_20cent",
    "country": "Croatia",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 20 Cents (2023) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 84320020,
    "mintageFormatted": "84,320,020",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_20cent_0.jpg",
    "image_key": "hr_regular_2023_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2023_50cent",
    "country": "Croatia",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 50 Cents (2023) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 65000020,
    "mintageFormatted": "65,000,020",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_50cent_0.jpg",
    "image_key": "hr_regular_2023_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2023_1euro",
    "country": "Croatia",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 1 Euro (2023) - Pine Marten (Kuna)",
    "subject": "Pine Marten (Kuna)",
    "description": "Silhouette of a pine marten (kuna) standing on a branch, historic symbol of Croatian currency",
    "mintage": 48061650,
    "mintageFormatted": "48,061,650",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_1euro_0.jpg",
    "image_key": "hr_regular_2023_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2023",
    "country": "Croatia",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 2 Euros (2023) - Geographical Map of Croatia",
    "subject": "Geographical Map of Croatia",
    "description": "Geographical map outline of the Republic of Croatia on a checkerboard background",
    "mintage": 79368450,
    "mintageFormatted": "79,368,450",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_2euro_0.jpg",
    "image_key": "hr_regular_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_croatia_2023_cc1",
    "country": "Croatia",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Croatia 2€ Commemorative (2023) - Introduction of the Euro",
    "subject": "Introduction of the Euro",
    "description": "Croatia 2 Euro Commemorative coin issued in 2023: Introduction of the Euro.",
    "mintage": 40000,
    "mintageFormatted": "40,000",
    "status": "circulating",
    "imagePath": "coins/hr_commemorative_2023_2euro_0.jpg",
    "image_key": "hr_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2024_1cent",
    "country": "Croatia",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 1 Cent (2024) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 1089506,
    "mintageFormatted": "1,089,506",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_1cent_0.jpg",
    "image_key": "hr_regular_2023_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2024_2cent",
    "country": "Croatia",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 2 Cents (2024) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 1088006,
    "mintageFormatted": "1,088,006",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_2cent_0.jpg",
    "image_key": "hr_regular_2023_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2024_5cent",
    "country": "Croatia",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 5 Cents (2024) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 13088006,
    "mintageFormatted": "13,088,006",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_5cent_0.jpg",
    "image_key": "hr_regular_2023_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2024_10cent",
    "country": "Croatia",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 10 Cents (2024) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 1048006,
    "mintageFormatted": "1,048,006",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_10cent_0.jpg",
    "image_key": "hr_regular_2023_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2024_20cent",
    "country": "Croatia",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 20 Cents (2024) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 4508006,
    "mintageFormatted": "4,508,006",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_20cent_0.jpg",
    "image_key": "hr_regular_2023_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2024_50cent",
    "country": "Croatia",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 50 Cents (2024) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 1028006,
    "mintageFormatted": "1,028,006",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_50cent_0.jpg",
    "image_key": "hr_regular_2023_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2024_1euro",
    "country": "Croatia",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 1 Euro (2024) - Pine Marten (Kuna)",
    "subject": "Pine Marten (Kuna)",
    "description": "Silhouette of a pine marten (kuna) standing on a branch, historic symbol of Croatian currency",
    "mintage": 1028006,
    "mintageFormatted": "1,028,006",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_1euro_0.jpg",
    "image_key": "hr_regular_2023_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2024",
    "country": "Croatia",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 2 Euros (2024) - Geographical Map of Croatia",
    "subject": "Geographical Map of Croatia",
    "description": "Geographical map outline of the Republic of Croatia on a checkerboard background",
    "mintage": 1008006,
    "mintageFormatted": "1,008,006",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_2euro_0.jpg",
    "image_key": "hr_regular_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_croatia_2024_cc1",
    "country": "Croatia",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Croatia 2€ Commemorative (2024) - Old Town of Varaždin",
    "subject": "Old Town of Varaždin",
    "description": "Croatia 2 Euro Commemorative coin issued in 2024: Old Town of Varaždin.",
    "mintage": 40000,
    "mintageFormatted": "40,000",
    "status": "circulating",
    "imagePath": "coins/hr_commemorative_2024_2euro_0.jpg",
    "image_key": "hr_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_croatia_2024_cc2",
    "country": "Croatia",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Croatia 2€ Commemorative (2024) - Marko Marulić",
    "subject": "Marko Marulić",
    "description": "Croatia 2 Euro Commemorative coin issued in 2024: Marko Marulić.",
    "mintage": 40000,
    "mintageFormatted": "40,000",
    "status": "circulating",
    "imagePath": "coins/hr_commemorative_2024_2euro_1.jpg",
    "image_key": "hr_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2025_1cent",
    "country": "Croatia",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 1 Cent (2025) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 14520000,
    "mintageFormatted": "14,520,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_1cent_0.jpg",
    "image_key": "hr_regular_2023_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2025_2cent",
    "country": "Croatia",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 2 Cents (2025) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 14460000,
    "mintageFormatted": "14,460,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_2cent_0.jpg",
    "image_key": "hr_regular_2023_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2025_5cent",
    "country": "Croatia",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 5 Cents (2025) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 15420000,
    "mintageFormatted": "15,420,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_5cent_0.jpg",
    "image_key": "hr_regular_2023_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2025_10cent",
    "country": "Croatia",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 10 Cents (2025) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 33840000,
    "mintageFormatted": "33,840,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_10cent_0.jpg",
    "image_key": "hr_regular_2023_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2025_20cent",
    "country": "Croatia",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 20 Cents (2025) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 28300000,
    "mintageFormatted": "28,300,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_20cent_0.jpg",
    "image_key": "hr_regular_2023_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2025_50cent",
    "country": "Croatia",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 50 Cents (2025) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_50cent_0.jpg",
    "image_key": "hr_regular_2023_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2025_1euro",
    "country": "Croatia",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 1 Euro (2025) - Pine Marten (Kuna)",
    "subject": "Pine Marten (Kuna)",
    "description": "Silhouette of a pine marten (kuna) standing on a branch, historic symbol of Croatian currency",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_1euro_0.jpg",
    "image_key": "hr_regular_2023_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2025",
    "country": "Croatia",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 2 Euros (2025) - Geographical Map of Croatia",
    "subject": "Geographical Map of Croatia",
    "description": "Geographical map outline of the Republic of Croatia on a checkerboard background",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_2euro_0.jpg",
    "image_key": "hr_regular_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_croatia_2025_cc1",
    "country": "Croatia",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Croatia 2€ Commemorative (2025) - Kingdom of Croatia and King Tomislav",
    "subject": "Kingdom of Croatia and King Tomislav",
    "description": "Croatia 2 Euro Commemorative coin issued in 2025: Kingdom of Croatia and King Tomislav.",
    "mintage": 40000,
    "mintageFormatted": "40,000",
    "status": "circulating",
    "imagePath": "coins/hr_commemorative_2025_2euro_0.jpg",
    "image_key": "hr_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_croatia_2025_cc2",
    "country": "Croatia",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Croatia 2€ Commemorative (2025) - City of Pula",
    "subject": "City of Pula",
    "description": "Croatia 2 Euro Commemorative coin issued in 2025: City of Pula.",
    "mintage": 40000,
    "mintageFormatted": "40,000",
    "status": "circulating",
    "imagePath": "coins/hr_commemorative_2025_2euro_1.jpg",
    "image_key": "hr_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2026_1cent",
    "country": "Croatia",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 1 Cent (2026) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 45000,
    "mintageFormatted": "45,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_1cent_0.jpg",
    "image_key": "hr_regular_2023_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2026_2cent",
    "country": "Croatia",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 2 Cents (2026) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 45000,
    "mintageFormatted": "45,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_2cent_0.jpg",
    "image_key": "hr_regular_2023_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2026_5cent",
    "country": "Croatia",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 5 Cents (2026) - Glagolitic Script (HR Ligature)",
    "subject": "Glagolitic Script (HR Ligature)",
    "description": "Angular Glagolitic script HR monogram with Croatian checkerboard background",
    "mintage": 45000,
    "mintageFormatted": "45,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_5cent_0.jpg",
    "image_key": "hr_regular_2023_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2026_10cent",
    "country": "Croatia",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 10 Cents (2026) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 45000,
    "mintageFormatted": "45,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_10cent_0.jpg",
    "image_key": "hr_regular_2023_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2026_20cent",
    "country": "Croatia",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 20 Cents (2026) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 45000,
    "mintageFormatted": "45,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_20cent_0.jpg",
    "image_key": "hr_regular_2023_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2026_50cent",
    "country": "Croatia",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 50 Cents (2026) - Nikola Tesla",
    "subject": "Nikola Tesla",
    "description": "Portrait of inventor Nikola Tesla against a checkerboard motif",
    "mintage": 45000,
    "mintageFormatted": "45,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_50cent_0.jpg",
    "image_key": "hr_regular_2023_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2026_1euro",
    "country": "Croatia",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 1 Euro (2026) - Pine Marten (Kuna)",
    "subject": "Pine Marten (Kuna)",
    "description": "Silhouette of a pine marten (kuna) standing on a branch, historic symbol of Croatian currency",
    "mintage": 45000,
    "mintageFormatted": "45,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_1euro_0.jpg",
    "image_key": "hr_regular_2023_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_croatia_2026",
    "country": "Croatia",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Croatia 2 Euros (2026) - Geographical Map of Croatia",
    "subject": "Geographical Map of Croatia",
    "description": "Geographical map outline of the Republic of Croatia on a checkerboard background",
    "mintage": 45000,
    "mintageFormatted": "45,000",
    "status": "circulating",
    "imagePath": "coins/hr_regular_2023_2euro_0.jpg",
    "image_key": "hr_regular_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_croatia_2026_cc1",
    "country": "Croatia",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Croatia 2€ Commemorative (2026) - Croatian Radio",
    "subject": "Croatian Radio",
    "description": "Croatia 2 Euro Commemorative coin issued in 2026: Croatian Radio.",
    "mintage": 190000,
    "mintageFormatted": "190,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_croatia_2026_cc2",
    "country": "Croatia",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Croatia 2€ Commemorative (2026) - City of Vukovar",
    "subject": "City of Vukovar",
    "description": "Croatia 2 Euro Commemorative coin issued in 2026: City of Vukovar.",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2008_1cent",
    "country": "Cyprus",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2008) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2008_2cent",
    "country": "Cyprus",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2008) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000000,
    "mintageFormatted": "100,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2008_5cent",
    "country": "Cyprus",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2008) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 60000000,
    "mintageFormatted": "60,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2008_10cent",
    "country": "Cyprus",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2008) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2008_20cent",
    "country": "Cyprus",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2008) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 65000000,
    "mintageFormatted": "65,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2008_50cent",
    "country": "Cyprus",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2008) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2008_1euro",
    "country": "Cyprus",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2008) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 28000000,
    "mintageFormatted": "28,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2008",
    "country": "Cyprus",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2008) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2009_1cent",
    "country": "Cyprus",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2009) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2009_2cent",
    "country": "Cyprus",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2009) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2009_5cent",
    "country": "Cyprus",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2009) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2009_10cent",
    "country": "Cyprus",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2009) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2009_20cent",
    "country": "Cyprus",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2009) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2009_50cent",
    "country": "Cyprus",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2009) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2009_1euro",
    "country": "Cyprus",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2009) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2009",
    "country": "Cyprus",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2009) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2009_cc-common",
    "country": "Cyprus",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Cyprus 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_commemorative_2009_2euro_0.jpg",
    "image_key": "cy_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_cyprus_2010_1cent",
    "country": "Cyprus",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2010) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2010_2cent",
    "country": "Cyprus",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2010) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2010_5cent",
    "country": "Cyprus",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2010) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2010_10cent",
    "country": "Cyprus",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2010) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2010_20cent",
    "country": "Cyprus",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2010) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2010_50cent",
    "country": "Cyprus",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2010) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2010_1euro",
    "country": "Cyprus",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2010) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2010",
    "country": "Cyprus",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2010) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2011_1cent",
    "country": "Cyprus",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2011) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 15200000,
    "mintageFormatted": "15,200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2011_2cent",
    "country": "Cyprus",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2011) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2011_5cent",
    "country": "Cyprus",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2011) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 30200000,
    "mintageFormatted": "30,200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2011_10cent",
    "country": "Cyprus",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2011) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2011_20cent",
    "country": "Cyprus",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2011) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2011_50cent",
    "country": "Cyprus",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2011) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2011_1euro",
    "country": "Cyprus",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2011) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2011",
    "country": "Cyprus",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2011) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2012_1cent",
    "country": "Cyprus",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2012) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 210000,
    "mintageFormatted": "210,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2012_2cent",
    "country": "Cyprus",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2012) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 210000,
    "mintageFormatted": "210,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2012_5cent",
    "country": "Cyprus",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2012) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2012_10cent",
    "country": "Cyprus",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2012) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2012_20cent",
    "country": "Cyprus",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2012) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2012_50cent",
    "country": "Cyprus",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2012) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2012_1euro",
    "country": "Cyprus",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2012) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2012",
    "country": "Cyprus",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2012) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2012_cc-common",
    "country": "Cyprus",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Cyprus 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 987000,
    "mintageFormatted": "987,000",
    "status": "circulating",
    "imagePath": "coins/cy_commemorative_2012_2euro_0.jpg",
    "image_key": "cy_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_cyprus_2013_1cent",
    "country": "Cyprus",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2013) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 90000,
    "mintageFormatted": "90,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2013_2cent",
    "country": "Cyprus",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2013) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 90000,
    "mintageFormatted": "90,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2013_5cent",
    "country": "Cyprus",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2013) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 90000,
    "mintageFormatted": "90,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2013_10cent",
    "country": "Cyprus",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2013) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 90000,
    "mintageFormatted": "90,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2013_20cent",
    "country": "Cyprus",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2013) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 90000,
    "mintageFormatted": "90,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2013_50cent",
    "country": "Cyprus",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2013) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 90000,
    "mintageFormatted": "90,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2013_1euro",
    "country": "Cyprus",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2013) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 90000,
    "mintageFormatted": "90,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2013",
    "country": "Cyprus",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2013) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 90000,
    "mintageFormatted": "90,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2014_1cent",
    "country": "Cyprus",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2014) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2014_2cent",
    "country": "Cyprus",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2014) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2014_5cent",
    "country": "Cyprus",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2014) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2014_10cent",
    "country": "Cyprus",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2014) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2014_20cent",
    "country": "Cyprus",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2014) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2014_50cent",
    "country": "Cyprus",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2014) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2014_1euro",
    "country": "Cyprus",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2014) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2014",
    "country": "Cyprus",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2014) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2015_1cent",
    "country": "Cyprus",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2015) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 7093000,
    "mintageFormatted": "7,093,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2015_2cent",
    "country": "Cyprus",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2015) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2015_5cent",
    "country": "Cyprus",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2015) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2015_10cent",
    "country": "Cyprus",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2015) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2015_20cent",
    "country": "Cyprus",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2015) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2015_50cent",
    "country": "Cyprus",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2015) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2015_1euro",
    "country": "Cyprus",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2015) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2015",
    "country": "Cyprus",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2015) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2015_cc-common",
    "country": "Cyprus",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Cyprus 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 336000,
    "mintageFormatted": "336,000",
    "status": "circulating",
    "imagePath": "coins/cy_commemorative_2015_2euro_0.jpg",
    "image_key": "cy_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_cyprus_2016_1cent",
    "country": "Cyprus",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2016) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2016_2cent",
    "country": "Cyprus",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2016) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2016_5cent",
    "country": "Cyprus",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2016) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2016_10cent",
    "country": "Cyprus",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2016) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2016_20cent",
    "country": "Cyprus",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2016) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2016_50cent",
    "country": "Cyprus",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2016) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2016_1euro",
    "country": "Cyprus",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2016) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2016",
    "country": "Cyprus",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2016) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 93000,
    "mintageFormatted": "93,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2017_1cent",
    "country": "Cyprus",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2017) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2017_2cent",
    "country": "Cyprus",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2017) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2017_5cent",
    "country": "Cyprus",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2017) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2017_10cent",
    "country": "Cyprus",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2017) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2017_20cent",
    "country": "Cyprus",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2017) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2017_50cent",
    "country": "Cyprus",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2017) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2017_1euro",
    "country": "Cyprus",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2017) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2017",
    "country": "Cyprus",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2017) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2017_cc1",
    "country": "Cyprus",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Cyprus 2€ Commemorative (2017) - Paphos 2017 - European Capital of Culture",
    "subject": "Paphos 2017 - European Capital of Culture",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2017: Paphos 2017 - European Capital of Culture.",
    "mintage": 418000,
    "mintageFormatted": "418,000",
    "status": "circulating",
    "imagePath": "coins/cy_commemorative_2017_2euro_0.jpg",
    "image_key": "cy_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2018_1cent",
    "country": "Cyprus",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2018) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 18095000,
    "mintageFormatted": "18,095,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2018_2cent",
    "country": "Cyprus",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2018) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2018_5cent",
    "country": "Cyprus",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2018) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 14095000,
    "mintageFormatted": "14,095,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2018_10cent",
    "country": "Cyprus",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2018) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2018_20cent",
    "country": "Cyprus",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2018) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2018_50cent",
    "country": "Cyprus",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2018) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2018_1euro",
    "country": "Cyprus",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2018) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2018",
    "country": "Cyprus",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2018) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 7095000,
    "mintageFormatted": "7,095,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2019_1cent",
    "country": "Cyprus",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2019) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 11095000,
    "mintageFormatted": "11,095,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2019_2cent",
    "country": "Cyprus",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2019) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 9095000,
    "mintageFormatted": "9,095,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2019_5cent",
    "country": "Cyprus",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2019) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 8095000,
    "mintageFormatted": "8,095,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2019_10cent",
    "country": "Cyprus",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2019) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 5595000,
    "mintageFormatted": "5,595,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2019_20cent",
    "country": "Cyprus",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2019) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 6095000,
    "mintageFormatted": "6,095,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2019_50cent",
    "country": "Cyprus",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2019) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1395000,
    "mintageFormatted": "1,395,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2019_1euro",
    "country": "Cyprus",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2019) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2019",
    "country": "Cyprus",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2019) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 1395000,
    "mintageFormatted": "1,395,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2020_1cent",
    "country": "Cyprus",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2020) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2020_2cent",
    "country": "Cyprus",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2020) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 8400000,
    "mintageFormatted": "8,400,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2020_5cent",
    "country": "Cyprus",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2020) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 7500000,
    "mintageFormatted": "7,500,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2020_10cent",
    "country": "Cyprus",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2020) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1700000,
    "mintageFormatted": "1,700,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2020_20cent",
    "country": "Cyprus",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2020) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 4300000,
    "mintageFormatted": "4,300,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2020_50cent",
    "country": "Cyprus",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2020) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2020_1euro",
    "country": "Cyprus",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2020) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2020",
    "country": "Cyprus",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2020) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 3300000,
    "mintageFormatted": "3,300,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2020_cc1",
    "country": "Cyprus",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Cyprus 2€ Commemorative (2020) - Cyprus Institute of Neurology and genetics",
    "subject": "Cyprus Institute of Neurology and genetics",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2020: Cyprus Institute of Neurology and genetics.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/cy_commemorative_2020_2euro_0.jpg",
    "image_key": "cy_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2021_1cent",
    "country": "Cyprus",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2021) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 9150000,
    "mintageFormatted": "9,150,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2021_2cent",
    "country": "Cyprus",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2021) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 12600000,
    "mintageFormatted": "12,600,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2021_5cent",
    "country": "Cyprus",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2021) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 7950000,
    "mintageFormatted": "7,950,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2021_10cent",
    "country": "Cyprus",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2021) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 4440000,
    "mintageFormatted": "4,440,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2021_20cent",
    "country": "Cyprus",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2021) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 4800000,
    "mintageFormatted": "4,800,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2021_50cent",
    "country": "Cyprus",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2021) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1920000,
    "mintageFormatted": "1,920,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2021_1euro",
    "country": "Cyprus",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2021) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 1575000,
    "mintageFormatted": "1,575,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2021",
    "country": "Cyprus",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2021) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2022_1cent",
    "country": "Cyprus",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2022) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 9905000,
    "mintageFormatted": "9,905,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2022_2cent",
    "country": "Cyprus",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2022) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 9755000,
    "mintageFormatted": "9,755,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2022_5cent",
    "country": "Cyprus",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2022) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 8855000,
    "mintageFormatted": "8,855,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2022_10cent",
    "country": "Cyprus",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2022) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 4805000,
    "mintageFormatted": "4,805,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2022_20cent",
    "country": "Cyprus",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2022) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 5165000,
    "mintageFormatted": "5,165,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2022_50cent",
    "country": "Cyprus",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2022) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 1925000,
    "mintageFormatted": "1,925,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2022_1euro",
    "country": "Cyprus",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2022) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 1730000,
    "mintageFormatted": "1,730,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2022",
    "country": "Cyprus",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2022) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 3755000,
    "mintageFormatted": "3,755,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2022_cc-common",
    "country": "Cyprus",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Cyprus 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/cy_commemorative_2022_2euro_0.jpg",
    "image_key": "cy_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_cyprus_2023_1cent",
    "country": "Cyprus",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2023) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2023_2cent",
    "country": "Cyprus",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2023) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2023_5cent",
    "country": "Cyprus",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2023) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2023_10cent",
    "country": "Cyprus",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2023) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 250000,
    "mintageFormatted": "250,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2023_20cent",
    "country": "Cyprus",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2023) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 250000,
    "mintageFormatted": "250,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2023_50cent",
    "country": "Cyprus",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2023) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 105000,
    "mintageFormatted": "105,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2023_1euro",
    "country": "Cyprus",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2023) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 105000,
    "mintageFormatted": "105,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2023",
    "country": "Cyprus",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2023) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 468000,
    "mintageFormatted": "468,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2023_cc1",
    "country": "Cyprus",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Cyprus 2€ Commemorative (2023) - Central Bank of Cyprus",
    "subject": "Central Bank of Cyprus",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2023: Central Bank of Cyprus.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/cy_commemorative_2023_2euro_0.jpg",
    "image_key": "cy_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2024_1cent",
    "country": "Cyprus",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2024) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2024_2cent",
    "country": "Cyprus",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2024) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2024_5cent",
    "country": "Cyprus",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2024) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2024_10cent",
    "country": "Cyprus",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2024) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2024_20cent",
    "country": "Cyprus",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2024) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2024_50cent",
    "country": "Cyprus",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2024) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2024_1euro",
    "country": "Cyprus",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2024) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2024",
    "country": "Cyprus",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2024) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2024_cc1",
    "country": "Cyprus",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Cyprus 2€ Commemorative (2024) - 20th Anniversary of Cypriot Entry into EU",
    "subject": "20th Anniversary of Cypriot Entry into EU",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2024: 20th Anniversary of Cypriot Entry into EU.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/cy_commemorative_2024_2euro_0.jpg",
    "image_key": "cy_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2025_1cent",
    "country": "Cyprus",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2025) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2025_2cent",
    "country": "Cyprus",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2025) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2025_5cent",
    "country": "Cyprus",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2025) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2025_10cent",
    "country": "Cyprus",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2025) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2025_20cent",
    "country": "Cyprus",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2025) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2025_50cent",
    "country": "Cyprus",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2025) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2025_1euro",
    "country": "Cyprus",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2025) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2025",
    "country": "Cyprus",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2025) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2026_1cent",
    "country": "Cyprus",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Cent (2026) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1cent_0.jpg",
    "image_key": "cy_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2026_2cent",
    "country": "Cyprus",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Cents (2026) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2cent_0.jpg",
    "image_key": "cy_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2026_5cent",
    "country": "Cyprus",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 5 Cents (2026) - Cypriot Mouflon",
    "subject": "Cypriot Mouflon",
    "description": "Wild sheep species native to Cyprus (Ovis gmelini ophion)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_5cent_0.jpg",
    "image_key": "cy_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2026_10cent",
    "country": "Cyprus",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 10 Cents (2026) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_10cent_0.jpg",
    "image_key": "cy_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2026_20cent",
    "country": "Cyprus",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 20 Cents (2026) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_20cent_0.jpg",
    "image_key": "cy_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2026_50cent",
    "country": "Cyprus",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 50 Cents (2026) - Kyrenia Ship",
    "subject": "Kyrenia Ship",
    "description": "Ancient 4th-century BC Greek merchant ship discovered off Kyrenia",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_50cent_0.jpg",
    "image_key": "cy_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2026_1euro",
    "country": "Cyprus",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 1 Euro (2026) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_1euro_0.jpg",
    "image_key": "cy_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_cyprus_2026",
    "country": "Cyprus",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Cyprus 2 Euros (2026) - Idol of Pomos",
    "subject": "Idol of Pomos",
    "description": "Chalcolithic cross-shaped anthropomorphic figurine from Pomos (~3000 BC)",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/cy_regular_2008_2euro_0.jpg",
    "image_key": "cy_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_cyprus_2026_cc1",
    "country": "Cyprus",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Cyprus 2€ Commemorative (2026) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Cyprus 2 Euro Commemorative coin issued in 2026: Presidency of the EU Council.",
    "mintage": 250000,
    "mintageFormatted": "250,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2011_1cent",
    "country": "Estonia",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Cent (2011) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 31951500,
    "mintageFormatted": "31,951,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1cent_0.jpg",
    "image_key": "ee_regular_2011_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2011_2cent",
    "country": "Estonia",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Cents (2011) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 29951500,
    "mintageFormatted": "29,951,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2011_5cent",
    "country": "Estonia",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 5 Cents (2011) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 29951500,
    "mintageFormatted": "29,951,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_5cent_0.jpg",
    "image_key": "ee_regular_2011_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2011_10cent",
    "country": "Estonia",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 10 Cents (2011) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 29951500,
    "mintageFormatted": "29,951,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_10cent_0.jpg",
    "image_key": "ee_regular_2011_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2011_20cent",
    "country": "Estonia",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 20 Cents (2011) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 24951500,
    "mintageFormatted": "24,951,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_20cent_0.jpg",
    "image_key": "ee_regular_2011_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2011_50cent",
    "country": "Estonia",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 50 Cents (2011) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 19951500,
    "mintageFormatted": "19,951,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_50cent_0.jpg",
    "image_key": "ee_regular_2011_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2011_1euro",
    "country": "Estonia",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Euro (2011) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 15951500,
    "mintageFormatted": "15,951,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1euro_0.jpg",
    "image_key": "ee_regular_2011_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2011",
    "country": "Estonia",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Euros (2011) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 10951500,
    "mintageFormatted": "10,951,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2euro_0.jpg",
    "image_key": "ee_regular_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2012_1cent",
    "country": "Estonia",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Cent (2012) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1cent_0.jpg",
    "image_key": "ee_regular_2011_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2012_2cent",
    "country": "Estonia",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Cents (2012) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2012_cc-common",
    "country": "Estonia",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Estonia 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2012_2euro_0.jpg",
    "image_key": "ee_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_estonia_2015_1cent",
    "country": "Estonia",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Cent (2015) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 14000000,
    "mintageFormatted": "14,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1cent_0.jpg",
    "image_key": "ee_regular_2011_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2015_2cent",
    "country": "Estonia",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Cents (2015) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 17100000,
    "mintageFormatted": "17,100,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2015_cc-common",
    "country": "Estonia",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Estonia 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 346500,
    "mintageFormatted": "346,500",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2015_2euro_0.jpg",
    "image_key": "ee_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_estonia_2016_1cent",
    "country": "Estonia",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 1 Cent (2016) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_1cent_0.jpg",
    "image_key": "ee_regular_2011_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2016_2cent",
    "country": "Estonia",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 2 Cents (2016) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2016_5cent",
    "country": "Estonia",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 5 Cents (2016) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_5cent_0.jpg",
    "image_key": "ee_regular_2011_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2016_10cent",
    "country": "Estonia",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 10 Cents (2016) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_10cent_0.jpg",
    "image_key": "ee_regular_2011_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2016_20cent",
    "country": "Estonia",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 20 Cents (2016) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_20cent_0.jpg",
    "image_key": "ee_regular_2011_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2016_50cent",
    "country": "Estonia",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 50 Cents (2016) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_50cent_0.jpg",
    "image_key": "ee_regular_2011_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2016_1euro",
    "country": "Estonia",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 1 Euro (2016) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_1euro_0.jpg",
    "image_key": "ee_regular_2011_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2016",
    "country": "Estonia",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 2 Euros (2016) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_2euro_0.jpg",
    "image_key": "ee_regular_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2016_cc1",
    "country": "Estonia",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2016) - Paul Keres",
    "subject": "Paul Keres",
    "description": "Estonia 2 Euro Commemorative coin issued in 2016: Paul Keres.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2016_2euro_0.jpg",
    "image_key": "ee_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2017_1cent",
    "country": "Estonia",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Cent (2017) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 29000000,
    "mintageFormatted": "29,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1cent_0.jpg",
    "image_key": "ee_regular_2011_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2017_2cent",
    "country": "Estonia",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Cents (2017) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2017_5cent",
    "country": "Estonia",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 5 Cents (2017) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 4550000,
    "mintageFormatted": "4,550,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_5cent_0.jpg",
    "image_key": "ee_regular_2011_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2017_20cent",
    "country": "Estonia",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 20 Cents (2017) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 3250000,
    "mintageFormatted": "3,250,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_20cent_0.jpg",
    "image_key": "ee_regular_2011_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2017_cc1",
    "country": "Estonia",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2017) - Estonia's Road to Independence",
    "subject": "Estonia's Road to Independence",
    "description": "Estonia 2 Euro Commemorative coin issued in 2017: Estonia's Road to Independence.",
    "mintage": 1490000,
    "mintageFormatted": "1,490,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2017_2euro_0.jpg",
    "image_key": "ee_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2018_1cent",
    "country": "Estonia",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Cent (2018) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1cent_0.jpg",
    "image_key": "ee_regular_2011_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2018_2cent",
    "country": "Estonia",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Cents (2018) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 8495000,
    "mintageFormatted": "8,495,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2018_5cent",
    "country": "Estonia",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 5 Cents (2018) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 4495000,
    "mintageFormatted": "4,495,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_5cent_0.jpg",
    "image_key": "ee_regular_2011_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2018_10cent",
    "country": "Estonia",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 10 Cents (2018) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_10cent_0.jpg",
    "image_key": "ee_regular_2011_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2018_20cent",
    "country": "Estonia",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 20 Cents (2018) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 3995000,
    "mintageFormatted": "3,995,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_20cent_0.jpg",
    "image_key": "ee_regular_2011_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2018_50cent",
    "country": "Estonia",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 50 Cents (2018) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_50cent_0.jpg",
    "image_key": "ee_regular_2011_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2018_1euro",
    "country": "Estonia",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Euro (2018) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1euro_0.jpg",
    "image_key": "ee_regular_2011_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2018",
    "country": "Estonia",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Euros (2018) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2euro_0.jpg",
    "image_key": "ee_regular_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2018_cc1",
    "country": "Estonia",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2018) - Independence of the Baltic States",
    "subject": "Independence of the Baltic States",
    "description": "Estonia 2 Euro Commemorative coin issued in 2018: Independence of the Baltic States.",
    "mintage": 485000,
    "mintageFormatted": "485,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2018_2euro_1.jpg",
    "image_key": "ee_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2018_cc2",
    "country": "Estonia",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2018) - Independence of Estonia",
    "subject": "Independence of Estonia",
    "description": "Estonia 2 Euro Commemorative coin issued in 2018: Independence of Estonia.",
    "mintage": 1302800,
    "mintageFormatted": "1,302,800",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2018_2euro_0.jpg",
    "image_key": "ee_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2019_1cent",
    "country": "Estonia",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Cent (2019) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1cent_0.jpg",
    "image_key": "ee_regular_2011_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2019_cc1",
    "country": "Estonia",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2019) - Estonian Song Festival",
    "subject": "Estonian Song Festival",
    "description": "Estonia 2 Euro Commemorative coin issued in 2019: Estonian Song Festival.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2019_2euro_1.jpg",
    "image_key": "ee_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2019_cc2",
    "country": "Estonia",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2019) - University of Tartu",
    "subject": "University of Tartu",
    "description": "Estonia 2 Euro Commemorative coin issued in 2019: University of Tartu.",
    "mintage": 982500,
    "mintageFormatted": "982,500",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2019_2euro_0.jpg",
    "image_key": "ee_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2020_2cent",
    "country": "Estonia",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Cents (2020) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2020_20cent",
    "country": "Estonia",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 20 Cents (2020) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_20cent_0.jpg",
    "image_key": "ee_regular_2011_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2020_cc1",
    "country": "Estonia",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2020) - Discovery of Antarctica",
    "subject": "Discovery of Antarctica",
    "description": "Estonia 2 Euro Commemorative coin issued in 2020: Discovery of Antarctica.",
    "mintage": 740000,
    "mintageFormatted": "740,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2020_2euro_0.jpg",
    "image_key": "ee_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2020_cc2",
    "country": "Estonia",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2020) - Tartu Peace Treaty",
    "subject": "Tartu Peace Treaty",
    "description": "Estonia 2 Euro Commemorative coin issued in 2020: Tartu Peace Treaty.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2020_2euro_1.jpg",
    "image_key": "ee_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2021_2cent",
    "country": "Estonia",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Cents (2021) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2021_20cent",
    "country": "Estonia",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 20 Cents (2021) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_20cent_0.jpg",
    "image_key": "ee_regular_2011_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2021_cc1",
    "country": "Estonia",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2021) - Finno-Ugric People",
    "subject": "Finno-Ugric People",
    "description": "Estonia 2 Euro Commemorative coin issued in 2021: Finno-Ugric People.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2021_2euro_1.jpg",
    "image_key": "ee_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2021_cc2",
    "country": "Estonia",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2021) - The Wolf",
    "subject": "The Wolf",
    "description": "Estonia 2 Euro Commemorative coin issued in 2021: The Wolf.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2021_2euro_0.jpg",
    "image_key": "ee_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2022_1cent",
    "country": "Estonia",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 1 Cent (2022) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 9992500,
    "mintageFormatted": "9,992,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_1cent_0.jpg",
    "image_key": "ee_regular_2011_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2022_2cent",
    "country": "Estonia",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Cents (2022) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 9992500,
    "mintageFormatted": "9,992,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2cent_0.jpg",
    "image_key": "ee_regular_2011_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2022_5cent",
    "country": "Estonia",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 5 Cents (2022) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 4192500,
    "mintageFormatted": "4,192,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_5cent_0.jpg",
    "image_key": "ee_regular_2011_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2022_10cent",
    "country": "Estonia",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 10 Cents (2022) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 2792500,
    "mintageFormatted": "2,792,500",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_10cent_0.jpg",
    "image_key": "ee_regular_2011_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2022_20cent",
    "country": "Estonia",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 20 Cents (2022) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_20cent_0.jpg",
    "image_key": "ee_regular_2011_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2022_50cent",
    "country": "Estonia",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 50 Cents (2022) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_50cent_0.jpg",
    "image_key": "ee_regular_2011_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2022_1euro",
    "country": "Estonia",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 1 Euro (2022) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_1euro_0.jpg",
    "image_key": "ee_regular_2011_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2022",
    "country": "Estonia",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Estonia 2 Euros (2022) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ee_regular_2011_2euro_0.jpg",
    "image_key": "ee_regular_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2022_cc1",
    "country": "Estonia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2022) - Society of Estonian Literati",
    "subject": "Society of Estonian Literati",
    "description": "Estonia 2 Euro Commemorative coin issued in 2022: Society of Estonian Literati.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2022_2euro_0.jpg",
    "image_key": "ee_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2022_cc2",
    "country": "Estonia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2022) - Ukraine and freedom",
    "subject": "Ukraine and freedom",
    "description": "Estonia 2 Euro Commemorative coin issued in 2022: Ukraine and freedom.",
    "mintage": 1960000,
    "mintageFormatted": "1,960,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2022_2euro_1.jpg",
    "image_key": "ee_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2022_cc-common",
    "country": "Estonia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Estonia 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 988000,
    "mintageFormatted": "988,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2022_2euro_2.jpg",
    "image_key": "ee_commemorative_2022_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_estonia_2023_5cent",
    "country": "Estonia",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 5 Cents (2023) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 5600000,
    "mintageFormatted": "5,600,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_5cent_0.jpg",
    "image_key": "ee_regular_2011_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2023_10cent",
    "country": "Estonia",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 10 Cents (2023) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_10cent_0.jpg",
    "image_key": "ee_regular_2011_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2023_20cent",
    "country": "Estonia",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 20 Cents (2023) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 4890000,
    "mintageFormatted": "4,890,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_20cent_0.jpg",
    "image_key": "ee_regular_2011_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_estonia_2023",
    "country": "Estonia",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Estonia 2 Euros (2023) - Map of Estonia",
    "subject": "Map of Estonia",
    "description": "Incused geographical map outline of Estonia",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ee_regular_2011_2euro_0.jpg",
    "image_key": "ee_regular_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2023_cc1",
    "country": "Estonia",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2023) - Barn Swallow",
    "subject": "Barn Swallow",
    "description": "Estonia 2 Euro Commemorative coin issued in 2023: Barn Swallow.",
    "mintage": 988000,
    "mintageFormatted": "988,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2023_2euro_0.jpg",
    "image_key": "ee_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2024_cc1",
    "country": "Estonia",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2024) - The Cornflower",
    "subject": "The Cornflower",
    "description": "Estonia 2 Euro Commemorative coin issued in 2024: The Cornflower.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2024_2euro_0.jpg",
    "image_key": "ee_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2025_cc1",
    "country": "Estonia",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2025) - First Text in Estonian",
    "subject": "First Text in Estonian",
    "description": "Estonia 2 Euro Commemorative coin issued in 2025: First Text in Estonian.",
    "mintage": 841500,
    "mintageFormatted": "841,500",
    "status": "circulating",
    "imagePath": "coins/ee_commemorative_2025_2euro_0.jpg",
    "image_key": "ee_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_estonia_2026_cc1",
    "country": "Estonia",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Estonia 2€ Commemorative (2026) - Sipsik",
    "subject": "Sipsik",
    "description": "Estonia 2 Euro Commemorative coin issued in 2026: Sipsik.",
    "mintage": 983000,
    "mintageFormatted": "983,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_1999_1cent",
    "country": "Finland",
    "year": 1999,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (1999) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 8017000,
    "mintageFormatted": "8,017,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_1999_2cent",
    "country": "Finland",
    "year": 1999,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (1999) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1702000,
    "mintageFormatted": "1,702,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_1999_5cent",
    "country": "Finland",
    "year": 1999,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (1999) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 63297000,
    "mintageFormatted": "63,297,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_1999_10cent",
    "country": "Finland",
    "year": 1999,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (1999) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 133437000,
    "mintageFormatted": "133,437,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_1999_20cent",
    "country": "Finland",
    "year": 1999,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (1999) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 42267000,
    "mintageFormatted": "42,267,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_1999_50cent",
    "country": "Finland",
    "year": 1999,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (1999) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 20613000,
    "mintageFormatted": "20,613,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_1999_1euro",
    "country": "Finland",
    "year": 1999,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (1999) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 16127000,
    "mintageFormatted": "16,127,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_1999",
    "country": "Finland",
    "year": 1999,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (1999) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 16007000,
    "mintageFormatted": "16,007,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2000_1cent",
    "country": "Finland",
    "year": 2000,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2000) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 7517000,
    "mintageFormatted": "7,517,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2000_2cent",
    "country": "Finland",
    "year": 2000,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2000) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 13854000,
    "mintageFormatted": "13,854,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2000_5cent",
    "country": "Finland",
    "year": 2000,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2000) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 56577000,
    "mintageFormatted": "56,577,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2000_10cent",
    "country": "Finland",
    "year": 2000,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2000) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 167366000,
    "mintageFormatted": "167,366,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2000_20cent",
    "country": "Finland",
    "year": 2000,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2000) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 417000,
    "mintageFormatted": "417,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2000_50cent",
    "country": "Finland",
    "year": 2000,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2000) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 67014000,
    "mintageFormatted": "67,014,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2000_1euro",
    "country": "Finland",
    "year": 2000,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2000) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 36556000,
    "mintageFormatted": "36,556,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2000",
    "country": "Finland",
    "year": 2000,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2000) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 8597000,
    "mintageFormatted": "8,597,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2001_1cent",
    "country": "Finland",
    "year": 2001,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2001) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 417000,
    "mintageFormatted": "417,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2001_2cent",
    "country": "Finland",
    "year": 2001,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2001) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 417000,
    "mintageFormatted": "417,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2001_5cent",
    "country": "Finland",
    "year": 2001,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2001) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 213673000,
    "mintageFormatted": "213,673,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2001_10cent",
    "country": "Finland",
    "year": 2001,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2001) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 14647000,
    "mintageFormatted": "14,647,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2001_20cent",
    "country": "Finland",
    "year": 2001,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2001) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 121680000,
    "mintageFormatted": "121,680,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2001_50cent",
    "country": "Finland",
    "year": 2001,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2001) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 4349000,
    "mintageFormatted": "4,349,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2001_1euro",
    "country": "Finland",
    "year": 2001,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2001) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 13779000,
    "mintageFormatted": "13,779,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2001",
    "country": "Finland",
    "year": 2001,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2001) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 29049000,
    "mintageFormatted": "29,049,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2002_1cent",
    "country": "Finland",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2002) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 513000,
    "mintageFormatted": "513,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2002_2cent",
    "country": "Finland",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2002) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 513000,
    "mintageFormatted": "513,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2002_5cent",
    "country": "Finland",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2002) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 101678000,
    "mintageFormatted": "101,678,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2002_10cent",
    "country": "Finland",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2002) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1353000,
    "mintageFormatted": "1,353,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2002_20cent",
    "country": "Finland",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2002) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 100613000,
    "mintageFormatted": "100,613,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2002_50cent",
    "country": "Finland",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2002) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1001000,
    "mintageFormatted": "1,001,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2002_1euro",
    "country": "Finland",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2002) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 13968000,
    "mintageFormatted": "13,968,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2002",
    "country": "Finland",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2002) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 1240000,
    "mintageFormatted": "1,240,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2003_1cent",
    "country": "Finland",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2003) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 6543500,
    "mintageFormatted": "6,543,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2003_2cent",
    "country": "Finland",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2003) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 6543500,
    "mintageFormatted": "6,543,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2003_5cent",
    "country": "Finland",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2003) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 543500,
    "mintageFormatted": "543,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2003_10cent",
    "country": "Finland",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2003) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 543500,
    "mintageFormatted": "543,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2003_20cent",
    "country": "Finland",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2003) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 543500,
    "mintageFormatted": "543,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2003_50cent",
    "country": "Finland",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2003) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 543500,
    "mintageFormatted": "543,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2003_1euro",
    "country": "Finland",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2003) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 543500,
    "mintageFormatted": "543,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2003",
    "country": "Finland",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2003) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 8833500,
    "mintageFormatted": "8,833,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2004_1cent",
    "country": "Finland",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2004) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 9567000,
    "mintageFormatted": "9,567,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2004_2cent",
    "country": "Finland",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2004) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 7901000,
    "mintageFormatted": "7,901,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2004_5cent",
    "country": "Finland",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2004) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 506000,
    "mintageFormatted": "506,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2004_10cent",
    "country": "Finland",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2004) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 506000,
    "mintageFormatted": "506,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2004_20cent",
    "country": "Finland",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2004) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 506000,
    "mintageFormatted": "506,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2004_50cent",
    "country": "Finland",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2004) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 506000,
    "mintageFormatted": "506,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2004_1euro",
    "country": "Finland",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2004) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 5406000,
    "mintageFormatted": "5,406,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2004",
    "country": "Finland",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2004) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 8960000,
    "mintageFormatted": "8,960,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2004_cc1",
    "country": "Finland",
    "year": 2004,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2004) - Enlargement of the European Union",
    "subject": "Enlargement of the European Union",
    "description": "Finland 2 Euro Commemorative coin issued in 2004: Enlargement of the European Union.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2004_2euro_0.jpg",
    "image_key": "fi_commemorative_2004_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2005_1cent",
    "country": "Finland",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2005) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 5719500,
    "mintageFormatted": "5,719,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2005_2cent",
    "country": "Finland",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2005) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 5719500,
    "mintageFormatted": "5,719,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2005_5cent",
    "country": "Finland",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2005) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 719500,
    "mintageFormatted": "719,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2005_10cent",
    "country": "Finland",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2005) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 719500,
    "mintageFormatted": "719,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2005_20cent",
    "country": "Finland",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2005) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 719500,
    "mintageFormatted": "719,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2005_50cent",
    "country": "Finland",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2005) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 4719500,
    "mintageFormatted": "4,719,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2005_1euro",
    "country": "Finland",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2005) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 7854500,
    "mintageFormatted": "7,854,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2005",
    "country": "Finland",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2005) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 8719500,
    "mintageFormatted": "8,719,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2005_cc1",
    "country": "Finland",
    "year": 2005,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2005) - United Nations + FI Admission into UN",
    "subject": "United Nations + FI Admission into UN",
    "description": "Finland 2 Euro Commemorative coin issued in 2005: United Nations + FI Admission into UN.",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2005_2euro_0.jpg",
    "image_key": "fi_commemorative_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2006_1cent",
    "country": "Finland",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2006) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 3924400,
    "mintageFormatted": "3,924,400",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2006_2cent",
    "country": "Finland",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2006) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 3924400,
    "mintageFormatted": "3,924,400",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2006_5cent",
    "country": "Finland",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2006) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 924400,
    "mintageFormatted": "924,400",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2006_10cent",
    "country": "Finland",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2006) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 924400,
    "mintageFormatted": "924,400",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2006_20cent",
    "country": "Finland",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2006) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 924400,
    "mintageFormatted": "924,400",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2006_50cent",
    "country": "Finland",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2006) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 6774400,
    "mintageFormatted": "6,774,400",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2006_1euro",
    "country": "Finland",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2006) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 1629400,
    "mintageFormatted": "1,629,400",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2006",
    "country": "Finland",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2006) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 8369400,
    "mintageFormatted": "8,369,400",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2006_cc1",
    "country": "Finland",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2006) - Universal Suffrage",
    "subject": "Universal Suffrage",
    "description": "Finland 2 Euro Commemorative coin issued in 2006: Universal Suffrage.",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2006_2euro_0.jpg",
    "image_key": "fi_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2007_1cent",
    "country": "Finland",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2007) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 2917000,
    "mintageFormatted": "2,917,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2007_2cent",
    "country": "Finland",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2007) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 2917000,
    "mintageFormatted": "2,917,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2007_5cent",
    "country": "Finland",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2007) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 917000,
    "mintageFormatted": "917,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2007_10cent",
    "country": "Finland",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2007) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 917000,
    "mintageFormatted": "917,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2007_20cent",
    "country": "Finland",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2007) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 917000,
    "mintageFormatted": "917,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2007_50cent",
    "country": "Finland",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2007) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 917000,
    "mintageFormatted": "917,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2007_1euro",
    "country": "Finland",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2007) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 917000,
    "mintageFormatted": "917,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2007",
    "country": "Finland",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2007) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 5137000,
    "mintageFormatted": "5,137,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2007_cc1",
    "country": "Finland",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2007) - Finnish Independence (90th Ann.)",
    "subject": "Finnish Independence (90th Ann.)",
    "description": "Finland 2 Euro Commemorative coin issued in 2007: Finnish Independence (90th Ann.).",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2007_2euro_0.jpg",
    "image_key": "fi_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2007_cc-common",
    "country": "Finland",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Finland 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 1400000,
    "mintageFormatted": "1,400,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2007_2euro_1.jpg",
    "image_key": "fi_commemorative_2007_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_finland_2008_1cent",
    "country": "Finland",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2008) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1436500,
    "mintageFormatted": "1,436,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2008_2cent",
    "country": "Finland",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2008) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1436500,
    "mintageFormatted": "1,436,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2008_5cent",
    "country": "Finland",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2008) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2008_10cent",
    "country": "Finland",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2008) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2008_20cent",
    "country": "Finland",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2008) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2008_50cent",
    "country": "Finland",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2008) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 7936500,
    "mintageFormatted": "7,936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2008_1euro",
    "country": "Finland",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2008) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2008",
    "country": "Finland",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2008) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 8236500,
    "mintageFormatted": "8,236,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2008_cc1",
    "country": "Finland",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2008) - Universal Declaration of Human Rights",
    "subject": "Universal Declaration of Human Rights",
    "description": "Finland 2 Euro Commemorative coin issued in 2008: Universal Declaration of Human Rights.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2008_2euro_0.jpg",
    "image_key": "fi_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2009_1cent",
    "country": "Finland",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2009) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2009_2cent",
    "country": "Finland",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2009) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2009_5cent",
    "country": "Finland",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2009) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2009_10cent",
    "country": "Finland",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2009) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2009_20cent",
    "country": "Finland",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2009) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2009_50cent",
    "country": "Finland",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2009) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 6936500,
    "mintageFormatted": "6,936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2009_1euro",
    "country": "Finland",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2009) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 936500,
    "mintageFormatted": "936,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2009",
    "country": "Finland",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2009) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 6256500,
    "mintageFormatted": "6,256,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2009_cc1",
    "country": "Finland",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2009) - Finnish Autonomy and Diet of Porvoo",
    "subject": "Finnish Autonomy and Diet of Porvoo",
    "description": "Finland 2 Euro Commemorative coin issued in 2009: Finnish Autonomy and Diet of Porvoo.",
    "mintage": 1600000,
    "mintageFormatted": "1,600,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2009_2euro_0.jpg",
    "image_key": "fi_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2009_cc-common",
    "country": "Finland",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Finland 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 1400000,
    "mintageFormatted": "1,400,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2009_2euro_1.jpg",
    "image_key": "fi_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_finland_2010_1cent",
    "country": "Finland",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2010) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 728000,
    "mintageFormatted": "728,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2010_2cent",
    "country": "Finland",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2010) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 728000,
    "mintageFormatted": "728,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2010_5cent",
    "country": "Finland",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2010) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 728000,
    "mintageFormatted": "728,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2010_10cent",
    "country": "Finland",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2010) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 738000,
    "mintageFormatted": "738,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2010_20cent",
    "country": "Finland",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2010) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 738000,
    "mintageFormatted": "738,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2010_50cent",
    "country": "Finland",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2010) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 738000,
    "mintageFormatted": "738,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2010_1euro",
    "country": "Finland",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2010) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 738000,
    "mintageFormatted": "738,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2010",
    "country": "Finland",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2010) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 3938000,
    "mintageFormatted": "3,938,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2010_cc1",
    "country": "Finland",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2010) - Currency Decree of 1860",
    "subject": "Currency Decree of 1860",
    "description": "Finland 2 Euro Commemorative coin issued in 2010: Currency Decree of 1860.",
    "mintage": 1600000,
    "mintageFormatted": "1,600,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2010_2euro_0.jpg",
    "image_key": "fi_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2011_1cent",
    "country": "Finland",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2011) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 745000,
    "mintageFormatted": "745,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2011_2cent",
    "country": "Finland",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2011) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 745000,
    "mintageFormatted": "745,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2011_5cent",
    "country": "Finland",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2011) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 745000,
    "mintageFormatted": "745,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2011_10cent",
    "country": "Finland",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2011) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 755000,
    "mintageFormatted": "755,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2011_20cent",
    "country": "Finland",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2011) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 8755000,
    "mintageFormatted": "8,755,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2011_50cent",
    "country": "Finland",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2011) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 3755000,
    "mintageFormatted": "3,755,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2011_1euro",
    "country": "Finland",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2011) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 755000,
    "mintageFormatted": "755,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2011",
    "country": "Finland",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2011) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 5155000,
    "mintageFormatted": "5,155,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2011_cc1",
    "country": "Finland",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2011) - Finland National Bank",
    "subject": "Finland National Bank",
    "description": "Finland 2 Euro Commemorative coin issued in 2011: Finland National Bank.",
    "mintage": 1600000,
    "mintageFormatted": "1,600,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2011_2euro_0.jpg",
    "image_key": "fi_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2012_1cent",
    "country": "Finland",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2012) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 724500,
    "mintageFormatted": "724,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2012_2cent",
    "country": "Finland",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2012) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 724500,
    "mintageFormatted": "724,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2012_5cent",
    "country": "Finland",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2012) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 724500,
    "mintageFormatted": "724,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2012_10cent",
    "country": "Finland",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2012) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 10724500,
    "mintageFormatted": "10,724,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2012_20cent",
    "country": "Finland",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2012) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 10724500,
    "mintageFormatted": "10,724,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2012_50cent",
    "country": "Finland",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2012) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 4724500,
    "mintageFormatted": "4,724,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2012_1euro",
    "country": "Finland",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2012) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 724500,
    "mintageFormatted": "724,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2012",
    "country": "Finland",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2012) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 3234000,
    "mintageFormatted": "3,234,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2012_cc1",
    "country": "Finland",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2012) - Helene Schjerfbeck",
    "subject": "Helene Schjerfbeck",
    "description": "Finland 2 Euro Commemorative coin issued in 2012: Helene Schjerfbeck.",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2012_2euro_0.jpg",
    "image_key": "fi_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2012_cc-common",
    "country": "Finland",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Finland 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2012_2euro_1.jpg",
    "image_key": "fi_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_finland_2013_1cent",
    "country": "Finland",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2013) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 341500,
    "mintageFormatted": "341,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2013_2cent",
    "country": "Finland",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2013) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 341500,
    "mintageFormatted": "341,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2013_5cent",
    "country": "Finland",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2013) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 341500,
    "mintageFormatted": "341,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2013_10cent",
    "country": "Finland",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2013) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 341500,
    "mintageFormatted": "341,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2013_20cent",
    "country": "Finland",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2013) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 341500,
    "mintageFormatted": "341,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2013_50cent",
    "country": "Finland",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2013) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 341500,
    "mintageFormatted": "341,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2013_1euro",
    "country": "Finland",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2013) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 341500,
    "mintageFormatted": "341,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2013",
    "country": "Finland",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2013) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 853500,
    "mintageFormatted": "853,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2013_cc1",
    "country": "Finland",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2013) - Frans Eemil Sillanpää",
    "subject": "Frans Eemil Sillanpää",
    "description": "Finland 2 Euro Commemorative coin issued in 2013: Frans Eemil Sillanpää.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2013_2euro_0.jpg",
    "image_key": "fi_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2013_cc2",
    "country": "Finland",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2013) - Parliament of 1863",
    "subject": "Parliament of 1863",
    "description": "Finland 2 Euro Commemorative coin issued in 2013: Parliament of 1863.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2013_2euro_1.jpg",
    "image_key": "fi_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2014_1cent",
    "country": "Finland",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2014) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 119100,
    "mintageFormatted": "119,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2014_2cent",
    "country": "Finland",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2014) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 119100,
    "mintageFormatted": "119,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2014_5cent",
    "country": "Finland",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2014) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 13699100,
    "mintageFormatted": "13,699,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2014_10cent",
    "country": "Finland",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2014) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 119100,
    "mintageFormatted": "119,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2014_20cent",
    "country": "Finland",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2014) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 119100,
    "mintageFormatted": "119,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2014_50cent",
    "country": "Finland",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2014) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 119100,
    "mintageFormatted": "119,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2014_1euro",
    "country": "Finland",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2014) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 119100,
    "mintageFormatted": "119,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2014",
    "country": "Finland",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2014) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 126100,
    "mintageFormatted": "126,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2014_cc1",
    "country": "Finland",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2014) - Tove Jansson",
    "subject": "Tove Jansson",
    "description": "Finland 2 Euro Commemorative coin issued in 2014: Tove Jansson.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2014_2euro_0.jpg",
    "image_key": "fi_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2014_cc2",
    "country": "Finland",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2014) - Ilmari Tapiovaara",
    "subject": "Ilmari Tapiovaara",
    "description": "Finland 2 Euro Commemorative coin issued in 2014: Ilmari Tapiovaara.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2014_2euro_1.jpg",
    "image_key": "fi_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2015_1cent",
    "country": "Finland",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2015) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 162100,
    "mintageFormatted": "162,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2015_2cent",
    "country": "Finland",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2015) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 162100,
    "mintageFormatted": "162,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2015_5cent",
    "country": "Finland",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2015) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 162100,
    "mintageFormatted": "162,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2015_10cent",
    "country": "Finland",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2015) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 10162100,
    "mintageFormatted": "10,162,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2015_20cent",
    "country": "Finland",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2015) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 10162100,
    "mintageFormatted": "10,162,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2015_50cent",
    "country": "Finland",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2015) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 162100,
    "mintageFormatted": "162,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2015_1euro",
    "country": "Finland",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2015) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 162100,
    "mintageFormatted": "162,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2015",
    "country": "Finland",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2015) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 169100,
    "mintageFormatted": "169,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2015_cc1",
    "country": "Finland",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2015) - Jean Sibelius",
    "subject": "Jean Sibelius",
    "description": "Finland 2 Euro Commemorative coin issued in 2015: Jean Sibelius.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2015_2euro_2.jpg",
    "image_key": "fi_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2015_cc2",
    "country": "Finland",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2015) - Akseli Gallen-Kallela",
    "subject": "Akseli Gallen-Kallela",
    "description": "Finland 2 Euro Commemorative coin issued in 2015: Akseli Gallen-Kallela.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2015_2euro_0.jpg",
    "image_key": "fi_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2015_cc-common",
    "country": "Finland",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Finland 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2015_2euro_1.jpg",
    "image_key": "fi_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_finland_2016_1cent",
    "country": "Finland",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2016) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 167100,
    "mintageFormatted": "167,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2016_2cent",
    "country": "Finland",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2016) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 167100,
    "mintageFormatted": "167,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2016_5cent",
    "country": "Finland",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2016) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 167100,
    "mintageFormatted": "167,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2016_10cent",
    "country": "Finland",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2016) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 167100,
    "mintageFormatted": "167,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2016_20cent",
    "country": "Finland",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2016) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 167100,
    "mintageFormatted": "167,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2016_50cent",
    "country": "Finland",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2016) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 167100,
    "mintageFormatted": "167,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2016_1euro",
    "country": "Finland",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2016) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 167100,
    "mintageFormatted": "167,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2016",
    "country": "Finland",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2016) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 172100,
    "mintageFormatted": "172,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2016_cc1",
    "country": "Finland",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2016) - Eino Leino",
    "subject": "Eino Leino",
    "description": "Finland 2 Euro Commemorative coin issued in 2016: Eino Leino.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2016_2euro_1.jpg",
    "image_key": "fi_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2016_cc2",
    "country": "Finland",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2016) - Georg Henrik von Wright",
    "subject": "Georg Henrik von Wright",
    "description": "Finland 2 Euro Commemorative coin issued in 2016: Georg Henrik von Wright.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2016_2euro_0.jpg",
    "image_key": "fi_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2017_1cent",
    "country": "Finland",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2017) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 69900,
    "mintageFormatted": "69,900",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2017_2cent",
    "country": "Finland",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2017) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 69900,
    "mintageFormatted": "69,900",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2017_5cent",
    "country": "Finland",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2017) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 10149900,
    "mintageFormatted": "10,149,900",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2017_10cent",
    "country": "Finland",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2017) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 69900,
    "mintageFormatted": "69,900",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2017_20cent",
    "country": "Finland",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2017) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 69900,
    "mintageFormatted": "69,900",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2017_50cent",
    "country": "Finland",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2017) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 69900,
    "mintageFormatted": "69,900",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2017_1euro",
    "country": "Finland",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2017) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 69100,
    "mintageFormatted": "69,100",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2017",
    "country": "Finland",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2017) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 74900,
    "mintageFormatted": "74,900",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2017_cc1",
    "country": "Finland",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2017) - Finnish Independence (100th Ann.)",
    "subject": "Finnish Independence (100th Ann.)",
    "description": "Finland 2 Euro Commemorative coin issued in 2017: Finnish Independence (100th Ann.).",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2017_2euro_1.jpg",
    "image_key": "fi_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2017_cc2",
    "country": "Finland",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2017) - Finnish Nature",
    "subject": "Finnish Nature",
    "description": "Finland 2 Euro Commemorative coin issued in 2017: Finnish Nature.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2017_2euro_0.jpg",
    "image_key": "fi_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2018_1cent",
    "country": "Finland",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Cent (2018) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 35500,
    "mintageFormatted": "35,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2018_2cent",
    "country": "Finland",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Cents (2018) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 35500,
    "mintageFormatted": "35,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2018_5cent",
    "country": "Finland",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2018) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 35500,
    "mintageFormatted": "35,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2018_10cent",
    "country": "Finland",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 10 Cents (2018) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 35500,
    "mintageFormatted": "35,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2018_20cent",
    "country": "Finland",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 20 Cents (2018) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 35500,
    "mintageFormatted": "35,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2018_50cent",
    "country": "Finland",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 50 Cents (2018) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 35500,
    "mintageFormatted": "35,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2018_1euro",
    "country": "Finland",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 1 Euro (2018) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 35500,
    "mintageFormatted": "35,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2018",
    "country": "Finland",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2018) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 2040500,
    "mintageFormatted": "2,040,500",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2018_cc1",
    "country": "Finland",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2018) - Koli Landscape",
    "subject": "Koli Landscape",
    "description": "Finland 2 Euro Commemorative coin issued in 2018: Koli Landscape.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2018_2euro_1.jpg",
    "image_key": "fi_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2018_cc2",
    "country": "Finland",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2018) - Finnish Sauna Culture",
    "subject": "Finnish Sauna Culture",
    "description": "Finland 2 Euro Commemorative coin issued in 2018: Finnish Sauna Culture.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2018_2euro_0.jpg",
    "image_key": "fi_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2019_5cent",
    "country": "Finland",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 5 Cents (2019) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 7980000,
    "mintageFormatted": "7,980,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2019",
    "country": "Finland",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Finland 2 Euros (2019) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 5970000,
    "mintageFormatted": "5,970,000",
    "status": "circulating",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2019_cc1",
    "country": "Finland",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2019) - Constitution Act of Finland",
    "subject": "Constitution Act of Finland",
    "description": "Finland 2 Euro Commemorative coin issued in 2019: Constitution Act of Finland.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2019_2euro_0.jpg",
    "image_key": "fi_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2020_1cent",
    "country": "Finland",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Cent (2020) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2020_2cent",
    "country": "Finland",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Cents (2020) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2020_5cent",
    "country": "Finland",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 5 Cents (2020) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2020_10cent",
    "country": "Finland",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 10 Cents (2020) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2020_20cent",
    "country": "Finland",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 20 Cents (2020) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2020_50cent",
    "country": "Finland",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 50 Cents (2020) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2020_1euro",
    "country": "Finland",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Euro (2020) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2020",
    "country": "Finland",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Euros (2020) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2020_cc1",
    "country": "Finland",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2020) - University of Turku",
    "subject": "University of Turku",
    "description": "Finland 2 Euro Commemorative coin issued in 2020: University of Turku.",
    "mintage": 720000,
    "mintageFormatted": "720,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2020_2euro_1.jpg",
    "image_key": "fi_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2020_cc2",
    "country": "Finland",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2020) - Väinö Linna",
    "subject": "Väinö Linna",
    "description": "Finland 2 Euro Commemorative coin issued in 2020: Väinö Linna.",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2020_2euro_0.jpg",
    "image_key": "fi_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2021_1cent",
    "country": "Finland",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Cent (2021) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2021_2cent",
    "country": "Finland",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Cents (2021) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2021_5cent",
    "country": "Finland",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 5 Cents (2021) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2021_10cent",
    "country": "Finland",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 10 Cents (2021) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2021_20cent",
    "country": "Finland",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 20 Cents (2021) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2021_50cent",
    "country": "Finland",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 50 Cents (2021) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2021_1euro",
    "country": "Finland",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Euro (2021) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2021",
    "country": "Finland",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Euros (2021) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2021_cc1",
    "country": "Finland",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2021) - Journalism and Free Press",
    "subject": "Journalism and Free Press",
    "description": "Finland 2 Euro Commemorative coin issued in 2021: Journalism and Free Press.",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2021_2euro_0.jpg",
    "image_key": "fi_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2021_cc2",
    "country": "Finland",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2021) - Autonomy of the Åland Islands",
    "subject": "Autonomy of the Åland Islands",
    "description": "Finland 2 Euro Commemorative coin issued in 2021: Autonomy of the Åland Islands.",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2021_2euro_1.jpg",
    "image_key": "fi_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2022_1cent",
    "country": "Finland",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Cent (2022) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2022_2cent",
    "country": "Finland",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Cents (2022) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2022_5cent",
    "country": "Finland",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 5 Cents (2022) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2022_10cent",
    "country": "Finland",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 10 Cents (2022) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2022_20cent",
    "country": "Finland",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 20 Cents (2022) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2022_50cent",
    "country": "Finland",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 50 Cents (2022) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2022_1euro",
    "country": "Finland",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Euro (2022) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2022",
    "country": "Finland",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Euros (2022) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2022_cc1",
    "country": "Finland",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2022) - National Ballet of Finland",
    "subject": "National Ballet of Finland",
    "description": "Finland 2 Euro Commemorative coin issued in 2022: National Ballet of Finland.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2022_2euro_0.jpg",
    "image_key": "fi_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2022_cc2",
    "country": "Finland",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2022) - Climate research in Finland",
    "subject": "Climate research in Finland",
    "description": "Finland 2 Euro Commemorative coin issued in 2022: Climate research in Finland.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2022_2euro_1.jpg",
    "image_key": "fi_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2022_cc-common",
    "country": "Finland",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Finland 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2022_2euro_2.jpg",
    "image_key": "fi_commemorative_2022_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_finland_2023_1cent",
    "country": "Finland",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Cent (2023) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2023_2cent",
    "country": "Finland",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Cents (2023) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2023_5cent",
    "country": "Finland",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 5 Cents (2023) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2023_10cent",
    "country": "Finland",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 10 Cents (2023) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2023_20cent",
    "country": "Finland",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 20 Cents (2023) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2023_50cent",
    "country": "Finland",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 50 Cents (2023) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2023_1euro",
    "country": "Finland",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Euro (2023) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2023",
    "country": "Finland",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Euros (2023) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2023_cc1",
    "country": "Finland",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2023) - First Finnish Nature Conservation Act",
    "subject": "First Finnish Nature Conservation Act",
    "description": "Finland 2 Euro Commemorative coin issued in 2023: First Finnish Nature Conservation Act.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2023_2euro_0.jpg",
    "image_key": "fi_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2023_cc2",
    "country": "Finland",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2023) - Social and Health Services",
    "subject": "Social and Health Services",
    "description": "Finland 2 Euro Commemorative coin issued in 2023: Social and Health Services.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2023_2euro_1.jpg",
    "image_key": "fi_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2024_1cent",
    "country": "Finland",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Cent (2024) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2024_2cent",
    "country": "Finland",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Cents (2024) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2024_5cent",
    "country": "Finland",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 5 Cents (2024) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2024_10cent",
    "country": "Finland",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 10 Cents (2024) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2024_20cent",
    "country": "Finland",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 20 Cents (2024) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2024_50cent",
    "country": "Finland",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 50 Cents (2024) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2024_1euro",
    "country": "Finland",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Euro (2024) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2024",
    "country": "Finland",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Euros (2024) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2024_cc1",
    "country": "Finland",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2024) - Elections and Democracy",
    "subject": "Elections and Democracy",
    "description": "Finland 2 Euro Commemorative coin issued in 2024: Elections and Democracy.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2024_2euro_0.jpg",
    "image_key": "fi_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2024_cc2",
    "country": "Finland",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2024) - Gesellius, Lindgren, Saarinen",
    "subject": "Gesellius, Lindgren, Saarinen",
    "description": "Finland 2 Euro Commemorative coin issued in 2024: Gesellius, Lindgren, Saarinen.",
    "mintage": 395200,
    "mintageFormatted": "395,200",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2024_2euro_1.jpg",
    "image_key": "fi_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2025_1cent",
    "country": "Finland",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Cent (2025) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2025_2cent",
    "country": "Finland",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Cents (2025) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2025_5cent",
    "country": "Finland",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 5 Cents (2025) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2025_10cent",
    "country": "Finland",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 10 Cents (2025) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2025_20cent",
    "country": "Finland",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 20 Cents (2025) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2025_50cent",
    "country": "Finland",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 50 Cents (2025) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2025_1euro",
    "country": "Finland",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Euro (2025) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2025",
    "country": "Finland",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Euros (2025) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2025_cc1",
    "country": "Finland",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2025) - Diplomacy and Foreign Policy of Finland",
    "subject": "Diplomacy and Foreign Policy of Finland",
    "description": "Finland 2 Euro Commemorative coin issued in 2025: Diplomacy and Foreign Policy of Finland.",
    "mintage": 75000,
    "mintageFormatted": "75,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2025_2euro_0.jpg",
    "image_key": "fi_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2025_cc2",
    "country": "Finland",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2025) - FIN-SWE Athletics Tournament",
    "subject": "FIN-SWE Athletics Tournament",
    "description": "Finland 2 Euro Commemorative coin issued in 2025: FIN-SWE Athletics Tournament.",
    "mintage": 75000,
    "mintageFormatted": "75,000",
    "status": "circulating",
    "imagePath": "coins/fi_commemorative_2025_2euro_1.jpg",
    "image_key": "fi_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2026_1cent",
    "country": "Finland",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Cent (2026) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fi_regular_1999_1cent_0.jpg",
    "image_key": "fi_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2026_2cent",
    "country": "Finland",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Cents (2026) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fi_regular_1999_2cent_0.jpg",
    "image_key": "fi_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2026_5cent",
    "country": "Finland",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 5 Cents (2026) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fi_regular_1999_5cent_0.jpg",
    "image_key": "fi_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2026_10cent",
    "country": "Finland",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 10 Cents (2026) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fi_regular_1999_10cent_0.jpg",
    "image_key": "fi_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2026_20cent",
    "country": "Finland",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 20 Cents (2026) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fi_regular_1999_20cent_0.jpg",
    "image_key": "fi_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2026_50cent",
    "country": "Finland",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 50 Cents (2026) - Heraldic Lion of Finland",
    "subject": "Heraldic Lion of Finland",
    "description": "Crowned heraldic lion from the coat of arms of Finland",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fi_regular_1999_50cent_0.jpg",
    "image_key": "fi_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2026_1euro",
    "country": "Finland",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 1 Euro (2026) - Two Whooper Swans in Flight",
    "subject": "Two Whooper Swans in Flight",
    "description": "Two flying whooper swans (national bird of Finland) designed by Pertti Mäkinen",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fi_regular_1999_1euro_0.jpg",
    "image_key": "fi_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_finland_2026",
    "country": "Finland",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2 Euros (2026) - Cloudberry Fruit and Flowers",
    "subject": "Cloudberry Fruit and Flowers",
    "description": "Leaves and berries of the cloudberry (Rubus chamaemorus) plant designed by Raimo Heino",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fi_regular_1999_2euro_0.jpg",
    "image_key": "fi_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2026_cc1",
    "country": "Finland",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Finland 2€ Commemorative (2026) - Yleisradio",
    "subject": "Yleisradio",
    "description": "Finland 2 Euro Commemorative coin issued in 2026: Yleisradio.",
    "mintage": 75000,
    "mintageFormatted": "75,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_finland_2026_cc2",
    "country": "Finland",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Finland 2€ Commemorative (2026) - Raili and Reima Pietilä",
    "subject": "Raili and Reima Pietilä",
    "description": "Finland 2 Euro Commemorative coin issued in 2026: Raili and Reima Pietilä.",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_1999_1cent",
    "country": "France",
    "year": 1999,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (1999) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 794016000,
    "mintageFormatted": "794,016,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_1999_2cent",
    "country": "France",
    "year": 1999,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (1999) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 702069000,
    "mintageFormatted": "702,069,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_1999_5cent",
    "country": "France",
    "year": 1999,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (1999) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 616192000,
    "mintageFormatted": "616,192,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_1999_10cent",
    "country": "France",
    "year": 1999,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (1999) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 447249600,
    "mintageFormatted": "447,249,600",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_1999_20cent",
    "country": "France",
    "year": 1999,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (1999) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 454291200,
    "mintageFormatted": "454,291,200",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_1999_50cent",
    "country": "France",
    "year": 1999,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (1999) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 105753600,
    "mintageFormatted": "105,753,600",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_1999_1euro",
    "country": "France",
    "year": 1999,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Euro (1999) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 301050000,
    "mintageFormatted": "301,050,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_1999",
    "country": "France",
    "year": 1999,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (1999) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 56695000,
    "mintageFormatted": "56,695,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2000_1cent",
    "country": "France",
    "year": 2000,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2000) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 605232000,
    "mintageFormatted": "605,232,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2000_2cent",
    "country": "France",
    "year": 2000,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2000) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 510120000,
    "mintageFormatted": "510,120,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2000_5cent",
    "country": "France",
    "year": 2000,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2000) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 280064000,
    "mintageFormatted": "280,064,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2000_10cent",
    "country": "France",
    "year": 2000,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2000) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 297432000,
    "mintageFormatted": "297,432,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2000_20cent",
    "country": "France",
    "year": 2000,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2000) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 148953600,
    "mintageFormatted": "148,953,600",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2000_50cent",
    "country": "France",
    "year": 2000,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2000) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 179496000,
    "mintageFormatted": "179,496,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2000_1euro",
    "country": "France",
    "year": 2000,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Euro (2000) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 297270000,
    "mintageFormatted": "297,270,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2000",
    "country": "France",
    "year": 2000,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2000) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 171120000,
    "mintageFormatted": "171,120,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2001_1cent",
    "country": "France",
    "year": 2001,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2001) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 300646580,
    "mintageFormatted": "300,646,580",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2001_2cent",
    "country": "France",
    "year": 2001,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2001) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 249075580,
    "mintageFormatted": "249,075,580",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2001_5cent",
    "country": "France",
    "year": 2001,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2001) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 217289477,
    "mintageFormatted": "217,289,477",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2001_10cent",
    "country": "France",
    "year": 2001,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2001) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 144478261,
    "mintageFormatted": "144,478,261",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2001_20cent",
    "country": "France",
    "year": 2001,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2001) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 256307108,
    "mintageFormatted": "256,307,108",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2001_50cent",
    "country": "France",
    "year": 2001,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2001) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 276252274,
    "mintageFormatted": "276,252,274",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2001_1euro",
    "country": "France",
    "year": 2001,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Euro (2001) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 150216624,
    "mintageFormatted": "150,216,624",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2001",
    "country": "France",
    "year": 2001,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2001) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 237915793,
    "mintageFormatted": "237,915,793",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2002_1cent",
    "country": "France",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2002) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 110000,
    "mintageFormatted": "110,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2002_2cent",
    "country": "France",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2002) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 9000,
    "mintageFormatted": "9,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2002_5cent",
    "country": "France",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2002) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 186283000,
    "mintageFormatted": "186,283,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2002_10cent",
    "country": "France",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2002) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 206646000,
    "mintageFormatted": "206,646,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2002_20cent",
    "country": "France",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2002) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 191996000,
    "mintageFormatted": "191,996,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2002_50cent",
    "country": "France",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2002) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 226384000,
    "mintageFormatted": "226,384,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2002_1euro",
    "country": "France",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Euro (2002) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 129324000,
    "mintageFormatted": "129,324,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2002",
    "country": "France",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2002) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 153606500,
    "mintageFormatted": "153,606,500",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2003_1cent",
    "country": "France",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2003) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 160017000,
    "mintageFormatted": "160,017,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2003_2cent",
    "country": "France",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2003) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 160062000,
    "mintageFormatted": "160,062,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2003_5cent",
    "country": "France",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2003) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 100977000,
    "mintageFormatted": "100,977,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2003_10cent",
    "country": "France",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2003) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 180717000,
    "mintageFormatted": "180,717,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2003_20cent",
    "country": "France",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 20 Cents (2003) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2003_50cent",
    "country": "France",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2003) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2003_1euro",
    "country": "France",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2003) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2003",
    "country": "France",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2003) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2004_1cent",
    "country": "France",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2004) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 400032000,
    "mintageFormatted": "400,032,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2004_2cent",
    "country": "France",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2004) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 300024000,
    "mintageFormatted": "300,024,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2004_5cent",
    "country": "France",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2004) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 60162000,
    "mintageFormatted": "60,162,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2004_10cent",
    "country": "France",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2004) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 1468800,
    "mintageFormatted": "1,468,800",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2004_20cent",
    "country": "France",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 20 Cents (2004) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2004_50cent",
    "country": "France",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2004) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2004_1euro",
    "country": "France",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2004) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2004",
    "country": "France",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2004) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2005_1cent",
    "country": "France",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2005) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 240206000,
    "mintageFormatted": "240,206,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2005_2cent",
    "country": "France",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2005) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 260187000,
    "mintageFormatted": "260,187,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2005_5cent",
    "country": "France",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2005) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 20174000,
    "mintageFormatted": "20,174,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2005_10cent",
    "country": "France",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2005) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 43576850,
    "mintageFormatted": "43,576,850",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2005_20cent",
    "country": "France",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 20 Cents (2005) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2005_50cent",
    "country": "France",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2005) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2005_1euro",
    "country": "France",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2005) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2005",
    "country": "France",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2005) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2006_1cent",
    "country": "France",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2006) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 343010000,
    "mintageFormatted": "343,010,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2006_2cent",
    "country": "France",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2006) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 283177500,
    "mintageFormatted": "283,177,500",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2006_5cent",
    "country": "France",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2006) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 132049000,
    "mintageFormatted": "132,049,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2006_10cent",
    "country": "France",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2006) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 60223000,
    "mintageFormatted": "60,223,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2006_20cent",
    "country": "France",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 20 Cents (2006) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2006_50cent",
    "country": "France",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2006) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2006_1euro",
    "country": "France",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2006) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2006",
    "country": "France",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2006) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2007_1cent",
    "country": "France",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2007) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 320142000,
    "mintageFormatted": "320,142,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2007_2cent",
    "country": "France",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2007) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 220350000,
    "mintageFormatted": "220,350,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2007_5cent",
    "country": "France",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2007) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 130062000,
    "mintageFormatted": "130,062,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2007_10cent",
    "country": "France",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2007) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 90095802,
    "mintageFormatted": "90,095,802",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2007_20cent",
    "country": "France",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2007) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 40157600,
    "mintageFormatted": "40,157,600",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2007_50cent",
    "country": "France",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2007) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2007_1euro",
    "country": "France",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2007) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2007",
    "country": "France",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2007) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2007_cc-common",
    "country": "France",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "France 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 9406875,
    "mintageFormatted": "9,406,875",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2007_2euro_0.jpg",
    "image_key": "fr_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_france_2008_1cent",
    "country": "France",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2008) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 462673100,
    "mintageFormatted": "462,673,100",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2008_2cent",
    "country": "France",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2008) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 386532000,
    "mintageFormatted": "386,532,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2008_5cent",
    "country": "France",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2008) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 218232000,
    "mintageFormatted": "218,232,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2008_10cent",
    "country": "France",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2008) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 178706400,
    "mintageFormatted": "178,706,400",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2008_20cent",
    "country": "France",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2008) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 25537600,
    "mintageFormatted": "25,537,600",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2008_50cent",
    "country": "France",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2008) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2008_1euro",
    "country": "France",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2008) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2008",
    "country": "France",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2008) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2008_cc1",
    "country": "France",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2008) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "France 2 Euro Commemorative coin issued in 2008: Presidency of the EU Council.",
    "mintage": 20084936,
    "mintageFormatted": "20,084,936",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2008_2euro_0.jpg",
    "image_key": "fr_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2009_1cent",
    "country": "France",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2009) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 436320000,
    "mintageFormatted": "436,320,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2009_2cent",
    "country": "France",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2009) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 343120000,
    "mintageFormatted": "343,120,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2009_5cent",
    "country": "France",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2009) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 184720000,
    "mintageFormatted": "184,720,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2009_10cent",
    "country": "France",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2009) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 142720000,
    "mintageFormatted": "142,720,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2009_20cent",
    "country": "France",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2009) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 82660000,
    "mintageFormatted": "82,660,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2009_50cent",
    "country": "France",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2009) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2009_1euro",
    "country": "France",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2009) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2009",
    "country": "France",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2009) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2009_cc-common",
    "country": "France",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "France 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 10060000,
    "mintageFormatted": "10,060,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2009_2euro_0.jpg",
    "image_key": "fr_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_france_2010_1cent",
    "country": "France",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2010) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 335556000,
    "mintageFormatted": "335,556,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2010_2cent",
    "country": "France",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2010) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 277041000,
    "mintageFormatted": "277,041,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2010_5cent",
    "country": "France",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2010) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 184232000,
    "mintageFormatted": "184,232,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2010_10cent",
    "country": "France",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2010) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 76153000,
    "mintageFormatted": "76,153,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2010_20cent",
    "country": "France",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2010) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 108024000,
    "mintageFormatted": "108,024,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2010_50cent",
    "country": "France",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2010) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2010_1euro",
    "country": "France",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2010) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2010",
    "country": "France",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2010) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2010_cc1",
    "country": "France",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2010) - Charles de Gaulle's Appeal of 18. June, 1940",
    "subject": "Charles de Gaulle's Appeal of 18. June, 1940",
    "description": "France 2 Euro Commemorative coin issued in 2010: Charles de Gaulle's Appeal of 18. June, 1940.",
    "mintage": 20064000,
    "mintageFormatted": "20,064,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2010_2euro_0.jpg",
    "image_key": "fr_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2011_1cent",
    "country": "France",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2011) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 320118000,
    "mintageFormatted": "320,118,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2011_2cent",
    "country": "France",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2011) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 250128000,
    "mintageFormatted": "250,128,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2011_5cent",
    "country": "France",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2011) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 144900000,
    "mintageFormatted": "144,900,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2011_10cent",
    "country": "France",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2011) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 99878000,
    "mintageFormatted": "99,878,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2011_20cent",
    "country": "France",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2011) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 54936000,
    "mintageFormatted": "54,936,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2011_50cent",
    "country": "France",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2011) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2011_1euro",
    "country": "France",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2011) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2011",
    "country": "France",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2011) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 36024000,
    "mintageFormatted": "36,024,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2011_cc1",
    "country": "France",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2011) - Fête de la musique",
    "subject": "Fête de la musique",
    "description": "France 2 Euro Commemorative coin issued in 2011: Fête de la musique.",
    "mintage": 10032000,
    "mintageFormatted": "10,032,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2011_2euro_0.jpg",
    "image_key": "fr_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2012_1cent",
    "country": "France",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2012) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 358566000,
    "mintageFormatted": "358,566,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2012_2cent",
    "country": "France",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2012) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 277668000,
    "mintageFormatted": "277,668,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2012_5cent",
    "country": "France",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2012) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 139104000,
    "mintageFormatted": "139,104,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2012_10cent",
    "country": "France",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2012) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 77357000,
    "mintageFormatted": "77,357,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2012_20cent",
    "country": "France",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 20 Cents (2012) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2012_50cent",
    "country": "France",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2012) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2012_1euro",
    "country": "France",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2012) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2012",
    "country": "France",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2012) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 36936000,
    "mintageFormatted": "36,936,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2012_cc1",
    "country": "France",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2012) - Abbé Pierre",
    "subject": "Abbé Pierre",
    "description": "France 2 Euro Commemorative coin issued in 2012: Abbé Pierre.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2012_2euro_0.jpg",
    "image_key": "fr_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2012_cc-common",
    "country": "France",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "France 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 10032000,
    "mintageFormatted": "10,032,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2012_2euro_1.jpg",
    "image_key": "fr_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_france_2013_1cent",
    "country": "France",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2013) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 282960000,
    "mintageFormatted": "282,960,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2013_2cent",
    "country": "France",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2013) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 220664000,
    "mintageFormatted": "220,664,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2013_5cent",
    "country": "France",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2013) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 147168000,
    "mintageFormatted": "147,168,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2013_10cent",
    "country": "France",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2013) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 139780800,
    "mintageFormatted": "139,780,800",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2013_20cent",
    "country": "France",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2013) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 27048000,
    "mintageFormatted": "27,048,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2013_50cent",
    "country": "France",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2013) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2013_1euro",
    "country": "France",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2013) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2013",
    "country": "France",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2013) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 17302500,
    "mintageFormatted": "17,302,500",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2013_cc1",
    "country": "France",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2013) - Élysée Treaty",
    "subject": "Élysée Treaty",
    "description": "France 2 Euro Commemorative coin issued in 2013: Élysée Treaty.",
    "mintage": 12556000,
    "mintageFormatted": "12,556,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2013_2euro_0.jpg",
    "image_key": "fr_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2013_cc2",
    "country": "France",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2013) - Pierre de Coubertin",
    "subject": "Pierre de Coubertin",
    "description": "France 2 Euro Commemorative coin issued in 2013: Pierre de Coubertin.",
    "mintage": 1026000,
    "mintageFormatted": "1,026,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2013_2euro_1.jpg",
    "image_key": "fr_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2014_1cent",
    "country": "France",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2014) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 365046000,
    "mintageFormatted": "365,046,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2014_2cent",
    "country": "France",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2014) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 209952000,
    "mintageFormatted": "209,952,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2014_5cent",
    "country": "France",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2014) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 130032000,
    "mintageFormatted": "130,032,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2014_10cent",
    "country": "France",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2014) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 35006400,
    "mintageFormatted": "35,006,400",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2014_20cent",
    "country": "France",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2014) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 45024000,
    "mintageFormatted": "45,024,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2014_50cent",
    "country": "France",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2014) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2014_1euro",
    "country": "France",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2014) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2014",
    "country": "France",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2014) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 8892000,
    "mintageFormatted": "8,892,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2014_cc1",
    "country": "France",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2014) - D-Day",
    "subject": "D-Day",
    "description": "France 2 Euro Commemorative coin issued in 2014: D-Day.",
    "mintage": 3078000,
    "mintageFormatted": "3,078,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2014_2euro_0.jpg",
    "image_key": "fr_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2014_cc2",
    "country": "France",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2014) - World AIDS Day",
    "subject": "World AIDS Day",
    "description": "France 2 Euro Commemorative coin issued in 2014: World AIDS Day.",
    "mintage": 3078000,
    "mintageFormatted": "3,078,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2014_2euro_1.jpg",
    "image_key": "fr_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2015_1cent",
    "country": "France",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2015) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 287280000,
    "mintageFormatted": "287,280,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2015_2cent",
    "country": "France",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2015) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 199260000,
    "mintageFormatted": "199,260,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2015_5cent",
    "country": "France",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2015) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 97020000,
    "mintageFormatted": "97,020,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2015_10cent",
    "country": "France",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2015) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 70990000,
    "mintageFormatted": "70,990,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2015_20cent",
    "country": "France",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2015) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 27720000,
    "mintageFormatted": "27,720,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2015_50cent",
    "country": "France",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2015) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2015_1euro",
    "country": "France",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2015) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2015",
    "country": "France",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2015) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2015_cc1",
    "country": "France",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2015) - End of WW2",
    "subject": "End of WW2",
    "description": "France 2 Euro Commemorative coin issued in 2015: End of WW2.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2015_2euro_1.jpg",
    "image_key": "fr_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2015_cc2",
    "country": "France",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2015) - Fête de la Fédération",
    "subject": "Fête de la Fédération",
    "description": "France 2 Euro Commemorative coin issued in 2015: Fête de la Fédération.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2015_2euro_2.jpg",
    "image_key": "fr_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2015_cc-common",
    "country": "France",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "France 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2015_2euro_0.jpg",
    "image_key": "fr_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_france_2016_1cent",
    "country": "France",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2016) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 293800000,
    "mintageFormatted": "293,800,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2016_2cent",
    "country": "France",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2016) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 192500000,
    "mintageFormatted": "192,500,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2016_5cent",
    "country": "France",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2016) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 142000000,
    "mintageFormatted": "142,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2016_10cent",
    "country": "France",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2016) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 115900000,
    "mintageFormatted": "115,900,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2016_20cent",
    "country": "France",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 20 Cents (2016) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2016_50cent",
    "country": "France",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2016) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2016_1euro",
    "country": "France",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2016) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2016",
    "country": "France",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2016) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 15912000,
    "mintageFormatted": "15,912,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2016_cc1",
    "country": "France",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2016) - UEFA Euro 2016 Football Championship",
    "subject": "UEFA Euro 2016 Football Championship",
    "description": "France 2 Euro Commemorative coin issued in 2016: UEFA Euro 2016 Football Championship.",
    "mintage": 10044000,
    "mintageFormatted": "10,044,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2016_2euro_0.jpg",
    "image_key": "fr_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2016_cc2",
    "country": "France",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2016) - François Mitterrand",
    "subject": "François Mitterrand",
    "description": "France 2 Euro Commemorative coin issued in 2016: François Mitterrand.",
    "mintage": 10044000,
    "mintageFormatted": "10,044,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2016_2euro_1.jpg",
    "image_key": "fr_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2017_1cent",
    "country": "France",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2017) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 270000000,
    "mintageFormatted": "270,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2017_2cent",
    "country": "France",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2017) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 200000000,
    "mintageFormatted": "200,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2017_5cent",
    "country": "France",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2017) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 130000000,
    "mintageFormatted": "130,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2017_10cent",
    "country": "France",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2017) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 90000000,
    "mintageFormatted": "90,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2017_20cent",
    "country": "France",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2017) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2017_50cent",
    "country": "France",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2017) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2017_1euro",
    "country": "France",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2017) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2017",
    "country": "France",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2017) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 30012000,
    "mintageFormatted": "30,012,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2017_cc1",
    "country": "France",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2017) - Auguste Rodin",
    "subject": "Auguste Rodin",
    "description": "France 2 Euro Commemorative coin issued in 2017: Auguste Rodin.",
    "mintage": 10044000,
    "mintageFormatted": "10,044,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2017_2euro_1.jpg",
    "image_key": "fr_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2017_cc2",
    "country": "France",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2017) - Pink Ribbon",
    "subject": "Pink Ribbon",
    "description": "France 2 Euro Commemorative coin issued in 2017: Pink Ribbon.",
    "mintage": 10044000,
    "mintageFormatted": "10,044,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2017_2euro_0.jpg",
    "image_key": "fr_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2018_1cent",
    "country": "France",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2018) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 207000000,
    "mintageFormatted": "207,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2018_2cent",
    "country": "France",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2018) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 142600000,
    "mintageFormatted": "142,600,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2018_5cent",
    "country": "France",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2018) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 75600000,
    "mintageFormatted": "75,600,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2018_10cent",
    "country": "France",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2018) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 99300000,
    "mintageFormatted": "99,300,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2018_20cent",
    "country": "France",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2018) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 79800000,
    "mintageFormatted": "79,800,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2018_50cent",
    "country": "France",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2018) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 26900000,
    "mintageFormatted": "26,900,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2018_1euro",
    "country": "France",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2018) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2018",
    "country": "France",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2018) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 49480000,
    "mintageFormatted": "49,480,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2018_cc1",
    "country": "France",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2018) - Le Bleuet de France",
    "subject": "Le Bleuet de France",
    "description": "France 2 Euro Commemorative coin issued in 2018: Le Bleuet de France.",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2018_2euro_0.jpg",
    "image_key": "fr_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2018_cc2",
    "country": "France",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2018) - Simone Veil",
    "subject": "Simone Veil",
    "description": "France 2 Euro Commemorative coin issued in 2018: Simone Veil.",
    "mintage": 15010000,
    "mintageFormatted": "15,010,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2018_2euro_1.jpg",
    "image_key": "fr_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2019_1cent",
    "country": "France",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2019) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 176762000,
    "mintageFormatted": "176,762,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2019_2cent",
    "country": "France",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2019) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 161280000,
    "mintageFormatted": "161,280,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2019_5cent",
    "country": "France",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2019) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 105930000,
    "mintageFormatted": "105,930,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2019_10cent",
    "country": "France",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2019) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 77011200,
    "mintageFormatted": "77,011,200",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2019_20cent",
    "country": "France",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2019) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 60825600,
    "mintageFormatted": "60,825,600",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2019_50cent",
    "country": "France",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2019) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 17760000,
    "mintageFormatted": "17,760,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2019_1euro",
    "country": "France",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2019) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2019",
    "country": "France",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2019) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 36450000,
    "mintageFormatted": "36,450,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2019_cc1",
    "country": "France",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2€ Commemorative (2019) - Astérix",
    "subject": "Astérix",
    "description": "France 2 Euro Commemorative coin issued in 2019: Astérix.",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_commemorative_2019_2euro_1.jpg",
    "image_key": "fr_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2019_cc2",
    "country": "France",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2019) - Fall of the Berlin Wall",
    "subject": "Fall of the Berlin Wall",
    "description": "France 2 Euro Commemorative coin issued in 2019: Fall of the Berlin Wall.",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2019_2euro_0.jpg",
    "image_key": "fr_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2020_1cent",
    "country": "France",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2020) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 144000000,
    "mintageFormatted": "144,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2020_2cent",
    "country": "France",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2020) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 101304000,
    "mintageFormatted": "101,304,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2020_5cent",
    "country": "France",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2020) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 89694000,
    "mintageFormatted": "89,694,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2020_10cent",
    "country": "France",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2020) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 83261000,
    "mintageFormatted": "83,261,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2020_20cent",
    "country": "France",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2020) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 42768000,
    "mintageFormatted": "42,768,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2020_50cent",
    "country": "France",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2020) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 22200000,
    "mintageFormatted": "22,200,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2020_1euro",
    "country": "France",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2020) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2020",
    "country": "France",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2020) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 45900000,
    "mintageFormatted": "45,900,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2020_cc1",
    "country": "France",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2020) - Charles de Gaulle",
    "subject": "Charles de Gaulle",
    "description": "France 2 Euro Commemorative coin issued in 2020: Charles de Gaulle.",
    "mintage": 18061940,
    "mintageFormatted": "18,061,940",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2020_2euro_1.jpg",
    "image_key": "fr_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2020_cc2",
    "country": "France",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2€ Commemorative (2020) - Medical Research",
    "subject": "Medical Research",
    "description": "France 2 Euro Commemorative coin issued in 2020: Medical Research.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_commemorative_2020_2euro_0.jpg",
    "image_key": "fr_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2021_1cent",
    "country": "France",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2021) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 214200000,
    "mintageFormatted": "214,200,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2021_2cent",
    "country": "France",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2021) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 133900000,
    "mintageFormatted": "133,900,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2021_5cent",
    "country": "France",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2021) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 54000000,
    "mintageFormatted": "54,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2021_10cent",
    "country": "France",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2021) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 80300000,
    "mintageFormatted": "80,300,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2021_20cent",
    "country": "France",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2021) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 68200000,
    "mintageFormatted": "68,200,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2021_50cent",
    "country": "France",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2021) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 18300000,
    "mintageFormatted": "18,300,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2021_1euro",
    "country": "France",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2021) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_1999_1euro_0.jpg",
    "image_key": "fr_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2021",
    "country": "France",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2021) - The Tree of Life (L'arbre de vie)",
    "subject": "The Tree of Life (L'arbre de vie)",
    "description": "Stylized tree symbolizing growth, freedom, and life within a hexagon by Joaquin Jimenez",
    "mintage": 31700000,
    "mintageFormatted": "31,700,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2euro_0.jpg",
    "image_key": "fr_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2021_cc1",
    "country": "France",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2021) - UNICEF",
    "subject": "UNICEF",
    "description": "France 2 Euro Commemorative coin issued in 2021: UNICEF.",
    "mintage": 7500000,
    "mintageFormatted": "7,500,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2021_2euro_1.jpg",
    "image_key": "fr_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2021_cc2",
    "country": "France",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2€ Commemorative (2021) - Running Marianne",
    "subject": "Running Marianne",
    "description": "France 2 Euro Commemorative coin issued in 2021: Running Marianne.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_commemorative_2021_2euro_0.jpg",
    "image_key": "fr_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2022_1cent",
    "country": "France",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2022) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 160100000,
    "mintageFormatted": "160,100,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2022_2cent",
    "country": "France",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2022) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 134946000,
    "mintageFormatted": "134,946,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2022_5cent",
    "country": "France",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2022) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 82071000,
    "mintageFormatted": "82,071,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2022_10cent",
    "country": "France",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2022) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 40420800,
    "mintageFormatted": "40,420,800",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2022_20cent",
    "country": "France",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2022) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 40233600,
    "mintageFormatted": "40,233,600",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2022_50cent",
    "country": "France",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2022) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 35520000,
    "mintageFormatted": "35,520,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2022_1euro",
    "country": "France",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2022) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_2022_1euro_0.jpg",
    "image_key": "fr_regular_2022_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2022",
    "country": "France",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2022) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 20898000,
    "mintageFormatted": "20,898,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2022_2euro_0.jpg",
    "image_key": "fr_regular_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2022_cc1",
    "country": "France",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2022) - Jacques Chirac",
    "subject": "Jacques Chirac",
    "description": "France 2 Euro Commemorative coin issued in 2022: Jacques Chirac.",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2022_2euro_1.jpg",
    "image_key": "fr_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2022_cc2",
    "country": "France",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2€ Commemorative (2022) - Genius and the Discus",
    "subject": "Genius and the Discus",
    "description": "France 2 Euro Commemorative coin issued in 2022: Genius and the Discus.",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_commemorative_2022_2euro_0.jpg",
    "image_key": "fr_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2022_cc-common",
    "country": "France",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "France 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2022_2euro_2.jpg",
    "image_key": "fr_commemorative_2022_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_france_2023_1cent",
    "country": "France",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2023) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 156000000,
    "mintageFormatted": "156,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2023_2cent",
    "country": "France",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2023) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 121000000,
    "mintageFormatted": "121,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2023_5cent",
    "country": "France",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2023) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 107000000,
    "mintageFormatted": "107,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2023_10cent",
    "country": "France",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2023) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 78000000,
    "mintageFormatted": "78,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_10cent_0.jpg",
    "image_key": "fr_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2023_20cent",
    "country": "France",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2023) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 45000000,
    "mintageFormatted": "45,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_20cent_0.jpg",
    "image_key": "fr_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2023_50cent",
    "country": "France",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2023) - The Sower (La Semeuse)",
    "subject": "The Sower (La Semeuse)",
    "description": "Modern rendition of the classic French Sower motif by Laurent Jorio",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_50cent_0.jpg",
    "image_key": "fr_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2023_1euro",
    "country": "France",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2023) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_2022_1euro_0.jpg",
    "image_key": "fr_regular_2022_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2023",
    "country": "France",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2023) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2022_2euro_0.jpg",
    "image_key": "fr_regular_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2023_cc1",
    "country": "France",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2023) - Rugby World Cup 2023",
    "subject": "Rugby World Cup 2023",
    "description": "France 2 Euro Commemorative coin issued in 2023: Rugby World Cup 2023.",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2023_2euro_0.jpg",
    "image_key": "fr_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2023_cc2",
    "country": "France",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2€ Commemorative (2023) - Boxing Sower",
    "subject": "Boxing Sower",
    "description": "France 2 Euro Commemorative coin issued in 2023: Boxing Sower.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_commemorative_2023_2euro_1.jpg",
    "image_key": "fr_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2024_1cent",
    "country": "France",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2024) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 132000000,
    "mintageFormatted": "132,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2024_2cent",
    "country": "France",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2024) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 120000000,
    "mintageFormatted": "120,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2024_5cent",
    "country": "France",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2024) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 78000000,
    "mintageFormatted": "78,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2024_10cent",
    "country": "France",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2024) - Simone Veil",
    "subject": "Simone Veil",
    "description": "Portrait of Simone Veil, icon of French political life and European integration, alongside Marianne",
    "mintage": 74000000,
    "mintageFormatted": "74,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2024_10cent_0.jpg",
    "image_key": "fr_regular_2024_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2024_20cent",
    "country": "France",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2024) - Joséphine Baker",
    "subject": "Joséphine Baker",
    "description": "Portrait of Joséphine Baker, hero of the French Resistance and civil rights activist, alongside Marianne",
    "mintage": 62000000,
    "mintageFormatted": "62,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2024_20cent_0.jpg",
    "image_key": "fr_regular_2024_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2024_50cent",
    "country": "France",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2024) - Marie Curie",
    "subject": "Marie Curie",
    "description": "Portrait of Nobel Prize-winning scientist Marie Curie alongside Marianne",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2024_50cent_0.jpg",
    "image_key": "fr_regular_2024_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2024_1euro",
    "country": "France",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2024) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_2022_1euro_0.jpg",
    "image_key": "fr_regular_2022_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2024",
    "country": "France",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2024) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 33000000,
    "mintageFormatted": "33,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2022_2euro_0.jpg",
    "image_key": "fr_regular_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2024_cc1",
    "country": "France",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2€ Commemorative (2024) - Wrestling Hercules",
    "subject": "Wrestling Hercules",
    "description": "France 2 Euro Commemorative coin issued in 2024: Wrestling Hercules.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_commemorative_2024_2euro_0.jpg",
    "image_key": "fr_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2024_cc2",
    "country": "France",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2024) - Paris Olympics & Paralymics, 2024",
    "subject": "Paris Olympics & Paralymics, 2024",
    "description": "France 2 Euro Commemorative coin issued in 2024: Paris Olympics & Paralymics, 2024.",
    "mintage": 24000000,
    "mintageFormatted": "24,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2024_2euro_1.jpg",
    "image_key": "fr_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2025_1cent",
    "country": "France",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2025) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 100000000,
    "mintageFormatted": "100,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2025_2cent",
    "country": "France",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2025) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 116000000,
    "mintageFormatted": "116,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2025_5cent",
    "country": "France",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2025) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 49000000,
    "mintageFormatted": "49,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2025_10cent",
    "country": "France",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 10 Cents (2025) - Simone Veil",
    "subject": "Simone Veil",
    "description": "Portrait of Simone Veil, icon of French political life and European integration, alongside Marianne",
    "mintage": 59000000,
    "mintageFormatted": "59,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2024_10cent_0.jpg",
    "image_key": "fr_regular_2024_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2025_20cent",
    "country": "France",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 20 Cents (2025) - Joséphine Baker",
    "subject": "Joséphine Baker",
    "description": "Portrait of Joséphine Baker, hero of the French Resistance and civil rights activist, alongside Marianne",
    "mintage": 65000000,
    "mintageFormatted": "65,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2024_20cent_0.jpg",
    "image_key": "fr_regular_2024_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2025_50cent",
    "country": "France",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 50 Cents (2025) - Marie Curie",
    "subject": "Marie Curie",
    "description": "Portrait of Nobel Prize-winning scientist Marie Curie alongside Marianne",
    "mintage": 29000000,
    "mintageFormatted": "29,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2024_50cent_0.jpg",
    "image_key": "fr_regular_2024_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2025_1euro",
    "country": "France",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2025) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_2022_1euro_0.jpg",
    "image_key": "fr_regular_2022_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2025",
    "country": "France",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Euros (2025) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 22000000,
    "mintageFormatted": "22,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_regular_2022_2euro_0.jpg",
    "image_key": "fr_regular_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2025_cc1",
    "country": "France",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2€ Commemorative (2025) - Louvre Museum",
    "subject": "Louvre Museum",
    "description": "France 2 Euro Commemorative coin issued in 2025: Louvre Museum.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_commemorative_2025_2euro_0.jpg",
    "image_key": "fr_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2025_cc2",
    "country": "France",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2025) - Notre Dame Cathedral Reopening",
    "subject": "Notre Dame Cathedral Reopening",
    "description": "France 2 Euro Commemorative coin issued in 2025: Notre Dame Cathedral Reopening.",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/fr_commemorative_2025_2euro_1.jpg",
    "image_key": "fr_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2026_1cent",
    "country": "France",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 1 Cent (2026) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/fr_regular_1999_1cent_0.jpg",
    "image_key": "fr_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2026_2cent",
    "country": "France",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 2 Cents (2026) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/fr_regular_1999_2cent_0.jpg",
    "image_key": "fr_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2026_5cent",
    "country": "France",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "France 5 Cents (2026) - Marianne",
    "subject": "Marianne",
    "description": "Portrait of Marianne, national symbol of the French Republic, by Fabienne Courtiade",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/fr_regular_1999_5cent_0.jpg",
    "image_key": "fr_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2026_10cent",
    "country": "France",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 10 Cents (2026) - Simone Veil",
    "subject": "Simone Veil",
    "description": "Portrait of Simone Veil, icon of French political life and European integration, alongside Marianne",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fr_regular_2024_10cent_0.jpg",
    "image_key": "fr_regular_2024_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2026_20cent",
    "country": "France",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 20 Cents (2026) - Joséphine Baker",
    "subject": "Joséphine Baker",
    "description": "Portrait of Joséphine Baker, hero of the French Resistance and civil rights activist, alongside Marianne",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fr_regular_2024_20cent_0.jpg",
    "image_key": "fr_regular_2024_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2026_50cent",
    "country": "France",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 50 Cents (2026) - Marie Curie",
    "subject": "Marie Curie",
    "description": "Portrait of Nobel Prize-winning scientist Marie Curie alongside Marianne",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fr_regular_2024_50cent_0.jpg",
    "image_key": "fr_regular_2024_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2026_1euro",
    "country": "France",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 1 Euro (2026) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/fr_regular_2022_1euro_0.jpg",
    "image_key": "fr_regular_2022_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_france_2026",
    "country": "France",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2 Euros (2026) - New Tree of Life (L'arbre de l'union)",
    "subject": "New Tree of Life (L'arbre de l'union)",
    "description": "Updated Tree of Life design blending oak and olive branches by Joaquin Jimenez",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/fr_regular_2022_2euro_0.jpg",
    "image_key": "fr_regular_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2026_cc1",
    "country": "France",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "France 2€ Commemorative (2026) - The Little Prince",
    "subject": "The Little Prince",
    "description": "France 2 Euro Commemorative coin issued in 2026: The Little Prince.",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_france_2026_cc2",
    "country": "France",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "France 2€ Commemorative (2026) - French Navy",
    "subject": "French Navy",
    "description": "France 2 Euro Commemorative coin issued in 2026: French Navy.",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1cent_a",
    "country": "Germany (A)",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2002) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 800000000,
    "mintageFormatted": "800,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_2cent_a",
    "country": "Germany (A)",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2002) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 459855000,
    "mintageFormatted": "459,855,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_5cent_a",
    "country": "Germany (A)",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2002) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 480000000,
    "mintageFormatted": "480,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_10cent_a",
    "country": "Germany (A)",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2002) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 696000000,
    "mintageFormatted": "696,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_20cent_a",
    "country": "Germany (A)",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2002) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 378000000,
    "mintageFormatted": "378,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_50cent_a",
    "country": "Germany (A)",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 50 Cents (2002) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 337600000,
    "mintageFormatted": "337,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1euro_a",
    "country": "Germany (A)",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Euro (2002) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 367750000,
    "mintageFormatted": "367,750,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_a",
    "country": "Germany (A)",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2002) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 238775000,
    "mintageFormatted": "238,775,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1cent_a",
    "country": "Germany (A)",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Cent (2003) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_2cent_a",
    "country": "Germany (A)",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2003) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 100000000,
    "mintageFormatted": "100,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_5cent_a",
    "country": "Germany (A)",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 5 Cents (2003) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_10cent_a",
    "country": "Germany (A)",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2003) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 50655000,
    "mintageFormatted": "50,655,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_20cent_a",
    "country": "Germany (A)",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2003) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 41855000,
    "mintageFormatted": "41,855,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_50cent_a",
    "country": "Germany (A)",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2003) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1euro_a",
    "country": "Germany (A)",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Euro (2003) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 50250000,
    "mintageFormatted": "50,250,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_a",
    "country": "Germany (A)",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2003) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 20475000,
    "mintageFormatted": "20,475,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1cent_a",
    "country": "Germany (A)",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2004) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 280000000,
    "mintageFormatted": "280,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_2cent_a",
    "country": "Germany (A)",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2004) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 127000000,
    "mintageFormatted": "127,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_5cent_a",
    "country": "Germany (A)",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2004) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 112000000,
    "mintageFormatted": "112,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_10cent_a",
    "country": "Germany (A)",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2004) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_20cent_a",
    "country": "Germany (A)",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 20 Cents (2004) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_50cent_a",
    "country": "Germany (A)",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 50 Cents (2004) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 82255000,
    "mintageFormatted": "82,255,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1euro_a",
    "country": "Germany (A)",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Euro (2004) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 21855000,
    "mintageFormatted": "21,855,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_a",
    "country": "Germany (A)",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2004) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 31500000,
    "mintageFormatted": "31,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1cent_a",
    "country": "Germany (A)",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2005) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 120000000,
    "mintageFormatted": "120,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_2cent_a",
    "country": "Germany (A)",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2005) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 73000000,
    "mintageFormatted": "73,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_5cent_a",
    "country": "Germany (A)",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2005) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 44000000,
    "mintageFormatted": "44,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_10cent_a",
    "country": "Germany (A)",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2005) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_20cent_a",
    "country": "Germany (A)",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2005) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_50cent_a",
    "country": "Germany (A)",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2005) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1euro_a",
    "country": "Germany (A)",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2005) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_a",
    "country": "Germany (A)",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 2 Euros (2005) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1cent_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Cent (2006) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_2cent_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2006) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 108000000,
    "mintageFormatted": "108,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_5cent_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2006) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 27000000,
    "mintageFormatted": "27,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_10cent_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2006) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_20cent_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2006) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 39000000,
    "mintageFormatted": "39,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_50cent_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2006) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1euro_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2006) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 2 Euros (2006) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2006_cc1_a",
    "country": "Germany (A)",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2006) - Schleswig-Holstein (Mint A)",
    "subject": "Schleswig-Holstein",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2006: Schleswig-Holstein.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2006_2euro_0.jpg",
    "image_key": "de_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1cent_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2007) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 119400000,
    "mintageFormatted": "119,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_2cent_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2007) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 100000000,
    "mintageFormatted": "100,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_5cent_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2007) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 52400000,
    "mintageFormatted": "52,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_10cent_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2007) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_20cent_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2007) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 21600000,
    "mintageFormatted": "21,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_50cent_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2007) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1euro_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2007) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc1_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2007) - Mecklenburg-Vorpommern (Mint A)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2007: Mecklenburg-Vorpommern.",
    "mintage": 985000,
    "mintageFormatted": "985,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_1.jpg",
    "image_key": "de_commemorative_2007_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc-common_a",
    "country": "Germany (A)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2007) - Treaty of Rome (ToR) (Mint A)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_0.jpg",
    "image_key": "de_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2008_1cent_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2008) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 101200000,
    "mintageFormatted": "101,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_2cent_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2008) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 80000000,
    "mintageFormatted": "80,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_5cent_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2008) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 29200000,
    "mintageFormatted": "29,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_10cent_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2008) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_20cent_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2008) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 15800000,
    "mintageFormatted": "15,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_50cent_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2008) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_1euro_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2008) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2008) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 11400000,
    "mintageFormatted": "11,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2008_cc1_a",
    "country": "Germany (A)",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2008) - Hamburg (Mint A)",
    "subject": "Hamburg",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2008: Hamburg.",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2008_2euro_0.jpg",
    "image_key": "de_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1cent_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2009) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 100000000,
    "mintageFormatted": "100,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_2cent_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2009) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 59000000,
    "mintageFormatted": "59,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_5cent_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2009) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 39600000,
    "mintageFormatted": "39,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_10cent_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2009) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_20cent_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2009) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 21600000,
    "mintageFormatted": "21,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_50cent_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2009) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1euro_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2009) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc1_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2009) - Saarland (Mint A)",
    "subject": "Saarland",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2009: Saarland.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_0.jpg",
    "image_key": "de_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc-common_a",
    "country": "Germany (A)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2009) - Economic and Monetary Union (EMU) (Mint A)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_1.jpg",
    "image_key": "de_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2010_1cent_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2010) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 94400000,
    "mintageFormatted": "94,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_2cent_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2010) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 72800000,
    "mintageFormatted": "72,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_5cent_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2010) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 39800000,
    "mintageFormatted": "39,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_10cent_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2010) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_20cent_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2010) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 24400000,
    "mintageFormatted": "24,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_50cent_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2010) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_1euro_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2010) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2010) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 19600000,
    "mintageFormatted": "19,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2010_cc1_a",
    "country": "Germany (A)",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2010) - Bremen (Mint A)",
    "subject": "Bremen",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2010: Bremen.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2010_2euro_0.jpg",
    "image_key": "de_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1cent_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2011) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 118400000,
    "mintageFormatted": "118,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_2cent_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2011) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 100400000,
    "mintageFormatted": "100,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_5cent_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2011) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 59200000,
    "mintageFormatted": "59,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_10cent_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2011) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_20cent_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2011) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 33000000,
    "mintageFormatted": "33,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_50cent_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2011) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1euro_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2011) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2011) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 23800000,
    "mintageFormatted": "23,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2011_cc1_a",
    "country": "Germany (A)",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2011) - Nordrhein-Westfalen (Mint A)",
    "subject": "Nordrhein-Westfalen",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2011: Nordrhein-Westfalen.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2011_2euro_0.jpg",
    "image_key": "de_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1cent_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2012) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 104200000,
    "mintageFormatted": "104,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_2cent_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2012) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 77400000,
    "mintageFormatted": "77,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_5cent_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2012) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 41800000,
    "mintageFormatted": "41,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_10cent_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2012) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_20cent_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2012) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 21200000,
    "mintageFormatted": "21,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_50cent_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2012) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1euro_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2012) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc1_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2012) - Bayern (Mint A)",
    "subject": "Bayern",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2012: Bayern.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_0.jpg",
    "image_key": "de_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc-common_a",
    "country": "Germany (A)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2012) - Ten Years of Euro (TYE) (Mint A)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_1.jpg",
    "image_key": "de_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2013_1cent_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2013) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 60000000,
    "mintageFormatted": "60,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_2cent_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2013) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 60000000,
    "mintageFormatted": "60,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_5cent_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2013) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 32000000,
    "mintageFormatted": "32,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_10cent_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2013) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_20cent_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2013) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 16000000,
    "mintageFormatted": "16,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_50cent_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2013) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_1euro_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2013) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc1_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2013) - Baden-Württemberg (Mint A)",
    "subject": "Baden-Württemberg",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2013: Baden-Württemberg.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_0.jpg",
    "image_key": "de_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc2_a",
    "country": "Germany (A)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2013) - Élysée Treaty (Mint A)",
    "subject": "Élysée Treaty",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2013: Élysée Treaty.",
    "mintage": 2200000,
    "mintageFormatted": "2,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_1.jpg",
    "image_key": "de_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1cent_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2014) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 66000000,
    "mintageFormatted": "66,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_2cent_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2014) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 61800000,
    "mintageFormatted": "61,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_5cent_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2014) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 32000000,
    "mintageFormatted": "32,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_10cent_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2014) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_20cent_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2014) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 19200000,
    "mintageFormatted": "19,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_50cent_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2014) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1euro_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2014) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2014) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 5600000,
    "mintageFormatted": "5,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2014_cc1_a",
    "country": "Germany (A)",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2014) - Niedersachsen (Mint A)",
    "subject": "Niedersachsen",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2014: Niedersachsen.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2014_2euro_0.jpg",
    "image_key": "de_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1cent_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2015) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 86200000,
    "mintageFormatted": "86,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_2cent_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2015) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 76000000,
    "mintageFormatted": "76,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_5cent_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2015) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 32800000,
    "mintageFormatted": "32,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_10cent_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2015) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_20cent_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2015) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 22800000,
    "mintageFormatted": "22,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_50cent_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2015) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1euro_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2015) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc1_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2015) - Hessen (Mint A)",
    "subject": "Hessen",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2015: Hessen.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_2.jpg",
    "image_key": "de_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc2_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2015) - Reunification (25th Ann.) (Mint A)",
    "subject": "Reunification (25th Ann.)",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2015: Reunification (25th Ann.).",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_1.jpg",
    "image_key": "de_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc-common_a",
    "country": "Germany (A)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2015) - EU Flag (Mint A)",
    "subject": "EU Flag",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_0.jpg",
    "image_key": "de_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2016_1cent_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2016) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 116600000,
    "mintageFormatted": "116,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_2cent_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2016) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 101400000,
    "mintageFormatted": "101,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_5cent_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2016) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 49200000,
    "mintageFormatted": "49,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_10cent_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2016) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_20cent_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2016) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 38400000,
    "mintageFormatted": "38,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_50cent_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2016) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_1euro_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2016) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2016) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 14200000,
    "mintageFormatted": "14,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2016_cc1_a",
    "country": "Germany (A)",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2016) - Sachsen (Mint A)",
    "subject": "Sachsen",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2016: Sachsen.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2016_2euro_0.jpg",
    "image_key": "de_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1cent_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2017) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 81600000,
    "mintageFormatted": "81,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_2cent_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2017) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 72200000,
    "mintageFormatted": "72,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_5cent_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2017) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_10cent_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2017) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 25200000,
    "mintageFormatted": "25,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_20cent_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2017) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 21600000,
    "mintageFormatted": "21,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_50cent_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2017) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1euro_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2017) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2017) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 18120000,
    "mintageFormatted": "18,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2017_cc1_a",
    "country": "Germany (A)",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2017) - Rheinland-Pfalz (Mint A)",
    "subject": "Rheinland-Pfalz",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2017: Rheinland-Pfalz.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2017_2euro_0.jpg",
    "image_key": "de_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1cent_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2018) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 90600000,
    "mintageFormatted": "90,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_2cent_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2018) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 95800000,
    "mintageFormatted": "95,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_5cent_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2018) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 40600000,
    "mintageFormatted": "40,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_10cent_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2018) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 24000000,
    "mintageFormatted": "24,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_20cent_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2018) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 28400000,
    "mintageFormatted": "28,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_50cent_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2018) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1euro_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2018) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc1_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2018) - Berlin (Mint A)",
    "subject": "Berlin",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2018: Berlin.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_1.jpg",
    "image_key": "de_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc2_a",
    "country": "Germany (A)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2018) - Helmut Schmidt (Mint A)",
    "subject": "Helmut Schmidt",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2018: Helmut Schmidt.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_0.jpg",
    "image_key": "de_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1cent_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2019) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 71100000,
    "mintageFormatted": "71,100,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_2cent_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2019) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 83700000,
    "mintageFormatted": "83,700,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_5cent_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2019) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 40050000,
    "mintageFormatted": "40,050,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_10cent_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2019) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 29500000,
    "mintageFormatted": "29,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_20cent_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2019) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 33800000,
    "mintageFormatted": "33,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_50cent_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2019) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1euro_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2019) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2019) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 14550000,
    "mintageFormatted": "14,550,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc1_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2019) - Bundesrat (Mint A)",
    "subject": "Bundesrat",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2019: Bundesrat.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_1.jpg",
    "image_key": "de_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc2_a",
    "country": "Germany (A)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2019) - Fall of the Berlin Wall (Mint A)",
    "subject": "Fall of the Berlin Wall",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2019: Fall of the Berlin Wall.",
    "mintage": 6530000,
    "mintageFormatted": "6,530,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_0.jpg",
    "image_key": "de_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1cent_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2020) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 49000000,
    "mintageFormatted": "49,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_2cent_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2020) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 65800000,
    "mintageFormatted": "65,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_5cent_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2020) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 19600000,
    "mintageFormatted": "19,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_10cent_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2020) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 39800000,
    "mintageFormatted": "39,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_20cent_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2020) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 38800000,
    "mintageFormatted": "38,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_50cent_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2020) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1euro_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2020) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2020) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 16000000,
    "mintageFormatted": "16,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc1_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2020) - Brandenburg (Mint A)",
    "subject": "Brandenburg",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2020: Brandenburg.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_1.jpg",
    "image_key": "de_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc2_a",
    "country": "Germany (A)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2020) - Warsaw genuflection (Mint A)",
    "subject": "Warsaw genuflection",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2020: Warsaw genuflection.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_0.jpg",
    "image_key": "de_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1cent_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2021) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 51400000,
    "mintageFormatted": "51,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_2cent_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2021) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 97600000,
    "mintageFormatted": "97,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_5cent_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2021) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 47600000,
    "mintageFormatted": "47,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_10cent_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2021) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 29600000,
    "mintageFormatted": "29,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_20cent_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2021) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_50cent_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2021) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1euro_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2021) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2021) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2021_cc1_a",
    "country": "Germany (A)",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2021) - Sachsen-Anhalt (Mint A)",
    "subject": "Sachsen-Anhalt",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2021: Sachsen-Anhalt.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2021_2euro_0.jpg",
    "image_key": "de_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1cent_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Cent (2022) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_2cent_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2022) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 42200000,
    "mintageFormatted": "42,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_5cent_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2022) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 27000000,
    "mintageFormatted": "27,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_10cent_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2022) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 19800000,
    "mintageFormatted": "19,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_20cent_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2022) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 26200000,
    "mintageFormatted": "26,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_50cent_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 50 Cents (2022) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1euro_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2022) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 2 Euros (2022) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc1_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2022) - Thüringen (Mint A)",
    "subject": "Thüringen",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2022: Thüringen.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_0.jpg",
    "image_key": "de_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc-common_a",
    "country": "Germany (A)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2022) - Erasmus Programme (Mint A)",
    "subject": "Erasmus Programme",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 3400000,
    "mintageFormatted": "3,400,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_1.jpg",
    "image_key": "de_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2023_1cent_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2023) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 28800000,
    "mintageFormatted": "28,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_2cent_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2023) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 18000000,
    "mintageFormatted": "18,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_5cent_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2023) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_10cent_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2023) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 18400000,
    "mintageFormatted": "18,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_20cent_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2023) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 11000000,
    "mintageFormatted": "11,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_50cent_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 50 Cents (2023) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_1euro_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2023) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2023) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 11000000,
    "mintageFormatted": "11,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc1_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2023) - Hamburg (Mint A)",
    "subject": "Hamburg",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2023: Hamburg.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_0.jpg",
    "image_key": "de_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc2_a",
    "country": "Germany (A)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2023) - Charlemagne (Mint A)",
    "subject": "Charlemagne",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2023: Charlemagne.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_1.jpg",
    "image_key": "de_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1cent_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2024) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 14000000,
    "mintageFormatted": "14,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_2cent_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 2 Cents (2024) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_5cent_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2024) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 10600000,
    "mintageFormatted": "10,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_10cent_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 10 Cents (2024) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 9800000,
    "mintageFormatted": "9,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_20cent_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2024) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4400000,
    "mintageFormatted": "4,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_50cent_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 50 Cents (2024) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1euro_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2024) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2024) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 8600000,
    "mintageFormatted": "8,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc1_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2024) - Mecklenburg-Vorpommern (Mint A)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2024: Mecklenburg-Vorpommern.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_0.jpg",
    "image_key": "de_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc2_a",
    "country": "Germany (A)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2024) - Constitution of St. Paul's Church (Mint A)",
    "subject": "Constitution of St. Paul's Church",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2024: Constitution of St. Paul's Church.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_1.jpg",
    "image_key": "de_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1cent_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Cent (2025) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_2cent_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 2 Cents (2025) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_5cent_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 5 Cents (2025) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_10cent_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2025) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_20cent_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 20 Cents (2025) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_50cent_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 50 Cents (2025) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 5400000,
    "mintageFormatted": "5,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1euro_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2025) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2025) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 5600000,
    "mintageFormatted": "5,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc1_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2025) - Saarland (Mint A)",
    "subject": "Saarland",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2025: Saarland.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2025_2euro_0.jpg",
    "image_key": "de_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc2_a",
    "country": "Germany (A)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2025) - Reunification (35th Ann.) (Mint A)",
    "subject": "Reunification (35th Ann.)",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2025: Reunification (35th Ann.).",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1cent_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 1 Cent (2026) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 19400000,
    "mintageFormatted": "19,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_2cent_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Cents (2026) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 32400000,
    "mintageFormatted": "32,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_5cent_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 5 Cents (2026) - Oak Twig (Eichenlaub) (Mint A)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at A)",
    "mintage": 10800000,
    "mintageFormatted": "10,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_10cent_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 10 Cents (2026) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_20cent_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 20 Cents (2026) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 4400000,
    "mintageFormatted": "4,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_50cent_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 50 Cents (2026) - Brandenburg Gate (Mint A)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at A)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1euro_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "A",
    "strikeType": "In Sets / Collector",
    "name": "Germany (A) 1 Euro (2026) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Standard Circulation",
    "name": "Germany (A) 2 Euros (2026) - Federal Eagle (Bundesadler) (Mint A)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at A)",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc1_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2026) - Konrad Adenauer (Mint A)",
    "subject": "Konrad Adenauer",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2026: Konrad Adenauer.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc2_a",
    "country": "Germany (A)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "A",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (A) 2€ Commemorative (2026) - Bremen (Mint A)",
    "subject": "Bremen",
    "description": "Germany (A) 2 Euro Commemorative coin issued in 2026: Bremen.",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1cent_d",
    "country": "Germany (D)",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2002) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 840000000,
    "mintageFormatted": "840,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_2cent_d",
    "country": "Germany (D)",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2002) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 483000000,
    "mintageFormatted": "483,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_5cent_d",
    "country": "Germany (D)",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2002) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 504000000,
    "mintageFormatted": "504,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_10cent_d",
    "country": "Germany (D)",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2002) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 721950000,
    "mintageFormatted": "721,950,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_20cent_d",
    "country": "Germany (D)",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2002) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 367000000,
    "mintageFormatted": "367,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_50cent_d",
    "country": "Germany (D)",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 50 Cents (2002) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 370240000,
    "mintageFormatted": "370,240,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1euro_d",
    "country": "Germany (D)",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Euro (2002) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 372600000,
    "mintageFormatted": "372,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_d",
    "country": "Germany (D)",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2002) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 231300000,
    "mintageFormatted": "231,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1cent_d",
    "country": "Germany (D)",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Cent (2003) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_2cent_d",
    "country": "Germany (D)",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2003) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 105000000,
    "mintageFormatted": "105,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_5cent_d",
    "country": "Germany (D)",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 5 Cents (2003) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_10cent_d",
    "country": "Germany (D)",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2003) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 50850000,
    "mintageFormatted": "50,850,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_20cent_d",
    "country": "Germany (D)",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2003) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 24100000,
    "mintageFormatted": "24,100,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_50cent_d",
    "country": "Germany (D)",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 50 Cents (2003) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 70615000,
    "mintageFormatted": "70,615,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1euro_d",
    "country": "Germany (D)",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2003) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_d",
    "country": "Germany (D)",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2003) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 22179000,
    "mintageFormatted": "22,179,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1cent_d",
    "country": "Germany (D)",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2004) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 294000000,
    "mintageFormatted": "294,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_2cent_d",
    "country": "Germany (D)",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2004) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 133350000,
    "mintageFormatted": "133,350,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_5cent_d",
    "country": "Germany (D)",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2004) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 117600000,
    "mintageFormatted": "117,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_10cent_d",
    "country": "Germany (D)",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2004) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 11195000,
    "mintageFormatted": "11,195,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_20cent_d",
    "country": "Germany (D)",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2004) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 49755000,
    "mintageFormatted": "49,755,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_50cent_d",
    "country": "Germany (D)",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2004) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1euro_d",
    "country": "Germany (D)",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Euro (2004) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 89255000,
    "mintageFormatted": "89,255,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_d",
    "country": "Germany (D)",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2004) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 19841000,
    "mintageFormatted": "19,841,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1cent_d",
    "country": "Germany (D)",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2005) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 126000000,
    "mintageFormatted": "126,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_2cent_d",
    "country": "Germany (D)",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2005) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 76650000,
    "mintageFormatted": "76,650,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_5cent_d",
    "country": "Germany (D)",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2005) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 46200000,
    "mintageFormatted": "46,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_10cent_d",
    "country": "Germany (D)",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2005) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_20cent_d",
    "country": "Germany (D)",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2005) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 8400000,
    "mintageFormatted": "8,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_50cent_d",
    "country": "Germany (D)",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2005) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1euro_d",
    "country": "Germany (D)",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2005) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_d",
    "country": "Germany (D)",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 2 Euros (2005) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1cent_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Cent (2006) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_2cent_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2006) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 113400000,
    "mintageFormatted": "113,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_5cent_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2006) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 28350000,
    "mintageFormatted": "28,350,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_10cent_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2006) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_20cent_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2006) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 40950000,
    "mintageFormatted": "40,950,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_50cent_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2006) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1euro_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2006) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 2 Euros (2006) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2006_cc1_d",
    "country": "Germany (D)",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2006) - Schleswig-Holstein (Mint D)",
    "subject": "Schleswig-Holstein",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2006: Schleswig-Holstein.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2006_2euro_0.jpg",
    "image_key": "de_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1cent_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2007) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 125370000,
    "mintageFormatted": "125,370,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_2cent_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2007) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 105000000,
    "mintageFormatted": "105,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_5cent_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2007) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 55020000,
    "mintageFormatted": "55,020,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_10cent_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2007) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_20cent_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2007) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 22680000,
    "mintageFormatted": "22,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_50cent_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2007) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1euro_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2007) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc1_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2007) - Mecklenburg-Vorpommern (Mint D)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2007: Mecklenburg-Vorpommern.",
    "mintage": 11835000,
    "mintageFormatted": "11,835,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_1.jpg",
    "image_key": "de_commemorative_2007_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc-common_d",
    "country": "Germany (D)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2007) - Treaty of Rome (ToR) (Mint D)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 14500000,
    "mintageFormatted": "14,500,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_0.jpg",
    "image_key": "de_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2008_1cent_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2008) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 106260000,
    "mintageFormatted": "106,260,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_2cent_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2008) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 84000000,
    "mintageFormatted": "84,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_5cent_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2008) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 30660000,
    "mintageFormatted": "30,660,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_10cent_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2008) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_20cent_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2008) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 16590000,
    "mintageFormatted": "16,590,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_50cent_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2008) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_1euro_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2008) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2008) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 11970000,
    "mintageFormatted": "11,970,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2008_cc1_d",
    "country": "Germany (D)",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2008) - Hamburg (Mint D)",
    "subject": "Hamburg",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2008: Hamburg.",
    "mintage": 8900000,
    "mintageFormatted": "8,900,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2008_2euro_0.jpg",
    "image_key": "de_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1cent_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2009) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 105000000,
    "mintageFormatted": "105,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_2cent_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2009) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 61950000,
    "mintageFormatted": "61,950,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_5cent_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2009) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 41580000,
    "mintageFormatted": "41,580,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_10cent_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2009) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_20cent_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2009) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 22680000,
    "mintageFormatted": "22,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_50cent_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2009) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1euro_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2009) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc1_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2009) - Saarland (Mint D)",
    "subject": "Saarland",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2009: Saarland.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_0.jpg",
    "image_key": "de_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc-common_d",
    "country": "Germany (D)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2009) - Economic and Monetary Union (EMU) (Mint D)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_1.jpg",
    "image_key": "de_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2010_1cent_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2010) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 99120000,
    "mintageFormatted": "99,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_2cent_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2010) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 76440000,
    "mintageFormatted": "76,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_5cent_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2010) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 41790000,
    "mintageFormatted": "41,790,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_10cent_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2010) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_20cent_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2010) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 25620000,
    "mintageFormatted": "25,620,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_50cent_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2010) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_1euro_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2010) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2010) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 20580000,
    "mintageFormatted": "20,580,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2010_cc1_d",
    "country": "Germany (D)",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2010) - Bremen (Mint D)",
    "subject": "Bremen",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2010: Bremen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2010_2euro_0.jpg",
    "image_key": "de_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1cent_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2011) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 124320000,
    "mintageFormatted": "124,320,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_2cent_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2011) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 105420000,
    "mintageFormatted": "105,420,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_5cent_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2011) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 62160000,
    "mintageFormatted": "62,160,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_10cent_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2011) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_20cent_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2011) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 34650000,
    "mintageFormatted": "34,650,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_50cent_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2011) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1euro_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2011) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2011) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 24990000,
    "mintageFormatted": "24,990,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2011_cc1_d",
    "country": "Germany (D)",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2011) - Nordrhein-Westfalen (Mint D)",
    "subject": "Nordrhein-Westfalen",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2011: Nordrhein-Westfalen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2011_2euro_0.jpg",
    "image_key": "de_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1cent_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2012) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 109410000,
    "mintageFormatted": "109,410,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_2cent_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2012) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 81270000,
    "mintageFormatted": "81,270,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_5cent_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2012) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 43890000,
    "mintageFormatted": "43,890,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_10cent_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2012) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_20cent_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2012) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 22260000,
    "mintageFormatted": "22,260,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_50cent_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2012) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1euro_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2012) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc1_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2012) - Bayern (Mint D)",
    "subject": "Bayern",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2012: Bayern.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_0.jpg",
    "image_key": "de_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc-common_d",
    "country": "Germany (D)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2012) - Ten Years of Euro (TYE) (Mint D)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_1.jpg",
    "image_key": "de_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2013_1cent_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2013) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 63000000,
    "mintageFormatted": "63,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_2cent_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2013) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 63000000,
    "mintageFormatted": "63,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_5cent_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2013) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 33600000,
    "mintageFormatted": "33,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_10cent_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2013) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_20cent_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2013) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 16800000,
    "mintageFormatted": "16,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_50cent_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2013) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_1euro_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2013) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc1_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2013) - Baden-Württemberg (Mint D)",
    "subject": "Baden-Württemberg",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2013: Baden-Württemberg.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_0.jpg",
    "image_key": "de_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc2_d",
    "country": "Germany (D)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2013) - Élysée Treaty (Mint D)",
    "subject": "Élysée Treaty",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2013: Élysée Treaty.",
    "mintage": 2310000,
    "mintageFormatted": "2,310,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_1.jpg",
    "image_key": "de_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1cent_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2014) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 69300000,
    "mintageFormatted": "69,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_2cent_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2014) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 64890000,
    "mintageFormatted": "64,890,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_5cent_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2014) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 33600000,
    "mintageFormatted": "33,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_10cent_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2014) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_20cent_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2014) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 20160000,
    "mintageFormatted": "20,160,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_50cent_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2014) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1euro_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2014) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2014) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 5880000,
    "mintageFormatted": "5,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2014_cc1_d",
    "country": "Germany (D)",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2014) - Niedersachsen (Mint D)",
    "subject": "Niedersachsen",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2014: Niedersachsen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2014_2euro_0.jpg",
    "image_key": "de_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1cent_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2015) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 90510000,
    "mintageFormatted": "90,510,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_2cent_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2015) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 79800000,
    "mintageFormatted": "79,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_5cent_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2015) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 34440000,
    "mintageFormatted": "34,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_10cent_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2015) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_20cent_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2015) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 23940000,
    "mintageFormatted": "23,940,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_50cent_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2015) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1euro_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2015) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc1_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2015) - Hessen (Mint D)",
    "subject": "Hessen",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2015: Hessen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_2.jpg",
    "image_key": "de_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc2_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2015) - Reunification (25th Ann.) (Mint D)",
    "subject": "Reunification (25th Ann.)",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2015: Reunification (25th Ann.).",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_1.jpg",
    "image_key": "de_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc-common_d",
    "country": "Germany (D)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2015) - EU Flag (Mint D)",
    "subject": "EU Flag",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_0.jpg",
    "image_key": "de_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2016_1cent_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2016) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 122430000,
    "mintageFormatted": "122,430,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_2cent_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2016) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 106470000,
    "mintageFormatted": "106,470,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_5cent_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2016) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 51660000,
    "mintageFormatted": "51,660,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_10cent_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2016) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_20cent_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2016) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 40320000,
    "mintageFormatted": "40,320,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_50cent_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2016) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_1euro_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2016) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2016) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 14910000,
    "mintageFormatted": "14,910,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2016_cc1_d",
    "country": "Germany (D)",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2016) - Sachsen (Mint D)",
    "subject": "Sachsen",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2016: Sachsen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2016_2euro_0.jpg",
    "image_key": "de_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1cent_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2017) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 85680000,
    "mintageFormatted": "85,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_2cent_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2017) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 75810000,
    "mintageFormatted": "75,810,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_5cent_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2017) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 31500000,
    "mintageFormatted": "31,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_10cent_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2017) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 26460000,
    "mintageFormatted": "26,460,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_20cent_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2017) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 22680000,
    "mintageFormatted": "22,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_50cent_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2017) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1euro_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2017) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2017) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 19110000,
    "mintageFormatted": "19,110,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2017_cc1_d",
    "country": "Germany (D)",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2017) - Rheinland-Pfalz (Mint D)",
    "subject": "Rheinland-Pfalz",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2017: Rheinland-Pfalz.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2017_2euro_0.jpg",
    "image_key": "de_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1cent_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2018) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 95130000,
    "mintageFormatted": "95,130,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_2cent_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2018) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 100590000,
    "mintageFormatted": "100,590,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_5cent_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2018) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 42630000,
    "mintageFormatted": "42,630,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_10cent_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2018) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 25200000,
    "mintageFormatted": "25,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_20cent_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2018) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 29820000,
    "mintageFormatted": "29,820,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_50cent_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2018) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1euro_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2018) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc1_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2018) - Berlin (Mint D)",
    "subject": "Berlin",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2018: Berlin.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_1.jpg",
    "image_key": "de_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc2_d",
    "country": "Germany (D)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2018) - Helmut Schmidt (Mint D)",
    "subject": "Helmut Schmidt",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2018: Helmut Schmidt.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_0.jpg",
    "image_key": "de_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1cent_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2019) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 76170000,
    "mintageFormatted": "76,170,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_2cent_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2019) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 89400000,
    "mintageFormatted": "89,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_5cent_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2019) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 43570000,
    "mintageFormatted": "43,570,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_10cent_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2019) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 32490000,
    "mintageFormatted": "32,490,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_20cent_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2019) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 37010000,
    "mintageFormatted": "37,010,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_50cent_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2019) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1euro_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2019) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2019) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 17790000,
    "mintageFormatted": "17,790,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc1_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2019) - Bundesrat (Mint D)",
    "subject": "Bundesrat",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2019: Bundesrat.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_1.jpg",
    "image_key": "de_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc2_d",
    "country": "Germany (D)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2019) - Fall of the Berlin Wall (Mint D)",
    "subject": "Fall of the Berlin Wall",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2019: Fall of the Berlin Wall.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_0.jpg",
    "image_key": "de_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1cent_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2020) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 51450000,
    "mintageFormatted": "51,450,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_2cent_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2020) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 69090000,
    "mintageFormatted": "69,090,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_5cent_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2020) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 20580000,
    "mintageFormatted": "20,580,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_10cent_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2020) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 41790000,
    "mintageFormatted": "41,790,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_20cent_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2020) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 40740000,
    "mintageFormatted": "40,740,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_50cent_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2020) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1euro_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2020) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2020) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 16800000,
    "mintageFormatted": "16,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc1_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2020) - Brandenburg (Mint D)",
    "subject": "Brandenburg",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2020: Brandenburg.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_1.jpg",
    "image_key": "de_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc2_d",
    "country": "Germany (D)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2020) - Warsaw genuflection (Mint D)",
    "subject": "Warsaw genuflection",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2020: Warsaw genuflection.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_0.jpg",
    "image_key": "de_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1cent_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2021) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 53970000,
    "mintageFormatted": "53,970,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_2cent_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2021) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 102480000,
    "mintageFormatted": "102,480,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_5cent_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2021) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 49980000,
    "mintageFormatted": "49,980,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_10cent_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2021) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 31080000,
    "mintageFormatted": "31,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_20cent_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2021) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 31500000,
    "mintageFormatted": "31,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_50cent_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2021) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1euro_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2021) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2021) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2021_cc1_d",
    "country": "Germany (D)",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2021) - Sachsen-Anhalt (Mint D)",
    "subject": "Sachsen-Anhalt",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2021: Sachsen-Anhalt.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2021_2euro_0.jpg",
    "image_key": "de_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1cent_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Cent (2022) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_2cent_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2022) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 44310000,
    "mintageFormatted": "44,310,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_5cent_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2022) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 28350000,
    "mintageFormatted": "28,350,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_10cent_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2022) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 20790000,
    "mintageFormatted": "20,790,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_20cent_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2022) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 27510000,
    "mintageFormatted": "27,510,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_50cent_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 50 Cents (2022) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1euro_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2022) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 2 Euros (2022) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc1_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2022) - Thüringen (Mint D)",
    "subject": "Thüringen",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2022: Thüringen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_0.jpg",
    "image_key": "de_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc-common_d",
    "country": "Germany (D)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2022) - Erasmus (Mint D)",
    "subject": "Erasmus",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2022: Erasmus.",
    "mintage": 3570000,
    "mintageFormatted": "3,570,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_1.jpg",
    "image_key": "de_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2023_1cent_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2023) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 30240000,
    "mintageFormatted": "30,240,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_2cent_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2023) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 18900000,
    "mintageFormatted": "18,900,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_5cent_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2023) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 9450000,
    "mintageFormatted": "9,450,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_10cent_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2023) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 19320000,
    "mintageFormatted": "19,320,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_20cent_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2023) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 11550000,
    "mintageFormatted": "11,550,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_50cent_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 50 Cents (2023) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 12600000,
    "mintageFormatted": "12,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_1euro_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2023) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2023) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 11550000,
    "mintageFormatted": "11,550,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc1_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2023) - Hamburg (Mint D)",
    "subject": "Hamburg",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2023: Hamburg.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_0.jpg",
    "image_key": "de_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc2_d",
    "country": "Germany (D)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2023) - Charlemagne (Mint D)",
    "subject": "Charlemagne",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2023: Charlemagne.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_1.jpg",
    "image_key": "de_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1cent_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2024) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 14700000,
    "mintageFormatted": "14,700,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_2cent_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 2 Cents (2024) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_5cent_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2024) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 11130000,
    "mintageFormatted": "11,130,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_10cent_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 10 Cents (2024) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 10290000,
    "mintageFormatted": "10,290,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_20cent_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2024) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4620000,
    "mintageFormatted": "4,620,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_50cent_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 50 Cents (2024) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 9450000,
    "mintageFormatted": "9,450,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1euro_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2024) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2024) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 9030000,
    "mintageFormatted": "9,030,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc1_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2024) - Mecklenburg-Vorpommern (Mint D)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2024: Mecklenburg-Vorpommern.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_0.jpg",
    "image_key": "de_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc2_d",
    "country": "Germany (D)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2024) - Constitution of St. Paul's Church (Mint D)",
    "subject": "Constitution of St. Paul's Church",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2024: Constitution of St. Paul's Church.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_1.jpg",
    "image_key": "de_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1cent_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Cent (2025) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_2cent_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 2 Cents (2025) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_5cent_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 5 Cents (2025) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_10cent_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2025) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_20cent_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 20 Cents (2025) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_50cent_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 50 Cents (2025) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 5670000,
    "mintageFormatted": "5,670,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1euro_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2025) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2025) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 5880000,
    "mintageFormatted": "5,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc1_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2025) - Saarland (Mint D)",
    "subject": "Saarland",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2025: Saarland.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2025_2euro_0.jpg",
    "image_key": "de_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc2_d",
    "country": "Germany (D)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2025) - Reunification (35th Ann.) (Mint D)",
    "subject": "Reunification (35th Ann.)",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2025: Reunification (35th Ann.).",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1cent_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 1 Cent (2026) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 20370000,
    "mintageFormatted": "20,370,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_2cent_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Cents (2026) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 34020000,
    "mintageFormatted": "34,020,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_5cent_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 5 Cents (2026) - Oak Twig (Eichenlaub) (Mint D)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at D)",
    "mintage": 11340000,
    "mintageFormatted": "11,340,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_10cent_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 10 Cents (2026) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_20cent_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 20 Cents (2026) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 4620000,
    "mintageFormatted": "4,620,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_50cent_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 50 Cents (2026) - Brandenburg Gate (Mint D)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at D)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1euro_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "D",
    "strikeType": "In Sets / Collector",
    "name": "Germany (D) 1 Euro (2026) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Standard Circulation",
    "name": "Germany (D) 2 Euros (2026) - Federal Eagle (Bundesadler) (Mint D)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at D)",
    "mintage": 8400000,
    "mintageFormatted": "8,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc1_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2026) - Konrad Adenauer (Mint D)",
    "subject": "Konrad Adenauer",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2026: Konrad Adenauer.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc2_d",
    "country": "Germany (D)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "D",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (D) 2€ Commemorative (2026) - Bremen (Mint D)",
    "subject": "Bremen",
    "description": "Germany (D) 2 Euro Commemorative coin issued in 2026: Bremen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1cent_f",
    "country": "Germany (F)",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2002) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 902660000,
    "mintageFormatted": "902,660,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_2cent_f",
    "country": "Germany (F)",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2002) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 495960000,
    "mintageFormatted": "495,960,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_5cent_f",
    "country": "Germany (F)",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2002) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 563710000,
    "mintageFormatted": "563,710,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_10cent_f",
    "country": "Germany (F)",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2002) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 788860000,
    "mintageFormatted": "788,860,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_20cent_f",
    "country": "Germany (F)",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2002) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 423760000,
    "mintageFormatted": "423,760,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_50cent_f",
    "country": "Germany (F)",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 50 Cents (2002) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 431980000,
    "mintageFormatted": "431,980,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1euro_f",
    "country": "Germany (F)",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Euro (2002) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 440910000,
    "mintageFormatted": "440,910,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_f",
    "country": "Germany (F)",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2002) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 264610000,
    "mintageFormatted": "264,610,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1cent_f",
    "country": "Germany (F)",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Cent (2003) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_2cent_f",
    "country": "Germany (F)",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2003) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 175400000,
    "mintageFormatted": "175,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_5cent_f",
    "country": "Germany (F)",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 5 Cents (2003) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_10cent_f",
    "country": "Germany (F)",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2003) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_20cent_f",
    "country": "Germany (F)",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2003) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 80040000,
    "mintageFormatted": "80,040,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_50cent_f",
    "country": "Germany (F)",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2003) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1euro_f",
    "country": "Germany (F)",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Euro (2003) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 375000,
    "mintageFormatted": "375,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_f",
    "country": "Germany (F)",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2003) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 40990000,
    "mintageFormatted": "40,990,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1cent_f",
    "country": "Germany (F)",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2004) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 339334000,
    "mintageFormatted": "339,334,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_2cent_f",
    "country": "Germany (F)",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2004) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 152400000,
    "mintageFormatted": "152,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_5cent_f",
    "country": "Germany (F)",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2004) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 146690000,
    "mintageFormatted": "146,690,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_10cent_f",
    "country": "Germany (F)",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2004) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 51200000,
    "mintageFormatted": "51,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_20cent_f",
    "country": "Germany (F)",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 20 Cents (2004) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_50cent_f",
    "country": "Germany (F)",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 50 Cents (2004) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 72020000,
    "mintageFormatted": "72,020,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1euro_f",
    "country": "Germany (F)",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Euro (2004) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 86715000,
    "mintageFormatted": "86,715,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_f",
    "country": "Germany (F)",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 2 Euros (2004) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1cent_f",
    "country": "Germany (F)",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2005) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 144000000,
    "mintageFormatted": "144,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_2cent_f",
    "country": "Germany (F)",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2005) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 87600000,
    "mintageFormatted": "87,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_5cent_f",
    "country": "Germany (F)",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2005) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 52800000,
    "mintageFormatted": "52,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_10cent_f",
    "country": "Germany (F)",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2005) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_20cent_f",
    "country": "Germany (F)",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2005) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 9600000,
    "mintageFormatted": "9,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_50cent_f",
    "country": "Germany (F)",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2005) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1euro_f",
    "country": "Germany (F)",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2005) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_f",
    "country": "Germany (F)",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 2 Euros (2005) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1cent_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Cent (2006) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_2cent_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2006) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 129600000,
    "mintageFormatted": "129,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_5cent_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2006) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 32400000,
    "mintageFormatted": "32,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_10cent_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2006) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_20cent_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2006) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 46800000,
    "mintageFormatted": "46,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_50cent_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2006) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1euro_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2006) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 2 Euros (2006) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2006_cc1_f",
    "country": "Germany (F)",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2006) - Schleswig-Holstein (Mint F)",
    "subject": "Schleswig-Holstein",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2006: Schleswig-Holstein.",
    "mintage": 7260000,
    "mintageFormatted": "7,260,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2006_2euro_0.jpg",
    "image_key": "de_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1cent_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2007) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 143280000,
    "mintageFormatted": "143,280,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_2cent_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2007) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 120000000,
    "mintageFormatted": "120,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_5cent_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2007) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 62880000,
    "mintageFormatted": "62,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_10cent_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2007) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_20cent_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2007) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 25520000,
    "mintageFormatted": "25,520,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_50cent_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2007) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1euro_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2007) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc1_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2007) - Mecklenburg-Vorpommern (Mint F)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2007: Mecklenburg-Vorpommern.",
    "mintage": 11850000,
    "mintageFormatted": "11,850,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_1.jpg",
    "image_key": "de_commemorative_2007_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc-common_f",
    "country": "Germany (F)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2007) - Treaty of Rome (ToR) (Mint F)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_0.jpg",
    "image_key": "de_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2008_1cent_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2008) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 121440000,
    "mintageFormatted": "121,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_2cent_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2008) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 96000000,
    "mintageFormatted": "96,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_5cent_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2008) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 35040000,
    "mintageFormatted": "35,040,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_10cent_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2008) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_20cent_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2008) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 18960000,
    "mintageFormatted": "18,960,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_50cent_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2008) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_1euro_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2008) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2008) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 13680000,
    "mintageFormatted": "13,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2008_cc1_f",
    "country": "Germany (F)",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2008) - Hamburg (Mint F)",
    "subject": "Hamburg",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2008: Hamburg.",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2008_2euro_0.jpg",
    "image_key": "de_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1cent_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2009) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 120000000,
    "mintageFormatted": "120,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_2cent_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2009) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 70800000,
    "mintageFormatted": "70,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_5cent_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2009) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 47520000,
    "mintageFormatted": "47,520,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_10cent_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2009) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_20cent_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2009) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 25920000,
    "mintageFormatted": "25,920,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_50cent_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2009) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1euro_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2009) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc1_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2009) - Saarland (Mint F)",
    "subject": "Saarland",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2009: Saarland.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_0.jpg",
    "image_key": "de_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc-common_f",
    "country": "Germany (F)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2009) - Economic and Monetary Union (EMU) (Mint F)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_1.jpg",
    "image_key": "de_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2010_1cent_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2010) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 113280000,
    "mintageFormatted": "113,280,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_2cent_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2010) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 87360000,
    "mintageFormatted": "87,360,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_5cent_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2010) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 47760000,
    "mintageFormatted": "47,760,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_10cent_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2010) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_20cent_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2010) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 29280000,
    "mintageFormatted": "29,280,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_50cent_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2010) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_1euro_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2010) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2010) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 23520000,
    "mintageFormatted": "23,520,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2010_cc1_f",
    "country": "Germany (F)",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2010) - Bremen (Mint F)",
    "subject": "Bremen",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2010: Bremen.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2010_2euro_0.jpg",
    "image_key": "de_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1cent_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2011) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 142080000,
    "mintageFormatted": "142,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_2cent_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2011) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 120480000,
    "mintageFormatted": "120,480,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_5cent_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2011) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 71040000,
    "mintageFormatted": "71,040,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_10cent_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2011) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_20cent_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2011) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 39600000,
    "mintageFormatted": "39,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_50cent_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2011) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1euro_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2011) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2011) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 28560000,
    "mintageFormatted": "28,560,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2011_cc1_f",
    "country": "Germany (F)",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2011) - Nordrhein-Westfalen (Mint F)",
    "subject": "Nordrhein-Westfalen",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2011: Nordrhein-Westfalen.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2011_2euro_0.jpg",
    "image_key": "de_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1cent_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2012) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 125040000,
    "mintageFormatted": "125,040,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_2cent_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2012) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 92880000,
    "mintageFormatted": "92,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_5cent_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2012) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 50160000,
    "mintageFormatted": "50,160,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_10cent_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2012) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_20cent_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2012) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 25440000,
    "mintageFormatted": "25,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_50cent_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2012) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1euro_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2012) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc1_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2012) - Bayern (Mint F)",
    "subject": "Bayern",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2012: Bayern.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_0.jpg",
    "image_key": "de_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc-common_f",
    "country": "Germany (F)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2012) - Ten Years of Euro (TYE) (Mint F)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_1.jpg",
    "image_key": "de_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2013_1cent_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2013) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 72000000,
    "mintageFormatted": "72,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_2cent_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2013) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 72000000,
    "mintageFormatted": "72,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_5cent_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2013) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 38400000,
    "mintageFormatted": "38,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_10cent_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2013) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_20cent_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2013) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 19200000,
    "mintageFormatted": "19,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_50cent_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2013) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_1euro_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2013) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc1_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2013) - Baden-Württemberg (Mint F)",
    "subject": "Baden-Württemberg",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2013: Baden-Württemberg.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_0.jpg",
    "image_key": "de_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc2_f",
    "country": "Germany (F)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2013) - Élysée Treaty (Mint F)",
    "subject": "Élysée Treaty",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2013: Élysée Treaty.",
    "mintage": 2640000,
    "mintageFormatted": "2,640,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_1.jpg",
    "image_key": "de_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1cent_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2014) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 79200000,
    "mintageFormatted": "79,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_2cent_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2014) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 74160000,
    "mintageFormatted": "74,160,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_5cent_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2014) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 38400000,
    "mintageFormatted": "38,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_10cent_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2014) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_20cent_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2014) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 23040000,
    "mintageFormatted": "23,040,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_50cent_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2014) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1euro_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2014) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2014) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 6720000,
    "mintageFormatted": "6,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2014_cc1_f",
    "country": "Germany (F)",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2014) - Niedersachsen (Mint F)",
    "subject": "Niedersachsen",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2014: Niedersachsen.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2014_2euro_0.jpg",
    "image_key": "de_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1cent_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2015) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 103440000,
    "mintageFormatted": "103,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_2cent_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2015) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 91200000,
    "mintageFormatted": "91,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_5cent_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2015) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 39360000,
    "mintageFormatted": "39,360,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_10cent_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2015) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_20cent_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2015) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 27360000,
    "mintageFormatted": "27,360,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_50cent_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2015) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1euro_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2015) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc1_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2015) - Hessen (Mint F)",
    "subject": "Hessen",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2015: Hessen.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_2.jpg",
    "image_key": "de_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc2_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2015) - Reunification (25th Ann.) (Mint F)",
    "subject": "Reunification (25th Ann.)",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2015: Reunification (25th Ann.).",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_1.jpg",
    "image_key": "de_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc-common_f",
    "country": "Germany (F)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2015) - EU Flag (Mint F)",
    "subject": "EU Flag",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_0.jpg",
    "image_key": "de_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2016_1cent_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2016) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 139920000,
    "mintageFormatted": "139,920,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_2cent_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2016) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 121680000,
    "mintageFormatted": "121,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_5cent_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2016) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 59040000,
    "mintageFormatted": "59,040,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_10cent_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2016) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_20cent_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2016) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 46080000,
    "mintageFormatted": "46,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_50cent_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2016) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_1euro_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2016) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2016) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 17040000,
    "mintageFormatted": "17,040,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2016_cc1_f",
    "country": "Germany (F)",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2016) - Sachsen (Mint F)",
    "subject": "Sachsen",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2016: Sachsen.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2016_2euro_0.jpg",
    "image_key": "de_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1cent_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2017) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 97920000,
    "mintageFormatted": "97,920,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_2cent_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2017) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 86640000,
    "mintageFormatted": "86,640,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_5cent_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2017) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 36000000,
    "mintageFormatted": "36,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_10cent_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2017) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 30240000,
    "mintageFormatted": "30,240,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_20cent_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2017) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 25920000,
    "mintageFormatted": "25,920,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_50cent_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2017) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1euro_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2017) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2017) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 21840000,
    "mintageFormatted": "21,840,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2017_cc1_f",
    "country": "Germany (F)",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2017) - Rheinland-Pfalz (Mint F)",
    "subject": "Rheinland-Pfalz",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2017: Rheinland-Pfalz.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2017_2euro_0.jpg",
    "image_key": "de_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1cent_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2018) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 108720000,
    "mintageFormatted": "108,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_2cent_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2018) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 114960000,
    "mintageFormatted": "114,960,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_5cent_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2018) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 48720000,
    "mintageFormatted": "48,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_10cent_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2018) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 28800000,
    "mintageFormatted": "28,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_20cent_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2018) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 34080000,
    "mintageFormatted": "34,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_50cent_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2018) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1euro_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2018) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc1_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2018) - Berlin (Mint F)",
    "subject": "Berlin",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2018: Berlin.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_1.jpg",
    "image_key": "de_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc2_f",
    "country": "Germany (F)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2018) - Helmut Schmidt (Mint F)",
    "subject": "Helmut Schmidt",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2018: Helmut Schmidt.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_0.jpg",
    "image_key": "de_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1cent_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2019) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 85380000,
    "mintageFormatted": "85,380,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_2cent_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2019) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 100500000,
    "mintageFormatted": "100,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_5cent_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2019) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 48120000,
    "mintageFormatted": "48,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_10cent_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2019) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 35460000,
    "mintageFormatted": "35,460,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_20cent_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2019) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 40620000,
    "mintageFormatted": "40,620,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_50cent_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2019) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1euro_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2019) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2019) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 17520000,
    "mintageFormatted": "17,520,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc1_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2019) - Bundesrat (Mint F)",
    "subject": "Bundesrat",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2019: Bundesrat.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_1.jpg",
    "image_key": "de_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc2_f",
    "country": "Germany (F)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2019) - Fall of the Berlin Wall (Mint F)",
    "subject": "Fall of the Berlin Wall",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2019: Fall of the Berlin Wall.",
    "mintage": 7840000,
    "mintageFormatted": "7,840,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_0.jpg",
    "image_key": "de_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1cent_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2020) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 58800000,
    "mintageFormatted": "58,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_2cent_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2020) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 78960000,
    "mintageFormatted": "78,960,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_5cent_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2020) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 23520000,
    "mintageFormatted": "23,520,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_10cent_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2020) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 47760000,
    "mintageFormatted": "47,760,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_20cent_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2020) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 46560000,
    "mintageFormatted": "46,560,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_50cent_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2020) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1euro_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2020) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2020) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 19200000,
    "mintageFormatted": "19,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc1_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2020) - Brandenburg (Mint F)",
    "subject": "Brandenburg",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2020: Brandenburg.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_1.jpg",
    "image_key": "de_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc2_f",
    "country": "Germany (F)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2020) - Warsaw genuflection (Mint F)",
    "subject": "Warsaw genuflection",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2020: Warsaw genuflection.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_0.jpg",
    "image_key": "de_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1cent_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2021) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 61680000,
    "mintageFormatted": "61,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_2cent_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2021) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 117120000,
    "mintageFormatted": "117,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_5cent_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2021) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 57120000,
    "mintageFormatted": "57,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_10cent_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2021) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 35520000,
    "mintageFormatted": "35,520,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_20cent_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2021) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 36000000,
    "mintageFormatted": "36,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_50cent_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2021) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1euro_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2021) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2021) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2021_cc1_f",
    "country": "Germany (F)",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2021) - Sachsen-Anhalt (Mint F)",
    "subject": "Sachsen-Anhalt",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2021: Sachsen-Anhalt.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2021_2euro_0.jpg",
    "image_key": "de_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1cent_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Cent (2022) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_2cent_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2022) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 50640000,
    "mintageFormatted": "50,640,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_5cent_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2022) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 32400000,
    "mintageFormatted": "32,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_10cent_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2022) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 23760000,
    "mintageFormatted": "23,760,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_20cent_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2022) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 31440000,
    "mintageFormatted": "31,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_50cent_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 50 Cents (2022) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 4800000,
    "mintageFormatted": "4,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1euro_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2022) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 2 Euros (2022) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc1_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2022) - Thüringen (Mint F)",
    "subject": "Thüringen",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2022: Thüringen.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_0.jpg",
    "image_key": "de_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc-common_f",
    "country": "Germany (F)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2022) - Erasmus (Mint F)",
    "subject": "Erasmus",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2022: Erasmus.",
    "mintage": 4080000,
    "mintageFormatted": "4,080,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_1.jpg",
    "image_key": "de_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2023_1cent_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2023) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 34560000,
    "mintageFormatted": "34,560,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_2cent_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2023) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 21600000,
    "mintageFormatted": "21,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_5cent_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2023) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 10800000,
    "mintageFormatted": "10,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_10cent_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2023) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 22080000,
    "mintageFormatted": "22,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_20cent_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2023) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 13200000,
    "mintageFormatted": "13,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_50cent_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 50 Cents (2023) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 14400000,
    "mintageFormatted": "14,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_1euro_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2023) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2023) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 13200000,
    "mintageFormatted": "13,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc1_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2023) - Hamburg (Mint F)",
    "subject": "Hamburg",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2023: Hamburg.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_0.jpg",
    "image_key": "de_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc2_f",
    "country": "Germany (F)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2023) - Charlemagne (Mint F)",
    "subject": "Charlemagne",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2023: Charlemagne.",
    "mintage": 4800000,
    "mintageFormatted": "4,800,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_1.jpg",
    "image_key": "de_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1cent_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2024) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 16800000,
    "mintageFormatted": "16,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_2cent_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 2 Cents (2024) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_5cent_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2024) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 12720000,
    "mintageFormatted": "12,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_10cent_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 10 Cents (2024) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 11760000,
    "mintageFormatted": "11,760,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_20cent_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2024) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 5280000,
    "mintageFormatted": "5,280,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_50cent_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 50 Cents (2024) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 10800000,
    "mintageFormatted": "10,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1euro_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2024) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2024) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 10220000,
    "mintageFormatted": "10,220,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc1_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2024) - Mecklenburg-Vorpommern (Mint F)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2024: Mecklenburg-Vorpommern.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_0.jpg",
    "image_key": "de_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc2_f",
    "country": "Germany (F)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2024) - Constitution of St. Paul's Church (Mint F)",
    "subject": "Constitution of St. Paul's Church",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2024: Constitution of St. Paul's Church.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_1.jpg",
    "image_key": "de_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1cent_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Cent (2025) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_2cent_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 2 Cents (2025) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_5cent_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 5 Cents (2025) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_10cent_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2025) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_20cent_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 20 Cents (2025) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_50cent_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 50 Cents (2025) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 6480000,
    "mintageFormatted": "6,480,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1euro_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2025) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2025) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 6720000,
    "mintageFormatted": "6,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc1_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2025) - Saarland (Mint F)",
    "subject": "Saarland",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2025: Saarland.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2025_2euro_0.jpg",
    "image_key": "de_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc2_f",
    "country": "Germany (F)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2025) - Reunification (35th Ann.) (Mint F)",
    "subject": "Reunification (35th Ann.)",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2025: Reunification (35th Ann.).",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1cent_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 1 Cent (2026) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 23280000,
    "mintageFormatted": "23,280,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_2cent_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Cents (2026) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 38880000,
    "mintageFormatted": "38,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_5cent_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 5 Cents (2026) - Oak Twig (Eichenlaub) (Mint F)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at F)",
    "mintage": 12960000,
    "mintageFormatted": "12,960,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_10cent_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 10 Cents (2026) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_20cent_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 20 Cents (2026) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 5280000,
    "mintageFormatted": "5,280,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_50cent_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 50 Cents (2026) - Brandenburg Gate (Mint F)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at F)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1euro_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "F",
    "strikeType": "In Sets / Collector",
    "name": "Germany (F) 1 Euro (2026) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Standard Circulation",
    "name": "Germany (F) 2 Euros (2026) - Federal Eagle (Bundesadler) (Mint F)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at F)",
    "mintage": 9600000,
    "mintageFormatted": "9,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc1_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2026) - Konrad Adenauer (Mint F)",
    "subject": "Konrad Adenauer",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2026: Konrad Adenauer.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc2_f",
    "country": "Germany (F)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "F",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (F) 2€ Commemorative (2026) - Bremen (Mint F)",
    "subject": "Bremen",
    "description": "Germany (F) 2 Euro Commemorative coin issued in 2026: Bremen.",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1cent_g",
    "country": "Germany (G)",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2002) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 537000000,
    "mintageFormatted": "537,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_2cent_g",
    "country": "Germany (G)",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2002) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 311800000,
    "mintageFormatted": "311,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_5cent_g",
    "country": "Germany (G)",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2002) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 328300000,
    "mintageFormatted": "328,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_10cent_g",
    "country": "Germany (G)",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2002) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 545400000,
    "mintageFormatted": "545,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_20cent_g",
    "country": "Germany (G)",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2002) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 252000000,
    "mintageFormatted": "252,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_50cent_g",
    "country": "Germany (G)",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 50 Cents (2002) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 257760000,
    "mintageFormatted": "257,760,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1euro_g",
    "country": "Germany (G)",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Euro (2002) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 266875000,
    "mintageFormatted": "266,875,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_g",
    "country": "Germany (G)",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2002) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 180950000,
    "mintageFormatted": "180,950,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1cent_g",
    "country": "Germany (G)",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Cent (2003) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_2cent_g",
    "country": "Germany (G)",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2003) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 80200000,
    "mintageFormatted": "80,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_5cent_g",
    "country": "Germany (G)",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 5 Cents (2003) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_10cent_g",
    "country": "Germany (G)",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2003) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_20cent_g",
    "country": "Germany (G)",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2003) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 42000000,
    "mintageFormatted": "42,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_50cent_g",
    "country": "Germany (G)",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2003) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1euro_g",
    "country": "Germany (G)",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2003) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_g",
    "country": "Germany (G)",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2003) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 29050000,
    "mintageFormatted": "29,050,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1cent_g",
    "country": "Germany (G)",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2004) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 218900000,
    "mintageFormatted": "218,900,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_2cent_g",
    "country": "Germany (G)",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2004) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 88900000,
    "mintageFormatted": "88,900,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_5cent_g",
    "country": "Germany (G)",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2004) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 86000000,
    "mintageFormatted": "86,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_10cent_g",
    "country": "Germany (G)",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2004) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 15460000,
    "mintageFormatted": "15,460,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_20cent_g",
    "country": "Germany (G)",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 20 Cents (2004) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_50cent_g",
    "country": "Germany (G)",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 50 Cents (2004) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 36240000,
    "mintageFormatted": "36,240,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1euro_g",
    "country": "Germany (G)",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Euro (2004) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 41025000,
    "mintageFormatted": "41,025,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_g",
    "country": "Germany (G)",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 2 Euros (2004) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1cent_g",
    "country": "Germany (G)",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2005) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 84000000,
    "mintageFormatted": "84,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_2cent_g",
    "country": "Germany (G)",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2005) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 51100000,
    "mintageFormatted": "51,100,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_5cent_g",
    "country": "Germany (G)",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2005) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 30800000,
    "mintageFormatted": "30,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_10cent_g",
    "country": "Germany (G)",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2005) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_20cent_g",
    "country": "Germany (G)",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2005) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 5600000,
    "mintageFormatted": "5,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_50cent_g",
    "country": "Germany (G)",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2005) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1euro_g",
    "country": "Germany (G)",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2005) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_g",
    "country": "Germany (G)",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 2 Euros (2005) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1cent_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Cent (2006) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_2cent_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2006) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 75600000,
    "mintageFormatted": "75,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_5cent_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2006) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 18900000,
    "mintageFormatted": "18,900,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_10cent_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2006) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_20cent_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2006) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 27300000,
    "mintageFormatted": "27,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_50cent_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2006) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1euro_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2006) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 2 Euros (2006) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2006_cc1_g",
    "country": "Germany (G)",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2006) - Schleswig-Holstein (Mint G)",
    "subject": "Schleswig-Holstein",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2006: Schleswig-Holstein.",
    "mintage": 4260000,
    "mintageFormatted": "4,260,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2006_2euro_0.jpg",
    "image_key": "de_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1cent_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2007) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 83580000,
    "mintageFormatted": "83,580,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_2cent_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2007) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_5cent_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2007) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 36680000,
    "mintageFormatted": "36,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_10cent_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2007) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_20cent_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2007) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 15120000,
    "mintageFormatted": "15,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_50cent_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2007) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1euro_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2007) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc1_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2007) - Mecklenburg-Vorpommern (Mint G)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2007: Mecklenburg-Vorpommern.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_1.jpg",
    "image_key": "de_commemorative_2007_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc-common_g",
    "country": "Germany (G)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2007) - Treaty of Rome (ToR) (Mint G)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_0.jpg",
    "image_key": "de_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2008_1cent_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2008) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 70840000,
    "mintageFormatted": "70,840,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_2cent_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2008) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 56000000,
    "mintageFormatted": "56,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_5cent_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2008) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 20440000,
    "mintageFormatted": "20,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_10cent_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2008) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_20cent_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2008) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 11060000,
    "mintageFormatted": "11,060,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_50cent_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2008) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_1euro_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2008) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2008) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 7980000,
    "mintageFormatted": "7,980,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2008_cc1_g",
    "country": "Germany (G)",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2008) - Hamburg (Mint G)",
    "subject": "Hamburg",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2008: Hamburg.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2008_2euro_0.jpg",
    "image_key": "de_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1cent_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2009) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_2cent_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2009) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 41300000,
    "mintageFormatted": "41,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_5cent_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2009) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 27720000,
    "mintageFormatted": "27,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_10cent_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2009) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_20cent_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2009) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 15120000,
    "mintageFormatted": "15,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_50cent_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2009) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1euro_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2009) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc1_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2009) - Saarland (Mint G)",
    "subject": "Saarland",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2009: Saarland.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_0.jpg",
    "image_key": "de_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc-common_g",
    "country": "Germany (G)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2009) - Economic and Monetary Union (EMU) (Mint G)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_1.jpg",
    "image_key": "de_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2010_1cent_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2010) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 66080000,
    "mintageFormatted": "66,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_2cent_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2010) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 50960000,
    "mintageFormatted": "50,960,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_5cent_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2010) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 27860000,
    "mintageFormatted": "27,860,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_10cent_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2010) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_20cent_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2010) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 17080000,
    "mintageFormatted": "17,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_50cent_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2010) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_1euro_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2010) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2010) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 13720000,
    "mintageFormatted": "13,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2010_cc1_g",
    "country": "Germany (G)",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2010) - Bremen (Mint G)",
    "subject": "Bremen",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2010: Bremen.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2010_2euro_0.jpg",
    "image_key": "de_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1cent_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2011) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 82880000,
    "mintageFormatted": "82,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_2cent_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2011) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 70280000,
    "mintageFormatted": "70,280,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_5cent_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2011) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 41440000,
    "mintageFormatted": "41,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_10cent_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2011) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_20cent_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2011) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 23100000,
    "mintageFormatted": "23,100,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_50cent_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2011) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1euro_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2011) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2011) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 16660000,
    "mintageFormatted": "16,660,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2011_cc1_g",
    "country": "Germany (G)",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2011) - Nordrhein-Westfalen (Mint G)",
    "subject": "Nordrhein-Westfalen",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2011: Nordrhein-Westfalen.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2011_2euro_0.jpg",
    "image_key": "de_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1cent_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2012) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 72940000,
    "mintageFormatted": "72,940,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_2cent_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2012) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 54180000,
    "mintageFormatted": "54,180,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_5cent_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2012) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 29260000,
    "mintageFormatted": "29,260,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_10cent_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2012) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_20cent_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2012) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 14840000,
    "mintageFormatted": "14,840,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_50cent_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2012) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1euro_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2012) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc1_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2012) - Bayern (Mint G)",
    "subject": "Bayern",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2012: Bayern.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_0.jpg",
    "image_key": "de_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc-common_g",
    "country": "Germany (G)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2012) - Ten Years of Euro (TYE) (Mint G)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_1.jpg",
    "image_key": "de_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2013_1cent_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2013) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 42000000,
    "mintageFormatted": "42,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_2cent_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2013) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 42000000,
    "mintageFormatted": "42,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_5cent_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2013) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 22400000,
    "mintageFormatted": "22,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_10cent_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2013) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_20cent_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2013) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 11200000,
    "mintageFormatted": "11,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_50cent_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2013) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_1euro_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2013) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc1_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2013) - Baden-Württemberg (Mint G)",
    "subject": "Baden-Württemberg",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2013: Baden-Württemberg.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_0.jpg",
    "image_key": "de_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc2_g",
    "country": "Germany (G)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2013) - Élysée Treaty (Mint G)",
    "subject": "Élysée Treaty",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2013: Élysée Treaty.",
    "mintage": 1540000,
    "mintageFormatted": "1,540,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_1.jpg",
    "image_key": "de_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1cent_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2014) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 46200000,
    "mintageFormatted": "46,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_2cent_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2014) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 43260000,
    "mintageFormatted": "43,260,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_5cent_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2014) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 22400000,
    "mintageFormatted": "22,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_10cent_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2014) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_20cent_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2014) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 13440000,
    "mintageFormatted": "13,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_50cent_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2014) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1euro_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2014) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2014) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 3920000,
    "mintageFormatted": "3,920,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2014_cc1_g",
    "country": "Germany (G)",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2014) - Niedersachsen (Mint G)",
    "subject": "Niedersachsen",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2014: Niedersachsen.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2014_2euro_0.jpg",
    "image_key": "de_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1cent_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2015) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 60340000,
    "mintageFormatted": "60,340,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_2cent_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2015) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 53200000,
    "mintageFormatted": "53,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_5cent_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2015) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 22960000,
    "mintageFormatted": "22,960,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_10cent_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2015) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_20cent_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2015) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 15960000,
    "mintageFormatted": "15,960,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_50cent_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2015) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1euro_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2015) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc1_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2015) - Hessen (Mint G)",
    "subject": "Hessen",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2015: Hessen.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_2.jpg",
    "image_key": "de_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc2_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2015) - Reunification (25th Ann.) (Mint G)",
    "subject": "Reunification (25th Ann.)",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2015: Reunification (25th Ann.).",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_1.jpg",
    "image_key": "de_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc-common_g",
    "country": "Germany (G)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2015) - EU Flag (Mint G)",
    "subject": "EU Flag",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_0.jpg",
    "image_key": "de_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2016_1cent_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2016) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 81620000,
    "mintageFormatted": "81,620,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_2cent_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2016) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 70980000,
    "mintageFormatted": "70,980,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_5cent_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2016) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 34440000,
    "mintageFormatted": "34,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_10cent_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2016) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_20cent_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2016) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 26880000,
    "mintageFormatted": "26,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_50cent_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2016) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_1euro_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2016) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2016) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 9940000,
    "mintageFormatted": "9,940,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2016_cc1_g",
    "country": "Germany (G)",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2016) - Sachsen (Mint G)",
    "subject": "Sachsen",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2016: Sachsen.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2016_2euro_0.jpg",
    "image_key": "de_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1cent_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2017) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 57120000,
    "mintageFormatted": "57,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_2cent_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2017) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 50540000,
    "mintageFormatted": "50,540,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_5cent_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2017) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 21000000,
    "mintageFormatted": "21,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_10cent_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2017) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 17640000,
    "mintageFormatted": "17,640,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_20cent_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2017) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 15120000,
    "mintageFormatted": "15,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_50cent_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2017) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1euro_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2017) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2017) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 12740000,
    "mintageFormatted": "12,740,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2017_cc1_g",
    "country": "Germany (G)",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2017) - Rheinland-Pfalz (Mint G)",
    "subject": "Rheinland-Pfalz",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2017: Rheinland-Pfalz.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2017_2euro_0.jpg",
    "image_key": "de_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1cent_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2018) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 63420000,
    "mintageFormatted": "63,420,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_2cent_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2018) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 67060000,
    "mintageFormatted": "67,060,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_5cent_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2018) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 28420000,
    "mintageFormatted": "28,420,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_10cent_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2018) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 16800000,
    "mintageFormatted": "16,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_20cent_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2018) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 19880000,
    "mintageFormatted": "19,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_50cent_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2018) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1euro_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2018) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc1_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2018) - Berlin (Mint G)",
    "subject": "Berlin",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2018: Berlin.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_1.jpg",
    "image_key": "de_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc2_g",
    "country": "Germany (G)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2018) - Helmut Schmidt (Mint G)",
    "subject": "Helmut Schmidt",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2018: Helmut Schmidt.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_0.jpg",
    "image_key": "de_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1cent_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2019) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 49680000,
    "mintageFormatted": "49,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_2cent_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2019) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 58500000,
    "mintageFormatted": "58,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_5cent_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2019) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 27950000,
    "mintageFormatted": "27,950,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_10cent_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2019) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 20560000,
    "mintageFormatted": "20,560,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_20cent_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2019) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 23570000,
    "mintageFormatted": "23,570,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_50cent_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2019) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1euro_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2019) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2019) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 10100000,
    "mintageFormatted": "10,100,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc1_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2019) - Bundesrat (Mint G)",
    "subject": "Bundesrat",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2019: Bundesrat.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_1.jpg",
    "image_key": "de_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc2_g",
    "country": "Germany (G)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2019) - Fall of the Berlin Wall (Mint G)",
    "subject": "Fall of the Berlin Wall",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2019: Fall of the Berlin Wall.",
    "mintage": 4570000,
    "mintageFormatted": "4,570,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_0.jpg",
    "image_key": "de_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1cent_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2020) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 34300000,
    "mintageFormatted": "34,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_2cent_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2020) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 46060000,
    "mintageFormatted": "46,060,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_5cent_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2020) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 13720000,
    "mintageFormatted": "13,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_10cent_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2020) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 27860000,
    "mintageFormatted": "27,860,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_20cent_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2020) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 27160000,
    "mintageFormatted": "27,160,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_50cent_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2020) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1euro_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2020) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2020) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 11200000,
    "mintageFormatted": "11,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc1_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2020) - Brandenburg (Mint G)",
    "subject": "Brandenburg",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2020: Brandenburg.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_1.jpg",
    "image_key": "de_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc2_g",
    "country": "Germany (G)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2020) - Warsaw genuflection (Mint G)",
    "subject": "Warsaw genuflection",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2020: Warsaw genuflection.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_0.jpg",
    "image_key": "de_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1cent_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2021) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 35980000,
    "mintageFormatted": "35,980,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_2cent_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2021) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 68320000,
    "mintageFormatted": "68,320,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_5cent_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2021) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 33320000,
    "mintageFormatted": "33,320,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_10cent_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2021) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 20720000,
    "mintageFormatted": "20,720,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_20cent_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2021) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 21000000,
    "mintageFormatted": "21,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_50cent_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2021) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1euro_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2021) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2021) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2021_cc1_g",
    "country": "Germany (G)",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2021) - Sachsen-Anhalt (Mint G)",
    "subject": "Sachsen-Anhalt",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2021: Sachsen-Anhalt.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2021_2euro_0.jpg",
    "image_key": "de_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1cent_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Cent (2022) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_2cent_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2022) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 29540000,
    "mintageFormatted": "29,540,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_5cent_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2022) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 18900000,
    "mintageFormatted": "18,900,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_10cent_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2022) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 13860000,
    "mintageFormatted": "13,860,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_20cent_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2022) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 18340000,
    "mintageFormatted": "18,340,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_50cent_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 50 Cents (2022) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 2800000,
    "mintageFormatted": "2,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1euro_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2022) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 2 Euros (2022) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc1_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2022) - Thüringen (Mint G)",
    "subject": "Thüringen",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2022: Thüringen.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_0.jpg",
    "image_key": "de_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc-common_g",
    "country": "Germany (G)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2022) - Erasmus (Mint G)",
    "subject": "Erasmus",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2022: Erasmus.",
    "mintage": 2380000,
    "mintageFormatted": "2,380,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_1.jpg",
    "image_key": "de_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2023_1cent_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2023) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 20160000,
    "mintageFormatted": "20,160,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_2cent_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2023) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 12600000,
    "mintageFormatted": "12,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_5cent_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2023) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_10cent_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2023) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 12880000,
    "mintageFormatted": "12,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_20cent_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2023) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 7700000,
    "mintageFormatted": "7,700,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_50cent_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 50 Cents (2023) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 8400000,
    "mintageFormatted": "8,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_1euro_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2023) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2023) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 7700000,
    "mintageFormatted": "7,700,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc1_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2023) - Hamburg (Mint G)",
    "subject": "Hamburg",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2023: Hamburg.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_0.jpg",
    "image_key": "de_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc2_g",
    "country": "Germany (G)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2023) - Charlemagne (Mint G)",
    "subject": "Charlemagne",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2023: Charlemagne.",
    "mintage": 2800000,
    "mintageFormatted": "2,800,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_1.jpg",
    "image_key": "de_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1cent_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2024) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 9800000,
    "mintageFormatted": "9,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_2cent_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 2 Cents (2024) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_5cent_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2024) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 7420000,
    "mintageFormatted": "7,420,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_10cent_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 10 Cents (2024) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 6860000,
    "mintageFormatted": "6,860,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_20cent_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2024) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3080000,
    "mintageFormatted": "3,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_50cent_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 50 Cents (2024) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1euro_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2024) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2024) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 6020000,
    "mintageFormatted": "6,020,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc1_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2024) - Mecklenburg-Vorpommern (Mint G)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2024: Mecklenburg-Vorpommern.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_0.jpg",
    "image_key": "de_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc2_g",
    "country": "Germany (G)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2024) - Constitution of St. Paul's Church (Mint G)",
    "subject": "Constitution of St. Paul's Church",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2024: Constitution of St. Paul's Church.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_1.jpg",
    "image_key": "de_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1cent_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Cent (2025) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_2cent_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 2 Cents (2025) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_5cent_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 5 Cents (2025) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_10cent_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2025) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_20cent_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 20 Cents (2025) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_50cent_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 50 Cents (2025) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3780000,
    "mintageFormatted": "3,780,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1euro_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2025) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2025) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 3920000,
    "mintageFormatted": "3,920,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc1_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2025) - Saarland (Mint G)",
    "subject": "Saarland",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2025: Saarland.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2025_2euro_0.jpg",
    "image_key": "de_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc2_g",
    "country": "Germany (G)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2025) - Reunification (35th Ann.) (Mint G)",
    "subject": "Reunification (35th Ann.)",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2025: Reunification (35th Ann.).",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1cent_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 1 Cent (2026) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 13580000,
    "mintageFormatted": "13,580,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_2cent_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Cents (2026) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 22680000,
    "mintageFormatted": "22,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_5cent_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 5 Cents (2026) - Oak Twig (Eichenlaub) (Mint G)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at G)",
    "mintage": 7560000,
    "mintageFormatted": "7,560,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_10cent_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 10 Cents (2026) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_20cent_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 20 Cents (2026) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 3080000,
    "mintageFormatted": "3,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_50cent_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 50 Cents (2026) - Brandenburg Gate (Mint G)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at G)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1euro_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "G",
    "strikeType": "In Sets / Collector",
    "name": "Germany (G) 1 Euro (2026) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Standard Circulation",
    "name": "Germany (G) 2 Euros (2026) - Federal Eagle (Bundesadler) (Mint G)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at G)",
    "mintage": 5600000,
    "mintageFormatted": "5,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc1_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2026) - Konrad Adenauer (Mint G)",
    "subject": "Konrad Adenauer",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2026: Konrad Adenauer.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc2_g",
    "country": "Germany (G)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "G",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (G) 2€ Commemorative (2026) - Bremen (Mint G)",
    "subject": "Bremen",
    "description": "Germany (G) 2 Euro Commemorative coin issued in 2026: Bremen.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1cent_j",
    "country": "Germany (J)",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2002) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 833100000,
    "mintageFormatted": "833,100,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_2cent_j",
    "country": "Germany (J)",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2002) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 419274000,
    "mintageFormatted": "419,274,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_5cent_j",
    "country": "Germany (J)",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2002) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 501850000,
    "mintageFormatted": "501,850,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_10cent_j",
    "country": "Germany (J)",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2002) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 694150000,
    "mintageFormatted": "694,150,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_20cent_j",
    "country": "Germany (J)",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2002) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 440955000,
    "mintageFormatted": "440,955,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_50cent_j",
    "country": "Germany (J)",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 50 Cents (2002) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 375467600,
    "mintageFormatted": "375,467,600",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_1euro_j",
    "country": "Germany (J)",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Euro (2002) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 372263000,
    "mintageFormatted": "372,263,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2002_j",
    "country": "Germany (J)",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2002) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 257718500,
    "mintageFormatted": "257,718,500",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1cent_j",
    "country": "Germany (J)",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Cent (2003) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_2cent_j",
    "country": "Germany (J)",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2003) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 168726000,
    "mintageFormatted": "168,726,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_5cent_j",
    "country": "Germany (J)",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 5 Cents (2003) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_10cent_j",
    "country": "Germany (J)",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2003) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 89990000,
    "mintageFormatted": "89,990,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_20cent_j",
    "country": "Germany (J)",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 20 Cents (2003) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_50cent_j",
    "country": "Germany (J)",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 50 Cents (2003) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 65532400,
    "mintageFormatted": "65,532,400",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_1euro_j",
    "country": "Germany (J)",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Euro (2003) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 29895000,
    "mintageFormatted": "29,895,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2003_j",
    "country": "Germany (J)",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2003) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 19500000,
    "mintageFormatted": "19,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1cent_j",
    "country": "Germany (J)",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2004) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 300900000,
    "mintageFormatted": "300,900,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_2cent_j",
    "country": "Germany (J)",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2004) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 133350000,
    "mintageFormatted": "133,350,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_5cent_j",
    "country": "Germany (J)",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2004) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 119750000,
    "mintageFormatted": "119,750,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_10cent_j",
    "country": "Germany (J)",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2004) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_20cent_j",
    "country": "Germany (J)",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 20 Cents (2004) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_50cent_j",
    "country": "Germany (J)",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2004) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_1euro_j",
    "country": "Germany (J)",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2004) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2004_j",
    "country": "Germany (J)",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2004) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 22510000,
    "mintageFormatted": "22,510,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1cent_j",
    "country": "Germany (J)",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2005) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 126000000,
    "mintageFormatted": "126,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_2cent_j",
    "country": "Germany (J)",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2005) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 76650000,
    "mintageFormatted": "76,650,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_5cent_j",
    "country": "Germany (J)",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2005) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 46200000,
    "mintageFormatted": "46,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_10cent_j",
    "country": "Germany (J)",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2005) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_20cent_j",
    "country": "Germany (J)",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2005) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 8400000,
    "mintageFormatted": "8,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_50cent_j",
    "country": "Germany (J)",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2005) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_1euro_j",
    "country": "Germany (J)",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Euro (2005) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 59842000,
    "mintageFormatted": "59,842,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2005_j",
    "country": "Germany (J)",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 2 Euros (2005) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1cent_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Cent (2006) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_2cent_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2006) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 148400000,
    "mintageFormatted": "148,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_5cent_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2006) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 28350000,
    "mintageFormatted": "28,350,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_10cent_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2006) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_20cent_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2006) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 40950000,
    "mintageFormatted": "40,950,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_50cent_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2006) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_1euro_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2006) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2006_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 2 Euros (2006) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2006_cc1_j",
    "country": "Germany (J)",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2006) - Schleswig-Holstein (Mint J)",
    "subject": "Schleswig-Holstein",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2006: Schleswig-Holstein.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2006_2euro_0.jpg",
    "image_key": "de_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1cent_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2007) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 125370000,
    "mintageFormatted": "125,370,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_2cent_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2007) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 105000000,
    "mintageFormatted": "105,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_5cent_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2007) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 55020000,
    "mintageFormatted": "55,020,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_10cent_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2007) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_20cent_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2007) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 22930000,
    "mintageFormatted": "22,930,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_50cent_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2007) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2007_1euro_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2007) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc1_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2007) - Mecklenburg-Vorpommern (Mint J)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2007: Mecklenburg-Vorpommern.",
    "mintage": 1070000,
    "mintageFormatted": "1,070,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_1.jpg",
    "image_key": "de_commemorative_2007_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2007_cc-common_j",
    "country": "Germany (J)",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2007) - Treaty of Rome (ToR) (Mint J)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2007_2euro_0.jpg",
    "image_key": "de_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2008_1cent_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2008) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 106260000,
    "mintageFormatted": "106,260,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_2cent_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2008) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 84000000,
    "mintageFormatted": "84,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_5cent_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2008) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 30660000,
    "mintageFormatted": "30,660,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_10cent_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2008) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_20cent_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2008) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 16340000,
    "mintageFormatted": "16,340,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_50cent_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2008) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_1euro_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2008) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2008_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2008) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 11970000,
    "mintageFormatted": "11,970,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2008_cc1_j",
    "country": "Germany (J)",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2008) - Hamburg (Mint J)",
    "subject": "Hamburg",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2008: Hamburg.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2008_2euro_0.jpg",
    "image_key": "de_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1cent_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2009) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 105000000,
    "mintageFormatted": "105,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_2cent_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2009) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 61950000,
    "mintageFormatted": "61,950,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_5cent_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2009) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 41580000,
    "mintageFormatted": "41,580,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_10cent_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2009) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_20cent_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2009) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 22680000,
    "mintageFormatted": "22,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_50cent_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2009) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2009_1euro_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2009) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc1_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2009) - Saarland (Mint J)",
    "subject": "Saarland",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2009: Saarland.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_0.jpg",
    "image_key": "de_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2009_cc-common_j",
    "country": "Germany (J)",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2009) - Economic and Monetary Union (EMU) (Mint J)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2009_2euro_1.jpg",
    "image_key": "de_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2010_1cent_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2010) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 99120000,
    "mintageFormatted": "99,120,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_2cent_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2010) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 76440000,
    "mintageFormatted": "76,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_5cent_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2010) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 41790000,
    "mintageFormatted": "41,790,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_10cent_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2010) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_20cent_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2010) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 25620000,
    "mintageFormatted": "25,620,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_50cent_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2010) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_1euro_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2010) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2010_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2010) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 20580000,
    "mintageFormatted": "20,580,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2010_cc1_j",
    "country": "Germany (J)",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2010) - Bremen (Mint J)",
    "subject": "Bremen",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2010: Bremen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2010_2euro_0.jpg",
    "image_key": "de_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1cent_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2011) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 124320000,
    "mintageFormatted": "124,320,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_2cent_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2011) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 105420000,
    "mintageFormatted": "105,420,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_5cent_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2011) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 62160000,
    "mintageFormatted": "62,160,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_10cent_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2011) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_20cent_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2011) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 34650000,
    "mintageFormatted": "34,650,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_50cent_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2011) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_1euro_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2011) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2011_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2011) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 24990000,
    "mintageFormatted": "24,990,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2011_cc1_j",
    "country": "Germany (J)",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2011) - Nordrhein-Westfalen (Mint J)",
    "subject": "Nordrhein-Westfalen",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2011: Nordrhein-Westfalen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2011_2euro_0.jpg",
    "image_key": "de_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1cent_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2012) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 109410000,
    "mintageFormatted": "109,410,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_2cent_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2012) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 81270000,
    "mintageFormatted": "81,270,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_5cent_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2012) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 43890000,
    "mintageFormatted": "43,890,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_10cent_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2012) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_20cent_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2012) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 22260000,
    "mintageFormatted": "22,260,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_50cent_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2012) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2012_1euro_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2012) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc1_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2012) - Bayern (Mint J)",
    "subject": "Bayern",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2012: Bayern.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_0.jpg",
    "image_key": "de_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2012_cc-common_j",
    "country": "Germany (J)",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2012) - Ten Years of Euro (TYE) (Mint J)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2012_2euro_1.jpg",
    "image_key": "de_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2013_1cent_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2013) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 63000000,
    "mintageFormatted": "63,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_2cent_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2013) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 63000000,
    "mintageFormatted": "63,000,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_5cent_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2013) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 33600000,
    "mintageFormatted": "33,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_10cent_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2013) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_20cent_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2013) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 16800000,
    "mintageFormatted": "16,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_50cent_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2013) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2013_1euro_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2013) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc1_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2013) - Baden-Württemberg (Mint J)",
    "subject": "Baden-Württemberg",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2013: Baden-Württemberg.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_0.jpg",
    "image_key": "de_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2013_cc2_j",
    "country": "Germany (J)",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2013) - Élysée Treaty (Mint J)",
    "subject": "Élysée Treaty",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2013: Élysée Treaty.",
    "mintage": 2310000,
    "mintageFormatted": "2,310,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2013_2euro_1.jpg",
    "image_key": "de_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1cent_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2014) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 69300000,
    "mintageFormatted": "69,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_2cent_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2014) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 64890000,
    "mintageFormatted": "64,890,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_5cent_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2014) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 33600000,
    "mintageFormatted": "33,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_10cent_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2014) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_20cent_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2014) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 20160000,
    "mintageFormatted": "20,160,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_50cent_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2014) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_1euro_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2014) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2014_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2014) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 5880000,
    "mintageFormatted": "5,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2014_cc1_j",
    "country": "Germany (J)",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2014) - Niedersachsen (Mint J)",
    "subject": "Niedersachsen",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2014: Niedersachsen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2014_2euro_0.jpg",
    "image_key": "de_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1cent_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2015) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 90510000,
    "mintageFormatted": "90,510,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_2cent_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2015) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 79800000,
    "mintageFormatted": "79,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_5cent_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2015) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 34440000,
    "mintageFormatted": "34,440,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_10cent_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2015) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_20cent_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2015) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 23940000,
    "mintageFormatted": "23,940,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_50cent_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2015) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2015_1euro_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2015) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc1_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2015) - Hessen (Mint J)",
    "subject": "Hessen",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2015: Hessen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_2.jpg",
    "image_key": "de_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc2_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2015) - Reunification (25th Ann.) (Mint J)",
    "subject": "Reunification (25th Ann.)",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2015: Reunification (25th Ann.).",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_1.jpg",
    "image_key": "de_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2015_cc-common_j",
    "country": "Germany (J)",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2015) - EU Flag (Mint J)",
    "subject": "EU Flag",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2015_2euro_0.jpg",
    "image_key": "de_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2016_1cent_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2016) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 122430000,
    "mintageFormatted": "122,430,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_2cent_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2016) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 106470000,
    "mintageFormatted": "106,470,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_5cent_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2016) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 51660000,
    "mintageFormatted": "51,660,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_10cent_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2016) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_20cent_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2016) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 40320000,
    "mintageFormatted": "40,320,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_50cent_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2016) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_1euro_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2016) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2016_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2016) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 14910000,
    "mintageFormatted": "14,910,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2016_cc1_j",
    "country": "Germany (J)",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2016) - Sachsen (Mint J)",
    "subject": "Sachsen",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2016: Sachsen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2016_2euro_0.jpg",
    "image_key": "de_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1cent_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2017) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 85680000,
    "mintageFormatted": "85,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_2cent_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2017) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 75810000,
    "mintageFormatted": "75,810,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_5cent_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2017) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 31500000,
    "mintageFormatted": "31,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_10cent_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2017) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 26460000,
    "mintageFormatted": "26,460,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_20cent_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2017) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 22680000,
    "mintageFormatted": "22,680,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_50cent_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2017) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_1euro_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2017) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2017_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2017) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 19110000,
    "mintageFormatted": "19,110,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2017_cc1_j",
    "country": "Germany (J)",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2017) - Rheinland-Pfalz (Mint J)",
    "subject": "Rheinland-Pfalz",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2017: Rheinland-Pfalz.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2017_2euro_0.jpg",
    "image_key": "de_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1cent_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2018) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 95130000,
    "mintageFormatted": "95,130,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_2cent_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2018) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 100590000,
    "mintageFormatted": "100,590,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_5cent_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2018) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 42630000,
    "mintageFormatted": "42,630,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_10cent_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2018) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 25200000,
    "mintageFormatted": "25,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_20cent_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2018) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 29820000,
    "mintageFormatted": "29,820,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_50cent_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2018) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2018_1euro_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2018) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc1_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2018) - Berlin (Mint J)",
    "subject": "Berlin",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2018: Berlin.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_1.jpg",
    "image_key": "de_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2018_cc2_j",
    "country": "Germany (J)",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2018) - Helmut Schmidt (Mint J)",
    "subject": "Helmut Schmidt",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2018: Helmut Schmidt.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2018_2euro_0.jpg",
    "image_key": "de_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1cent_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2019) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 74670000,
    "mintageFormatted": "74,670,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_2cent_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2019) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 87900000,
    "mintageFormatted": "87,900,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_5cent_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2019) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 42070000,
    "mintageFormatted": "42,070,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_10cent_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2019) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 30990000,
    "mintageFormatted": "30,990,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_20cent_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2019) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 35510000,
    "mintageFormatted": "35,510,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_50cent_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2019) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_1euro_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2019) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2019_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2019) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 15290000,
    "mintageFormatted": "15,290,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc1_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2019) - Bundesrat (Mint J)",
    "subject": "Bundesrat",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2019: Bundesrat.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_1.jpg",
    "image_key": "de_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2019_cc2_j",
    "country": "Germany (J)",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2019) - Fall of the Berlin Wall (Mint J)",
    "subject": "Fall of the Berlin Wall",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2019: Fall of the Berlin Wall.",
    "mintage": 6860000,
    "mintageFormatted": "6,860,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2019_2euro_0.jpg",
    "image_key": "de_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1cent_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2020) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 51450000,
    "mintageFormatted": "51,450,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_2cent_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2020) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 69090000,
    "mintageFormatted": "69,090,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_5cent_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2020) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 20580000,
    "mintageFormatted": "20,580,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_10cent_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2020) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 41790000,
    "mintageFormatted": "41,790,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_20cent_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2020) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 40740000,
    "mintageFormatted": "40,740,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_50cent_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2020) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_1euro_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2020) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2020_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2020) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 16800000,
    "mintageFormatted": "16,800,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc1_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2020) - Brandenburg (Mint J)",
    "subject": "Brandenburg",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2020: Brandenburg.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_1.jpg",
    "image_key": "de_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2020_cc2_j",
    "country": "Germany (J)",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2020) - Warsaw genuflection (Mint J)",
    "subject": "Warsaw genuflection",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2020: Warsaw genuflection.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2020_2euro_0.jpg",
    "image_key": "de_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1cent_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2021) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 53970000,
    "mintageFormatted": "53,970,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_2cent_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2021) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 102480000,
    "mintageFormatted": "102,480,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_5cent_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2021) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 49980000,
    "mintageFormatted": "49,980,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_10cent_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2021) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 31080000,
    "mintageFormatted": "31,080,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_20cent_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2021) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 31500000,
    "mintageFormatted": "31,500,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_50cent_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2021) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_1euro_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2021) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2021_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2021) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2021_cc1_j",
    "country": "Germany (J)",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2021) - Sachsen-Anhalt (Mint J)",
    "subject": "Sachsen-Anhalt",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2021: Sachsen-Anhalt.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2021_2euro_0.jpg",
    "image_key": "de_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1cent_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Cent (2022) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_2cent_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2022) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 44310000,
    "mintageFormatted": "44,310,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_5cent_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2022) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 28350000,
    "mintageFormatted": "28,350,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_10cent_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2022) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 20790000,
    "mintageFormatted": "20,790,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_20cent_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2022) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 27510000,
    "mintageFormatted": "27,510,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_50cent_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 50 Cents (2022) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_1euro_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2022) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2022_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 2 Euros (2022) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc1_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2022) - Thüringen (Mint J)",
    "subject": "Thüringen",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2022: Thüringen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_0.jpg",
    "image_key": "de_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2022_cc-common_j",
    "country": "Germany (J)",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2022) - Erasmus (Mint J)",
    "subject": "Erasmus",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2022: Erasmus.",
    "mintage": 3570000,
    "mintageFormatted": "3,570,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2022_2euro_1.jpg",
    "image_key": "de_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_germany_2023_1cent_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2023) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 30240000,
    "mintageFormatted": "30,240,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_2cent_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2023) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 18900000,
    "mintageFormatted": "18,900,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_5cent_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2023) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 9450000,
    "mintageFormatted": "9,450,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_10cent_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2023) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 19320000,
    "mintageFormatted": "19,320,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_20cent_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2023) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 11550000,
    "mintageFormatted": "11,550,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_50cent_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 50 Cents (2023) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 12600000,
    "mintageFormatted": "12,600,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_1euro_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2023) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2023_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2023) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 11550000,
    "mintageFormatted": "11,550,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc1_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2023) - Hamburg (Mint J)",
    "subject": "Hamburg",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2023: Hamburg.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_0.jpg",
    "image_key": "de_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2023_cc2_j",
    "country": "Germany (J)",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2023) - Charlemagne (Mint J)",
    "subject": "Charlemagne",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2023: Charlemagne.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2023_2euro_1.jpg",
    "image_key": "de_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1cent_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2024) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 14700000,
    "mintageFormatted": "14,700,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_2cent_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 2 Cents (2024) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_5cent_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2024) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 11130000,
    "mintageFormatted": "11,130,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_10cent_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 10 Cents (2024) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 10290000,
    "mintageFormatted": "10,290,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_20cent_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2024) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4620000,
    "mintageFormatted": "4,620,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_50cent_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 50 Cents (2024) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 9450000,
    "mintageFormatted": "9,450,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_1euro_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2024) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2024_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2024) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 9030000,
    "mintageFormatted": "9,030,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc1_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2024) - Mecklenburg-Vorpommern (Mint J)",
    "subject": "Mecklenburg-Vorpommern",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2024: Mecklenburg-Vorpommern.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_0.jpg",
    "image_key": "de_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2024_cc2_j",
    "country": "Germany (J)",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2024) - Constitution of St. Paul's Church (Mint J)",
    "subject": "Constitution of St. Paul's Church",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2024: Constitution of St. Paul's Church.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2024_2euro_1.jpg",
    "image_key": "de_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1cent_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Cent (2025) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_2cent_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 2 Cents (2025) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_5cent_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 5 Cents (2025) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_10cent_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2025) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_20cent_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 20 Cents (2025) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_50cent_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 50 Cents (2025) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 5670000,
    "mintageFormatted": "5,670,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_1euro_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2025) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2025_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2025) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 5880000,
    "mintageFormatted": "5,880,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc1_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2025) - Saarland (Mint J)",
    "subject": "Saarland",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2025: Saarland.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/de_commemorative_2025_2euro_0.jpg",
    "image_key": "de_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2025_cc2_j",
    "country": "Germany (J)",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2025) - Reunification (35th Ann.) (Mint J)",
    "subject": "Reunification (35th Ann.)",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2025: Reunification (35th Ann.).",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1cent_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 1 Cent (2026) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 20370000,
    "mintageFormatted": "20,370,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_1cent_0.jpg",
    "image_key": "de_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_2cent_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Cents (2026) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 34020000,
    "mintageFormatted": "34,020,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2cent_0.jpg",
    "image_key": "de_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_5cent_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 5 Cents (2026) - Oak Twig (Eichenlaub) (Mint J)",
    "subject": "Oak Twig (Eichenlaub)",
    "description": "German oak twig with acorns, traditional symbol from the old pfennig coins (Minted at J)",
    "mintage": 11340000,
    "mintageFormatted": "11,340,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_5cent_0.jpg",
    "image_key": "de_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_10cent_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 10 Cents (2026) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_10cent_0.jpg",
    "image_key": "de_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_20cent_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 20 Cents (2026) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 4620000,
    "mintageFormatted": "4,620,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_20cent_0.jpg",
    "image_key": "de_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_50cent_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 50 Cents (2026) - Brandenburg Gate (Mint J)",
    "subject": "Brandenburg Gate",
    "description": "Brandenburg Gate in Berlin, symbol of German division and subsequent reunification (Minted at J)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_50cent_0.jpg",
    "image_key": "de_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_1euro_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "J",
    "strikeType": "In Sets / Collector",
    "name": "Germany (J) 1 Euro (2026) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/de_regular_2002_1euro_0.jpg",
    "image_key": "de_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_germany_2026_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Standard Circulation",
    "name": "Germany (J) 2 Euros (2026) - Federal Eagle (Bundesadler) (Mint J)",
    "subject": "Federal Eagle (Bundesadler)",
    "description": "Traditional symbol of German sovereignty and federal authority (Minted at J)",
    "mintage": 8400000,
    "mintageFormatted": "8,400,000",
    "status": "circulating",
    "imagePath": "coins/de_regular_2002_2euro_0.jpg",
    "image_key": "de_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc1_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2026) - Konrad Adenauer (Mint J)",
    "subject": "Konrad Adenauer",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2026: Konrad Adenauer.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_germany_2026_cc2_j",
    "country": "Germany (J)",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": "J",
    "strikeType": "Commemorative Circulation",
    "name": "Germany (J) 2€ Commemorative (2026) - Bremen (Mint J)",
    "subject": "Bremen",
    "description": "Germany (J) 2 Euro Commemorative coin issued in 2026: Bremen.",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_1cent",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2002) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 100950000,
    "mintageFormatted": "100,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_2cent",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2002) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 175950000,
    "mintageFormatted": "175,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_5cent",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2002) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 210950000,
    "mintageFormatted": "210,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_10cent",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2002) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 138950000,
    "mintageFormatted": "138,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_20cent",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2002) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 208950000,
    "mintageFormatted": "208,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_50cent",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2002) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 92950000,
    "mintageFormatted": "92,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_1euro",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2002) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 61450000,
    "mintageFormatted": "61,450,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2002) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 75350000,
    "mintageFormatted": "75,350,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_1cent_s",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": "S",
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2002) - Ancient Athenian Trireme (Mint S)",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece (Minted at S)",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_2cent_s",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": "S",
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2002) - Corvette (Korveta) (Mint S)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821) (Minted at S)",
    "mintage": 18000000,
    "mintageFormatted": "18,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_5cent_s",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": "S",
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2002) - Modern Maritime Tanker (Mint S)",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence (Minted at S)",
    "mintage": 90000000,
    "mintageFormatted": "90,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_10cent_s",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": "S",
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2002) - Rigas Feraios (Mint S)",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment (Minted at S)",
    "mintage": 100000000,
    "mintageFormatted": "100,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_20cent_s",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": "S",
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2002) - Ioannis Kapodistrias (Mint S)",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece (Minted at S)",
    "mintage": 120000000,
    "mintageFormatted": "120,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_50cent_s",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": "S",
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2002) - Eleftherios Venizelos (Mint S)",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer (Minted at S)",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_1euro_s",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": "S",
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2002) - Athenian Owl Drachma (Mint S)",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin (Minted at S)",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2002_s",
    "country": "Greece",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": "S",
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2002) - Europa Kidnapped by Zeus (Mint S)",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull (Minted at S)",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2003_1cent",
    "country": "Greece",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2003) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 35100000,
    "mintageFormatted": "35,100,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2003_2cent",
    "country": "Greece",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2003) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 9400000,
    "mintageFormatted": "9,400,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2003_5cent",
    "country": "Greece",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2003) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 650000,
    "mintageFormatted": "650,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2003_10cent",
    "country": "Greece",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2003) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2003_20cent",
    "country": "Greece",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2003) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 700700,
    "mintageFormatted": "700,700",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2003_50cent",
    "country": "Greece",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2003) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2003_1euro",
    "country": "Greece",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2003) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 11600000,
    "mintageFormatted": "11,600,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2003",
    "country": "Greece",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2003) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 450000,
    "mintageFormatted": "450,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2004_1cent",
    "country": "Greece",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2004) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 49970000,
    "mintageFormatted": "49,970,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2004_2cent",
    "country": "Greece",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2004) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 24970000,
    "mintageFormatted": "24,970,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2004_5cent",
    "country": "Greece",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2004) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 220000,
    "mintageFormatted": "220,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2004_10cent",
    "country": "Greece",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2004) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 9970000,
    "mintageFormatted": "9,970,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2004_20cent",
    "country": "Greece",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2004) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 470000,
    "mintageFormatted": "470,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2004_50cent",
    "country": "Greece",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2004) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 470000,
    "mintageFormatted": "470,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2004_1euro",
    "country": "Greece",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2004) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 9970000,
    "mintageFormatted": "9,970,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2004",
    "country": "Greece",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2004) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2004_cc1",
    "country": "Greece",
    "year": 2004,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2004) - 2004 Summer Olympics",
    "subject": "2004 Summer Olympics",
    "description": "Greece 2 Euro Commemorative coin issued in 2004: 2004 Summer Olympics.",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2004_2euro_0.jpg",
    "image_key": "gr_commemorative_2004_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2005_1cent",
    "country": "Greece",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2005) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 14950000,
    "mintageFormatted": "14,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2005_2cent",
    "country": "Greece",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2005) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 15570000,
    "mintageFormatted": "15,570,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2005_5cent",
    "country": "Greece",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2005) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2005_10cent",
    "country": "Greece",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2005) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 24950000,
    "mintageFormatted": "24,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2005_20cent",
    "country": "Greece",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2005) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2005_50cent",
    "country": "Greece",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2005) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2005_1euro",
    "country": "Greece",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2005) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 9950000,
    "mintageFormatted": "9,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2005",
    "country": "Greece",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2005) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2006_1cent",
    "country": "Greece",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2006) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 44950000,
    "mintageFormatted": "44,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2006_2cent",
    "country": "Greece",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2006) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 44950000,
    "mintageFormatted": "44,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2006_5cent",
    "country": "Greece",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2006) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 49950000,
    "mintageFormatted": "49,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2006_10cent",
    "country": "Greece",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2006) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 44950000,
    "mintageFormatted": "44,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2006_20cent",
    "country": "Greece",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2006) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2006_50cent",
    "country": "Greece",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2006) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2006_1euro",
    "country": "Greece",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2006) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 9950000,
    "mintageFormatted": "9,950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2006",
    "country": "Greece",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2006) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2007_1cent",
    "country": "Greece",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2007) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 60001681,
    "mintageFormatted": "60,001,681",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2007_2cent",
    "country": "Greece",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2007) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 25000103,
    "mintageFormatted": "25,000,103",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2007_5cent",
    "country": "Greece",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2007) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 55005598,
    "mintageFormatted": "55,005,598",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2007_10cent",
    "country": "Greece",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2007) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 60044185,
    "mintageFormatted": "60,044,185",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2007_20cent",
    "country": "Greece",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2007) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 955113,
    "mintageFormatted": "955,113",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2007_50cent",
    "country": "Greece",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2007) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 952239,
    "mintageFormatted": "952,239",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2007_1euro",
    "country": "Greece",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2007) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 24167900,
    "mintageFormatted": "24,167,900",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2007",
    "country": "Greece",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2007) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2007_cc-common",
    "country": "Greece",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Greece 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 3978549,
    "mintageFormatted": "3,978,549",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2007_2euro_0.jpg",
    "image_key": "gr_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_greece_2008_1cent",
    "country": "Greece",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2008) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 24001977,
    "mintageFormatted": "24,001,977",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2008_2cent",
    "country": "Greece",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2008) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 68009877,
    "mintageFormatted": "68,009,877",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2008_5cent",
    "country": "Greece",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2008) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 50000713,
    "mintageFormatted": "50,000,713",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2008_10cent",
    "country": "Greece",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2008) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 40578476,
    "mintageFormatted": "40,578,476",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2008_20cent",
    "country": "Greece",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2008) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 20003617,
    "mintageFormatted": "20,003,617",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2008_50cent",
    "country": "Greece",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2008) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 10019641,
    "mintageFormatted": "10,019,641",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2008_1euro",
    "country": "Greece",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2008) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 4001726,
    "mintageFormatted": "4,001,726",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2008",
    "country": "Greece",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2008) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 1007522,
    "mintageFormatted": "1,007,522",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2009_1cent",
    "country": "Greece",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2009) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 49975000,
    "mintageFormatted": "49,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2009_2cent",
    "country": "Greece",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2009) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 15975000,
    "mintageFormatted": "15,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2009_5cent",
    "country": "Greece",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2009) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 37975000,
    "mintageFormatted": "37,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2009_10cent",
    "country": "Greece",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2009) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 45975000,
    "mintageFormatted": "45,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2009_20cent",
    "country": "Greece",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2009) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 23975000,
    "mintageFormatted": "23,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2009_50cent",
    "country": "Greece",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2009) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 6975000,
    "mintageFormatted": "6,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2009_1euro",
    "country": "Greece",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2009) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 17975000,
    "mintageFormatted": "17,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2009",
    "country": "Greece",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2009) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 982500,
    "mintageFormatted": "982,500",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2009_cc-common",
    "country": "Greece",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Greece 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2009_2euro_0.jpg",
    "image_key": "gr_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_greece_2010_1cent",
    "country": "Greece",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2010) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 26975000,
    "mintageFormatted": "26,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2010_2cent",
    "country": "Greece",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2010) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 30975000,
    "mintageFormatted": "30,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2010_5cent",
    "country": "Greece",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2010) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 4975000,
    "mintageFormatted": "4,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2010_10cent",
    "country": "Greece",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2010) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 4975000,
    "mintageFormatted": "4,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2010_20cent",
    "country": "Greece",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2010) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 11975000,
    "mintageFormatted": "11,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2010_50cent",
    "country": "Greece",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2010) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 5975000,
    "mintageFormatted": "5,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2010_1euro",
    "country": "Greece",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2010) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 10975000,
    "mintageFormatted": "10,975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2010",
    "country": "Greece",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2010) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 975000,
    "mintageFormatted": "975,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2010_cc1",
    "country": "Greece",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2010) - Battle of Marathon",
    "subject": "Battle of Marathon",
    "description": "Greece 2 Euro Commemorative coin issued in 2010: Battle of Marathon.",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2010_2euro_0.jpg",
    "image_key": "gr_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2011_1cent",
    "country": "Greece",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2011) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 34965000,
    "mintageFormatted": "34,965,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2011_2cent",
    "country": "Greece",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2011) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 46965000,
    "mintageFormatted": "46,965,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2011_5cent",
    "country": "Greece",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2011) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 33965000,
    "mintageFormatted": "33,965,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2011_10cent",
    "country": "Greece",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2011) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 35965000,
    "mintageFormatted": "35,965,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2011_20cent",
    "country": "Greece",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2011) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 965000,
    "mintageFormatted": "965,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2011_50cent",
    "country": "Greece",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2011) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 6965000,
    "mintageFormatted": "6,965,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2011_1euro",
    "country": "Greece",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2011) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 965000,
    "mintageFormatted": "965,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2011",
    "country": "Greece",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2011) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2011_cc1",
    "country": "Greece",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2011) - 2011 Special Olympics",
    "subject": "2011 Special Olympics",
    "description": "Greece 2 Euro Commemorative coin issued in 2011: 2011 Special Olympics.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2011_2euro_0.jpg",
    "image_key": "gr_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2012_1cent",
    "country": "Greece",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2012) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 48000000,
    "mintageFormatted": "48,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2012_2cent",
    "country": "Greece",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2012) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 34000000,
    "mintageFormatted": "34,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2012_5cent",
    "country": "Greece",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2012) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2012_10cent",
    "country": "Greece",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 10 Cents (2012) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2012_20cent",
    "country": "Greece",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 20 Cents (2012) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2012_50cent",
    "country": "Greece",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 50 Cents (2012) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2012_1euro",
    "country": "Greece",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2012) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2012",
    "country": "Greece",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2012) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2012_cc-common",
    "country": "Greece",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Greece 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2012_2euro_0.jpg",
    "image_key": "gr_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_greece_2013_1cent",
    "country": "Greece",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2013) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 44000000,
    "mintageFormatted": "44,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2013_2cent",
    "country": "Greece",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2013) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 41000000,
    "mintageFormatted": "41,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2013_5cent",
    "country": "Greece",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 5 Cents (2013) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2013_10cent",
    "country": "Greece",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2013) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 19000000,
    "mintageFormatted": "19,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2013_20cent",
    "country": "Greece",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 20 Cents (2013) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2013_50cent",
    "country": "Greece",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 50 Cents (2013) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2013_1euro",
    "country": "Greece",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2013) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2013",
    "country": "Greece",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2013) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2013_cc1",
    "country": "Greece",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2013) - Union of Crete with Greece",
    "subject": "Union of Crete with Greece",
    "description": "Greece 2 Euro Commemorative coin issued in 2013: Union of Crete with Greece.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2013_2euro_0.jpg",
    "image_key": "gr_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2013_cc2",
    "country": "Greece",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2013) - Platonic Academy",
    "subject": "Platonic Academy",
    "description": "Greece 2 Euro Commemorative coin issued in 2013: Platonic Academy.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2013_2euro_1.jpg",
    "image_key": "gr_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2014_1cent",
    "country": "Greece",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2014) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 45000000,
    "mintageFormatted": "45,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2014_2cent",
    "country": "Greece",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2014) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2014_5cent",
    "country": "Greece",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2014) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 18000000,
    "mintageFormatted": "18,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2014_10cent",
    "country": "Greece",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 10 Cents (2014) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2014_20cent",
    "country": "Greece",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 20 Cents (2014) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2014_50cent",
    "country": "Greece",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 50 Cents (2014) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2014_1euro",
    "country": "Greece",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2014) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2014",
    "country": "Greece",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2014) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2014_cc1",
    "country": "Greece",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2014) - Domenikos Theotokopoulos, El Greco",
    "subject": "Domenikos Theotokopoulos, El Greco",
    "description": "Greece 2 Euro Commemorative coin issued in 2014: Domenikos Theotokopoulos, El Greco.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2014_2euro_0.jpg",
    "image_key": "gr_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2014_cc2",
    "country": "Greece",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2014) - Union of the Ionian Islands with Greece",
    "subject": "Union of the Ionian Islands with Greece",
    "description": "Greece 2 Euro Commemorative coin issued in 2014: Union of the Ionian Islands with Greece.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2014_2euro_1.jpg",
    "image_key": "gr_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2015_1cent",
    "country": "Greece",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2015) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2015_2cent",
    "country": "Greece",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2015) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 32000000,
    "mintageFormatted": "32,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2015_5cent",
    "country": "Greece",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2015) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2015_10cent",
    "country": "Greece",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 10 Cents (2015) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2015_20cent",
    "country": "Greece",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 20 Cents (2015) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2015_50cent",
    "country": "Greece",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 50 Cents (2015) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2015_1euro",
    "country": "Greece",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2015) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2015",
    "country": "Greece",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2015) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2015_cc1",
    "country": "Greece",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2015) - Spyros Louis",
    "subject": "Spyros Louis",
    "description": "Greece 2 Euro Commemorative coin issued in 2015: Spyros Louis.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2015_2euro_1.jpg",
    "image_key": "gr_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2015_cc-common",
    "country": "Greece",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Greece 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2015_2euro_0.jpg",
    "image_key": "gr_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_greece_2016_1cent",
    "country": "Greece",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2016) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 49000000,
    "mintageFormatted": "49,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2016_2cent",
    "country": "Greece",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2016) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 52000000,
    "mintageFormatted": "52,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2016_5cent",
    "country": "Greece",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2016) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 27000000,
    "mintageFormatted": "27,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2016_10cent",
    "country": "Greece",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2016) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2016_20cent",
    "country": "Greece",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 20 Cents (2016) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2016_50cent",
    "country": "Greece",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 50 Cents (2016) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2016_1euro",
    "country": "Greece",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2016) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2016",
    "country": "Greece",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2016) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2016_cc1",
    "country": "Greece",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2016) - Arkady Monastery Torching",
    "subject": "Arkady Monastery Torching",
    "description": "Greece 2 Euro Commemorative coin issued in 2016: Arkady Monastery Torching.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2016_2euro_0.jpg",
    "image_key": "gr_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2016_cc2",
    "country": "Greece",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2016) - Dimitri Mitropoulos",
    "subject": "Dimitri Mitropoulos",
    "description": "Greece 2 Euro Commemorative coin issued in 2016: Dimitri Mitropoulos.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2016_2euro_1.jpg",
    "image_key": "gr_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2017_1cent",
    "country": "Greece",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2017) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2017_2cent",
    "country": "Greece",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2017) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 34000000,
    "mintageFormatted": "34,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2017_5cent",
    "country": "Greece",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2017) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2017_10cent",
    "country": "Greece",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2017) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2017_20cent",
    "country": "Greece",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 20 Cents (2017) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2017_50cent",
    "country": "Greece",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 50 Cents (2017) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2017_1euro",
    "country": "Greece",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2017) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2017",
    "country": "Greece",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2017) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2017_cc1",
    "country": "Greece",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2017) - Nikos Kazantzakis",
    "subject": "Nikos Kazantzakis",
    "description": "Greece 2 Euro Commemorative coin issued in 2017: Nikos Kazantzakis.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2017_2euro_0.jpg",
    "image_key": "gr_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2017_cc2",
    "country": "Greece",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2017) - Archaeological Site of Philippi",
    "subject": "Archaeological Site of Philippi",
    "description": "Greece 2 Euro Commemorative coin issued in 2017: Archaeological Site of Philippi.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2017_2euro_1.jpg",
    "image_key": "gr_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2018_1cent",
    "country": "Greece",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2018) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 39000000,
    "mintageFormatted": "39,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2018_2cent",
    "country": "Greece",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2018) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 14000000,
    "mintageFormatted": "14,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2018_5cent",
    "country": "Greece",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2018) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2018_10cent",
    "country": "Greece",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2018) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 14000000,
    "mintageFormatted": "14,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2018_20cent",
    "country": "Greece",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 20 Cents (2018) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2018_50cent",
    "country": "Greece",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 50 Cents (2018) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2018_1euro",
    "country": "Greece",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2018) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2018",
    "country": "Greece",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2018) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2018_cc1",
    "country": "Greece",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2018) - Kostis Palamas",
    "subject": "Kostis Palamas",
    "description": "Greece 2 Euro Commemorative coin issued in 2018: Kostis Palamas.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2018_2euro_0.jpg",
    "image_key": "gr_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2018_cc2",
    "country": "Greece",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2018) - Union of the Dodecanese with Greece",
    "subject": "Union of the Dodecanese with Greece",
    "description": "Greece 2 Euro Commemorative coin issued in 2018: Union of the Dodecanese with Greece.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2018_2euro_1.jpg",
    "image_key": "gr_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2019_1cent",
    "country": "Greece",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2019) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 41000000,
    "mintageFormatted": "41,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2019_2cent",
    "country": "Greece",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2019) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2019_5cent",
    "country": "Greece",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2019) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 36000000,
    "mintageFormatted": "36,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2019_10cent",
    "country": "Greece",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2019) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 24000000,
    "mintageFormatted": "24,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2019_20cent",
    "country": "Greece",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2019) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2019_50cent",
    "country": "Greece",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2019) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2019_1euro",
    "country": "Greece",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2019) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2019",
    "country": "Greece",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2019) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2019_cc1",
    "country": "Greece",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2019) - Manolis Andronicos",
    "subject": "Manolis Andronicos",
    "description": "Greece 2 Euro Commemorative coin issued in 2019: Manolis Andronicos.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2019_2euro_0.jpg",
    "image_key": "gr_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2019_cc2",
    "country": "Greece",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2019) - Andreas Kalvos",
    "subject": "Andreas Kalvos",
    "description": "Greece 2 Euro Commemorative coin issued in 2019: Andreas Kalvos.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2019_2euro_1.jpg",
    "image_key": "gr_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2020_1cent",
    "country": "Greece",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2020) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2020_2cent",
    "country": "Greece",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2020) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 43000000,
    "mintageFormatted": "43,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2020_5cent",
    "country": "Greece",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2020) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2020_10cent",
    "country": "Greece",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2020) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2020_20cent",
    "country": "Greece",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2020) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 32000000,
    "mintageFormatted": "32,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2020_50cent",
    "country": "Greece",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2020) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2020_1euro",
    "country": "Greece",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2020) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2020",
    "country": "Greece",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2020) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2020_cc1",
    "country": "Greece",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2020) - Battle of Thermopylae",
    "subject": "Battle of Thermopylae",
    "description": "Greece 2 Euro Commemorative coin issued in 2020: Battle of Thermopylae.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2020_2euro_1.jpg",
    "image_key": "gr_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2020_cc2",
    "country": "Greece",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2020) - Union of Thrace with Greece",
    "subject": "Union of Thrace with Greece",
    "description": "Greece 2 Euro Commemorative coin issued in 2020: Union of Thrace with Greece.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2020_2euro_0.jpg",
    "image_key": "gr_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2021_1cent",
    "country": "Greece",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2021) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 22000000,
    "mintageFormatted": "22,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2021_2cent",
    "country": "Greece",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2021) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2021_5cent",
    "country": "Greece",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2021) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 16000000,
    "mintageFormatted": "16,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2021_10cent",
    "country": "Greece",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 10 Cents (2021) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2021_20cent",
    "country": "Greece",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2021) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2021_50cent",
    "country": "Greece",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2021) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2021_1euro",
    "country": "Greece",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2021) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2021",
    "country": "Greece",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2021) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2021_cc1",
    "country": "Greece",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2021) - 1821 Greek Revolution",
    "subject": "1821 Greek Revolution",
    "description": "Greece 2 Euro Commemorative coin issued in 2021: 1821 Greek Revolution.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2021_2euro_0.jpg",
    "image_key": "gr_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2022_1cent",
    "country": "Greece",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2022) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2022_2cent",
    "country": "Greece",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2022) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 23000000,
    "mintageFormatted": "23,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2022_5cent",
    "country": "Greece",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2022) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 24000000,
    "mintageFormatted": "24,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2022_10cent",
    "country": "Greece",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 10 Cents (2022) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2022_20cent",
    "country": "Greece",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2022) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2022_50cent",
    "country": "Greece",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 50 Cents (2022) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2022_1euro",
    "country": "Greece",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 1 Euro (2022) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2022",
    "country": "Greece",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Greece 2 Euros (2022) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2022_cc1",
    "country": "Greece",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2022) - First Greek Constitution",
    "subject": "First Greek Constitution",
    "description": "Greece 2 Euro Commemorative coin issued in 2022: First Greek Constitution.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2022_2euro_0.jpg",
    "image_key": "gr_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2022_cc-common",
    "country": "Greece",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Greece 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2022_2euro_1.jpg",
    "image_key": "gr_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_greece_2023_1cent",
    "country": "Greece",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2023) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 22000000,
    "mintageFormatted": "22,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2023_2cent",
    "country": "Greece",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2023) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2023_5cent",
    "country": "Greece",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2023) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2023_10cent",
    "country": "Greece",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2023) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 28000000,
    "mintageFormatted": "28,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2023_20cent",
    "country": "Greece",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2023) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 39000000,
    "mintageFormatted": "39,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2023_50cent",
    "country": "Greece",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2023) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 19000000,
    "mintageFormatted": "19,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2023_1euro",
    "country": "Greece",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2023) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2023",
    "country": "Greece",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2023) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2023_cc1",
    "country": "Greece",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2023) - Maria Callas",
    "subject": "Maria Callas",
    "description": "Greece 2 Euro Commemorative coin issued in 2023: Maria Callas.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2023_2euro_0.jpg",
    "image_key": "gr_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2023_cc2",
    "country": "Greece",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2023) - Constantin Carathéodory",
    "subject": "Constantin Carathéodory",
    "description": "Greece 2 Euro Commemorative coin issued in 2023: Constantin Carathéodory.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2023_2euro_1.jpg",
    "image_key": "gr_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2024_1cent",
    "country": "Greece",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2024) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 19000000,
    "mintageFormatted": "19,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2024_2cent",
    "country": "Greece",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2024) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2024_5cent",
    "country": "Greece",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2024) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2024_10cent",
    "country": "Greece",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2024) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 22000000,
    "mintageFormatted": "22,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2024_20cent",
    "country": "Greece",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2024) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2024_50cent",
    "country": "Greece",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2024) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2024_1euro",
    "country": "Greece",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2024) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2024",
    "country": "Greece",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2024) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2024_cc1",
    "country": "Greece",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2024) - Penelope Delta",
    "subject": "Penelope Delta",
    "description": "Greece 2 Euro Commemorative coin issued in 2024: Penelope Delta.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2024_2euro_0.jpg",
    "image_key": "gr_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2024_cc2",
    "country": "Greece",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2024) - Restoration of Democracy",
    "subject": "Restoration of Democracy",
    "description": "Greece 2 Euro Commemorative coin issued in 2024: Restoration of Democracy.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2024_2euro_1.jpg",
    "image_key": "gr_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2025_1cent",
    "country": "Greece",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2025) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 45000000,
    "mintageFormatted": "45,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2025_2cent",
    "country": "Greece",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2025) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 61000000,
    "mintageFormatted": "61,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2025_5cent",
    "country": "Greece",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2025) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 55000000,
    "mintageFormatted": "55,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2025_10cent",
    "country": "Greece",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2025) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 38000000,
    "mintageFormatted": "38,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2025_20cent",
    "country": "Greece",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2025) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 45000000,
    "mintageFormatted": "45,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2025_50cent",
    "country": "Greece",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2025) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2025_1euro",
    "country": "Greece",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2025) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2025",
    "country": "Greece",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2025) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 15500000,
    "mintageFormatted": "15,500,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2025_cc1",
    "country": "Greece",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2025) - Mikis Theodorakis",
    "subject": "Mikis Theodorakis",
    "description": "Greece 2 Euro Commemorative coin issued in 2025: Mikis Theodorakis.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2025_2euro_0.jpg",
    "image_key": "gr_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2025_cc2",
    "country": "Greece",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2025) - Laskarina Bouboulina",
    "subject": "Laskarina Bouboulina",
    "description": "Greece 2 Euro Commemorative coin issued in 2025: Laskarina Bouboulina.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/gr_commemorative_2025_2euro_1.jpg",
    "image_key": "gr_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2026_1cent",
    "country": "Greece",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Cent (2026) - Ancient Athenian Trireme",
    "subject": "Ancient Athenian Trireme",
    "description": "5th-century BC Athenian trireme, greatest warship of ancient Greece",
    "mintage": 47000000,
    "mintageFormatted": "47,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1cent_0.jpg",
    "image_key": "gr_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2026_2cent",
    "country": "Greece",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Cents (2026) - Corvette (Korveta)",
    "subject": "Corvette (Korveta)",
    "description": "19th-century corvette ship used during the Greek War of Independence (1821)",
    "mintage": 26000000,
    "mintageFormatted": "26,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2cent_0.jpg",
    "image_key": "gr_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2026_5cent",
    "country": "Greece",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 5 Cents (2026) - Modern Maritime Tanker",
    "subject": "Modern Maritime Tanker",
    "description": "Modern commercial oil tanker, symbolizing Greek maritime and shipping excellence",
    "mintage": 28000000,
    "mintageFormatted": "28,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_5cent_0.jpg",
    "image_key": "gr_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2026_10cent",
    "country": "Greece",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 10 Cents (2026) - Rigas Feraios",
    "subject": "Rigas Feraios",
    "description": "Portrait of Rigas Feraios (1757–1798), pioneering thinker of the Greek Enlightenment",
    "mintage": 45000000,
    "mintageFormatted": "45,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_10cent_0.jpg",
    "image_key": "gr_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2026_20cent",
    "country": "Greece",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 20 Cents (2026) - Ioannis Kapodistrias",
    "subject": "Ioannis Kapodistrias",
    "description": "Portrait of Count Ioannis Kapodistrias (1776–1831), first Governor of independent Greece",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_20cent_0.jpg",
    "image_key": "gr_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2026_50cent",
    "country": "Greece",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 50 Cents (2026) - Eleftherios Venizelos",
    "subject": "Eleftherios Venizelos",
    "description": "Portrait of Eleftherios Venizelos (1864–1936), eminent statesman and reformer",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_50cent_0.jpg",
    "image_key": "gr_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2026_1euro",
    "country": "Greece",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 1 Euro (2026) - Athenian Owl Drachma",
    "subject": "Athenian Owl Drachma",
    "description": "Owl of Athena inspired by the ancient 5th-century BC Athenian 4-drachma coin",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_1euro_0.jpg",
    "image_key": "gr_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_greece_2026",
    "country": "Greece",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Greece 2 Euros (2026) - Europa Kidnapped by Zeus",
    "subject": "Europa Kidnapped by Zeus",
    "description": "Scene from Greek mythology depicting Europa abducted by Zeus in the form of a white bull",
    "mintage": 17500000,
    "mintageFormatted": "17,500,000",
    "status": "circulating",
    "imagePath": "coins/gr_regular_2001_2euro_0.jpg",
    "image_key": "gr_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2026_cc1",
    "country": "Greece",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2026) - Third Siege of Missolonghi",
    "subject": "Third Siege of Missolonghi",
    "description": "Greece 2 Euro Commemorative coin issued in 2026: Third Siege of Missolonghi.",
    "mintage": 740500,
    "mintageFormatted": "740,500",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_greece_2026_cc2",
    "country": "Greece",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Greece 2€ Commemorative (2026) - Modern Academy of Athens",
    "subject": "Modern Academy of Athens",
    "description": "Greece 2 Euro Commemorative coin issued in 2026: Modern Academy of Athens.",
    "mintage": 740500,
    "mintageFormatted": "740,500",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2002_1cent",
    "country": "Ireland",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2002) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 404340000,
    "mintageFormatted": "404,340,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2002_2cent",
    "country": "Ireland",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2002) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 354640000,
    "mintageFormatted": "354,640,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2002_5cent",
    "country": "Ireland",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2002) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 456270000,
    "mintageFormatted": "456,270,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2002_10cent",
    "country": "Ireland",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2002) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 275910000,
    "mintageFormatted": "275,910,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2002_20cent",
    "country": "Ireland",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2002) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 234580000,
    "mintageFormatted": "234,580,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2002_50cent",
    "country": "Ireland",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2002) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 144140000,
    "mintageFormatted": "144,140,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2002_1euro",
    "country": "Ireland",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2002) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 135140000,
    "mintageFormatted": "135,140,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2002",
    "country": "Ireland",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2002) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 90590000,
    "mintageFormatted": "90,590,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2003_1cent",
    "country": "Ireland",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2003) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 77900000,
    "mintageFormatted": "77,900,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2003_2cent",
    "country": "Ireland",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2003) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 177290000,
    "mintageFormatted": "177,290,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2003_5cent",
    "country": "Ireland",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2003) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 48350000,
    "mintageFormatted": "48,350,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2003_10cent",
    "country": "Ireland",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2003) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 133820000,
    "mintageFormatted": "133,820,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2003_20cent",
    "country": "Ireland",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2003) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 57140000,
    "mintageFormatted": "57,140,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2003_50cent",
    "country": "Ireland",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2003) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 11810000,
    "mintageFormatted": "11,810,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2003_1euro",
    "country": "Ireland",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2003) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 2520000,
    "mintageFormatted": "2,520,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2003",
    "country": "Ireland",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2003) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 2630000,
    "mintageFormatted": "2,630,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2004_1cent",
    "country": "Ireland",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2004) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 174830000,
    "mintageFormatted": "174,830,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2004_2cent",
    "country": "Ireland",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2004) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 143000000,
    "mintageFormatted": "143,000,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2004_5cent",
    "country": "Ireland",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2004) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 82330000,
    "mintageFormatted": "82,330,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2004_10cent",
    "country": "Ireland",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2004) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 36770000,
    "mintageFormatted": "36,770,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2004_20cent",
    "country": "Ireland",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2004) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 32420000,
    "mintageFormatted": "32,420,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2004_50cent",
    "country": "Ireland",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2004) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 6750000,
    "mintageFormatted": "6,750,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2004_1euro",
    "country": "Ireland",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2004) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1630000,
    "mintageFormatted": "1,630,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2004",
    "country": "Ireland",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2004) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 3740000,
    "mintageFormatted": "3,740,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2005_1cent",
    "country": "Ireland",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2005) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 128550000,
    "mintageFormatted": "128,550,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2005_2cent",
    "country": "Ireland",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2005) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 74650000,
    "mintageFormatted": "74,650,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2005_5cent",
    "country": "Ireland",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2005) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 56510000,
    "mintageFormatted": "56,510,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2005_10cent",
    "country": "Ireland",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2005) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 7150000,
    "mintageFormatted": "7,150,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2005_20cent",
    "country": "Ireland",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2005) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 40490000,
    "mintageFormatted": "40,490,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2005_50cent",
    "country": "Ireland",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2005) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 17310000,
    "mintageFormatted": "17,310,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2005_1euro",
    "country": "Ireland",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2005) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 6820000,
    "mintageFormatted": "6,820,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2005",
    "country": "Ireland",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2005) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 13470000,
    "mintageFormatted": "13,470,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2006_1cent",
    "country": "Ireland",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2006) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 110930000,
    "mintageFormatted": "110,930,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2006_2cent",
    "country": "Ireland",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2006) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 26550000,
    "mintageFormatted": "26,550,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2006_5cent",
    "country": "Ireland",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2006) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 89770000,
    "mintageFormatted": "89,770,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2006_10cent",
    "country": "Ireland",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2006) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 9600000,
    "mintageFormatted": "9,600,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2006_20cent",
    "country": "Ireland",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2006) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10360000,
    "mintageFormatted": "10,360,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2006_50cent",
    "country": "Ireland",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2006) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 7460000,
    "mintageFormatted": "7,460,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2006_1euro",
    "country": "Ireland",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2006) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2006",
    "country": "Ireland",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2006) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 5080000,
    "mintageFormatted": "5,080,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2007_1cent",
    "country": "Ireland",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2007) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 163800000,
    "mintageFormatted": "163,800,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2007_2cent",
    "country": "Ireland",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2007) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 200940000,
    "mintageFormatted": "200,940,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2007_5cent",
    "country": "Ireland",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2007) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 136210000,
    "mintageFormatted": "136,210,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2007_10cent",
    "country": "Ireland",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2007) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 76990000,
    "mintageFormatted": "76,990,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2007_20cent",
    "country": "Ireland",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2007) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 34470000,
    "mintageFormatted": "34,470,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2007_50cent",
    "country": "Ireland",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2007) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 8680000,
    "mintageFormatted": "8,680,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2007_1euro",
    "country": "Ireland",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2007) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 5700000,
    "mintageFormatted": "5,700,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2007",
    "country": "Ireland",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2007) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 7410000,
    "mintageFormatted": "7,410,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2007_cc-common",
    "country": "Ireland",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Ireland 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 4700000,
    "mintageFormatted": "4,700,000",
    "status": "circulating",
    "imagePath": "coins/ie_commemorative_2007_2euro_0.jpg",
    "image_key": "ie_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_ireland_2008_1cent",
    "country": "Ireland",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2008) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 46120000,
    "mintageFormatted": "46,120,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2008_2cent",
    "country": "Ireland",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2008) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 35800000,
    "mintageFormatted": "35,800,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2008_5cent",
    "country": "Ireland",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2008) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 61870000,
    "mintageFormatted": "61,870,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2008_10cent",
    "country": "Ireland",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2008) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 56530000,
    "mintageFormatted": "56,530,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2008_20cent",
    "country": "Ireland",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2008) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 45970000,
    "mintageFormatted": "45,970,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2008_50cent",
    "country": "Ireland",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2008) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1190000,
    "mintageFormatted": "1,190,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2008_1euro",
    "country": "Ireland",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2008) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 2560000,
    "mintageFormatted": "2,560,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2008",
    "country": "Ireland",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2008) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 6080000,
    "mintageFormatted": "6,080,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2009_1cent",
    "country": "Ireland",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2009) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 52170000,
    "mintageFormatted": "52,170,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2009_2cent",
    "country": "Ireland",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2009) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 44250000,
    "mintageFormatted": "44,250,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2009_5cent",
    "country": "Ireland",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2009) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 11300000,
    "mintageFormatted": "11,300,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2009_10cent",
    "country": "Ireland",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2009) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 11740000,
    "mintageFormatted": "11,740,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2009_20cent",
    "country": "Ireland",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2009) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 5390000,
    "mintageFormatted": "5,390,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2009_50cent",
    "country": "Ireland",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2009) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 2900000,
    "mintageFormatted": "2,900,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2009_1euro",
    "country": "Ireland",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2009) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 3290000,
    "mintageFormatted": "3,290,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2009",
    "country": "Ireland",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2009) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1010000,
    "mintageFormatted": "1,010,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2009_cc-common",
    "country": "Ireland",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Ireland 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 3800000,
    "mintageFormatted": "3,800,000",
    "status": "circulating",
    "imagePath": "coins/ie_commemorative_2009_2euro_0.jpg",
    "image_key": "ie_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_ireland_2010_1cent",
    "country": "Ireland",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2010) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10920000,
    "mintageFormatted": "10,920,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2010_2cent",
    "country": "Ireland",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2010) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 3470000,
    "mintageFormatted": "3,470,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2010_5cent",
    "country": "Ireland",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2010) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2010_10cent",
    "country": "Ireland",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2010) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2010_20cent",
    "country": "Ireland",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2010) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2010_50cent",
    "country": "Ireland",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2010) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1140000,
    "mintageFormatted": "1,140,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2010_1euro",
    "country": "Ireland",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2010) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2010",
    "country": "Ireland",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2010) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1440000,
    "mintageFormatted": "1,440,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2011_1cent",
    "country": "Ireland",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2011) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 40950000,
    "mintageFormatted": "40,950,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2011_2cent",
    "country": "Ireland",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2011) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 4700000,
    "mintageFormatted": "4,700,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2011_5cent",
    "country": "Ireland",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2011) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2011_10cent",
    "country": "Ireland",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2011) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 920000,
    "mintageFormatted": "920,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2011_20cent",
    "country": "Ireland",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2011) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1140000,
    "mintageFormatted": "1,140,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2011_50cent",
    "country": "Ireland",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2011) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1060000,
    "mintageFormatted": "1,060,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2011_1euro",
    "country": "Ireland",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2011) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1060000,
    "mintageFormatted": "1,060,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2011",
    "country": "Ireland",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2011) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1020000,
    "mintageFormatted": "1,020,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2012_1cent",
    "country": "Ireland",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2012) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 61370000,
    "mintageFormatted": "61,370,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2012_2cent",
    "country": "Ireland",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2012) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 11910000,
    "mintageFormatted": "11,910,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2012_5cent",
    "country": "Ireland",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2012) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1020000,
    "mintageFormatted": "1,020,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2012_10cent",
    "country": "Ireland",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2012) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1060000,
    "mintageFormatted": "1,060,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2012_20cent",
    "country": "Ireland",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2012) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 970000,
    "mintageFormatted": "970,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2012_50cent",
    "country": "Ireland",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2012) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2012_1euro",
    "country": "Ireland",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2012) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1010000,
    "mintageFormatted": "1,010,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2012",
    "country": "Ireland",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2012) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 7412000,
    "mintageFormatted": "7,412,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2012_cc-common",
    "country": "Ireland",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Ireland 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 1350000,
    "mintageFormatted": "1,350,000",
    "status": "circulating",
    "imagePath": "coins/ie_commemorative_2012_2euro_0.jpg",
    "image_key": "ie_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_ireland_2013_1cent",
    "country": "Ireland",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2013) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 61464000,
    "mintageFormatted": "61,464,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2013_2cent",
    "country": "Ireland",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2013) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 34799000,
    "mintageFormatted": "34,799,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2013_5cent",
    "country": "Ireland",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2013) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1042000,
    "mintageFormatted": "1,042,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2013_10cent",
    "country": "Ireland",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2013) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 936000,
    "mintageFormatted": "936,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2013_20cent",
    "country": "Ireland",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2013) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1284000,
    "mintageFormatted": "1,284,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2013_50cent",
    "country": "Ireland",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2013) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 960000,
    "mintageFormatted": "960,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2013_1euro",
    "country": "Ireland",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2013) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 958000,
    "mintageFormatted": "958,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2013",
    "country": "Ireland",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2013) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2014_1cent",
    "country": "Ireland",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2014) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 35131000,
    "mintageFormatted": "35,131,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2014_2cent",
    "country": "Ireland",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2014) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 3112000,
    "mintageFormatted": "3,112,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2014_5cent",
    "country": "Ireland",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2014) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1055000,
    "mintageFormatted": "1,055,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2014_10cent",
    "country": "Ireland",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2014) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1080000,
    "mintageFormatted": "1,080,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2014_20cent",
    "country": "Ireland",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2014) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1183000,
    "mintageFormatted": "1,183,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2014_50cent",
    "country": "Ireland",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2014) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1067000,
    "mintageFormatted": "1,067,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2014_1euro",
    "country": "Ireland",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2014) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 977000,
    "mintageFormatted": "977,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2014",
    "country": "Ireland",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2014) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 5306000,
    "mintageFormatted": "5,306,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2015_1cent",
    "country": "Ireland",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2015) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 2400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2015_2cent",
    "country": "Ireland",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2015) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 2400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2015_5cent",
    "country": "Ireland",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2015) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1090000,
    "mintageFormatted": "1,090,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2015_10cent",
    "country": "Ireland",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2015) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 9150000,
    "mintageFormatted": "9,150,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2015_20cent",
    "country": "Ireland",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2015) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1110000,
    "mintageFormatted": "1,110,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2015_50cent",
    "country": "Ireland",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2015) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1120000,
    "mintageFormatted": "1,120,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2015_1euro",
    "country": "Ireland",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2015) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1080000,
    "mintageFormatted": "1,080,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2015",
    "country": "Ireland",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2015) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1140323,
    "mintageFormatted": "1,140,323",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2015_cc-common",
    "country": "Ireland",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Ireland 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 1058677,
    "mintageFormatted": "1,058,677",
    "status": "circulating",
    "imagePath": "coins/ie_commemorative_2015_2euro_0.jpg",
    "image_key": "ie_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_ireland_2016_1cent",
    "country": "Ireland",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2016) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 160000,
    "mintageFormatted": "160,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2016_2cent",
    "country": "Ireland",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2016) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 110000,
    "mintageFormatted": "110,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2016_5cent",
    "country": "Ireland",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2016) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 30000,
    "mintageFormatted": "30,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2016_10cent",
    "country": "Ireland",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2016) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 2230000,
    "mintageFormatted": "2,230,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2016_20cent",
    "country": "Ireland",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2016) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 30000,
    "mintageFormatted": "30,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2016_50cent",
    "country": "Ireland",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2016) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 30000,
    "mintageFormatted": "30,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2016_1euro",
    "country": "Ireland",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2016) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 30000,
    "mintageFormatted": "30,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2016",
    "country": "Ireland",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2016) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10625000,
    "mintageFormatted": "10,625,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2016_cc1",
    "country": "Ireland",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2016) - 1916 Easter Rising",
    "subject": "1916 Easter Rising",
    "description": "Ireland 2 Euro Commemorative coin issued in 2016: 1916 Easter Rising.",
    "mintage": 4500000,
    "mintageFormatted": "4,500,000",
    "status": "circulating",
    "imagePath": "coins/ie_commemorative_2016_2euro_0.jpg",
    "image_key": "ie_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2017_1cent",
    "country": "Ireland",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2017) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 9170,
    "mintageFormatted": "9,170",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2017_2cent",
    "country": "Ireland",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2017) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 9120,
    "mintageFormatted": "9,120",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2017_5cent",
    "country": "Ireland",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2017) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 782980,
    "mintageFormatted": "782,980",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2017_10cent",
    "country": "Ireland",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2017) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 189255,
    "mintageFormatted": "189,255",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2017_20cent",
    "country": "Ireland",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2017) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 9115,
    "mintageFormatted": "9,115",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2017_50cent",
    "country": "Ireland",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2017) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 9260,
    "mintageFormatted": "9,260",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2017_1euro",
    "country": "Ireland",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2017) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 84300,
    "mintageFormatted": "84,300",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2017",
    "country": "Ireland",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2017) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 84730,
    "mintageFormatted": "84,730",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2018_1cent",
    "country": "Ireland",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Cent (2018) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 19980,
    "mintageFormatted": "19,980",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2018_2cent",
    "country": "Ireland",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Cents (2018) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 19980,
    "mintageFormatted": "19,980",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2018_5cent",
    "country": "Ireland",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2018) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 30066180,
    "mintageFormatted": "30,066,180",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2018_10cent",
    "country": "Ireland",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2018) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 179800,
    "mintageFormatted": "179,800",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2018_20cent",
    "country": "Ireland",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2018) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 120030,
    "mintageFormatted": "120,030",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2018_50cent",
    "country": "Ireland",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2018) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 79990,
    "mintageFormatted": "79,990",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2018_1euro",
    "country": "Ireland",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2018) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 79710,
    "mintageFormatted": "79,710",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2018",
    "country": "Ireland",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2018) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 83440,
    "mintageFormatted": "83,440",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2019_1cent",
    "country": "Ireland",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2019) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2019_2cent",
    "country": "Ireland",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2019) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2019_5cent",
    "country": "Ireland",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2019) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2019_10cent",
    "country": "Ireland",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2019) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2019_20cent",
    "country": "Ireland",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 20 Cents (2019) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "Set only / Undetermined",
    "status": "Set only / Undetermined",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2019_50cent",
    "country": "Ireland",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 50 Cents (2019) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "Set only / Undetermined",
    "status": "Set only / Undetermined",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2019_1euro",
    "country": "Ireland",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Euro (2019) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "Set only / Undetermined",
    "status": "Set only / Undetermined",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2019",
    "country": "Ireland",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Euros (2019) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "Set only / Undetermined",
    "status": "Set only / Undetermined",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2019_cc1",
    "country": "Ireland",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2019) - First meeting of the Dáil Éireann",
    "subject": "First meeting of the Dáil Éireann",
    "description": "Ireland 2 Euro Commemorative coin issued in 2019: First meeting of the Dáil Éireann.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/ie_commemorative_2019_2euro_0.jpg",
    "image_key": "ie_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2020_1cent",
    "country": "Ireland",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2020) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2020_2cent",
    "country": "Ireland",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2020) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2020_5cent",
    "country": "Ireland",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2020) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 44992107,
    "mintageFormatted": "44,992,107",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2020_10cent",
    "country": "Ireland",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 10 Cents (2020) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "Set only / Undetermined",
    "status": "Set only / Undetermined",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2020_20cent",
    "country": "Ireland",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 20 Cents (2020) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 75100,
    "mintageFormatted": "75,100",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2020_50cent",
    "country": "Ireland",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2020) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 75100,
    "mintageFormatted": "75,100",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2020_1euro",
    "country": "Ireland",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 1 Euro (2020) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 60000,
    "mintageFormatted": "60,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2020",
    "country": "Ireland",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2020) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 76500,
    "mintageFormatted": "76,500",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2021_1cent",
    "country": "Ireland",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2021) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2021_2cent",
    "country": "Ireland",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2021) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2021_5cent",
    "country": "Ireland",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2021) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2021_10cent",
    "country": "Ireland",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2021) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2021_20cent",
    "country": "Ireland",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 20 Cents (2021) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2021_50cent",
    "country": "Ireland",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 50 Cents (2021) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2021_1euro",
    "country": "Ireland",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Euro (2021) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2021",
    "country": "Ireland",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Euros (2021) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2022_1cent",
    "country": "Ireland",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2022) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1000,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2022_2cent",
    "country": "Ireland",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2022) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 1000,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2022_5cent",
    "country": "Ireland",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 5 Cents (2022) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2022_10cent",
    "country": "Ireland",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2022) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2022_20cent",
    "country": "Ireland",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 20 Cents (2022) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2022_50cent",
    "country": "Ireland",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 50 Cents (2022) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2022_1euro",
    "country": "Ireland",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Euro (2022) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2022",
    "country": "Ireland",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Euros (2022) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2022_cc-common",
    "country": "Ireland",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Ireland 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/ie_commemorative_2022_2euro_0.jpg",
    "image_key": "ie_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_ireland_2023_1cent",
    "country": "Ireland",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2023) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 800,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2023_2cent",
    "country": "Ireland",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2023) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 800,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2023_5cent",
    "country": "Ireland",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 5 Cents (2023) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2023_10cent",
    "country": "Ireland",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2023) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2023_20cent",
    "country": "Ireland",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 20 Cents (2023) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2023_50cent",
    "country": "Ireland",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 50 Cents (2023) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2023_1euro",
    "country": "Ireland",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Euro (2023) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2023",
    "country": "Ireland",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Euros (2023) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2023_cc1",
    "country": "Ireland",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2023) - EU Membership",
    "subject": "EU Membership",
    "description": "Ireland 2 Euro Commemorative coin issued in 2023: EU Membership.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/ie_commemorative_2023_2euro_0.jpg",
    "image_key": "ie_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2024_1cent",
    "country": "Ireland",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2024) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 600,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2024_2cent",
    "country": "Ireland",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2024) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 600,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2024_5cent",
    "country": "Ireland",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 5 Cents (2024) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2024_10cent",
    "country": "Ireland",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2024) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2024_20cent",
    "country": "Ireland",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 20 Cents (2024) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2024_50cent",
    "country": "Ireland",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 50 Cents (2024) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2024_1euro",
    "country": "Ireland",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Euro (2024) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2024",
    "country": "Ireland",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Euros (2024) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2025_1cent",
    "country": "Ireland",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2025) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2025_2cent",
    "country": "Ireland",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2025) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2025_5cent",
    "country": "Ireland",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 5 Cents (2025) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2025_10cent",
    "country": "Ireland",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 10 Cents (2025) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2025_20cent",
    "country": "Ireland",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 20 Cents (2025) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2025_50cent",
    "country": "Ireland",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 50 Cents (2025) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2025_1euro",
    "country": "Ireland",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Euro (2025) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2025",
    "country": "Ireland",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Euros (2025) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2026_1cent",
    "country": "Ireland",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Cent (2026) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_1cent_0.jpg",
    "image_key": "ie_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2026_2cent",
    "country": "Ireland",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2 Cents (2026) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/ie_regular_2002_2cent_0.jpg",
    "image_key": "ie_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2026_5cent",
    "country": "Ireland",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 5 Cents (2026) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_5cent_0.jpg",
    "image_key": "ie_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2026_10cent",
    "country": "Ireland",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 10 Cents (2026) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_10cent_0.jpg",
    "image_key": "ie_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2026_20cent",
    "country": "Ireland",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 20 Cents (2026) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_20cent_0.jpg",
    "image_key": "ie_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2026_50cent",
    "country": "Ireland",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 50 Cents (2026) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_50cent_0.jpg",
    "image_key": "ie_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2026_1euro",
    "country": "Ireland",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 1 Euro (2026) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/ie_regular_2002_1euro_0.jpg",
    "image_key": "ie_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_ireland_2026",
    "country": "Ireland",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Ireland 2 Euros (2026) - Celtic Harp (Cláirseach)",
    "subject": "Celtic Harp (Cláirseach)",
    "description": "Traditional Irish harp, official emblem of Ireland, with the word 'ÉIRE'",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/ie_regular_2002_2euro_0.jpg",
    "image_key": "ie_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2026_cc1",
    "country": "Ireland",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Ireland 2€ Commemorative (2026) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Ireland 2 Euro Commemorative coin issued in 2026: Presidency of the EU Council.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_ireland_2026_cc2",
    "country": "Ireland",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Ireland 2€ Commemorative (2026) - ???",
    "subject": "???",
    "description": "Ireland 2 Euro Commemorative coin issued in 2026: ???.",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2002_1cent",
    "country": "Italy",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2002) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 1348599500,
    "mintageFormatted": "1,348,599,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2002_2cent",
    "country": "Italy",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2002) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 1098866250,
    "mintageFormatted": "1,098,866,250",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2002_5cent",
    "country": "Italy",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2002) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 1341442204,
    "mintageFormatted": "1,341,442,204",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2002_10cent",
    "country": "Italy",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2002) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 1142083000,
    "mintageFormatted": "1,142,083,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2002_20cent",
    "country": "Italy",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2002) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 1411536000,
    "mintageFormatted": "1,411,536,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2002_50cent",
    "country": "Italy",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2002) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 1136418000,
    "mintageFormatted": "1,136,418,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2002_1euro",
    "country": "Italy",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2002) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 965725300,
    "mintageFormatted": "965,725,300",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2002",
    "country": "Italy",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2002) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 463402200,
    "mintageFormatted": "463,402,200",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2003_1cent",
    "country": "Italy",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2003) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 9637000,
    "mintageFormatted": "9,637,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2003_2cent",
    "country": "Italy",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2003) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 21555000,
    "mintageFormatted": "21,555,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2003_5cent",
    "country": "Italy",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2003) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 1844000,
    "mintageFormatted": "1,844,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2003_10cent",
    "country": "Italy",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2003) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 29714000,
    "mintageFormatted": "29,714,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2003_20cent",
    "country": "Italy",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2003) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 25893000,
    "mintageFormatted": "25,893,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2003_50cent",
    "country": "Italy",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2003) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 44563000,
    "mintageFormatted": "44,563,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2003_1euro",
    "country": "Italy",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2003) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 66230000,
    "mintageFormatted": "66,230,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2003",
    "country": "Italy",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2003) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 36098000,
    "mintageFormatted": "36,098,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2004_1cent",
    "country": "Italy",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2004) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 99920000,
    "mintageFormatted": "99,920,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2004_2cent",
    "country": "Italy",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2004) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 119920000,
    "mintageFormatted": "119,920,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2004_5cent",
    "country": "Italy",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2004) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 9920000,
    "mintageFormatted": "9,920,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2004_10cent",
    "country": "Italy",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2004) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 4920000,
    "mintageFormatted": "4,920,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2004_20cent",
    "country": "Italy",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2004) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 4920000,
    "mintageFormatted": "4,920,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2004_50cent",
    "country": "Italy",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2004) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 4920000,
    "mintageFormatted": "4,920,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2004_1euro",
    "country": "Italy",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2004) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 4920000,
    "mintageFormatted": "4,920,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2004",
    "country": "Italy",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2004) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 6920000,
    "mintageFormatted": "6,920,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2004_cc1",
    "country": "Italy",
    "year": 2004,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2004) - World Food Programme",
    "subject": "World Food Programme",
    "description": "Italy 2 Euro Commemorative coin issued in 2004: World Food Programme.",
    "mintage": 16000000,
    "mintageFormatted": "16,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2004_2euro_0.jpg",
    "image_key": "it_commemorative_2004_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2005_1cent",
    "country": "Italy",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2005) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 179938500,
    "mintageFormatted": "179,938,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2005_2cent",
    "country": "Italy",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2005) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 119938500,
    "mintageFormatted": "119,938,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2005_5cent",
    "country": "Italy",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2005) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 69938500,
    "mintageFormatted": "69,938,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2005_10cent",
    "country": "Italy",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2005) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 99938500,
    "mintageFormatted": "99,938,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2005_20cent",
    "country": "Italy",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2005) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 4938500,
    "mintageFormatted": "4,938,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2005_50cent",
    "country": "Italy",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2005) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 4938500,
    "mintageFormatted": "4,938,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2005_1euro",
    "country": "Italy",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2005) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 4938500,
    "mintageFormatted": "4,938,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2005",
    "country": "Italy",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2005) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 61938500,
    "mintageFormatted": "61,938,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2005_cc1",
    "country": "Italy",
    "year": 2005,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2005) - Signing of the European Constitution",
    "subject": "Signing of the European Constitution",
    "description": "Italy 2 Euro Commemorative coin issued in 2005: Signing of the European Constitution.",
    "mintage": 18000000,
    "mintageFormatted": "18,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2005_2euro_0.jpg",
    "image_key": "it_commemorative_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2006_1cent",
    "country": "Italy",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2006) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 158947500,
    "mintageFormatted": "158,947,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2006_2cent",
    "country": "Italy",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2006) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 195947500,
    "mintageFormatted": "195,947,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2006_5cent",
    "country": "Italy",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2006) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 118947500,
    "mintageFormatted": "118,947,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2006_10cent",
    "country": "Italy",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2006) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 179947500,
    "mintageFormatted": "179,947,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2006_20cent",
    "country": "Italy",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2006) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 4947500,
    "mintageFormatted": "4,947,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2006_50cent",
    "country": "Italy",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2006) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 4947500,
    "mintageFormatted": "4,947,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2006_1euro",
    "country": "Italy",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2006) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 107947500,
    "mintageFormatted": "107,947,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2006",
    "country": "Italy",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2006) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 9947500,
    "mintageFormatted": "9,947,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2006_cc1",
    "country": "Italy",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2006) - 2006 Winter Olympics",
    "subject": "2006 Winter Olympics",
    "description": "Italy 2 Euro Commemorative coin issued in 2006: 2006 Winter Olympics.",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2006_2euro_0.jpg",
    "image_key": "it_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2007_1cent",
    "country": "Italy",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2007) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 214954000,
    "mintageFormatted": "214,954,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2007_2cent",
    "country": "Italy",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2007) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 139954000,
    "mintageFormatted": "139,954,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2007_5cent",
    "country": "Italy",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2007) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 84954000,
    "mintageFormatted": "84,954,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2007_10cent",
    "country": "Italy",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2007) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 104954000,
    "mintageFormatted": "104,954,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2007_20cent",
    "country": "Italy",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2007) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 4954000,
    "mintageFormatted": "4,954,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2007_50cent",
    "country": "Italy",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2007) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 4954000,
    "mintageFormatted": "4,954,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2007_1euro",
    "country": "Italy",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2007) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 134954000,
    "mintageFormatted": "134,954,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2007",
    "country": "Italy",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2007) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 4954000,
    "mintageFormatted": "4,954,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2007_cc-common",
    "country": "Italy",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Italy 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2007_2euro_0.jpg",
    "image_key": "it_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_italy_2008_1cent",
    "country": "Italy",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2008) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 179956400,
    "mintageFormatted": "179,956,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2008_2cent",
    "country": "Italy",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2008) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 134956400,
    "mintageFormatted": "134,956,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2008_5cent",
    "country": "Italy",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2008) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 89956400,
    "mintageFormatted": "89,956,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2008_10cent",
    "country": "Italy",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2008) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 104956400,
    "mintageFormatted": "104,956,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2008_20cent",
    "country": "Italy",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2008) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 4956400,
    "mintageFormatted": "4,956,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2008_50cent",
    "country": "Italy",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2008) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 4956400,
    "mintageFormatted": "4,956,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2008_1euro",
    "country": "Italy",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2008) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 134956400,
    "mintageFormatted": "134,956,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2008",
    "country": "Italy",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2008) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 2456400,
    "mintageFormatted": "2,456,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2008_cc1",
    "country": "Italy",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2008) - Universal Declaration of Human Rights",
    "subject": "Universal Declaration of Human Rights",
    "description": "Italy 2 Euro Commemorative coin issued in 2008: Universal Declaration of Human Rights.",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2008_2euro_0.jpg",
    "image_key": "it_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2009_1cent",
    "country": "Italy",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2009) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 174951500,
    "mintageFormatted": "174,951,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2009_2cent",
    "country": "Italy",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2009) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 184951500,
    "mintageFormatted": "184,951,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2009_5cent",
    "country": "Italy",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2009) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 94951500,
    "mintageFormatted": "94,951,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2009_10cent",
    "country": "Italy",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2009) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 105951500,
    "mintageFormatted": "105,951,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2009_20cent",
    "country": "Italy",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2009) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 59951500,
    "mintageFormatted": "59,951,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2009_50cent",
    "country": "Italy",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2009) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 2451500,
    "mintageFormatted": "2,451,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2009_1euro",
    "country": "Italy",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2009) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 144951500,
    "mintageFormatted": "144,951,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2009",
    "country": "Italy",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2009) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 1951500,
    "mintageFormatted": "1,951,500",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2009_cc1",
    "country": "Italy",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2009) - Louis Braille",
    "subject": "Louis Braille",
    "description": "Italy 2 Euro Commemorative coin issued in 2009: Louis Braille.",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2009_2euro_0.jpg",
    "image_key": "it_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2009_cc-common",
    "country": "Italy",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Italy 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2009_2euro_1.jpg",
    "image_key": "it_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_italy_2010_1cent",
    "country": "Italy",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2010) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 125448100,
    "mintageFormatted": "125,448,100",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2010_2cent",
    "country": "Italy",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2010) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 120243400,
    "mintageFormatted": "120,243,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2010_5cent",
    "country": "Italy",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2010) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 67618100,
    "mintageFormatted": "67,618,100",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2010_10cent",
    "country": "Italy",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2010) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 91328400,
    "mintageFormatted": "91,328,400",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2010_20cent",
    "country": "Italy",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2010) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 57787000,
    "mintageFormatted": "57,787,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2010_50cent",
    "country": "Italy",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2010) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 9209800,
    "mintageFormatted": "9,209,800",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2010_1euro",
    "country": "Italy",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2010) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 96533100,
    "mintageFormatted": "96,533,100",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2010",
    "country": "Italy",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2010) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 5831100,
    "mintageFormatted": "5,831,100",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2010_cc1",
    "country": "Italy",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2010) - Camillo Benso, Count of Cavour",
    "subject": "Camillo Benso, Count of Cavour",
    "description": "Italy 2 Euro Commemorative coin issued in 2010: Camillo Benso, Count of Cavour.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2010_2euro_0.jpg",
    "image_key": "it_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2011_1cent",
    "country": "Italy",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2011) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 133691709,
    "mintageFormatted": "133,691,709",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2011_2cent",
    "country": "Italy",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2011) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 109158405,
    "mintageFormatted": "109,158,405",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2011_5cent",
    "country": "Italy",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2011) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 37096565,
    "mintageFormatted": "37,096,565",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2011_10cent",
    "country": "Italy",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2011) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 76119410,
    "mintageFormatted": "76,119,410",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2011_20cent",
    "country": "Italy",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2011) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 66758340,
    "mintageFormatted": "66,758,340",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2011_50cent",
    "country": "Italy",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2011) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 5106000,
    "mintageFormatted": "5,106,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2011_1euro",
    "country": "Italy",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2011) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 98033010,
    "mintageFormatted": "98,033,010",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2011",
    "country": "Italy",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2011) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 14065890,
    "mintageFormatted": "14,065,890",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2011_cc1",
    "country": "Italy",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2011) - Italian Unification",
    "subject": "Italian Unification",
    "description": "Italy 2 Euro Commemorative coin issued in 2011: Italian Unification.",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2011_2euro_0.jpg",
    "image_key": "it_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2012_1cent",
    "country": "Italy",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2012) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 217400000,
    "mintageFormatted": "217,400,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2012_2cent",
    "country": "Italy",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2012) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 79300000,
    "mintageFormatted": "79,300,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2012_5cent",
    "country": "Italy",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2012) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 62500000,
    "mintageFormatted": "62,500,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2012_10cent",
    "country": "Italy",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2012) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 97400000,
    "mintageFormatted": "97,400,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2012_20cent",
    "country": "Italy",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2012) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2012_50cent",
    "country": "Italy",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2012) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2012_1euro",
    "country": "Italy",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2012) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2012",
    "country": "Italy",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2012) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 27000000,
    "mintageFormatted": "27,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2012_cc1",
    "country": "Italy",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2012) - Giovanni Pascoli",
    "subject": "Giovanni Pascoli",
    "description": "Italy 2 Euro Commemorative coin issued in 2012: Giovanni Pascoli.",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2012_2euro_0.jpg",
    "image_key": "it_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2012_cc-common",
    "country": "Italy",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Italy 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2012_2euro_1.jpg",
    "image_key": "it_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_italy_2013_1cent",
    "country": "Italy",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2013) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 243460000,
    "mintageFormatted": "243,460,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2013_2cent",
    "country": "Italy",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2013) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 150100000,
    "mintageFormatted": "150,100,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2013_5cent",
    "country": "Italy",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2013) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 80000000,
    "mintageFormatted": "80,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2013_10cent",
    "country": "Italy",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2013) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2013_20cent",
    "country": "Italy",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2013) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2013_50cent",
    "country": "Italy",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2013) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2013_1euro",
    "country": "Italy",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2013) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2013",
    "country": "Italy",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2013) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2013_cc1",
    "country": "Italy",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2013) - Giuseppe Verdi",
    "subject": "Giuseppe Verdi",
    "description": "Italy 2 Euro Commemorative coin issued in 2013: Giuseppe Verdi.",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2013_2euro_0.jpg",
    "image_key": "it_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2013_cc2",
    "country": "Italy",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2013) - Giovanni Boccaccio",
    "subject": "Giovanni Boccaccio",
    "description": "Italy 2 Euro Commemorative coin issued in 2013: Giovanni Boccaccio.",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2013_2euro_1.jpg",
    "image_key": "it_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2014_1cent",
    "country": "Italy",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2014) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 150000000,
    "mintageFormatted": "150,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2014_2cent",
    "country": "Italy",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2014) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 115000000,
    "mintageFormatted": "115,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2014_5cent",
    "country": "Italy",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2014) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2014_10cent",
    "country": "Italy",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2014) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2014_20cent",
    "country": "Italy",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2014) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2014_50cent",
    "country": "Italy",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2014) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2014_1euro",
    "country": "Italy",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2014) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2014",
    "country": "Italy",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2014) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2014_cc1",
    "country": "Italy",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2014) - Carabinieri",
    "subject": "Carabinieri",
    "description": "Italy 2 Euro Commemorative coin issued in 2014: Carabinieri.",
    "mintage": 6500000,
    "mintageFormatted": "6,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2014_2euro_0.jpg",
    "image_key": "it_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2014_cc2",
    "country": "Italy",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2014) - Galileo Galilei",
    "subject": "Galileo Galilei",
    "description": "Italy 2 Euro Commemorative coin issued in 2014: Galileo Galilei.",
    "mintage": 6500000,
    "mintageFormatted": "6,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2014_2euro_1.jpg",
    "image_key": "it_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2015_1cent",
    "country": "Italy",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2015) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 220000000,
    "mintageFormatted": "220,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2015_2cent",
    "country": "Italy",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2015) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 120000000,
    "mintageFormatted": "120,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2015_5cent",
    "country": "Italy",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2015) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2015_10cent",
    "country": "Italy",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2015) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2015_20cent",
    "country": "Italy",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2015) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2015_50cent",
    "country": "Italy",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2015) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2015_1euro",
    "country": "Italy",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2015) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2015",
    "country": "Italy",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2015) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2015_cc1",
    "country": "Italy",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2015) - Expo Milano 2015",
    "subject": "Expo Milano 2015",
    "description": "Italy 2 Euro Commemorative coin issued in 2015: Expo Milano 2015.",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2015_2euro_2.jpg",
    "image_key": "it_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2015_cc2",
    "country": "Italy",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2015) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Italy 2 Euro Commemorative coin issued in 2015: Dante Alighieri.",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2015_2euro_1.jpg",
    "image_key": "it_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2015_cc-common",
    "country": "Italy",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Italy 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2015_2euro_0.jpg",
    "image_key": "it_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_italy_2016_1cent",
    "country": "Italy",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2016) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 160000000,
    "mintageFormatted": "160,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2016_2cent",
    "country": "Italy",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2016) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 140000000,
    "mintageFormatted": "140,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2016_5cent",
    "country": "Italy",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2016) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2016_10cent",
    "country": "Italy",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2016) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2016_20cent",
    "country": "Italy",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2016) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2016_50cent",
    "country": "Italy",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2016) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2016_1euro",
    "country": "Italy",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2016) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2016",
    "country": "Italy",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2016) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2016_cc1",
    "country": "Italy",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2016) - Donatello",
    "subject": "Donatello",
    "description": "Italy 2 Euro Commemorative coin issued in 2016: Donatello.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2016_2euro_0.jpg",
    "image_key": "it_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2016_cc2",
    "country": "Italy",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2016) - Maccio Plauto",
    "subject": "Maccio Plauto",
    "description": "Italy 2 Euro Commemorative coin issued in 2016: Maccio Plauto.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2016_2euro_1.jpg",
    "image_key": "it_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2017_1cent",
    "country": "Italy",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Cent (2017) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 260000000,
    "mintageFormatted": "260,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2017_2cent",
    "country": "Italy",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Cents (2017) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 150000000,
    "mintageFormatted": "150,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2017_5cent",
    "country": "Italy",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2017) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 80000000,
    "mintageFormatted": "80,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2017_10cent",
    "country": "Italy",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2017) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2017_20cent",
    "country": "Italy",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2017) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2017_50cent",
    "country": "Italy",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2017) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2017_1euro",
    "country": "Italy",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2017) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2017",
    "country": "Italy",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2017) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2017_cc1",
    "country": "Italy",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2017) - Basilica San Marco",
    "subject": "Basilica San Marco",
    "description": "Italy 2 Euro Commemorative coin issued in 2017: Basilica San Marco.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2017_2euro_0.jpg",
    "image_key": "it_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2017_cc2",
    "country": "Italy",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2017) - Tito Livio",
    "subject": "Tito Livio",
    "description": "Italy 2 Euro Commemorative coin issued in 2017: Tito Livio.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2017_2euro_1.jpg",
    "image_key": "it_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2018_1cent",
    "country": "Italy",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2018) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2018_2cent",
    "country": "Italy",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2018) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2018_5cent",
    "country": "Italy",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2018) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 169977000,
    "mintageFormatted": "169,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2018_10cent",
    "country": "Italy",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2018) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 99977000,
    "mintageFormatted": "99,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2018_20cent",
    "country": "Italy",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2018) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 50977000,
    "mintageFormatted": "50,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2018_50cent",
    "country": "Italy",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2018) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 1977000,
    "mintageFormatted": "1,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2018_1euro",
    "country": "Italy",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2018) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 977000,
    "mintageFormatted": "977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2018",
    "country": "Italy",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2018) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 23977000,
    "mintageFormatted": "23,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2018_cc1",
    "country": "Italy",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2018) - Constitution of the Italian Republic",
    "subject": "Constitution of the Italian Republic",
    "description": "Italy 2 Euro Commemorative coin issued in 2018: Constitution of the Italian Republic.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2018_2euro_1.jpg",
    "image_key": "it_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2018_cc2",
    "country": "Italy",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2018) - Ministry of Health",
    "subject": "Ministry of Health",
    "description": "Italy 2 Euro Commemorative coin issued in 2018: Ministry of Health.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2018_2euro_0.jpg",
    "image_key": "it_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2019_1cent",
    "country": "Italy",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2019) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2019_2cent",
    "country": "Italy",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2019) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2019_5cent",
    "country": "Italy",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2019) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 89958000,
    "mintageFormatted": "89,958,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2019_10cent",
    "country": "Italy",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2019) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 109958000,
    "mintageFormatted": "109,958,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2019_20cent",
    "country": "Italy",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2019) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 84958000,
    "mintageFormatted": "84,958,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2019_50cent",
    "country": "Italy",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2019) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 19958000,
    "mintageFormatted": "19,958,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2019_1euro",
    "country": "Italy",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2019) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 958000,
    "mintageFormatted": "958,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2019",
    "country": "Italy",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2019) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 11958000,
    "mintageFormatted": "11,958,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2019_cc1",
    "country": "Italy",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2019) - Leonardo da Vinci",
    "subject": "Leonardo da Vinci",
    "description": "Italy 2 Euro Commemorative coin issued in 2019: Leonardo da Vinci.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2019_2euro_0.jpg",
    "image_key": "it_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2020_1cent",
    "country": "Italy",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2020) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2020_2cent",
    "country": "Italy",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2020) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2020_5cent",
    "country": "Italy",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2020) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 49978000,
    "mintageFormatted": "49,978,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2020_10cent",
    "country": "Italy",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2020) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 44978000,
    "mintageFormatted": "44,978,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2020_20cent",
    "country": "Italy",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2020) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 19978000,
    "mintageFormatted": "19,978,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2020_50cent",
    "country": "Italy",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2020) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 19978000,
    "mintageFormatted": "19,978,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2020_1euro",
    "country": "Italy",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2020) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 978000,
    "mintageFormatted": "978,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2020",
    "country": "Italy",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2020) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 13978000,
    "mintageFormatted": "13,978,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2020_cc1",
    "country": "Italy",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2020) - National Firefighters Corps",
    "subject": "National Firefighters Corps",
    "description": "Italy 2 Euro Commemorative coin issued in 2020: National Firefighters Corps.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2020_2euro_1.jpg",
    "image_key": "it_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2020_cc2",
    "country": "Italy",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2020) - Maria Montessori",
    "subject": "Maria Montessori",
    "description": "Italy 2 Euro Commemorative coin issued in 2020: Maria Montessori.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2020_2euro_0.jpg",
    "image_key": "it_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2021_1cent",
    "country": "Italy",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2021) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2021_2cent",
    "country": "Italy",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2021) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2021_5cent",
    "country": "Italy",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2021) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 60000000,
    "mintageFormatted": "60,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2021_10cent",
    "country": "Italy",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2021) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2021_20cent",
    "country": "Italy",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2021) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2021_50cent",
    "country": "Italy",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2021) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2021_1euro",
    "country": "Italy",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2021) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2021",
    "country": "Italy",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2021) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 19000000,
    "mintageFormatted": "19,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2021_cc1",
    "country": "Italy",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2021) - Rome, Capital of Italy",
    "subject": "Rome, Capital of Italy",
    "description": "Italy 2 Euro Commemorative coin issued in 2021: Rome, Capital of Italy.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2021_2euro_0.jpg",
    "image_key": "it_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2021_cc2",
    "country": "Italy",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2021) - Health Professions in COVID-19",
    "subject": "Health Professions in COVID-19",
    "description": "Italy 2 Euro Commemorative coin issued in 2021: Health Professions in COVID-19.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2021_2euro_1.jpg",
    "image_key": "it_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2022_1cent",
    "country": "Italy",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2022) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2022_2cent",
    "country": "Italy",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2022) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2022_5cent",
    "country": "Italy",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2022) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2022_10cent",
    "country": "Italy",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2022) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2022_20cent",
    "country": "Italy",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2022) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2022_50cent",
    "country": "Italy",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2022) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2022_1euro",
    "country": "Italy",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2022) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2022",
    "country": "Italy",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2022) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 16000000,
    "mintageFormatted": "16,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2022_cc1",
    "country": "Italy",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2022) - Giovanni Falcone and Paolo Borsellino",
    "subject": "Giovanni Falcone and Paolo Borsellino",
    "description": "Italy 2 Euro Commemorative coin issued in 2022: Giovanni Falcone and Paolo Borsellino.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2022_2euro_1.jpg",
    "image_key": "it_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2022_cc2",
    "country": "Italy",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2022) - Italian National Police",
    "subject": "Italian National Police",
    "description": "Italy 2 Euro Commemorative coin issued in 2022: Italian National Police.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2022_2euro_0.jpg",
    "image_key": "it_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2022_cc-common",
    "country": "Italy",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Italy 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2022_2euro_2.jpg",
    "image_key": "it_commemorative_2022_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_italy_2023_1cent",
    "country": "Italy",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2023) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2023_2cent",
    "country": "Italy",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2023) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2023_5cent",
    "country": "Italy",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2023) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 69977000,
    "mintageFormatted": "69,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2023_10cent",
    "country": "Italy",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2023) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 49977000,
    "mintageFormatted": "49,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2023_20cent",
    "country": "Italy",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2023) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 36977000,
    "mintageFormatted": "36,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2023_50cent",
    "country": "Italy",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2023) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 19977000,
    "mintageFormatted": "19,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2023_1euro",
    "country": "Italy",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2023) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 977000,
    "mintageFormatted": "977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2023",
    "country": "Italy",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2023) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 21977000,
    "mintageFormatted": "21,977,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2023_cc1",
    "country": "Italy",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2023) - Alessandro Manzoni",
    "subject": "Alessandro Manzoni",
    "description": "Italy 2 Euro Commemorative coin issued in 2023: Alessandro Manzoni.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2023_2euro_0.jpg",
    "image_key": "it_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2023_cc2",
    "country": "Italy",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2023) - Italian Air Force",
    "subject": "Italian Air Force",
    "description": "Italy 2 Euro Commemorative coin issued in 2023: Italian Air Force.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2023_2euro_1.jpg",
    "image_key": "it_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2024_1cent",
    "country": "Italy",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2024) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2024_2cent",
    "country": "Italy",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2024) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2024_5cent",
    "country": "Italy",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2024) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 200000000,
    "mintageFormatted": "200,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2024_10cent",
    "country": "Italy",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2024) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 150000000,
    "mintageFormatted": "150,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2024_20cent",
    "country": "Italy",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2024) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 150000000,
    "mintageFormatted": "150,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2024_50cent",
    "country": "Italy",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2024) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 160000000,
    "mintageFormatted": "160,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2024_1euro",
    "country": "Italy",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2024) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2024",
    "country": "Italy",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2024) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 54000000,
    "mintageFormatted": "54,000,000",
    "status": "circulating",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2024_cc1",
    "country": "Italy",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2024) - Financial Police",
    "subject": "Financial Police",
    "description": "Italy 2 Euro Commemorative coin issued in 2024: Financial Police.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2024_2euro_0.jpg",
    "image_key": "it_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2024_cc2",
    "country": "Italy",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2024) - Rita Levi-Montalcini",
    "subject": "Rita Levi-Montalcini",
    "description": "Italy 2 Euro Commemorative coin issued in 2024: Rita Levi-Montalcini.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2024_2euro_1.jpg",
    "image_key": "it_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2025_1cent",
    "country": "Italy",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2025) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2025_2cent",
    "country": "Italy",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2025) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2025_5cent",
    "country": "Italy",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2025) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2025_10cent",
    "country": "Italy",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 10 Cents (2025) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2025_20cent",
    "country": "Italy",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2025) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2025_50cent",
    "country": "Italy",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 50 Cents (2025) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2025_1euro",
    "country": "Italy",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 1 Euro (2025) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2025",
    "country": "Italy",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 2 Euros (2025) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2025_cc1",
    "country": "Italy",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2025) - Jubilee of 2025",
    "subject": "Jubilee of 2025",
    "description": "Italy 2 Euro Commemorative coin issued in 2025: Jubilee of 2025.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2025_2euro_0.jpg",
    "image_key": "it_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2025_cc2",
    "country": "Italy",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Italy 2€ Commemorative (2025) - World Tour of Ship 'Amerigo Vespucci'",
    "subject": "World Tour of Ship 'Amerigo Vespucci'",
    "description": "Italy 2 Euro Commemorative coin issued in 2025: World Tour of Ship 'Amerigo Vespucci'.",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/it_commemorative_2025_2euro_1.jpg",
    "image_key": "it_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2026_1cent",
    "country": "Italy",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Cent (2026) - Castel del Monte",
    "subject": "Castel del Monte",
    "description": "13th-century octagonal fortress in Apulia built by Holy Roman Emperor Frederick II",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/it_regular_1999_1cent_0.jpg",
    "image_key": "it_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2026_2cent",
    "country": "Italy",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Cents (2026) - Mole Antonelliana",
    "subject": "Mole Antonelliana",
    "description": "Iconic landmark monument and tower in Turin designed by Alessandro Antonelli",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/it_regular_1999_2cent_0.jpg",
    "image_key": "it_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2026_5cent",
    "country": "Italy",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 5 Cents (2026) - Flavian Amphitheatre (Colosseum)",
    "subject": "Flavian Amphitheatre (Colosseum)",
    "description": "Ancient Roman Colosseum in Rome, architectural masterpiece of antiquity",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/it_regular_1999_5cent_0.jpg",
    "image_key": "it_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2026_10cent",
    "country": "Italy",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 10 Cents (2026) - Birth of Venus (Botticelli)",
    "subject": "Birth of Venus (Botticelli)",
    "description": "Detail of the head of Venus from Sandro Botticelli's Renaissance painting 'The Birth of Venus'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/it_regular_1999_10cent_0.jpg",
    "image_key": "it_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2026_20cent",
    "country": "Italy",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Italy 20 Cents (2026) - Unique Forms of Continuity in Space (Boccioni)",
    "subject": "Unique Forms of Continuity in Space (Boccioni)",
    "description": "Futurist bronze sculpture by Umberto Boccioni depicting dynamic human movement",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/it_regular_1999_20cent_0.jpg",
    "image_key": "it_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2026_50cent",
    "country": "Italy",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 50 Cents (2026) - Equestrian Statue of Marcus Aurelius",
    "subject": "Equestrian Statue of Marcus Aurelius",
    "description": "Ancient Roman bronze equestrian statue of Emperor Marcus Aurelius on Piazza del Campidoglio",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/it_regular_1999_50cent_0.jpg",
    "image_key": "it_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2026_1euro",
    "country": "Italy",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 1 Euro (2026) - Vitruvian Man (Leonardo da Vinci)",
    "subject": "Vitruvian Man (Leonardo da Vinci)",
    "description": "Renowned drawing of proportional harmony by Leonardo da Vinci",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/it_regular_1999_1euro_0.jpg",
    "image_key": "it_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_italy_2026",
    "country": "Italy",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2 Euros (2026) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Portrait of supreme Italian poet Dante Alighieri by Raphael (from the Vatican Parnassus fresco)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/it_regular_1999_2euro_0.jpg",
    "image_key": "it_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2026_cc1",
    "country": "Italy",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2€ Commemorative (2026) - San Francesco d'Assisi",
    "subject": "San Francesco d'Assisi",
    "description": "Italy 2 Euro Commemorative coin issued in 2026: San Francesco d'Assisi.",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_italy_2026_cc2",
    "country": "Italy",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Italy 2€ Commemorative (2026) - Carlo Collodi",
    "subject": "Carlo Collodi",
    "description": "Italy 2 Euro Commemorative coin issued in 2026: Carlo Collodi.",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2014_1cent",
    "country": "Latvia",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 1 Cent (2014) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 120000000,
    "mintageFormatted": "120,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2014_2cent",
    "country": "Latvia",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 2 Cents (2014) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 80000000,
    "mintageFormatted": "80,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2014_5cent",
    "country": "Latvia",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 5 Cents (2014) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2014_10cent",
    "country": "Latvia",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 10 Cents (2014) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2014_20cent",
    "country": "Latvia",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 20 Cents (2014) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 35800000,
    "mintageFormatted": "35,800,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2014_50cent",
    "country": "Latvia",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 50 Cents (2014) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 25700000,
    "mintageFormatted": "25,700,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2014_1euro",
    "country": "Latvia",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 1 Euro (2014) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 30400000,
    "mintageFormatted": "30,400,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2014",
    "country": "Latvia",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 2 Euros (2014) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 20200000,
    "mintageFormatted": "20,200,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2014_cc1",
    "country": "Latvia",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2014) - Riga 2014 - European Capital of Culture",
    "subject": "Riga 2014 - European Capital of Culture",
    "description": "Latvia 2 Euro Commemorative coin issued in 2014: Riga 2014 - European Capital of Culture.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2014_2euro_0.jpg",
    "image_key": "lv_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2015_1cent",
    "country": "Latvia",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2015) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2015_2cent",
    "country": "Latvia",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2015) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2015_5cent",
    "country": "Latvia",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2015) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2015_10cent",
    "country": "Latvia",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2015) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2015_20cent",
    "country": "Latvia",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2015) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2015_50cent",
    "country": "Latvia",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2015) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2015_1euro",
    "country": "Latvia",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2015) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2015",
    "country": "Latvia",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2015) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2015_cc1",
    "country": "Latvia",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2015) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Latvia 2 Euro Commemorative coin issued in 2015: Presidency of the EU Council.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2015_2euro_2.jpg",
    "image_key": "lv_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2015_cc2",
    "country": "Latvia",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2015) - The Black Stork",
    "subject": "The Black Stork",
    "description": "Latvia 2 Euro Commemorative coin issued in 2015: The Black Stork.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2015_2euro_0.jpg",
    "image_key": "lv_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2015_cc-common",
    "country": "Latvia",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Latvia 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2015_2euro_1.jpg",
    "image_key": "lv_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_latvia_2016_1cent",
    "country": "Latvia",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2016) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2016_2cent",
    "country": "Latvia",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2016) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2016_5cent",
    "country": "Latvia",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2016) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2016_10cent",
    "country": "Latvia",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2016) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2016_20cent",
    "country": "Latvia",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2016) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2016_50cent",
    "country": "Latvia",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2016) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2016_1euro",
    "country": "Latvia",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 1 Euro (2016) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2016",
    "country": "Latvia",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2016) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2016_cc1",
    "country": "Latvia",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2016) - Latvian Farming and Countryside",
    "subject": "Latvian Farming and Countryside",
    "description": "Latvia 2 Euro Commemorative coin issued in 2016: Latvian Farming and Countryside.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2016_2euro_1.jpg",
    "image_key": "lv_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2016_cc2",
    "country": "Latvia",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2016) - Vidzeme",
    "subject": "Vidzeme",
    "description": "Latvia 2 Euro Commemorative coin issued in 2016: Vidzeme.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2016_2euro_0.jpg",
    "image_key": "lv_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2017_cc1",
    "country": "Latvia",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2017) - Kurzeme",
    "subject": "Kurzeme",
    "description": "Latvia 2 Euro Commemorative coin issued in 2017: Kurzeme.",
    "mintage": 505000,
    "mintageFormatted": "505,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2017_2euro_1.jpg",
    "image_key": "lv_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2017_cc2",
    "country": "Latvia",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2017) - Latgale",
    "subject": "Latgale",
    "description": "Latvia 2 Euro Commemorative coin issued in 2017: Latgale.",
    "mintage": 505000,
    "mintageFormatted": "505,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2017_2euro_0.jpg",
    "image_key": "lv_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2018_1cent",
    "country": "Latvia",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2018) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2018_2cent",
    "country": "Latvia",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2018) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2018_5cent",
    "country": "Latvia",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2018) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2018_10cent",
    "country": "Latvia",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2018) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2018_20cent",
    "country": "Latvia",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2018) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2018_50cent",
    "country": "Latvia",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2018) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2018_1euro",
    "country": "Latvia",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2018) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2018",
    "country": "Latvia",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2018) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2018_cc1",
    "country": "Latvia",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2018) - Independence of the Baltic States",
    "subject": "Independence of the Baltic States",
    "description": "Latvia 2 Euro Commemorative coin issued in 2018: Independence of the Baltic States.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2018_2euro_1.jpg",
    "image_key": "lv_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2018_cc2",
    "country": "Latvia",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2018) - Zemgale",
    "subject": "Zemgale",
    "description": "Latvia 2 Euro Commemorative coin issued in 2018: Zemgale.",
    "mintage": 505000,
    "mintageFormatted": "505,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2018_2euro_0.jpg",
    "image_key": "lv_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2019_1cent",
    "country": "Latvia",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2019) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2019_2cent",
    "country": "Latvia",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2019) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2019_5cent",
    "country": "Latvia",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 5 Cents (2019) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2019_10cent",
    "country": "Latvia",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2019) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2019_20cent",
    "country": "Latvia",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2019) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2019_50cent",
    "country": "Latvia",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2019) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2019_1euro",
    "country": "Latvia",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2019) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2019",
    "country": "Latvia",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2019) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2019_cc1",
    "country": "Latvia",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2019) - The Rising Sun",
    "subject": "The Rising Sun",
    "description": "Latvia 2 Euro Commemorative coin issued in 2019: The Rising Sun.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2019_2euro_0.jpg",
    "image_key": "lv_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2020_1cent",
    "country": "Latvia",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2020) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2020_2cent",
    "country": "Latvia",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2020) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2020_5cent",
    "country": "Latvia",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2020) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2020_10cent",
    "country": "Latvia",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2020) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2020_20cent",
    "country": "Latvia",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2020) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2020_50cent",
    "country": "Latvia",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2020) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2020_1euro",
    "country": "Latvia",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2020) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2020",
    "country": "Latvia",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2020) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2020_cc1",
    "country": "Latvia",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2020) - Latgalian Ceramics",
    "subject": "Latgalian Ceramics",
    "description": "Latvia 2 Euro Commemorative coin issued in 2020: Latgalian Ceramics.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2020_2euro_0.jpg",
    "image_key": "lv_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2021_1cent",
    "country": "Latvia",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2021) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2021_2cent",
    "country": "Latvia",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2021) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2021_5cent",
    "country": "Latvia",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2021) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2021_10cent",
    "country": "Latvia",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2021) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2021_20cent",
    "country": "Latvia",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2021) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2021_50cent",
    "country": "Latvia",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2021) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2021_1euro",
    "country": "Latvia",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2021) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2021",
    "country": "Latvia",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2021) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2021_cc1",
    "country": "Latvia",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2021) - De Jure Recognition of Latvia",
    "subject": "De Jure Recognition of Latvia",
    "description": "Latvia 2 Euro Commemorative coin issued in 2021: De Jure Recognition of Latvia.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2021_2euro_0.jpg",
    "image_key": "lv_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2022_1cent",
    "country": "Latvia",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2022) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2022_2cent",
    "country": "Latvia",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2022) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2022_5cent",
    "country": "Latvia",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2022) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2022_10cent",
    "country": "Latvia",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2022) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2022_20cent",
    "country": "Latvia",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2022) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2022_50cent",
    "country": "Latvia",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2022) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2022_1euro",
    "country": "Latvia",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2022) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2022",
    "country": "Latvia",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2022) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2022_cc1",
    "country": "Latvia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2022) - Financial Literacy",
    "subject": "Financial Literacy",
    "description": "Latvia 2 Euro Commemorative coin issued in 2022: Financial Literacy.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2022_2euro_0.jpg",
    "image_key": "lv_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2022_cc-common",
    "country": "Latvia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Latvia 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2022_2euro_1.jpg",
    "image_key": "lv_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_latvia_2023_5cent",
    "country": "Latvia",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Latvia 5 Cents (2023) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2023_cc1",
    "country": "Latvia",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2023) - Ukrainian Sunflower",
    "subject": "Ukrainian Sunflower",
    "description": "Latvia 2 Euro Commemorative coin issued in 2023: Ukrainian Sunflower.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2023_2euro_0.jpg",
    "image_key": "lv_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2024_1cent",
    "country": "Latvia",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2024) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2024_2cent",
    "country": "Latvia",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2024) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2024_5cent",
    "country": "Latvia",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2024) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2024_10cent",
    "country": "Latvia",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2024) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2024_20cent",
    "country": "Latvia",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2024) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2024_50cent",
    "country": "Latvia",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2024) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2024_1euro",
    "country": "Latvia",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2024) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2024",
    "country": "Latvia",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2024) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2024_cc1",
    "country": "Latvia",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2024) - Latvian Puzuris",
    "subject": "Latvian Puzuris",
    "description": "Latvia 2 Euro Commemorative coin issued in 2024: Latvian Puzuris.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/lv_commemorative_2024_2euro_0.jpg",
    "image_key": "lv_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2025_1cent",
    "country": "Latvia",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2025) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2025_2cent",
    "country": "Latvia",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2025) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2025_5cent",
    "country": "Latvia",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2025) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2025_10cent",
    "country": "Latvia",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2025) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2025_20cent",
    "country": "Latvia",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2025) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2025_50cent",
    "country": "Latvia",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2025) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2025_1euro",
    "country": "Latvia",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2025) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2025",
    "country": "Latvia",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2025) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2025_cc1",
    "country": "Latvia",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Latvia 2€ Commemorative (2025) - Sēlija",
    "subject": "Sēlija",
    "description": "Latvia 2 Euro Commemorative coin issued in 2025: Sēlija.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2026_1cent",
    "country": "Latvia",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Cent (2026) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1cent_0.jpg",
    "image_key": "lv_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2026_2cent",
    "country": "Latvia",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Cents (2026) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2cent_0.jpg",
    "image_key": "lv_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2026_5cent",
    "country": "Latvia",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 5 Cents (2026) - Lesser Coat of Arms of Latvia",
    "subject": "Lesser Coat of Arms of Latvia",
    "description": "Small coat of arms of the Republic of Latvia",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_5cent_0.jpg",
    "image_key": "lv_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2026_10cent",
    "country": "Latvia",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 10 Cents (2026) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_10cent_0.jpg",
    "image_key": "lv_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2026_20cent",
    "country": "Latvia",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 20 Cents (2026) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_20cent_0.jpg",
    "image_key": "lv_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2026_50cent",
    "country": "Latvia",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 50 Cents (2026) - Greater Coat of Arms of Latvia",
    "subject": "Greater Coat of Arms of Latvia",
    "description": "Large coat of arms of the Republic of Latvia with lion and griffin supporters",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_50cent_0.jpg",
    "image_key": "lv_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2026_1euro",
    "country": "Latvia",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 1 Euro (2026) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_1euro_0.jpg",
    "image_key": "lv_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_latvia_2026",
    "country": "Latvia",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2 Euros (2026) - Latvian Maiden (Milda)",
    "subject": "Latvian Maiden (Milda)",
    "description": "Latvian folk maiden symbol of national freedom, originally featured on the 1929 5-lats coin",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lv_regular_2014_2euro_0.jpg",
    "image_key": "lv_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_latvia_2026_cc1",
    "country": "Latvia",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Latvia 2€ Commemorative (2026) - Christmas Markets",
    "subject": "Christmas Markets",
    "description": "Latvia 2 Euro Commemorative coin issued in 2026: Christmas Markets.",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2015_1cent",
    "country": "Lithuania",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 1 Cent (2015) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2015_2cent",
    "country": "Lithuania",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 2 Cents (2015) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2015_5cent",
    "country": "Lithuania",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 5 Cents (2015) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 60000000,
    "mintageFormatted": "60,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2015_10cent",
    "country": "Lithuania",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 10 Cents (2015) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2015_20cent",
    "country": "Lithuania",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 20 Cents (2015) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2015_50cent",
    "country": "Lithuania",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 50 Cents (2015) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2015_1euro",
    "country": "Lithuania",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 1 Euro (2015) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2015",
    "country": "Lithuania",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 2 Euros (2015) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2015_cc1",
    "country": "Lithuania",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2015) - Lithuanian Language",
    "subject": "Lithuanian Language",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2015: Lithuanian Language.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2015_2euro_0.jpg",
    "image_key": "lt_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2015_cc-common",
    "country": "Lithuania",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 745000,
    "mintageFormatted": "745,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2015_2euro_1.jpg",
    "image_key": "lt_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_lithuania_2016_1cent",
    "country": "Lithuania",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 1 Cent (2016) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2016_cc1",
    "country": "Lithuania",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2016) - Baltic Culture",
    "subject": "Baltic Culture",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2016: Baltic Culture.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2016_2euro_0.jpg",
    "image_key": "lt_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2017_1cent",
    "country": "Lithuania",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 1 Cent (2017) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 22000000,
    "mintageFormatted": "22,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2017_2cent",
    "country": "Lithuania",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 2 Cents (2017) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 23000000,
    "mintageFormatted": "23,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2017_10cent",
    "country": "Lithuania",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 10 Cents (2017) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 14000000,
    "mintageFormatted": "14,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2017_20cent",
    "country": "Lithuania",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 20 Cents (2017) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2017",
    "country": "Lithuania",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 2 Euros (2017) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2017_cc1",
    "country": "Lithuania",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2017) - Vilnius, Capital of Culture & Art",
    "subject": "Vilnius, Capital of Culture & Art",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2017: Vilnius, Capital of Culture & Art.",
    "mintage": 999000,
    "mintageFormatted": "999,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2017_2euro_0.jpg",
    "image_key": "lt_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2018_1cent",
    "country": "Lithuania",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2018) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2018_2cent",
    "country": "Lithuania",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2018) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2018_5cent",
    "country": "Lithuania",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 5 Cents (2018) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2018_10cent",
    "country": "Lithuania",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 10 Cents (2018) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2018_20cent",
    "country": "Lithuania",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2018) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2018_50cent",
    "country": "Lithuania",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2018) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2018_1euro",
    "country": "Lithuania",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2018) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2018",
    "country": "Lithuania",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Euros (2018) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2018_cc1",
    "country": "Lithuania",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2018) - Independence of the Baltic States",
    "subject": "Independence of the Baltic States",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2018: Independence of the Baltic States.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2018_2euro_1.jpg",
    "image_key": "lt_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2018_cc2",
    "country": "Lithuania",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2018) - Song and Dance Celebration",
    "subject": "Song and Dance Celebration",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2018: Song and Dance Celebration.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2018_2euro_0.jpg",
    "image_key": "lt_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2019_1cent",
    "country": "Lithuania",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2019) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2019_2cent",
    "country": "Lithuania",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2019) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2019_5cent",
    "country": "Lithuania",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 5 Cents (2019) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2019_10cent",
    "country": "Lithuania",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 10 Cents (2019) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2019_20cent",
    "country": "Lithuania",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2019) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2019_50cent",
    "country": "Lithuania",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2019) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2019_1euro",
    "country": "Lithuania",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2019) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2019",
    "country": "Lithuania",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Euros (2019) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2019_cc1",
    "country": "Lithuania",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2019) - Sutartinės",
    "subject": "Sutartinės",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2019: Sutartinės.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2019_2euro_0.jpg",
    "image_key": "lt_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2019_cc2",
    "country": "Lithuania",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2019) - Žemaitija",
    "subject": "Žemaitija",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2019: Žemaitija.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2019_2euro_1.jpg",
    "image_key": "lt_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2020_1cent",
    "country": "Lithuania",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2020) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2020_2cent",
    "country": "Lithuania",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2020) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2020_5cent",
    "country": "Lithuania",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 5 Cents (2020) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2020_10cent",
    "country": "Lithuania",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 10 Cents (2020) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2020_20cent",
    "country": "Lithuania",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2020) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2020_50cent",
    "country": "Lithuania",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2020) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2020_1euro",
    "country": "Lithuania",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2020) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2020",
    "country": "Lithuania",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 2 Euros (2020) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2020_cc1",
    "country": "Lithuania",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2020) - Aukštaitija",
    "subject": "Aukštaitija",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2020: Aukštaitija.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2020_2euro_0.jpg",
    "image_key": "lt_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2020_cc2",
    "country": "Lithuania",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2020) - Hill of Crosses",
    "subject": "Hill of Crosses",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2020: Hill of Crosses.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2020_2euro_1.jpg",
    "image_key": "lt_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2021_1cent",
    "country": "Lithuania",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2021) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2021_2cent",
    "country": "Lithuania",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2021) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2021_5cent",
    "country": "Lithuania",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 5 Cents (2021) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2021_10cent",
    "country": "Lithuania",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 10 Cents (2021) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2021_20cent",
    "country": "Lithuania",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2021) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2021_50cent",
    "country": "Lithuania",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2021) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2021_1euro",
    "country": "Lithuania",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2021) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2021",
    "country": "Lithuania",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 2 Euros (2021) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2021_cc1",
    "country": "Lithuania",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2021) - Žuvintas Biosphere Reserve",
    "subject": "Žuvintas Biosphere Reserve",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2021: Žuvintas Biosphere Reserve.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2021_2euro_0.jpg",
    "image_key": "lt_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2021_cc2",
    "country": "Lithuania",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2021) - Dzūkija",
    "subject": "Dzūkija",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2021: Dzūkija.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2021_2euro_1.jpg",
    "image_key": "lt_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2022_1cent",
    "country": "Lithuania",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2022) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2022_2cent",
    "country": "Lithuania",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2022) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2022_5cent",
    "country": "Lithuania",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 5 Cents (2022) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2022_10cent",
    "country": "Lithuania",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 10 Cents (2022) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2022_20cent",
    "country": "Lithuania",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2022) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2022_50cent",
    "country": "Lithuania",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2022) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2022_1euro",
    "country": "Lithuania",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2022) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2022",
    "country": "Lithuania",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Euros (2022) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2022_cc1",
    "country": "Lithuania",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2022) - Basketball in Lithuania",
    "subject": "Basketball in Lithuania",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2022: Basketball in Lithuania.",
    "mintage": 742500,
    "mintageFormatted": "742,500",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2022_2euro_0.jpg",
    "image_key": "lt_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2022_cc2",
    "country": "Lithuania",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2022) - Suvalkija",
    "subject": "Suvalkija",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2022: Suvalkija.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2022_2euro_1.jpg",
    "image_key": "lt_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2022_cc-common",
    "country": "Lithuania",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2022_2euro_2.jpg",
    "image_key": "lt_commemorative_2022_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_lithuania_2023_1cent",
    "country": "Lithuania",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2023) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2023_2cent",
    "country": "Lithuania",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2023) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2023_5cent",
    "country": "Lithuania",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 5 Cents (2023) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2023_10cent",
    "country": "Lithuania",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 10 Cents (2023) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2023_20cent",
    "country": "Lithuania",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2023) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2023_50cent",
    "country": "Lithuania",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2023) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2023_1euro",
    "country": "Lithuania",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2023) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2023",
    "country": "Lithuania",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Euros (2023) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2023_cc1",
    "country": "Lithuania",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2023) - Together with Ukraine",
    "subject": "Together with Ukraine",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2023: Together with Ukraine.",
    "mintage": 450000,
    "mintageFormatted": "450,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2023_2euro_0.jpg",
    "image_key": "lt_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2024_1cent",
    "country": "Lithuania",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2024) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2024_2cent",
    "country": "Lithuania",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2024) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2024_5cent",
    "country": "Lithuania",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 5 Cents (2024) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2024_10cent",
    "country": "Lithuania",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 10 Cents (2024) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2024_20cent",
    "country": "Lithuania",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2024) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2024_50cent",
    "country": "Lithuania",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2024) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2024_1euro",
    "country": "Lithuania",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2024) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2024",
    "country": "Lithuania",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 2 Euros (2024) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2024_cc1",
    "country": "Lithuania",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2024) - Sodai straw gardens",
    "subject": "Sodai straw gardens",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2024: Sodai straw gardens.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2024_2euro_0.jpg",
    "image_key": "lt_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2025_1cent",
    "country": "Lithuania",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2025) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2025_2cent",
    "country": "Lithuania",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2025) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2025_5cent",
    "country": "Lithuania",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 5 Cents (2025) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2025_10cent",
    "country": "Lithuania",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 10 Cents (2025) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2025_20cent",
    "country": "Lithuania",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2025) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2025_50cent",
    "country": "Lithuania",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2025) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2025_1euro",
    "country": "Lithuania",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2025) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2025",
    "country": "Lithuania",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Euros (2025) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2025_cc1",
    "country": "Lithuania",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2025) - Defence of the Lithuanian State",
    "subject": "Defence of the Lithuanian State",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2025: Defence of the Lithuanian State.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2025_2euro_0.jpg",
    "image_key": "lt_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2025_cc2",
    "country": "Lithuania",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2025) - Mažoji Lietuva",
    "subject": "Mažoji Lietuva",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2025: Mažoji Lietuva.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "coins/lt_commemorative_2025_2euro_1.jpg",
    "image_key": "lt_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2026_1cent",
    "country": "Lithuania",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Cent (2026) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1cent_0.jpg",
    "image_key": "lt_regular_2015_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2026_2cent",
    "country": "Lithuania",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 2 Cents (2026) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_2cent_0.jpg",
    "image_key": "lt_regular_2015_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2026_5cent",
    "country": "Lithuania",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 5 Cents (2026) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_5cent_0.jpg",
    "image_key": "lt_regular_2015_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2026_10cent",
    "country": "Lithuania",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 10 Cents (2026) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_10cent_0.jpg",
    "image_key": "lt_regular_2015_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2026_20cent",
    "country": "Lithuania",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 20 Cents (2026) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_20cent_0.jpg",
    "image_key": "lt_regular_2015_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2026_50cent",
    "country": "Lithuania",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 50 Cents (2026) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_50cent_0.jpg",
    "image_key": "lt_regular_2015_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2026_1euro",
    "country": "Lithuania",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Lithuania 1 Euro (2026) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lt_regular_2015_1euro_0.jpg",
    "image_key": "lt_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_lithuania_2026",
    "country": "Lithuania",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Lithuania 2 Euros (2026) - Vytis (The Chaser)",
    "subject": "Vytis (The Chaser)",
    "description": "Coat of arms of Lithuania depicting an armored knight on horseback with raised sword",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lt_regular_2015_2euro_0.jpg",
    "image_key": "lt_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2026_cc1",
    "country": "Lithuania",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2026) - Energy Independence",
    "subject": "Energy Independence",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2026: Energy Independence.",
    "mintage": 495000,
    "mintageFormatted": "495,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_lithuania_2026_cc2",
    "country": "Lithuania",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Lithuania 2€ Commemorative (2026) - Kaunas",
    "subject": "Kaunas",
    "description": "Lithuania 2 Euro Commemorative coin issued in 2026: Kaunas.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2002_1cent",
    "country": "Luxembourg",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2002) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 34517500,
    "mintageFormatted": "34,517,500",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2002_2cent",
    "country": "Luxembourg",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2002) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 35917500,
    "mintageFormatted": "35,917,500",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2002_5cent",
    "country": "Luxembourg",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2002) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 28917500,
    "mintageFormatted": "28,917,500",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2002_10cent",
    "country": "Luxembourg",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2002) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 25117500,
    "mintageFormatted": "25,117,500",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2002_20cent",
    "country": "Luxembourg",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2002) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 25717000,
    "mintageFormatted": "25,717,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2002_50cent",
    "country": "Luxembourg",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2002) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 21917500,
    "mintageFormatted": "21,917,500",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2002_1euro",
    "country": "Luxembourg",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2002) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 21318525,
    "mintageFormatted": "21,318,525",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2002",
    "country": "Luxembourg",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2002) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 18517500,
    "mintageFormatted": "18,517,500",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2003_1cent",
    "country": "Luxembourg",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2003) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2003_2cent",
    "country": "Luxembourg",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2003) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2003_5cent",
    "country": "Luxembourg",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2003) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4500000,
    "mintageFormatted": "4,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2003_10cent",
    "country": "Luxembourg",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2003) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2003_20cent",
    "country": "Luxembourg",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2003) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2003_50cent",
    "country": "Luxembourg",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2003) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2003_1euro",
    "country": "Luxembourg",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2003) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2003",
    "country": "Luxembourg",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2003) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2004_1cent",
    "country": "Luxembourg",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2004) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 21001000,
    "mintageFormatted": "21,001,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2004_2cent",
    "country": "Luxembourg",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2004) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 20001000,
    "mintageFormatted": "20,001,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2004_5cent",
    "country": "Luxembourg",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2004) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 16001000,
    "mintageFormatted": "16,001,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2004_10cent",
    "country": "Luxembourg",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2004) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 12001000,
    "mintageFormatted": "12,001,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2004_20cent",
    "country": "Luxembourg",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2004) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 14001000,
    "mintageFormatted": "14,001,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2004_50cent",
    "country": "Luxembourg",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2004) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 10001000,
    "mintageFormatted": "10,001,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2004_1euro",
    "country": "Luxembourg",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2004) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 9001000,
    "mintageFormatted": "9,001,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2004",
    "country": "Luxembourg",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2004) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7553200,
    "mintageFormatted": "7,553,200",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2004_cc1",
    "country": "Luxembourg",
    "year": 2004,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2004) - Monogram of Grand Duke Henri",
    "subject": "Monogram of Grand Duke Henri",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2004: Monogram of Grand Duke Henri.",
    "mintage": 2447800,
    "mintageFormatted": "2,447,800",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2004_2euro_0.jpg",
    "image_key": "lu_commemorative_2004_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2005_1cent",
    "country": "Luxembourg",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2005) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2005_2cent",
    "country": "Luxembourg",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2005) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2005_5cent",
    "country": "Luxembourg",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2005) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2005_10cent",
    "country": "Luxembourg",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2005) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2005_20cent",
    "country": "Luxembourg",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2005) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2005_50cent",
    "country": "Luxembourg",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2005) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2005_1euro",
    "country": "Luxembourg",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2005) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2005",
    "country": "Luxembourg",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2005) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2005_cc1",
    "country": "Luxembourg",
    "year": 2005,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2005) - Grand Duke Henri, Grand Duke Adolphe",
    "subject": "Grand Duke Henri, Grand Duke Adolphe",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2005: Grand Duke Henri, Grand Duke Adolphe.",
    "mintage": 2720000,
    "mintageFormatted": "2,720,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2005_2euro_0.jpg",
    "image_key": "lu_commemorative_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2006_1cent",
    "country": "Luxembourg",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2006) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2006_2cent",
    "country": "Luxembourg",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2006) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2006_5cent",
    "country": "Luxembourg",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2006) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2006_10cent",
    "country": "Luxembourg",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2006) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2006_20cent",
    "country": "Luxembourg",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2006) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2006_50cent",
    "country": "Luxembourg",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2006) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2006_1euro",
    "country": "Luxembourg",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2006) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2006",
    "country": "Luxembourg",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2006) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2006_cc1",
    "country": "Luxembourg",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2006) - Guillaume, Heir of Grand Duke Henri",
    "subject": "Guillaume, Heir of Grand Duke Henri",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2006: Guillaume, Heir of Grand Duke Henri.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2006_2euro_0.jpg",
    "image_key": "lu_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2007_1cent",
    "country": "Luxembourg",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2007) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2007_2cent",
    "country": "Luxembourg",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2007) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2007_5cent",
    "country": "Luxembourg",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2007) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2007_10cent",
    "country": "Luxembourg",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2007) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2007_20cent",
    "country": "Luxembourg",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2007) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2007_50cent",
    "country": "Luxembourg",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2007) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2007_1euro",
    "country": "Luxembourg",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2007) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 480000,
    "mintageFormatted": "480,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2007",
    "country": "Luxembourg",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2007) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2007_cc1",
    "country": "Luxembourg",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2007) - Palais Grand-Ducal",
    "subject": "Palais Grand-Ducal",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2007: Palais Grand-Ducal.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2007_2euro_1.jpg",
    "image_key": "lu_commemorative_2007_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2007_cc-common",
    "country": "Luxembourg",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2007_2euro_0.jpg",
    "image_key": "lu_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_luxembourg_2008_1cent",
    "country": "Luxembourg",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2008) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2008_2cent",
    "country": "Luxembourg",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2008) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2008_5cent",
    "country": "Luxembourg",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2008) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2008_10cent",
    "country": "Luxembourg",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2008) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2008_20cent",
    "country": "Luxembourg",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2008) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2008_50cent",
    "country": "Luxembourg",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2008) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2008_1euro",
    "country": "Luxembourg",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2008) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 480000,
    "mintageFormatted": "480,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2008",
    "country": "Luxembourg",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2008) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2008_cc1",
    "country": "Luxembourg",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2008) - Château de Berg",
    "subject": "Château de Berg",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2008: Château de Berg.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2008_2euro_0.jpg",
    "image_key": "lu_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2009_1cent",
    "country": "Luxembourg",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2009) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2009_2cent",
    "country": "Luxembourg",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2009) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2009_5cent",
    "country": "Luxembourg",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2009) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2009_10cent",
    "country": "Luxembourg",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2009) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2009_20cent",
    "country": "Luxembourg",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2009) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2009_50cent",
    "country": "Luxembourg",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2009) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2009_1euro",
    "country": "Luxembourg",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2009) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 240000,
    "mintageFormatted": "240,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2009",
    "country": "Luxembourg",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2009) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 240000,
    "mintageFormatted": "240,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2009_cc1",
    "country": "Luxembourg",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2009) - Accession of Grand Duchess Charlotte (90th Ann.)",
    "subject": "Accession of Grand Duchess Charlotte (90th Ann.)",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2009: Accession of Grand Duchess Charlotte (90th Ann.).",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2009_2euro_0.jpg",
    "image_key": "lu_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2009_cc-common",
    "country": "Luxembourg",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2009_2euro_1.jpg",
    "image_key": "lu_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_luxembourg_2010_1cent",
    "country": "Luxembourg",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2010) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2010_2cent",
    "country": "Luxembourg",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2010) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2010_5cent",
    "country": "Luxembourg",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2010) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2010_10cent",
    "country": "Luxembourg",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2010) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2010_20cent",
    "country": "Luxembourg",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2010) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2010_50cent",
    "country": "Luxembourg",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2010) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2010_1euro",
    "country": "Luxembourg",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2010) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2010",
    "country": "Luxembourg",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2010) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2010_cc1",
    "country": "Luxembourg",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2010) - Coat of Arms of Grand Duke Henri",
    "subject": "Coat of Arms of Grand Duke Henri",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2010: Coat of Arms of Grand Duke Henri.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2010_2euro_0.jpg",
    "image_key": "lu_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2011_1cent",
    "country": "Luxembourg",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2011) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7600000,
    "mintageFormatted": "7,600,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2011_2cent",
    "country": "Luxembourg",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2011) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6200000,
    "mintageFormatted": "6,200,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2011_5cent",
    "country": "Luxembourg",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2011) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6700000,
    "mintageFormatted": "6,700,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2011_10cent",
    "country": "Luxembourg",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2011) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4800000,
    "mintageFormatted": "4,800,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2011_20cent",
    "country": "Luxembourg",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2011) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5300000,
    "mintageFormatted": "5,300,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2011_50cent",
    "country": "Luxembourg",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2011) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2011_1euro",
    "country": "Luxembourg",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2011) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1520000,
    "mintageFormatted": "1,520,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2011",
    "country": "Luxembourg",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2011) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2320000,
    "mintageFormatted": "2,320,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2011_cc1",
    "country": "Luxembourg",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2011) - Appointment of Jean as Lieutenant-Représentant",
    "subject": "Appointment of Jean as Lieutenant-Représentant",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2011: Appointment of Jean as Lieutenant-Représentant.",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2011_2euro_0.jpg",
    "image_key": "lu_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2012_1cent",
    "country": "Luxembourg",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2012) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 9200000,
    "mintageFormatted": "9,200,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2012_2cent",
    "country": "Luxembourg",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2012) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2012_5cent",
    "country": "Luxembourg",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2012) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5200000,
    "mintageFormatted": "5,200,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2012_10cent",
    "country": "Luxembourg",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2012) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2200000,
    "mintageFormatted": "2,200,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2012_20cent",
    "country": "Luxembourg",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2012) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5200000,
    "mintageFormatted": "5,200,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2012_50cent",
    "country": "Luxembourg",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2012) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2600000,
    "mintageFormatted": "2,600,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2012_1euro",
    "country": "Luxembourg",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2012) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2240000,
    "mintageFormatted": "2,240,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2012",
    "country": "Luxembourg",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2012) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3760000,
    "mintageFormatted": "3,760,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2012_cc1",
    "country": "Luxembourg",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2012) - Death of Guillaume IV",
    "subject": "Death of Guillaume IV",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2012: Death of Guillaume IV.",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2012_2euro_0.jpg",
    "image_key": "lu_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2012_cc2",
    "country": "Luxembourg",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2012) - Wedding of Guillaume and Stéphania",
    "subject": "Wedding of Guillaume and Stéphania",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2012: Wedding of Guillaume and Stéphania.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2012_2euro_1.jpg",
    "image_key": "lu_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2012_cc-common",
    "country": "Luxembourg",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_luxembourg_2013_1cent",
    "country": "Luxembourg",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2013) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5100000,
    "mintageFormatted": "5,100,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2013_2cent",
    "country": "Luxembourg",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2013) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7100000,
    "mintageFormatted": "7,100,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2013_5cent",
    "country": "Luxembourg",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2013) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7100000,
    "mintageFormatted": "7,100,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2013_10cent",
    "country": "Luxembourg",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2013) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3600000,
    "mintageFormatted": "3,600,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2013_20cent",
    "country": "Luxembourg",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2013) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7100000,
    "mintageFormatted": "7,100,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2013_50cent",
    "country": "Luxembourg",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2013) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6100000,
    "mintageFormatted": "6,100,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2013_1euro",
    "country": "Luxembourg",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2013) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3320000,
    "mintageFormatted": "3,320,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2013",
    "country": "Luxembourg",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2013) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3120000,
    "mintageFormatted": "3,120,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2013_cc1",
    "country": "Luxembourg",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2013) - National Anthem of Luxembourg",
    "subject": "National Anthem of Luxembourg",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2013: National Anthem of Luxembourg.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2013_2euro_0.jpg",
    "image_key": "lu_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2014_1cent",
    "country": "Luxembourg",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2014) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2014_2cent",
    "country": "Luxembourg",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2014) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2014_5cent",
    "country": "Luxembourg",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2014) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2014_10cent",
    "country": "Luxembourg",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2014) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2014_20cent",
    "country": "Luxembourg",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2014) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2014_50cent",
    "country": "Luxembourg",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2014) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2014_1euro",
    "country": "Luxembourg",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2014) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2014",
    "country": "Luxembourg",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2014) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2014_cc1",
    "country": "Luxembourg",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2014) - Independence of Luxembourg",
    "subject": "Independence of Luxembourg",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2014: Independence of Luxembourg.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2014_2euro_1.jpg",
    "image_key": "lu_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2014_cc2",
    "country": "Luxembourg",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2014) - Accession of Grand Duke Jean",
    "subject": "Accession of Grand Duke Jean",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2014: Accession of Grand Duke Jean.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2014_2euro_0.jpg",
    "image_key": "lu_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2015_1cent",
    "country": "Luxembourg",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2015) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2015_2cent",
    "country": "Luxembourg",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2015) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2015_5cent",
    "country": "Luxembourg",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2015) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2015_10cent",
    "country": "Luxembourg",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2015) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2015_20cent",
    "country": "Luxembourg",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2015) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2015_50cent",
    "country": "Luxembourg",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2015) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2015_1euro",
    "country": "Luxembourg",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2015) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2015",
    "country": "Luxembourg",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2015) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2015_cc1",
    "country": "Luxembourg",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2015) - Accession of Grand Duke Henri (15th Ann.)",
    "subject": "Accession of Grand Duke Henri (15th Ann.)",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2015: Accession of Grand Duke Henri (15th Ann.).",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2015_2euro_1.jpg",
    "image_key": "lu_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2015_cc2",
    "country": "Luxembourg",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2015) - House of Nassau-Weilburg",
    "subject": "House of Nassau-Weilburg",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2015: House of Nassau-Weilburg.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2015_2euro_2.jpg",
    "image_key": "lu_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2015_cc-common",
    "country": "Luxembourg",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2015_2euro_0.jpg",
    "image_key": "lu_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_luxembourg_2016_1cent",
    "country": "Luxembourg",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2016) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2016_2cent",
    "country": "Luxembourg",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2016) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2016_5cent",
    "country": "Luxembourg",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2016) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2016_10cent",
    "country": "Luxembourg",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2016) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2016_20cent",
    "country": "Luxembourg",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2016) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2016_50cent",
    "country": "Luxembourg",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2016) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2016_1euro",
    "country": "Luxembourg",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2016) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2016",
    "country": "Luxembourg",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2016) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2016_cc1",
    "country": "Luxembourg",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2016) - Grand Duchess Charlotte Bridge",
    "subject": "Grand Duchess Charlotte Bridge",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2016: Grand Duchess Charlotte Bridge.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2016_2euro_0.jpg",
    "image_key": "lu_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2017_1cent",
    "country": "Luxembourg",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2017) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2017_2cent",
    "country": "Luxembourg",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2017) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2017_5cent",
    "country": "Luxembourg",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2017) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2017_10cent",
    "country": "Luxembourg",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2017) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2017_20cent",
    "country": "Luxembourg",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2017) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2017_50cent",
    "country": "Luxembourg",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2017) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2017_1euro",
    "country": "Luxembourg",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2017) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2017",
    "country": "Luxembourg",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2017) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2017_cc1",
    "country": "Luxembourg",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2017) - Voluntariness of the Luxembourg army",
    "subject": "Voluntariness of the Luxembourg army",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2017: Voluntariness of the Luxembourg army.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2017_2euro_1.jpg",
    "image_key": "lu_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2017_cc2",
    "country": "Luxembourg",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2017) - Grand Duke Guillaume III",
    "subject": "Grand Duke Guillaume III",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2017: Grand Duke Guillaume III.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2017_2euro_0.jpg",
    "image_key": "lu_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2018_1cent",
    "country": "Luxembourg",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2018) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2018_2cent",
    "country": "Luxembourg",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2018) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2018_5cent",
    "country": "Luxembourg",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2018) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1450000,
    "mintageFormatted": "1,450,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2018_10cent",
    "country": "Luxembourg",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2018) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2018_20cent",
    "country": "Luxembourg",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2018) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2018_50cent",
    "country": "Luxembourg",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2018) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2018_1euro",
    "country": "Luxembourg",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2018) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2018",
    "country": "Luxembourg",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2018) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2018_cc1",
    "country": "Luxembourg",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2018) - Constitution of Luxembourg",
    "subject": "Constitution of Luxembourg",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2018: Constitution of Luxembourg.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2018_2euro_1.jpg",
    "image_key": "lu_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2018_cc2",
    "country": "Luxembourg",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2018) - Grand Duke Guillaume I",
    "subject": "Grand Duke Guillaume I",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2018: Grand Duke Guillaume I.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2018_2euro_0.jpg",
    "image_key": "lu_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2019_1cent",
    "country": "Luxembourg",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2019) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2019_2cent",
    "country": "Luxembourg",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2019) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2019_5cent",
    "country": "Luxembourg",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2019) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2019_10cent",
    "country": "Luxembourg",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2019) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2019_20cent",
    "country": "Luxembourg",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2019) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2019_50cent",
    "country": "Luxembourg",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2019) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2019_1euro",
    "country": "Luxembourg",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2019) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2019",
    "country": "Luxembourg",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2019) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2019_cc1",
    "country": "Luxembourg",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2019) - Accession of Grand Duchess Charlotte (100th Ann.)",
    "subject": "Accession of Grand Duchess Charlotte (100th Ann.)",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2019: Accession of Grand Duchess Charlotte (100th Ann.).",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2019_2euro_1.jpg",
    "image_key": "lu_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2019_cc2",
    "country": "Luxembourg",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2019) - Universal Suffrage",
    "subject": "Universal Suffrage",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2019: Universal Suffrage.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2019_2euro_0.jpg",
    "image_key": "lu_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2020_1cent",
    "country": "Luxembourg",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2020) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2020_2cent",
    "country": "Luxembourg",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2020) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2020_5cent",
    "country": "Luxembourg",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2020) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2050000,
    "mintageFormatted": "2,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2020_10cent",
    "country": "Luxembourg",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2020) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1550000,
    "mintageFormatted": "1,550,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2020_20cent",
    "country": "Luxembourg",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2020) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2020_50cent",
    "country": "Luxembourg",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2020) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2020_1euro",
    "country": "Luxembourg",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2020) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2020",
    "country": "Luxembourg",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2020) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2020_cc1",
    "country": "Luxembourg",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2020) - Prince Henri",
    "subject": "Prince Henri",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2020: Prince Henri.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2020_2euro_1.jpg",
    "image_key": "lu_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2020_cc2",
    "country": "Luxembourg",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2020) - Birth of future heir Prince Charles",
    "subject": "Birth of future heir Prince Charles",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2020: Birth of future heir Prince Charles.",
    "mintage": 160000,
    "mintageFormatted": "160,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2020_2euro_0.jpg",
    "image_key": "lu_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2021_1cent",
    "country": "Luxembourg",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2021) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2021_2cent",
    "country": "Luxembourg",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2021) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2021_5cent",
    "country": "Luxembourg",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2021) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3050000,
    "mintageFormatted": "3,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2021_10cent",
    "country": "Luxembourg",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2021) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2021_20cent",
    "country": "Luxembourg",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2021) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3050000,
    "mintageFormatted": "3,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2021_50cent",
    "country": "Luxembourg",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2021) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2021_1euro",
    "country": "Luxembourg",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2021) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2021",
    "country": "Luxembourg",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2021) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2021_cc1",
    "country": "Luxembourg",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2021) - Grand Duke Jean",
    "subject": "Grand Duke Jean",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2021: Grand Duke Jean.",
    "mintage": 160000,
    "mintageFormatted": "160,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2021_2euro_0.jpg",
    "image_key": "lu_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2021_cc2",
    "country": "Luxembourg",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2021) - Wedding of Grand Duke Henri",
    "subject": "Wedding of Grand Duke Henri",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2021: Wedding of Grand Duke Henri.",
    "mintage": 160000,
    "mintageFormatted": "160,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2021_2euro_1.jpg",
    "image_key": "lu_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2022_1cent",
    "country": "Luxembourg",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2022) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2022_2cent",
    "country": "Luxembourg",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2022) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2022_5cent",
    "country": "Luxembourg",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2022) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3050000,
    "mintageFormatted": "3,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2022_10cent",
    "country": "Luxembourg",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2022) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2050000,
    "mintageFormatted": "2,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2022_20cent",
    "country": "Luxembourg",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2022) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2022_50cent",
    "country": "Luxembourg",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2022) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2022_1euro",
    "country": "Luxembourg",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2022) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2022",
    "country": "Luxembourg",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2022) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2022_cc1",
    "country": "Luxembourg",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2022) - Wedding of Guillaume and Stéphania (10th Ann.)",
    "subject": "Wedding of Guillaume and Stéphania (10th Ann.)",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2022: Wedding of Guillaume and Stéphania (10th Ann.).",
    "mintage": 160000,
    "mintageFormatted": "160,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2022_2euro_2.jpg",
    "image_key": "lu_commemorative_2022_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2022_cc2",
    "country": "Luxembourg",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2022) - Flag of Luxembourg",
    "subject": "Flag of Luxembourg",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2022: Flag of Luxembourg.",
    "mintage": 160000,
    "mintageFormatted": "160,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2022_2euro_0.jpg",
    "image_key": "lu_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2022_cc-common",
    "country": "Luxembourg",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 160000,
    "mintageFormatted": "160,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2022_2euro_1.jpg",
    "image_key": "lu_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_luxembourg_2023_1cent",
    "country": "Luxembourg",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2023) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6250000,
    "mintageFormatted": "6,250,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2023_2cent",
    "country": "Luxembourg",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2023) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 8150000,
    "mintageFormatted": "8,150,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2023_5cent",
    "country": "Luxembourg",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2023) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5950000,
    "mintageFormatted": "5,950,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2023_10cent",
    "country": "Luxembourg",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2023) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 5150000,
    "mintageFormatted": "5,150,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2023_20cent",
    "country": "Luxembourg",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2023) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6376400,
    "mintageFormatted": "6,376,400",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2023_50cent",
    "country": "Luxembourg",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2023) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3032800,
    "mintageFormatted": "3,032,800",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2023_1euro",
    "country": "Luxembourg",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2023) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2023",
    "country": "Luxembourg",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2023) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 6250000,
    "mintageFormatted": "6,250,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2023_cc1",
    "country": "Luxembourg",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Luxembourg 2€ Commemorative (2023) - Chamber of Deputies and First Constitution",
    "subject": "Chamber of Deputies and First Constitution",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2023: Chamber of Deputies and First Constitution.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lu_commemorative_2023_2euro_0.jpg",
    "image_key": "lu_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2023_cc2",
    "country": "Luxembourg",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Luxembourg 2€ Commemorative (2023) - Grand Duke Henri as a member of the IOC",
    "subject": "Grand Duke Henri as a member of the IOC",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2023: Grand Duke Henri as a member of the IOC.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/lu_commemorative_2023_2euro_1.jpg",
    "image_key": "lu_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2024_1cent",
    "country": "Luxembourg",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2024) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2024_2cent",
    "country": "Luxembourg",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2024) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2024_5cent",
    "country": "Luxembourg",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2024) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 2050000,
    "mintageFormatted": "2,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2024_10cent",
    "country": "Luxembourg",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2024) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2024_20cent",
    "country": "Luxembourg",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2024) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3050000,
    "mintageFormatted": "3,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2024_50cent",
    "country": "Luxembourg",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2024) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2024_1euro",
    "country": "Luxembourg",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2024) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2024",
    "country": "Luxembourg",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2024) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3050000,
    "mintageFormatted": "3,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2024_cc1",
    "country": "Luxembourg",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2024) - Grand Duke Guillaume II",
    "subject": "Grand Duke Guillaume II",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2024: Grand Duke Guillaume II.",
    "mintage": 120000,
    "mintageFormatted": "120,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2024_2euro_0.jpg",
    "image_key": "lu_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2024_cc2",
    "country": "Luxembourg",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2024) - The Freiersteppler on Lux.'s Coins",
    "subject": "The Freiersteppler on Lux.'s Coins",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2024: The Freiersteppler on Lux.'s Coins.",
    "mintage": 120000,
    "mintageFormatted": "120,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2024_2euro_1.jpg",
    "image_key": "lu_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2025_1cent",
    "country": "Luxembourg",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2025) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2025_2cent",
    "country": "Luxembourg",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2025) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2025_5cent",
    "country": "Luxembourg",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2025) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1550000,
    "mintageFormatted": "1,550,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2025_10cent",
    "country": "Luxembourg",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2025) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3050000,
    "mintageFormatted": "3,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2025_20cent",
    "country": "Luxembourg",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2025) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3050000,
    "mintageFormatted": "3,050,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2025_50cent",
    "country": "Luxembourg",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2025) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 550000,
    "mintageFormatted": "550,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2025_1euro",
    "country": "Luxembourg",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2025) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 50000,
    "mintageFormatted": "50,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2025",
    "country": "Luxembourg",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2025) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 570000,
    "mintageFormatted": "570,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2025_cc1",
    "country": "Luxembourg",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2025) - Accession of Grand Duke Henri (25th Ann.)",
    "subject": "Accession of Grand Duke Henri (25th Ann.)",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2025: Accession of Grand Duke Henri (25th Ann.).",
    "mintage": 120000,
    "mintageFormatted": "120,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2025_2euro_0.jpg",
    "image_key": "lu_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2025_cc2",
    "country": "Luxembourg",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2025) - Schuman Declaration",
    "subject": "Schuman Declaration",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2025: Schuman Declaration.",
    "mintage": 120000,
    "mintageFormatted": "120,000",
    "status": "circulating",
    "imagePath": "coins/lu_commemorative_2025_2euro_1.jpg",
    "image_key": "lu_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2026_1cent",
    "country": "Luxembourg",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Cent (2026) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1cent_0.jpg",
    "image_key": "lu_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2026_2cent",
    "country": "Luxembourg",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Cents (2026) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2cent_0.jpg",
    "image_key": "lu_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2026_5cent",
    "country": "Luxembourg",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 5 Cents (2026) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1300000,
    "mintageFormatted": "1,300,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_5cent_0.jpg",
    "image_key": "lu_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2026_10cent",
    "country": "Luxembourg",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 10 Cents (2026) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_10cent_0.jpg",
    "image_key": "lu_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2026_20cent",
    "country": "Luxembourg",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 20 Cents (2026) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_20cent_0.jpg",
    "image_key": "lu_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2026_50cent",
    "country": "Luxembourg",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 50 Cents (2026) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 1600000,
    "mintageFormatted": "1,600,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_50cent_0.jpg",
    "image_key": "lu_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2026_1euro",
    "country": "Luxembourg",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 1 Euro (2026) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 560000,
    "mintageFormatted": "560,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_1euro_0.jpg",
    "image_key": "lu_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_luxembourg_2026",
    "country": "Luxembourg",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Luxembourg 2 Euros (2026) - Grand Duke Henri",
    "subject": "Grand Duke Henri",
    "description": "Effigy of His Royal Highness Grand Duke Henri of Luxembourg",
    "mintage": 3200000,
    "mintageFormatted": "3,200,000",
    "status": "circulating",
    "imagePath": "coins/lu_regular_1999_2euro_0.jpg",
    "image_key": "lu_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2026_cc1",
    "country": "Luxembourg",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2026) - Ascession of Grand Duke Guillaume",
    "subject": "Ascession of Grand Duke Guillaume",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2026: Ascession of Grand Duke Guillaume.",
    "mintage": 120000,
    "mintageFormatted": "120,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_luxembourg_2026_cc2",
    "country": "Luxembourg",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Luxembourg 2€ Commemorative (2026) - Charlemagne Prize",
    "subject": "Charlemagne Prize",
    "description": "Luxembourg 2 Euro Commemorative coin issued in 2026: Charlemagne Prize.",
    "mintage": 120000,
    "mintageFormatted": "120,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2008_1cent",
    "country": "Malta",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Cent (2008) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2008_2cent",
    "country": "Malta",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2008) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 36000000,
    "mintageFormatted": "36,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2008_5cent",
    "country": "Malta",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2008) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 34000000,
    "mintageFormatted": "34,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2008_10cent",
    "country": "Malta",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2008) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 41000000,
    "mintageFormatted": "41,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2008_20cent",
    "country": "Malta",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2008) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2008_50cent",
    "country": "Malta",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2008) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2008_1euro",
    "country": "Malta",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Euro (2008) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 14000000,
    "mintageFormatted": "14,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2008",
    "country": "Malta",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Euros (2008) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2009_cc-common",
    "country": "Malta",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Malta 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 700000,
    "mintageFormatted": "700,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2009_2euro_0.jpg",
    "image_key": "mt_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_malta_2010",
    "country": "Malta",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Euros (2010) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2011_1cent",
    "country": "Malta",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2011) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2011_2cent",
    "country": "Malta",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Cents (2011) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2011_5cent",
    "country": "Malta",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 5 Cents (2011) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2011_10cent",
    "country": "Malta",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 10 Cents (2011) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2011_20cent",
    "country": "Malta",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 20 Cents (2011) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2011_50cent",
    "country": "Malta",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 50 Cents (2011) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2011_1euro",
    "country": "Malta",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2011) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2011",
    "country": "Malta",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2011) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2011_cc1",
    "country": "Malta",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2011) - First elected representatives 1849",
    "subject": "First elected representatives 1849",
    "description": "Malta 2 Euro Commemorative coin issued in 2011: First elected representatives 1849.",
    "mintage": 430000,
    "mintageFormatted": "430,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2011_2euro_0.jpg",
    "image_key": "mt_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2012_1cent",
    "country": "Malta",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2012) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2012_2cent",
    "country": "Malta",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Cents (2012) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2012_5cent",
    "country": "Malta",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 5 Cents (2012) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2012_10cent",
    "country": "Malta",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 10 Cents (2012) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2012_20cent",
    "country": "Malta",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 20 Cents (2012) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2012_50cent",
    "country": "Malta",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 50 Cents (2012) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2012_1euro",
    "country": "Malta",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2012) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2012",
    "country": "Malta",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2012) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2012_cc1",
    "country": "Malta",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2012) - Majority Representation 1887",
    "subject": "Majority Representation 1887",
    "description": "Malta 2 Euro Commemorative coin issued in 2012: Majority Representation 1887.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2012_2euro_0.jpg",
    "image_key": "mt_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2012_cc-common",
    "country": "Malta",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Malta 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2012_2euro_1.jpg",
    "image_key": "mt_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_malta_2013_1cent",
    "country": "Malta",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Cent (2013) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 10700000,
    "mintageFormatted": "10,700,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2013_2cent",
    "country": "Malta",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2013) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 7500000,
    "mintageFormatted": "7,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2013_5cent",
    "country": "Malta",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2013) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2013_10cent",
    "country": "Malta",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 10 Cents (2013) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2013_20cent",
    "country": "Malta",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 20 Cents (2013) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2013_50cent",
    "country": "Malta",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2013) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2013_1euro",
    "country": "Malta",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2013) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2013",
    "country": "Malta",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Euros (2013) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 4500000,
    "mintageFormatted": "4,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2013_cc1",
    "country": "Malta",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2013) - Self-Government Constitution of 1921",
    "subject": "Self-Government Constitution of 1921",
    "description": "Malta 2 Euro Commemorative coin issued in 2013: Self-Government Constitution of 1921.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2013_2euro_0.jpg",
    "image_key": "mt_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2014_1cent",
    "country": "Malta",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2014) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2014_2cent",
    "country": "Malta",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Cents (2014) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2014_5cent",
    "country": "Malta",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 5 Cents (2014) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2014_10cent",
    "country": "Malta",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 10 Cents (2014) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2014_20cent",
    "country": "Malta",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 20 Cents (2014) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2014_50cent",
    "country": "Malta",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 50 Cents (2014) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2014_1euro",
    "country": "Malta",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2014) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2014",
    "country": "Malta",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2014) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2014_cc1",
    "country": "Malta",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2014) - Malta Police Force",
    "subject": "Malta Police Force",
    "description": "Malta 2 Euro Commemorative coin issued in 2014: Malta Police Force.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2014_2euro_0.jpg",
    "image_key": "mt_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2014_cc2",
    "country": "Malta",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2014) - Independence 1964",
    "subject": "Independence 1964",
    "description": "Malta 2 Euro Commemorative coin issued in 2014: Independence 1964.",
    "mintage": 425000,
    "mintageFormatted": "425,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2014_2euro_1.jpg",
    "image_key": "mt_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2015_1cent",
    "country": "Malta",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2015) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2015_2cent",
    "country": "Malta",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2015) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3100000,
    "mintageFormatted": "3,100,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2015_5cent",
    "country": "Malta",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2015) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2015_10cent",
    "country": "Malta",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 10 Cents (2015) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2015_20cent",
    "country": "Malta",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 20 Cents (2015) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2015_50cent",
    "country": "Malta",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 50 Cents (2015) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2015_1euro",
    "country": "Malta",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2015) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2015",
    "country": "Malta",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Euros (2015) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 7200000,
    "mintageFormatted": "7,200,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2015_cc1",
    "country": "Malta",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2015) - First flight from Malta",
    "subject": "First flight from Malta",
    "description": "Malta 2 Euro Commemorative coin issued in 2015: First flight from Malta.",
    "mintage": 325000,
    "mintageFormatted": "325,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2015_2euro_2.jpg",
    "image_key": "mt_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2015_cc2",
    "country": "Malta",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2015) - Republic of Malta 1974",
    "subject": "Republic of Malta 1974",
    "description": "Malta 2 Euro Commemorative coin issued in 2015: Republic of Malta 1974.",
    "mintage": 435000,
    "mintageFormatted": "435,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2015_2euro_1.jpg",
    "image_key": "mt_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2015_cc-common",
    "country": "Malta",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Malta 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2015_2euro_0.jpg",
    "image_key": "mt_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_malta_2016_1cent",
    "country": "Malta",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Cent (2016) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 250000,
    "mintageFormatted": "250,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2016_2cent",
    "country": "Malta",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2016) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 250000,
    "mintageFormatted": "250,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2016_5cent",
    "country": "Malta",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2016) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 250000,
    "mintageFormatted": "250,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2016_10cent",
    "country": "Malta",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2016) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2016_20cent",
    "country": "Malta",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2016) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2016_50cent",
    "country": "Malta",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2016) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2016_1euro",
    "country": "Malta",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Euro (2016) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 125000,
    "mintageFormatted": "125,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2016",
    "country": "Malta",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Euros (2016) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 125000,
    "mintageFormatted": "125,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2016_cc1",
    "country": "Malta",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2016) - Temples of Ġgantija",
    "subject": "Temples of Ġgantija",
    "description": "Malta 2 Euro Commemorative coin issued in 2016: Temples of Ġgantija.",
    "mintage": 410000,
    "mintageFormatted": "410,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2016_2euro_1.jpg",
    "image_key": "mt_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2016_cc2",
    "country": "Malta",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2016) - Solidarity through Love",
    "subject": "Solidarity through Love",
    "description": "Malta 2 Euro Commemorative coin issued in 2016: Solidarity through Love.",
    "mintage": 380000,
    "mintageFormatted": "380,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2016_2euro_0.jpg",
    "image_key": "mt_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2017_1cent",
    "country": "Malta",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Cent (2017) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2017_2cent",
    "country": "Malta",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Cents (2017) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2017_5cent",
    "country": "Malta",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2017) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 4500000,
    "mintageFormatted": "4,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2017_10cent",
    "country": "Malta",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2017) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2017_20cent",
    "country": "Malta",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 20 Cents (2017) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2017_50cent",
    "country": "Malta",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2017) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2017_1euro",
    "country": "Malta",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Euro (2017) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2017",
    "country": "Malta",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2017) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2017_cc1",
    "country": "Malta",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2017) - Temples of Ħaġar Qim",
    "subject": "Temples of Ħaġar Qim",
    "description": "Malta 2 Euro Commemorative coin issued in 2017: Temples of Ħaġar Qim.",
    "mintage": 405000,
    "mintageFormatted": "405,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2017_2euro_1.jpg",
    "image_key": "mt_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2017_cc2",
    "country": "Malta",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2017) - The Peace",
    "subject": "The Peace",
    "description": "Malta 2 Euro Commemorative coin issued in 2017: The Peace.",
    "mintage": 380000,
    "mintageFormatted": "380,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2017_2euro_0.jpg",
    "image_key": "mt_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2018_1cent",
    "country": "Malta",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Cent (2018) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 21000000,
    "mintageFormatted": "21,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2018_2cent",
    "country": "Malta",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2018) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2018_5cent",
    "country": "Malta",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 5 Cents (2018) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2018_10cent",
    "country": "Malta",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 10 Cents (2018) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2018_20cent",
    "country": "Malta",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 20 Cents (2018) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2018_50cent",
    "country": "Malta",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 50 Cents (2018) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2018_1euro",
    "country": "Malta",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2018) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2018",
    "country": "Malta",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2018) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2018_cc1",
    "country": "Malta",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2018) - Temples of Mnajdra",
    "subject": "Temples of Mnajdra",
    "description": "Malta 2 Euro Commemorative coin issued in 2018: Temples of Mnajdra.",
    "mintage": 335000,
    "mintageFormatted": "335,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2018_2euro_0.jpg",
    "image_key": "mt_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2018_cc2",
    "country": "Malta",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2018) - Cultural Heritage",
    "subject": "Cultural Heritage",
    "description": "Malta 2 Euro Commemorative coin issued in 2018: Cultural Heritage.",
    "mintage": 320000,
    "mintageFormatted": "320,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2018_2euro_1.jpg",
    "image_key": "mt_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2019_1cent",
    "country": "Malta",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Cent (2019) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2019_2cent",
    "country": "Malta",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Cents (2019) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2019_5cent",
    "country": "Malta",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2019) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 10500000,
    "mintageFormatted": "10,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2019_10cent",
    "country": "Malta",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2019) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2019_20cent",
    "country": "Malta",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2019) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2019_50cent",
    "country": "Malta",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2019) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2019_1euro",
    "country": "Malta",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Euro (2019) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2019",
    "country": "Malta",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2019) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2019_cc1",
    "country": "Malta",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2019) - Temples of Ta’ Ħaġrat",
    "subject": "Temples of Ta’ Ħaġrat",
    "description": "Malta 2 Euro Commemorative coin issued in 2019: Temples of Ta’ Ħaġrat.",
    "mintage": 335000,
    "mintageFormatted": "335,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2019_2euro_1.jpg",
    "image_key": "mt_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2019_cc2",
    "country": "Malta",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2019) - Nature and Environment",
    "subject": "Nature and Environment",
    "description": "Malta 2 Euro Commemorative coin issued in 2019: Nature and Environment.",
    "mintage": 320000,
    "mintageFormatted": "320,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2019_2euro_0.jpg",
    "image_key": "mt_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2020_1cent",
    "country": "Malta",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2020) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2020_2cent",
    "country": "Malta",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2020) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2020_5cent",
    "country": "Malta",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2020) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2020_10cent",
    "country": "Malta",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2020) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2020_20cent",
    "country": "Malta",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2020) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2020_50cent",
    "country": "Malta",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2020) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2020_1euro",
    "country": "Malta",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Euro (2020) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2020",
    "country": "Malta",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2020) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2020_cc1",
    "country": "Malta",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2020) - Temples of Skorba",
    "subject": "Temples of Skorba",
    "description": "Malta 2 Euro Commemorative coin issued in 2020: Temples of Skorba.",
    "mintage": 180000,
    "mintageFormatted": "180,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2020_2euro_1.jpg",
    "image_key": "mt_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2020_cc2",
    "country": "Malta",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2020) - Children’s Games",
    "subject": "Children’s Games",
    "description": "Malta 2 Euro Commemorative coin issued in 2020: Children’s Games.",
    "mintage": 220000,
    "mintageFormatted": "220,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2020_2euro_0.jpg",
    "image_key": "mt_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2021_1cent",
    "country": "Malta",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Cent (2021) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 6500000,
    "mintageFormatted": "6,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2021_2cent",
    "country": "Malta",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2021) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2021_5cent",
    "country": "Malta",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2021) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 4600000,
    "mintageFormatted": "4,600,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2021_10cent",
    "country": "Malta",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2021) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 3100000,
    "mintageFormatted": "3,100,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2021_20cent",
    "country": "Malta",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2021) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2021_50cent",
    "country": "Malta",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2021) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1200000,
    "mintageFormatted": "1,200,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2021_1euro",
    "country": "Malta",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Euro (2021) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1100000,
    "mintageFormatted": "1,100,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2021",
    "country": "Malta",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2021) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2021_cc1",
    "country": "Malta",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2021) - Heroes of the Pandemic",
    "subject": "Heroes of the Pandemic",
    "description": "Malta 2 Euro Commemorative coin issued in 2021: Heroes of the Pandemic.",
    "mintage": 10250,
    "mintageFormatted": "10,250",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2021_2euro_1.jpg",
    "image_key": "mt_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2021_cc2",
    "country": "Malta",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2021) - Temples of Tarxien",
    "subject": "Temples of Tarxien",
    "description": "Malta 2 Euro Commemorative coin issued in 2021: Temples of Tarxien.",
    "mintage": 181000,
    "mintageFormatted": "181,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2021_2euro_0.jpg",
    "image_key": "mt_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2022_1cent",
    "country": "Malta",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Cent (2022) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2022_2cent",
    "country": "Malta",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2022) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 4900000,
    "mintageFormatted": "4,900,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2022_5cent",
    "country": "Malta",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2022) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3600000,
    "mintageFormatted": "3,600,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2022_10cent",
    "country": "Malta",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2022) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1100000,
    "mintageFormatted": "1,100,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2022_20cent",
    "country": "Malta",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2022) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2022_50cent",
    "country": "Malta",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 50 Cents (2022) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2022_1euro",
    "country": "Malta",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2022) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2022",
    "country": "Malta",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2022) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2022_cc1",
    "country": "Malta",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2022) - Ħal-Saflieni Hypogeum",
    "subject": "Ħal-Saflieni Hypogeum",
    "description": "Malta 2 Euro Commemorative coin issued in 2022: Ħal-Saflieni Hypogeum.",
    "mintage": 162500,
    "mintageFormatted": "162,500",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2022_2euro_0.jpg",
    "image_key": "mt_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2022_cc2",
    "country": "Malta",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2022) - Women Peace and Security",
    "subject": "Women Peace and Security",
    "description": "Malta 2 Euro Commemorative coin issued in 2022: Women Peace and Security.",
    "mintage": 12500,
    "mintageFormatted": "12,500",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2022_2euro_1.jpg",
    "image_key": "mt_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2022_cc-common",
    "country": "Malta",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Malta 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 75000,
    "mintageFormatted": "75,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2022_2euro_2.jpg",
    "image_key": "mt_commemorative_2022_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_malta_2023_1cent",
    "country": "Malta",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2023) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2023_2cent",
    "country": "Malta",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Cents (2023) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2023_5cent",
    "country": "Malta",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2023) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 3300000,
    "mintageFormatted": "3,300,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2023_10cent",
    "country": "Malta",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2023) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 2300000,
    "mintageFormatted": "2,300,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2023_20cent",
    "country": "Malta",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2023) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1800000,
    "mintageFormatted": "1,800,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2023_50cent",
    "country": "Malta",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2023) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2023_1euro",
    "country": "Malta",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Euro (2023) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2023",
    "country": "Malta",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2023) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2023_cc1",
    "country": "Malta",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2023) - Nicolaus Copernicus",
    "subject": "Nicolaus Copernicus",
    "description": "Malta 2 Euro Commemorative coin issued in 2023: Nicolaus Copernicus.",
    "mintage": 5000,
    "mintageFormatted": "5,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2023_2euro_0.jpg",
    "image_key": "mt_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2023_cc2",
    "country": "Malta",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2023) - Napoleon Bonaparte and the French in Malta",
    "subject": "Napoleon Bonaparte and the French in Malta",
    "description": "Malta 2 Euro Commemorative coin issued in 2023: Napoleon Bonaparte and the French in Malta.",
    "mintage": 5000,
    "mintageFormatted": "5,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2023_2euro_1.jpg",
    "image_key": "mt_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2024_1cent",
    "country": "Malta",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2024) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2024_2cent",
    "country": "Malta",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Cents (2024) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2024_5cent",
    "country": "Malta",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 5 Cents (2024) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2024_10cent",
    "country": "Malta",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 10 Cents (2024) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2024_20cent",
    "country": "Malta",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2024) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2024_50cent",
    "country": "Malta",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2024) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2024_1euro",
    "country": "Malta",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2024) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2024",
    "country": "Malta",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Euros (2024) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2024_cc1",
    "country": "Malta",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2€ Commemorative (2024) - Maltese Honeybee",
    "subject": "Maltese Honeybee",
    "description": "Malta 2 Euro Commemorative coin issued in 2024: Maltese Honeybee.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_commemorative_2024_2euro_0.jpg",
    "image_key": "mt_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2024_cc2",
    "country": "Malta",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2€ Commemorative (2024) - The Cittadella on Gozo",
    "subject": "The Cittadella on Gozo",
    "description": "Malta 2 Euro Commemorative coin issued in 2024: The Cittadella on Gozo.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_commemorative_2024_2euro_1.jpg",
    "image_key": "mt_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2025_1cent",
    "country": "Malta",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2025) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2025_2cent",
    "country": "Malta",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Cents (2025) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 1700000,
    "mintageFormatted": "1,700,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2025_5cent",
    "country": "Malta",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 5 Cents (2025) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2025_10cent",
    "country": "Malta",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 10 Cents (2025) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2025_20cent",
    "country": "Malta",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2025) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1100000,
    "mintageFormatted": "1,100,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2025_50cent",
    "country": "Malta",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 50 Cents (2025) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2025_1euro",
    "country": "Malta",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Euro (2025) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2025",
    "country": "Malta",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Euros (2025) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2025_cc1",
    "country": "Malta",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2025) - Maltese Ox",
    "subject": "Maltese Ox",
    "description": "Malta 2 Euro Commemorative coin issued in 2025: Maltese Ox.",
    "mintage": 105000,
    "mintageFormatted": "105,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2025_2euro_0.jpg",
    "image_key": "mt_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2025_cc2",
    "country": "Malta",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2025) - L-Imdina",
    "subject": "L-Imdina",
    "description": "Malta 2 Euro Commemorative coin issued in 2025: L-Imdina.",
    "mintage": 105000,
    "mintageFormatted": "105,000",
    "status": "circulating",
    "imagePath": "coins/mt_commemorative_2025_2euro_1.jpg",
    "image_key": "mt_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2026_1cent",
    "country": "Malta",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 1 Cent (2026) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_1cent_0.jpg",
    "image_key": "mt_regular_2008_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2026_2cent",
    "country": "Malta",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Malta 2 Cents (2026) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mt_regular_2008_2cent_0.jpg",
    "image_key": "mt_regular_2008_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2026_5cent",
    "country": "Malta",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 5 Cents (2026) - Mnajdra Megalithic Temples",
    "subject": "Mnajdra Megalithic Temples",
    "description": "Prehistoric megalithic temple complex of Mnajdra (~3600 BC)",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_5cent_0.jpg",
    "image_key": "mt_regular_2008_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2026_10cent",
    "country": "Malta",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 10 Cents (2026) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_10cent_0.jpg",
    "image_key": "mt_regular_2008_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2026_20cent",
    "country": "Malta",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 20 Cents (2026) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_20cent_0.jpg",
    "image_key": "mt_regular_2008_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2026_50cent",
    "country": "Malta",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 50 Cents (2026) - Coat of Arms of Malta",
    "subject": "Coat of Arms of Malta",
    "description": "National coat of arms of Malta on a heraldic shield",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_50cent_0.jpg",
    "image_key": "mt_regular_2008_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2026_1euro",
    "country": "Malta",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 1 Euro (2026) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_1euro_0.jpg",
    "image_key": "mt_regular_2008_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_malta_2026",
    "country": "Malta",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Malta 2 Euros (2026) - Maltese Cross",
    "subject": "Maltese Cross",
    "description": "Eight-pointed Sovereign Military Order of Malta cross",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mt_regular_2008_2euro_0.jpg",
    "image_key": "mt_regular_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2026_cc1",
    "country": "Malta",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2026) - Pharaoh Hound",
    "subject": "Pharaoh Hound",
    "description": "Malta 2 Euro Commemorative coin issued in 2026: Pharaoh Hound.",
    "mintage": 5000,
    "mintageFormatted": "5,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_malta_2026_cc2",
    "country": "Malta",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Malta 2€ Commemorative (2026) - Valletta",
    "subject": "Valletta",
    "description": "Malta 2 Euro Commemorative coin issued in 2026: Valletta.",
    "mintage": 5000,
    "mintageFormatted": "5,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2001_1cent",
    "country": "Monaco",
    "year": 2001,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Cent (2001) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 327200,
    "mintageFormatted": "327,200",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_1cent_0.jpg",
    "image_key": "mc_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2001_2cent",
    "country": "Monaco",
    "year": 2001,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Cents (2001) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 373400,
    "mintageFormatted": "373,400",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_2cent_0.jpg",
    "image_key": "mc_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2001_5cent",
    "country": "Monaco",
    "year": 2001,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 5 Cents (2001) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_5cent_0.jpg",
    "image_key": "mc_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2001_10cent",
    "country": "Monaco",
    "year": 2001,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 10 Cents (2001) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_10cent_0.jpg",
    "image_key": "mc_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2001_20cent",
    "country": "Monaco",
    "year": 2001,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 20 Cents (2001) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 366400,
    "mintageFormatted": "366,400",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_20cent_0.jpg",
    "image_key": "mc_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2001_50cent",
    "country": "Monaco",
    "year": 2001,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 50 Cents (2001) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_50cent_0.jpg",
    "image_key": "mc_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2001_1euro",
    "country": "Monaco",
    "year": 2001,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2001) - Prince Rainier III and Hereditary Prince Albert",
    "subject": "Prince Rainier III and Hereditary Prince Albert",
    "description": "Dual portrait of Prince Rainier III and Hereditary Prince Albert",
    "mintage": 971100,
    "mintageFormatted": "971,100",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_1euro_0.jpg",
    "image_key": "mc_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2001",
    "country": "Monaco",
    "year": 2001,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2001) - Prince Rainier III",
    "subject": "Prince Rainier III",
    "description": "Portrait of Prince Rainier III of Monaco",
    "mintage": 899800,
    "mintageFormatted": "899,800",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_2euro_0.jpg",
    "image_key": "mc_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2002_1cent",
    "country": "Monaco",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2002) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_1cent_0.jpg",
    "image_key": "mc_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2002_2cent",
    "country": "Monaco",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2002) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_2cent_0.jpg",
    "image_key": "mc_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2002_5cent",
    "country": "Monaco",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2002) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_5cent_0.jpg",
    "image_key": "mc_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2002_10cent",
    "country": "Monaco",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 10 Cents (2002) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 367200,
    "mintageFormatted": "367,200",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_10cent_0.jpg",
    "image_key": "mc_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2002_20cent",
    "country": "Monaco",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 20 Cents (2002) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 336000,
    "mintageFormatted": "336,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_20cent_0.jpg",
    "image_key": "mc_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2002_50cent",
    "country": "Monaco",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 50 Cents (2002) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 324000,
    "mintageFormatted": "324,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_50cent_0.jpg",
    "image_key": "mc_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2002_1euro",
    "country": "Monaco",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2002) - Prince Rainier III and Hereditary Prince Albert",
    "subject": "Prince Rainier III and Hereditary Prince Albert",
    "description": "Dual portrait of Prince Rainier III and Hereditary Prince Albert",
    "mintage": 472500,
    "mintageFormatted": "472,500",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_1euro_0.jpg",
    "image_key": "mc_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2002",
    "country": "Monaco",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2002) - Prince Rainier III",
    "subject": "Prince Rainier III",
    "description": "Portrait of Prince Rainier III of Monaco",
    "mintage": 456000,
    "mintageFormatted": "456,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_2euro_0.jpg",
    "image_key": "mc_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2003_10cent",
    "country": "Monaco",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 10 Cents (2003) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 100800,
    "mintageFormatted": "100,800",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_10cent_0.jpg",
    "image_key": "mc_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2003_20cent",
    "country": "Monaco",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 20 Cents (2003) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_20cent_0.jpg",
    "image_key": "mc_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2003_50cent",
    "country": "Monaco",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 50 Cents (2003) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_50cent_0.jpg",
    "image_key": "mc_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2003_1euro",
    "country": "Monaco",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2003) - Prince Rainier III and Hereditary Prince Albert",
    "subject": "Prince Rainier III and Hereditary Prince Albert",
    "description": "Dual portrait of Prince Rainier III and Hereditary Prince Albert",
    "mintage": 135000,
    "mintageFormatted": "135,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_1euro_0.jpg",
    "image_key": "mc_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2003",
    "country": "Monaco",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2003) - Prince Rainier III",
    "subject": "Prince Rainier III",
    "description": "Portrait of Prince Rainier III of Monaco",
    "mintage": 228000,
    "mintageFormatted": "228,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2001_2euro_0.jpg",
    "image_key": "mc_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2004_1cent",
    "country": "Monaco",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2004) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_1cent_0.jpg",
    "image_key": "mc_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2004_2cent",
    "country": "Monaco",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2004) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_2cent_0.jpg",
    "image_key": "mc_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2004_5cent",
    "country": "Monaco",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2004) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_5cent_0.jpg",
    "image_key": "mc_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2004_10cent",
    "country": "Monaco",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2004) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_10cent_0.jpg",
    "image_key": "mc_regular_2001_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2004_20cent",
    "country": "Monaco",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2004) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_20cent_0.jpg",
    "image_key": "mc_regular_2001_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2004_50cent",
    "country": "Monaco",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2004) - Princely Seal of Monaco",
    "subject": "Princely Seal of Monaco",
    "description": "Monogram and seal of Prince Rainier III",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_50cent_0.jpg",
    "image_key": "mc_regular_2001_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2004_1euro",
    "country": "Monaco",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Euro (2004) - Prince Rainier III and Hereditary Prince Albert",
    "subject": "Prince Rainier III and Hereditary Prince Albert",
    "description": "Dual portrait of Prince Rainier III and Hereditary Prince Albert",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_1euro_0.jpg",
    "image_key": "mc_regular_2001_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2004",
    "country": "Monaco",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Euros (2004) - Prince Rainier III",
    "subject": "Prince Rainier III",
    "description": "Portrait of Prince Rainier III of Monaco",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_2euro_0.jpg",
    "image_key": "mc_regular_2001_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2005_1cent",
    "country": "Monaco",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2005) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_1cent_0.jpg",
    "image_key": "mc_regular_2001_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2005_2cent",
    "country": "Monaco",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2005) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_2cent_0.jpg",
    "image_key": "mc_regular_2001_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2005_5cent",
    "country": "Monaco",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2005) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2001_5cent_0.jpg",
    "image_key": "mc_regular_2001_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2006_1cent",
    "country": "Monaco",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2006) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1cent_0.jpg",
    "image_key": "mc_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2006_2cent",
    "country": "Monaco",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2006) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2cent_0.jpg",
    "image_key": "mc_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2006_5cent",
    "country": "Monaco",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2006) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_5cent_0.jpg",
    "image_key": "mc_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2006_10cent",
    "country": "Monaco",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2006) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_10cent_0.jpg",
    "image_key": "mc_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2006_20cent",
    "country": "Monaco",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2006) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_20cent_0.jpg",
    "image_key": "mc_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2006_50cent",
    "country": "Monaco",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2006) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_50cent_0.jpg",
    "image_key": "mc_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2006_1euro",
    "country": "Monaco",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Euro (2006) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2006",
    "country": "Monaco",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Euros (2006) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2007_1euro",
    "country": "Monaco",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2007) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2007_cc1",
    "country": "Monaco",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2007) - Princess Grace Kelly",
    "subject": "Princess Grace Kelly",
    "description": "Monaco 2 Euro Commemorative coin issued in 2007: Princess Grace Kelly.",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2007_2euro_0.jpg",
    "image_key": "mc_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2009_1cent",
    "country": "Monaco",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2009) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1cent_0.jpg",
    "image_key": "mc_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2009_2cent",
    "country": "Monaco",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2009) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2cent_0.jpg",
    "image_key": "mc_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2009_5cent",
    "country": "Monaco",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2009) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_5cent_0.jpg",
    "image_key": "mc_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2009_10cent",
    "country": "Monaco",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2009) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_10cent_0.jpg",
    "image_key": "mc_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2009_20cent",
    "country": "Monaco",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2009) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_20cent_0.jpg",
    "image_key": "mc_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2009_50cent",
    "country": "Monaco",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2009) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_50cent_0.jpg",
    "image_key": "mc_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2009_1euro",
    "country": "Monaco",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Euro (2009) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2009",
    "country": "Monaco",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2009) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 250000,
    "mintageFormatted": "250,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2010",
    "country": "Monaco",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Euros (2010) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2011_1cent",
    "country": "Monaco",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2011) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1cent_0.jpg",
    "image_key": "mc_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2011_2cent",
    "country": "Monaco",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2011) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2cent_0.jpg",
    "image_key": "mc_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2011_5cent",
    "country": "Monaco",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2011) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_5cent_0.jpg",
    "image_key": "mc_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2011_10cent",
    "country": "Monaco",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2011) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_10cent_0.jpg",
    "image_key": "mc_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2011_20cent",
    "country": "Monaco",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2011) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_20cent_0.jpg",
    "image_key": "mc_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2011_50cent",
    "country": "Monaco",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2011) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_50cent_0.jpg",
    "image_key": "mc_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2011_1euro",
    "country": "Monaco",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Euro (2011) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2011",
    "country": "Monaco",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2011) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1032052,
    "mintageFormatted": "1,032,052",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2011_cc1",
    "country": "Monaco",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Monaco 2€ Commemorative (2011) - Wedding of Albert and Charlene",
    "subject": "Wedding of Albert and Charlene",
    "description": "Monaco 2 Euro Commemorative coin issued in 2011: Wedding of Albert and Charlene.",
    "mintage": 81057,
    "mintageFormatted": "81,057",
    "status": "circulating",
    "imagePath": "coins/mc_commemorative_2011_2euro_0.jpg",
    "image_key": "mc_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2012",
    "country": "Monaco",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2012) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1082373,
    "mintageFormatted": "1,082,373",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2012_cc1",
    "country": "Monaco",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Monaco 2€ Commemorative (2012) - Sovereignity of Monaco",
    "subject": "Sovereignity of Monaco",
    "description": "Monaco 2 Euro Commemorative coin issued in 2012: Sovereignity of Monaco.",
    "mintage": 98500,
    "mintageFormatted": "98,500",
    "status": "circulating",
    "imagePath": "coins/mc_commemorative_2012_2euro_0.jpg",
    "image_key": "mc_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2013_1cent",
    "country": "Monaco",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2013) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1cent_0.jpg",
    "image_key": "mc_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2013_2cent",
    "country": "Monaco",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2013) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2cent_0.jpg",
    "image_key": "mc_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2013_5cent",
    "country": "Monaco",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2013) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_5cent_0.jpg",
    "image_key": "mc_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2013_10cent",
    "country": "Monaco",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2013) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_10cent_0.jpg",
    "image_key": "mc_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2013_20cent",
    "country": "Monaco",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2013) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_20cent_0.jpg",
    "image_key": "mc_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2013_50cent",
    "country": "Monaco",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2013) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_50cent_0.jpg",
    "image_key": "mc_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2013_1euro",
    "country": "Monaco",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Euro (2013) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2013",
    "country": "Monaco",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Euros (2013) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2013_cc1",
    "country": "Monaco",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Monaco 2€ Commemorative (2013) - Monégasque Admission to the UN",
    "subject": "Monégasque Admission to the UN",
    "description": "Monaco 2 Euro Commemorative coin issued in 2013: Monégasque Admission to the UN.",
    "mintage": 1229131,
    "mintageFormatted": "1,229,131",
    "status": "circulating",
    "imagePath": "coins/mc_commemorative_2013_2euro_0.jpg",
    "image_key": "mc_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2014_1cent",
    "country": "Monaco",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2014) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1cent_0.jpg",
    "image_key": "mc_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2014_2cent",
    "country": "Monaco",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2014) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2cent_0.jpg",
    "image_key": "mc_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2014_5cent",
    "country": "Monaco",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2014) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_5cent_0.jpg",
    "image_key": "mc_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2014_10cent",
    "country": "Monaco",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2014) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_10cent_0.jpg",
    "image_key": "mc_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2014_20cent",
    "country": "Monaco",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2014) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_20cent_0.jpg",
    "image_key": "mc_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2014_50cent",
    "country": "Monaco",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2014) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_50cent_0.jpg",
    "image_key": "mc_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2014_1euro",
    "country": "Monaco",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2014) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1000272,
    "mintageFormatted": "1,000,272",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2014",
    "country": "Monaco",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2014) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 772000,
    "mintageFormatted": "772,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2015",
    "country": "Monaco",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2015) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1306782,
    "mintageFormatted": "1,306,782",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2015_cc1",
    "country": "Monaco",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2015) - First Castle on the Rock",
    "subject": "First Castle on the Rock",
    "description": "Monaco 2 Euro Commemorative coin issued in 2015: First Castle on the Rock.",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2015_2euro_0.jpg",
    "image_key": "mc_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2016_1euro",
    "country": "Monaco",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2016) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2016",
    "country": "Monaco",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2016) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 864645,
    "mintageFormatted": "864,645",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2016_cc1",
    "country": "Monaco",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2016) - Foundation of Monte Carlo",
    "subject": "Foundation of Monte Carlo",
    "description": "Monaco 2 Euro Commemorative coin issued in 2016: Foundation of Monte Carlo.",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2016_2euro_0.jpg",
    "image_key": "mc_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2017_1cent",
    "country": "Monaco",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2017) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1cent_0.jpg",
    "image_key": "mc_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2017_2cent",
    "country": "Monaco",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2017) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2cent_0.jpg",
    "image_key": "mc_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2017_5cent",
    "country": "Monaco",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2017) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_5cent_0.jpg",
    "image_key": "mc_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2017_10cent",
    "country": "Monaco",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2017) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_10cent_0.jpg",
    "image_key": "mc_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2017_20cent",
    "country": "Monaco",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2017) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_20cent_0.jpg",
    "image_key": "mc_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2017_50cent",
    "country": "Monaco",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2017) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_50cent_0.jpg",
    "image_key": "mc_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2017_1euro",
    "country": "Monaco",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Euro (2017) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2017",
    "country": "Monaco",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2017) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1383528,
    "mintageFormatted": "1,383,528",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2017_cc1",
    "country": "Monaco",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2017) - Carabiniers du Prince",
    "subject": "Carabiniers du Prince",
    "description": "Monaco 2 Euro Commemorative coin issued in 2017: Carabiniers du Prince.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2017_2euro_0.jpg",
    "image_key": "mc_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2018_1euro",
    "country": "Monaco",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2018) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2018",
    "country": "Monaco",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2018) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 934771,
    "mintageFormatted": "934,771",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2018_cc1",
    "country": "Monaco",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2018) - François Joseph Bosio",
    "subject": "François Joseph Bosio",
    "description": "Monaco 2 Euro Commemorative coin issued in 2018: François Joseph Bosio.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2018_2euro_0.jpg",
    "image_key": "mc_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2019_1euro",
    "country": "Monaco",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2019) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 550000,
    "mintageFormatted": "550,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2019",
    "country": "Monaco",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2019) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1195119,
    "mintageFormatted": "1,195,119",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2019_cc1",
    "country": "Monaco",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2019) - Prince Honoré V",
    "subject": "Prince Honoré V",
    "description": "Monaco 2 Euro Commemorative coin issued in 2019: Prince Honoré V.",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2019_2euro_0.jpg",
    "image_key": "mc_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2020_1cent",
    "country": "Monaco",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2020) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_1cent_0.jpg",
    "image_key": "mc_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2020_2cent",
    "country": "Monaco",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2020) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_2cent_0.jpg",
    "image_key": "mc_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2020_5cent",
    "country": "Monaco",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2020) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_5cent_0.jpg",
    "image_key": "mc_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2020_10cent",
    "country": "Monaco",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2020) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_10cent_0.jpg",
    "image_key": "mc_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2020_20cent",
    "country": "Monaco",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2020) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_20cent_0.jpg",
    "image_key": "mc_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2020_50cent",
    "country": "Monaco",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2020) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2006_50cent_0.jpg",
    "image_key": "mc_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2020_1euro",
    "country": "Monaco",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2020) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1087017,
    "mintageFormatted": "1,087,017",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2020",
    "country": "Monaco",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2020) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2020_cc1",
    "country": "Monaco",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2020) - Prince Honoré III",
    "subject": "Prince Honoré III",
    "description": "Monaco 2 Euro Commemorative coin issued in 2020: Prince Honoré III.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2020_2euro_0.jpg",
    "image_key": "mc_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2021_1euro",
    "country": "Monaco",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2021) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1167728,
    "mintageFormatted": "1,167,728",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2021",
    "country": "Monaco",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2021) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1035000,
    "mintageFormatted": "1,035,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2021_cc1",
    "country": "Monaco",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2021) - Wedding of Albert and Charlene (10th Ann.)",
    "subject": "Wedding of Albert and Charlene (10th Ann.)",
    "description": "Monaco 2 Euro Commemorative coin issued in 2021: Wedding of Albert and Charlene (10th Ann.).",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2021_2euro_0.jpg",
    "image_key": "mc_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2022_1euro",
    "country": "Monaco",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2022) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1180912,
    "mintageFormatted": "1,180,912",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2022",
    "country": "Monaco",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2022) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1050000,
    "mintageFormatted": "1,050,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2022_cc1",
    "country": "Monaco",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2022) - Prince Albert I",
    "subject": "Prince Albert I",
    "description": "Monaco 2 Euro Commemorative coin issued in 2022: Prince Albert I.",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2022_2euro_0.jpg",
    "image_key": "mc_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2023_1euro",
    "country": "Monaco",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2023) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1256833,
    "mintageFormatted": "1,256,833",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2023",
    "country": "Monaco",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2023) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2023_cc1",
    "country": "Monaco",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2023) - Prince Rainier III",
    "subject": "Prince Rainier III",
    "description": "Monaco 2 Euro Commemorative coin issued in 2023: Prince Rainier III.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2023_2euro_0.jpg",
    "image_key": "mc_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2024_1euro",
    "country": "Monaco",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2024) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1531092,
    "mintageFormatted": "1,531,092",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_1euro_0.jpg",
    "image_key": "mc_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2024",
    "country": "Monaco",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2024) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2006_2euro_0.jpg",
    "image_key": "mc_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2024_cc1",
    "country": "Monaco",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2024) - Treaty with Charles V",
    "subject": "Treaty with Charles V",
    "description": "Monaco 2 Euro Commemorative coin issued in 2024: Treaty with Charles V.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2024_2euro_0.jpg",
    "image_key": "mc_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2025_1cent",
    "country": "Monaco",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 1 Cent (2025) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2025_1cent_0.jpg",
    "image_key": "mc_regular_2025_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2025_2cent",
    "country": "Monaco",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2 Cents (2025) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2025_2cent_0.jpg",
    "image_key": "mc_regular_2025_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2025_5cent",
    "country": "Monaco",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 5 Cents (2025) - Coat of Arms of Monaco",
    "subject": "Coat of Arms of Monaco",
    "description": "Coat of arms of the Princely House of Grimaldi",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2025_5cent_0.jpg",
    "image_key": "mc_regular_2025_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2025_10cent",
    "country": "Monaco",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 10 Cents (2025) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2025_10cent_0.jpg",
    "image_key": "mc_regular_2025_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2025_20cent",
    "country": "Monaco",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 20 Cents (2025) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2025_20cent_0.jpg",
    "image_key": "mc_regular_2025_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2025_50cent",
    "country": "Monaco",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 50 Cents (2025) - Princely Monogram of Prince Albert II",
    "subject": "Princely Monogram of Prince Albert II",
    "description": "Monogram of Prince Albert II of Monaco",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_regular_2025_50cent_0.jpg",
    "image_key": "mc_regular_2025_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2025_1euro",
    "country": "Monaco",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 1 Euro (2025) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1573583,
    "mintageFormatted": "1,573,583",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2025_1euro_0.jpg",
    "image_key": "mc_regular_2025_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_monaco_2025",
    "country": "Monaco",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Monaco 2 Euros (2025) - Prince Albert II",
    "subject": "Prince Albert II",
    "description": "Portrait of Prince Albert II of Monaco",
    "mintage": 1207000,
    "mintageFormatted": "1,207,000",
    "status": "circulating",
    "imagePath": "coins/mc_regular_2025_2euro_0.jpg",
    "image_key": "mc_regular_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2025_cc1",
    "country": "Monaco",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2025) - Comté de Carladés",
    "subject": "Comté de Carladés",
    "description": "Monaco 2 Euro Commemorative coin issued in 2025: Comté de Carladés.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2025_2euro_0.jpg",
    "image_key": "mc_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2025_cc2",
    "country": "Monaco",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2025) - Marquisant Des Baux",
    "subject": "Marquisant Des Baux",
    "description": "Monaco 2 Euro Commemorative coin issued in 2025: Marquisant Des Baux.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/mc_commemorative_2025_2euro_1.jpg",
    "image_key": "mc_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_monaco_2026_cc1",
    "country": "Monaco",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Monaco 2€ Commemorative (2026) - Duché de Valentinois",
    "subject": "Duché de Valentinois",
    "description": "Monaco 2 Euro Commemorative coin issued in 2026: Duché de Valentinois.",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_1999_1cent",
    "country": "Netherlands",
    "year": 1999,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (1999) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 47800000,
    "mintageFormatted": "47,800,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_1999_2cent",
    "country": "Netherlands",
    "year": 1999,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (1999) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 109000000,
    "mintageFormatted": "109,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_1999_5cent",
    "country": "Netherlands",
    "year": 1999,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (1999) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 213000000,
    "mintageFormatted": "213,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_1999_10cent",
    "country": "Netherlands",
    "year": 1999,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (1999) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 149700000,
    "mintageFormatted": "149,700,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_1999_20cent",
    "country": "Netherlands",
    "year": 1999,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (1999) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 86500000,
    "mintageFormatted": "86,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_1999_50cent",
    "country": "Netherlands",
    "year": 1999,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (1999) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 99600000,
    "mintageFormatted": "99,600,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_1999_1euro",
    "country": "Netherlands",
    "year": 1999,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (1999) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 63500000,
    "mintageFormatted": "63,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_1999",
    "country": "Netherlands",
    "year": 1999,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (1999) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 9900000,
    "mintageFormatted": "9,900,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2000_1cent",
    "country": "Netherlands",
    "year": 2000,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2000) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 276800000,
    "mintageFormatted": "276,800,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2000_2cent",
    "country": "Netherlands",
    "year": 2000,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2000) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 122000000,
    "mintageFormatted": "122,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2000_5cent",
    "country": "Netherlands",
    "year": 2000,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2000) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 184200000,
    "mintageFormatted": "184,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2000_10cent",
    "country": "Netherlands",
    "year": 2000,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2000) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 156700000,
    "mintageFormatted": "156,700,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2000_20cent",
    "country": "Netherlands",
    "year": 2000,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2000) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 67500000,
    "mintageFormatted": "67,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2000_50cent",
    "country": "Netherlands",
    "year": 2000,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2000) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 87000000,
    "mintageFormatted": "87,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2000_1euro",
    "country": "Netherlands",
    "year": 2000,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2000) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 62800000,
    "mintageFormatted": "62,800,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2000",
    "country": "Netherlands",
    "year": 2000,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2000) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 24400000,
    "mintageFormatted": "24,400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2001_1cent",
    "country": "Netherlands",
    "year": 2001,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2001) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 179300000,
    "mintageFormatted": "179,300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2001_2cent",
    "country": "Netherlands",
    "year": 2001,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2001) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 145800000,
    "mintageFormatted": "145,800,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2001_5cent",
    "country": "Netherlands",
    "year": 2001,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2001) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 205900000,
    "mintageFormatted": "205,900,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2001_10cent",
    "country": "Netherlands",
    "year": 2001,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2001) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 193500000,
    "mintageFormatted": "193,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2001_20cent",
    "country": "Netherlands",
    "year": 2001,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2001) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 97600000,
    "mintageFormatted": "97,600,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2001_50cent",
    "country": "Netherlands",
    "year": 2001,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2001) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 94500000,
    "mintageFormatted": "94,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2001_1euro",
    "country": "Netherlands",
    "year": 2001,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2001) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 67900000,
    "mintageFormatted": "67,900,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2001",
    "country": "Netherlands",
    "year": 2001,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2001) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 140500000,
    "mintageFormatted": "140,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2002_1cent",
    "country": "Netherlands",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2002) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2002_2cent",
    "country": "Netherlands",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2002) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 53100000,
    "mintageFormatted": "53,100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2002_5cent",
    "country": "Netherlands",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2002) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 900000,
    "mintageFormatted": "900,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2002_10cent",
    "country": "Netherlands",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2002) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2002_20cent",
    "country": "Netherlands",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2002) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 51200000,
    "mintageFormatted": "51,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2002_50cent",
    "country": "Netherlands",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2002) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 80900000,
    "mintageFormatted": "80,900,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2002_1euro",
    "country": "Netherlands",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2002) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 20100000,
    "mintageFormatted": "20,100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2002",
    "country": "Netherlands",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2002) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 37200000,
    "mintageFormatted": "37,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2003_1cent",
    "country": "Netherlands",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2003) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 58100000,
    "mintageFormatted": "58,100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2003_2cent",
    "country": "Netherlands",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2003) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 151200000,
    "mintageFormatted": "151,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2003_5cent",
    "country": "Netherlands",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2003) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 1400000,
    "mintageFormatted": "1,400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2003_10cent",
    "country": "Netherlands",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2003) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 1200000,
    "mintageFormatted": "1,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2003_20cent",
    "country": "Netherlands",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2003) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 58200000,
    "mintageFormatted": "58,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2003_50cent",
    "country": "Netherlands",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2003) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 1200000,
    "mintageFormatted": "1,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2003_1euro",
    "country": "Netherlands",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2003) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 1400000,
    "mintageFormatted": "1,400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2003",
    "country": "Netherlands",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2003) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 1200000,
    "mintageFormatted": "1,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2004_1cent",
    "country": "Netherlands",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2004) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 113900000,
    "mintageFormatted": "113,900,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2004_2cent",
    "country": "Netherlands",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2004) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 115700000,
    "mintageFormatted": "115,700,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2004_5cent",
    "country": "Netherlands",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2004) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2004_10cent",
    "country": "Netherlands",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2004) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2004_20cent",
    "country": "Netherlands",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2004) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 20500000,
    "mintageFormatted": "20,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2004_50cent",
    "country": "Netherlands",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2004) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2004_1euro",
    "country": "Netherlands",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2004) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2004",
    "country": "Netherlands",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2004) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2005_1cent",
    "country": "Netherlands",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2005) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2005_2cent",
    "country": "Netherlands",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2005) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2005_5cent",
    "country": "Netherlands",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2005) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 80400000,
    "mintageFormatted": "80,400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2005_10cent",
    "country": "Netherlands",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2005) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2005_20cent",
    "country": "Netherlands",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2005) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2005_50cent",
    "country": "Netherlands",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2005) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2005_1euro",
    "country": "Netherlands",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2005) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2005",
    "country": "Netherlands",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2005) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2006_1cent",
    "country": "Netherlands",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2006) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2006_2cent",
    "country": "Netherlands",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2006) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2006_5cent",
    "country": "Netherlands",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2006) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 60100000,
    "mintageFormatted": "60,100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2006_10cent",
    "country": "Netherlands",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2006) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2006_20cent",
    "country": "Netherlands",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2006) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2006_50cent",
    "country": "Netherlands",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2006) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2006_1euro",
    "country": "Netherlands",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2006) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2006",
    "country": "Netherlands",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2006) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2007_1cent",
    "country": "Netherlands",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2007) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2007_2cent",
    "country": "Netherlands",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2007) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2007_5cent",
    "country": "Netherlands",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2007) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 78600000,
    "mintageFormatted": "78,600,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2007_10cent",
    "country": "Netherlands",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2007) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2007_20cent",
    "country": "Netherlands",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2007) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2007_50cent",
    "country": "Netherlands",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2007) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2007_1euro",
    "country": "Netherlands",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2007) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2007",
    "country": "Netherlands",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2007) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2007_cc-common",
    "country": "Netherlands",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 6327680,
    "mintageFormatted": "6,327,680",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2007_2euro_0.jpg",
    "image_key": "nl_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_netherlands_2008_1cent",
    "country": "Netherlands",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2008) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2008_2cent",
    "country": "Netherlands",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2008) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2008_5cent",
    "country": "Netherlands",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2008) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 74700000,
    "mintageFormatted": "74,700,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2008_10cent",
    "country": "Netherlands",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2008) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2008_20cent",
    "country": "Netherlands",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2008) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2008_50cent",
    "country": "Netherlands",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2008) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2008_1euro",
    "country": "Netherlands",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2008) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2008",
    "country": "Netherlands",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2008) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2009_1cent",
    "country": "Netherlands",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2009) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2009_2cent",
    "country": "Netherlands",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2009) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2009_5cent",
    "country": "Netherlands",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2009) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 40200000,
    "mintageFormatted": "40,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2009_10cent",
    "country": "Netherlands",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2009) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2009_20cent",
    "country": "Netherlands",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2009) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2009_50cent",
    "country": "Netherlands",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2009) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2009_1euro",
    "country": "Netherlands",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2009) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2009",
    "country": "Netherlands",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2009) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2009_cc-common",
    "country": "Netherlands",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 5300000,
    "mintageFormatted": "5,300,000",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2009_2euro_0.jpg",
    "image_key": "nl_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_netherlands_2010_1cent",
    "country": "Netherlands",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2010) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2010_2cent",
    "country": "Netherlands",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2010) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2010_5cent",
    "country": "Netherlands",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2010) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 40100000,
    "mintageFormatted": "40,100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2010_10cent",
    "country": "Netherlands",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2010) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2010_20cent",
    "country": "Netherlands",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2010) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2010_50cent",
    "country": "Netherlands",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2010) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2010_1euro",
    "country": "Netherlands",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2010) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2010",
    "country": "Netherlands",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2010) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2011_1cent",
    "country": "Netherlands",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2011) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2011_2cent",
    "country": "Netherlands",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2011) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2011_5cent",
    "country": "Netherlands",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2011) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 20300000,
    "mintageFormatted": "20,300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2011_10cent",
    "country": "Netherlands",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2011) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2011_20cent",
    "country": "Netherlands",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2011) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2011_50cent",
    "country": "Netherlands",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2011) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2011_1euro",
    "country": "Netherlands",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2011) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2011",
    "country": "Netherlands",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2011) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2011_cc1",
    "country": "Netherlands",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2011) - Desiderius Erasmus & \"The Praise of Folly\"",
    "subject": "Desiderius Erasmus & \"The Praise of Folly\"",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2011: Desiderius Erasmus & \"The Praise of Folly\".",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2011_2euro_0.jpg",
    "image_key": "nl_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2012_1cent",
    "country": "Netherlands",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2012) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2012_2cent",
    "country": "Netherlands",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2012) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2012_5cent",
    "country": "Netherlands",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2012) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 10500000,
    "mintageFormatted": "10,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2012_10cent",
    "country": "Netherlands",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2012) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2012_20cent",
    "country": "Netherlands",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2012) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2012_50cent",
    "country": "Netherlands",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2012) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2012_1euro",
    "country": "Netherlands",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2012) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2012",
    "country": "Netherlands",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2012) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2012_cc-common",
    "country": "Netherlands",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2012_2euro_0.jpg",
    "image_key": "nl_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_netherlands_2013_1cent",
    "country": "Netherlands",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2013) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 35200000,
    "mintageFormatted": "35,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1cent_0.jpg",
    "image_key": "nl_regular_2000_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2013_2cent",
    "country": "Netherlands",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2013) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2cent_0.jpg",
    "image_key": "nl_regular_2000_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2013_5cent",
    "country": "Netherlands",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2013) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 26200000,
    "mintageFormatted": "26,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_5cent_0.jpg",
    "image_key": "nl_regular_2000_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2013_10cent",
    "country": "Netherlands",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2013) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_10cent_0.jpg",
    "image_key": "nl_regular_2000_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2013_20cent",
    "country": "Netherlands",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2013) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_20cent_0.jpg",
    "image_key": "nl_regular_2000_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2013_50cent",
    "country": "Netherlands",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2013) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized profile portrait of Queen Beatrix of the Netherlands",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_50cent_0.jpg",
    "image_key": "nl_regular_2000_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2013_1euro",
    "country": "Netherlands",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2013) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_1euro_0.jpg",
    "image_key": "nl_regular_2000_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2013",
    "country": "Netherlands",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2013) - Queen Beatrix",
    "subject": "Queen Beatrix",
    "description": "Stylized portrait of Queen Beatrix with royal motto 'Beatrix Koningin der Nederlanden'",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2000_2euro_0.jpg",
    "image_key": "nl_regular_2000_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2013_cc1",
    "country": "Netherlands",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2013) - Abdication of Queen Beatrix",
    "subject": "Abdication of Queen Beatrix",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2013: Abdication of Queen Beatrix.",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2013_2euro_1.jpg",
    "image_key": "nl_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2013_cc2",
    "country": "Netherlands",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2013) - Kingdom of the Netherlands",
    "subject": "Kingdom of the Netherlands",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2013: Kingdom of the Netherlands.",
    "mintage": 3500000,
    "mintageFormatted": "3,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2013_2euro_0.jpg",
    "image_key": "nl_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2014_1cent",
    "country": "Netherlands",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2014) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 530000,
    "mintageFormatted": "530,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2014_2cent",
    "country": "Netherlands",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2014) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 530000,
    "mintageFormatted": "530,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2014_5cent",
    "country": "Netherlands",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2014) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2014_10cent",
    "country": "Netherlands",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2014) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2014_20cent",
    "country": "Netherlands",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2014) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2014_50cent",
    "country": "Netherlands",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2014) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2014_1euro",
    "country": "Netherlands",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2014) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2014",
    "country": "Netherlands",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2014) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2014_cc1",
    "country": "Netherlands",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2014) - Accession of King Willem-Alexander",
    "subject": "Accession of King Willem-Alexander",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2014: Accession of King Willem-Alexander.",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2014_2euro_0.jpg",
    "image_key": "nl_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2015_1cent",
    "country": "Netherlands",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2015) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2015_2cent",
    "country": "Netherlands",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2015) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2015_5cent",
    "country": "Netherlands",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2015) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 55000000,
    "mintageFormatted": "55,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2015_10cent",
    "country": "Netherlands",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2015) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2015_20cent",
    "country": "Netherlands",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2015) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2015_50cent",
    "country": "Netherlands",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2015) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2015_1euro",
    "country": "Netherlands",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2015) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2015",
    "country": "Netherlands",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2015) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2015_cc-common",
    "country": "Netherlands",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2015_2euro_0.jpg",
    "image_key": "nl_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_netherlands_2016_1cent",
    "country": "Netherlands",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Cent (2016) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2016_2cent",
    "country": "Netherlands",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Cents (2016) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2016_5cent",
    "country": "Netherlands",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2016) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 70000000,
    "mintageFormatted": "70,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2016_10cent",
    "country": "Netherlands",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2016) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2016_20cent",
    "country": "Netherlands",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2016) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2016_50cent",
    "country": "Netherlands",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2016) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2016_1euro",
    "country": "Netherlands",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 1 Euro (2016) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2016",
    "country": "Netherlands",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2016) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2017_1cent",
    "country": "Netherlands",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2017) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2017_2cent",
    "country": "Netherlands",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2017) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2017_5cent",
    "country": "Netherlands",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2017) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 63000000,
    "mintageFormatted": "63,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2017_10cent",
    "country": "Netherlands",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2017) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 20200000,
    "mintageFormatted": "20,200,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2017_20cent",
    "country": "Netherlands",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 20 Cents (2017) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2017_50cent",
    "country": "Netherlands",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2017) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2017_1euro",
    "country": "Netherlands",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2017) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2017",
    "country": "Netherlands",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Euros (2017) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2018_1cent",
    "country": "Netherlands",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2018) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2018_2cent",
    "country": "Netherlands",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2018) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2018_5cent",
    "country": "Netherlands",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2018) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 60000000,
    "mintageFormatted": "60,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2018_10cent",
    "country": "Netherlands",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2018) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 12500000,
    "mintageFormatted": "12,500,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2018_20cent",
    "country": "Netherlands",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2018) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2018_50cent",
    "country": "Netherlands",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2018) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2018_1euro",
    "country": "Netherlands",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2018) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2018",
    "country": "Netherlands",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Euros (2018) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2019_1cent",
    "country": "Netherlands",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2019) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2019_2cent",
    "country": "Netherlands",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2019) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2019_5cent",
    "country": "Netherlands",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2019) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2019_10cent",
    "country": "Netherlands",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2019) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2019_20cent",
    "country": "Netherlands",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 20 Cents (2019) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2019_50cent",
    "country": "Netherlands",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2019) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2019_1euro",
    "country": "Netherlands",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2019) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2019",
    "country": "Netherlands",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Euros (2019) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2020_1cent",
    "country": "Netherlands",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2020) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2020_2cent",
    "country": "Netherlands",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2020) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2020_5cent",
    "country": "Netherlands",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2020) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2020_10cent",
    "country": "Netherlands",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 10 Cents (2020) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2020_20cent",
    "country": "Netherlands",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 20 Cents (2020) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2020_50cent",
    "country": "Netherlands",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2020) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2020_1euro",
    "country": "Netherlands",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2020) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2020",
    "country": "Netherlands",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Euros (2020) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2021_1cent",
    "country": "Netherlands",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2021) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2021_2cent",
    "country": "Netherlands",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2021) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2021_5cent",
    "country": "Netherlands",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 5 Cents (2021) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2021_10cent",
    "country": "Netherlands",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 10 Cents (2021) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2021_20cent",
    "country": "Netherlands",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 20 Cents (2021) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2021_50cent",
    "country": "Netherlands",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2021) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2021_1euro",
    "country": "Netherlands",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2021) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2021",
    "country": "Netherlands",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Euros (2021) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2022_1cent",
    "country": "Netherlands",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2022) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2022_2cent",
    "country": "Netherlands",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2022) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2022_5cent",
    "country": "Netherlands",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2022) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2022_10cent",
    "country": "Netherlands",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2022) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2022_20cent",
    "country": "Netherlands",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2022) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2022_50cent",
    "country": "Netherlands",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2022) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2022_1euro",
    "country": "Netherlands",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2022) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2022",
    "country": "Netherlands",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Euros (2022) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_netherlands_2022_cc-common",
    "country": "Netherlands",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Netherlands 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Netherlands 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 570000,
    "mintageFormatted": "570,000",
    "status": "circulating",
    "imagePath": "coins/nl_commemorative_2022_2euro_0.jpg",
    "image_key": "nl_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_netherlands_2023_1cent",
    "country": "Netherlands",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2023) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2023_2cent",
    "country": "Netherlands",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2023) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2023_5cent",
    "country": "Netherlands",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2023) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2023_10cent",
    "country": "Netherlands",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2023) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2023_20cent",
    "country": "Netherlands",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2023) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 16000000,
    "mintageFormatted": "16,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2023_50cent",
    "country": "Netherlands",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 50 Cents (2023) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2023_1euro",
    "country": "Netherlands",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2023) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2023",
    "country": "Netherlands",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Euros (2023) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2024_1cent",
    "country": "Netherlands",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2024) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2024_2cent",
    "country": "Netherlands",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2024) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2024_5cent",
    "country": "Netherlands",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2024) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2024_10cent",
    "country": "Netherlands",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 10 Cents (2024) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 0,
    "mintageFormatted": "Set only / Undetermined",
    "status": "Set only / Undetermined",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2024_20cent",
    "country": "Netherlands",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2024) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2024_50cent",
    "country": "Netherlands",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2024) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2024_1euro",
    "country": "Netherlands",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2024) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2024",
    "country": "Netherlands",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2024) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2025_1cent",
    "country": "Netherlands",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2025) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2025_2cent",
    "country": "Netherlands",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2025) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 400,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2025_5cent",
    "country": "Netherlands",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2025) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2025_10cent",
    "country": "Netherlands",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 10 Cents (2025) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2025_20cent",
    "country": "Netherlands",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2025) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2025_50cent",
    "country": "Netherlands",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2025) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2025_1euro",
    "country": "Netherlands",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2025) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2025",
    "country": "Netherlands",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2025) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2026_1cent",
    "country": "Netherlands",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Cent (2026) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/nl_regular_2014_1cent_0.jpg",
    "image_key": "nl_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2026_2cent",
    "country": "Netherlands",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 2 Cents (2026) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/nl_regular_2014_2cent_0.jpg",
    "image_key": "nl_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2026_5cent",
    "country": "Netherlands",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 5 Cents (2026) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/nl_regular_2014_5cent_0.jpg",
    "image_key": "nl_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2026_10cent",
    "country": "Netherlands",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 10 Cents (2026) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/nl_regular_2014_10cent_0.jpg",
    "image_key": "nl_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2026_20cent",
    "country": "Netherlands",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 20 Cents (2026) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/nl_regular_2014_20cent_0.jpg",
    "image_key": "nl_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2026_50cent",
    "country": "Netherlands",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 50 Cents (2026) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander of the Netherlands",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/nl_regular_2014_50cent_0.jpg",
    "image_key": "nl_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2026_1euro",
    "country": "Netherlands",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Netherlands 1 Euro (2026) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/nl_regular_2014_1euro_0.jpg",
    "image_key": "nl_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_netherlands_2026",
    "country": "Netherlands",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Netherlands 2 Euros (2026) - King Willem-Alexander",
    "subject": "King Willem-Alexander",
    "description": "Profile portrait of King Willem-Alexander with motto 'Willem-Alexander Koning der Nederlanden'",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/nl_regular_2014_2euro_0.jpg",
    "image_key": "nl_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2002_1cent",
    "country": "Portugal",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2002) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 278106172,
    "mintageFormatted": "278,106,172",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2002_2cent",
    "country": "Portugal",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2002) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 324376590,
    "mintageFormatted": "324,376,590",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2002_5cent",
    "country": "Portugal",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2002) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 234512047,
    "mintageFormatted": "234,512,047",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2002_10cent",
    "country": "Portugal",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2002) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 220289835,
    "mintageFormatted": "220,289,835",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2002_20cent",
    "country": "Portugal",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2002) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 147411038,
    "mintageFormatted": "147,411,038",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2002_50cent",
    "country": "Portugal",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2002) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 151947133,
    "mintageFormatted": "151,947,133",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2002_1euro",
    "country": "Portugal",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2002) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 100228135,
    "mintageFormatted": "100,228,135",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2002",
    "country": "Portugal",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Euros (2002) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 61930775,
    "mintageFormatted": "61,930,775",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2003_1cent",
    "country": "Portugal",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Cent (2003) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2003_2cent",
    "country": "Portugal",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2003) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2003_5cent",
    "country": "Portugal",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 5 Cents (2003) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2003_10cent",
    "country": "Portugal",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2003) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 6332000,
    "mintageFormatted": "6,332,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2003_20cent",
    "country": "Portugal",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2003) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 9493600,
    "mintageFormatted": "9,493,600",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2003_50cent",
    "country": "Portugal",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2003) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 10353000,
    "mintageFormatted": "10,353,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2003_1euro",
    "country": "Portugal",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2003) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 16206875,
    "mintageFormatted": "16,206,875",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2003",
    "country": "Portugal",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Euros (2003) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 5979750,
    "mintageFormatted": "5,979,750",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2004_1cent",
    "country": "Portugal",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2004) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 75000000,
    "mintageFormatted": "75,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2004_2cent",
    "country": "Portugal",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2004) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2004_5cent",
    "country": "Portugal",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2004) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2004_10cent",
    "country": "Portugal",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2004) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2004_20cent",
    "country": "Portugal",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2004) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2004_50cent",
    "country": "Portugal",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2004) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2004_1euro",
    "country": "Portugal",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2004) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2004",
    "country": "Portugal",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Euros (2004) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2005_1cent",
    "country": "Portugal",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2005) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2005_2cent",
    "country": "Portugal",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2005) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2005_5cent",
    "country": "Portugal",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2005) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2005_10cent",
    "country": "Portugal",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2005) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2005_20cent",
    "country": "Portugal",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2005) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2005_50cent",
    "country": "Portugal",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2005) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2005_1euro",
    "country": "Portugal",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2005) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2005",
    "country": "Portugal",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Euros (2005) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2006_1cent",
    "country": "Portugal",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2006) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2006_2cent",
    "country": "Portugal",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2006) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2006_5cent",
    "country": "Portugal",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2006) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2006_10cent",
    "country": "Portugal",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2006) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2006_20cent",
    "country": "Portugal",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2006) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2006_50cent",
    "country": "Portugal",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2006) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2006_1euro",
    "country": "Portugal",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2006) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2006",
    "country": "Portugal",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Euros (2006) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2007_1cent",
    "country": "Portugal",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2007) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 105000000,
    "mintageFormatted": "105,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2007_2cent",
    "country": "Portugal",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2007) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2007_5cent",
    "country": "Portugal",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2007) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2007_10cent",
    "country": "Portugal",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2007) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2007_20cent",
    "country": "Portugal",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 20 Cents (2007) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2007_50cent",
    "country": "Portugal",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2007) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2007_1euro",
    "country": "Portugal",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2007) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 4935400,
    "mintageFormatted": "4,935,400",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2007",
    "country": "Portugal",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2007) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2007_cc1",
    "country": "Portugal",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2007) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Portugal 2 Euro Commemorative coin issued in 2007: Presidency of the EU Council.",
    "mintage": 1250000,
    "mintageFormatted": "1,250,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2007_2euro_0.jpg",
    "image_key": "pt_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2007_cc-common",
    "country": "Portugal",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Portugal 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2007_2euro_1.jpg",
    "image_key": "pt_commemorative_2007_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_portugal_2008_1cent",
    "country": "Portugal",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2008) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 75000000,
    "mintageFormatted": "75,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2008_2cent",
    "country": "Portugal",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2008) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2008_5cent",
    "country": "Portugal",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2008) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2008_10cent",
    "country": "Portugal",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2008) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2008_20cent",
    "country": "Portugal",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2008) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2008_50cent",
    "country": "Portugal",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2008) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2008_1euro",
    "country": "Portugal",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2008) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 4901625,
    "mintageFormatted": "4,901,625",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2008",
    "country": "Portugal",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2008) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2008_cc1",
    "country": "Portugal",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2008) - Universal Declaration of Human Rights",
    "subject": "Universal Declaration of Human Rights",
    "description": "Portugal 2 Euro Commemorative coin issued in 2008: Universal Declaration of Human Rights.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2008_2euro_0.jpg",
    "image_key": "pt_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2009_1cent",
    "country": "Portugal",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2009) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 60000000,
    "mintageFormatted": "60,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2009_2cent",
    "country": "Portugal",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2009) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 45000000,
    "mintageFormatted": "45,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2009_5cent",
    "country": "Portugal",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2009) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2009_10cent",
    "country": "Portugal",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2009) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2009_20cent",
    "country": "Portugal",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2009) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2009_50cent",
    "country": "Portugal",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2009) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2009_1euro",
    "country": "Portugal",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2009) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2009",
    "country": "Portugal",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2009) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2009_cc1",
    "country": "Portugal",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2009) - 2009 Lusophony Games",
    "subject": "2009 Lusophony Games",
    "description": "Portugal 2 Euro Commemorative coin issued in 2009: 2009 Lusophony Games.",
    "mintage": 1250000,
    "mintageFormatted": "1,250,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2009_2euro_0.jpg",
    "image_key": "pt_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2009_cc-common",
    "country": "Portugal",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Portugal 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 1250000,
    "mintageFormatted": "1,250,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2009_2euro_1.jpg",
    "image_key": "pt_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_portugal_2010_1cent",
    "country": "Portugal",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2010) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2010_2cent",
    "country": "Portugal",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2010) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2010_5cent",
    "country": "Portugal",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2010) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2010_10cent",
    "country": "Portugal",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2010) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2010_20cent",
    "country": "Portugal",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2010) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2010_50cent",
    "country": "Portugal",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2010) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2010_1euro",
    "country": "Portugal",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2010) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2010",
    "country": "Portugal",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2010) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2010_cc1",
    "country": "Portugal",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2010) - Portuguese Republic",
    "subject": "Portuguese Republic",
    "description": "Portugal 2 Euro Commemorative coin issued in 2010: Portuguese Republic.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2010_2euro_0.jpg",
    "image_key": "pt_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2011_1cent",
    "country": "Portugal",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2011) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2011_2cent",
    "country": "Portugal",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2011) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2011_5cent",
    "country": "Portugal",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2011) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2011_10cent",
    "country": "Portugal",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2011) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2011_20cent",
    "country": "Portugal",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2011) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2011_50cent",
    "country": "Portugal",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2011) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2011_1euro",
    "country": "Portugal",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2011) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2011",
    "country": "Portugal",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2011) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2011_cc1",
    "country": "Portugal",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2011) - Fernão Mendes Pinto",
    "subject": "Fernão Mendes Pinto",
    "description": "Portugal 2 Euro Commemorative coin issued in 2011: Fernão Mendes Pinto.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2011_2euro_0.jpg",
    "image_key": "pt_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2012_1cent",
    "country": "Portugal",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2012) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2012_2cent",
    "country": "Portugal",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2012) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2012_5cent",
    "country": "Portugal",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2012) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2012_10cent",
    "country": "Portugal",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2012) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2012_20cent",
    "country": "Portugal",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 20 Cents (2012) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2012_50cent",
    "country": "Portugal",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2012) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2012_1euro",
    "country": "Portugal",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Euro (2012) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2012",
    "country": "Portugal",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2012) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2012_cc1",
    "country": "Portugal",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2012) - Guimarães 2012 - European Capital of Culture",
    "subject": "Guimarães 2012 - European Capital of Culture",
    "description": "Portugal 2 Euro Commemorative coin issued in 2012: Guimarães 2012 - European Capital of Culture.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2012_2euro_0.jpg",
    "image_key": "pt_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2012_cc-common",
    "country": "Portugal",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Portugal 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2012_2euro_1.jpg",
    "image_key": "pt_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_portugal_2013_1cent",
    "country": "Portugal",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Cent (2013) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2013_2cent",
    "country": "Portugal",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2013) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2013_5cent",
    "country": "Portugal",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 5 Cents (2013) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2013_10cent",
    "country": "Portugal",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2013) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2013_20cent",
    "country": "Portugal",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 20 Cents (2013) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2013_50cent",
    "country": "Portugal",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2013) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2013_1euro",
    "country": "Portugal",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Euro (2013) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2013",
    "country": "Portugal",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2013) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2013_cc1",
    "country": "Portugal",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2013) - Torre dos Clérigos",
    "subject": "Torre dos Clérigos",
    "description": "Portugal 2 Euro Commemorative coin issued in 2013: Torre dos Clérigos.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2013_2euro_0.jpg",
    "image_key": "pt_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2014_1cent",
    "country": "Portugal",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2014) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2014_2cent",
    "country": "Portugal",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2014) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2014_5cent",
    "country": "Portugal",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 5 Cents (2014) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2014_10cent",
    "country": "Portugal",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2014) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2014_20cent",
    "country": "Portugal",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 20 Cents (2014) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2014_50cent",
    "country": "Portugal",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2014) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2014_1euro",
    "country": "Portugal",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2014) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2014",
    "country": "Portugal",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2014) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2014_cc1",
    "country": "Portugal",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2014) - Carnation Revolution (40th Ann.)",
    "subject": "Carnation Revolution (40th Ann.)",
    "description": "Portugal 2 Euro Commemorative coin issued in 2014: Carnation Revolution (40th Ann.).",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2014_2euro_1.jpg",
    "image_key": "pt_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2014_cc2",
    "country": "Portugal",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2014) - International Year of Family Farming",
    "subject": "International Year of Family Farming",
    "description": "Portugal 2 Euro Commemorative coin issued in 2014: International Year of Family Farming.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2014_2euro_0.jpg",
    "image_key": "pt_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2015_1cent",
    "country": "Portugal",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2015) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2015_2cent",
    "country": "Portugal",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2015) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2015_5cent",
    "country": "Portugal",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 5 Cents (2015) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2015_10cent",
    "country": "Portugal",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2015) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2015_20cent",
    "country": "Portugal",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2015) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2015_50cent",
    "country": "Portugal",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2015) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2015_1euro",
    "country": "Portugal",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2015) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2015",
    "country": "Portugal",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2015) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2015_cc1",
    "country": "Portugal",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2015) - Portuguese Red Cross",
    "subject": "Portuguese Red Cross",
    "description": "Portugal 2 Euro Commemorative coin issued in 2015: Portuguese Red Cross.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2015_2euro_1.jpg",
    "image_key": "pt_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2015_cc2",
    "country": "Portugal",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2015) - First Contact with Timor",
    "subject": "First Contact with Timor",
    "description": "Portugal 2 Euro Commemorative coin issued in 2015: First Contact with Timor.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2015_2euro_2.jpg",
    "image_key": "pt_commemorative_2015_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2015_cc-common",
    "country": "Portugal",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Portugal 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2015_2euro_0.jpg",
    "image_key": "pt_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_portugal_2016_1cent",
    "country": "Portugal",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2016) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2016_2cent",
    "country": "Portugal",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2016) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2016_5cent",
    "country": "Portugal",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2016) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2016_10cent",
    "country": "Portugal",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2016) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2016_20cent",
    "country": "Portugal",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2016) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2016_50cent",
    "country": "Portugal",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2016) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2016_1euro",
    "country": "Portugal",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2016) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2016",
    "country": "Portugal",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2016) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2016_cc1",
    "country": "Portugal",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2016) - 2016 Olympics",
    "subject": "2016 Olympics",
    "description": "Portugal 2 Euro Commemorative coin issued in 2016: 2016 Olympics.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2016_2euro_1.jpg",
    "image_key": "pt_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2016_cc2",
    "country": "Portugal",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2016) - 25th April Bridge",
    "subject": "25th April Bridge",
    "description": "Portugal 2 Euro Commemorative coin issued in 2016: 25th April Bridge.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2016_2euro_0.jpg",
    "image_key": "pt_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2017_1cent",
    "country": "Portugal",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2017) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 55000000,
    "mintageFormatted": "55,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2017_2cent",
    "country": "Portugal",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Cents (2017) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 35000000,
    "mintageFormatted": "35,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2017_5cent",
    "country": "Portugal",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2017) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2017_10cent",
    "country": "Portugal",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2017) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2017_20cent",
    "country": "Portugal",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2017) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2017_50cent",
    "country": "Portugal",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2017) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2017_1euro",
    "country": "Portugal",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2017) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2017",
    "country": "Portugal",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2017) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2017_cc1",
    "country": "Portugal",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2017) - Public Security",
    "subject": "Public Security",
    "description": "Portugal 2 Euro Commemorative coin issued in 2017: Public Security.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2017_2euro_1.jpg",
    "image_key": "pt_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2017_cc2",
    "country": "Portugal",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2017) - Raul Brandão",
    "subject": "Raul Brandão",
    "description": "Portugal 2 Euro Commemorative coin issued in 2017: Raul Brandão.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2017_2euro_0.jpg",
    "image_key": "pt_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2018_1cent",
    "country": "Portugal",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Cent (2018) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2018_2cent",
    "country": "Portugal",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2018) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2018_5cent",
    "country": "Portugal",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2018) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 37545200,
    "mintageFormatted": "37,545,200",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2018_10cent",
    "country": "Portugal",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2018) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 19304000,
    "mintageFormatted": "19,304,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2018_20cent",
    "country": "Portugal",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2018) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2018_50cent",
    "country": "Portugal",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2018) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2018_1euro",
    "country": "Portugal",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2018) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 25000000,
    "mintageFormatted": "25,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2018",
    "country": "Portugal",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2018) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2018_cc1",
    "country": "Portugal",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2018) - INCM",
    "subject": "INCM",
    "description": "Portugal 2 Euro Commemorative coin issued in 2018: INCM.",
    "mintage": 430500,
    "mintageFormatted": "430,500",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2018_2euro_1.jpg",
    "image_key": "pt_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2018_cc2",
    "country": "Portugal",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2018) - Botanical Garden of Ajuda",
    "subject": "Botanical Garden of Ajuda",
    "description": "Portugal 2 Euro Commemorative coin issued in 2018: Botanical Garden of Ajuda.",
    "mintage": 430500,
    "mintageFormatted": "430,500",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2018_2euro_0.jpg",
    "image_key": "pt_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2019_1cent",
    "country": "Portugal",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2019) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2019_2cent",
    "country": "Portugal",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2019) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2019_5cent",
    "country": "Portugal",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2019) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2019_10cent",
    "country": "Portugal",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2019) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2019_20cent",
    "country": "Portugal",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 20 Cents (2019) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2019_50cent",
    "country": "Portugal",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2019) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2019_1euro",
    "country": "Portugal",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2019) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2019",
    "country": "Portugal",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2019) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2019_cc1",
    "country": "Portugal",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2019) - Circumnavigation of Fernão de Magalhães",
    "subject": "Circumnavigation of Fernão de Magalhães",
    "description": "Portugal 2 Euro Commemorative coin issued in 2019: Circumnavigation of Fernão de Magalhães.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2019_2euro_1.jpg",
    "image_key": "pt_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2019_cc2",
    "country": "Portugal",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2019) - Discovery of the Madeira Archipelago",
    "subject": "Discovery of the Madeira Archipelago",
    "description": "Portugal 2 Euro Commemorative coin issued in 2019: Discovery of the Madeira Archipelago.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2019_2euro_0.jpg",
    "image_key": "pt_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2020_1cent",
    "country": "Portugal",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2020) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2020_2cent",
    "country": "Portugal",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2020) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2020_5cent",
    "country": "Portugal",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2020) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2020_10cent",
    "country": "Portugal",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2020) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2020_20cent",
    "country": "Portugal",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2020) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2020_50cent",
    "country": "Portugal",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2020) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2020_1euro",
    "country": "Portugal",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2020) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2020",
    "country": "Portugal",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2020) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2020_cc1",
    "country": "Portugal",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2020) - University of Coimbra",
    "subject": "University of Coimbra",
    "description": "Portugal 2 Euro Commemorative coin issued in 2020: University of Coimbra.",
    "mintage": 350000,
    "mintageFormatted": "350,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2020_2euro_0.jpg",
    "image_key": "pt_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2020_cc2",
    "country": "Portugal",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2020) - United Nations",
    "subject": "United Nations",
    "description": "Portugal 2 Euro Commemorative coin issued in 2020: United Nations.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2020_2euro_1.jpg",
    "image_key": "pt_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2021_1cent",
    "country": "Portugal",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Cent (2021) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2021_2cent",
    "country": "Portugal",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2021) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2021_5cent",
    "country": "Portugal",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2021) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2021_10cent",
    "country": "Portugal",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2021) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2021_20cent",
    "country": "Portugal",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2021) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2021_50cent",
    "country": "Portugal",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2021) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2021_1euro",
    "country": "Portugal",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Euro (2021) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2021",
    "country": "Portugal",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2021) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2021_cc1",
    "country": "Portugal",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2021) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Portugal 2 Euro Commemorative coin issued in 2021: Presidency of the EU Council.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2021_2euro_0.jpg",
    "image_key": "pt_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2021_cc2",
    "country": "Portugal",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2021) - 2021 Olympics",
    "subject": "2021 Olympics",
    "description": "Portugal 2 Euro Commemorative coin issued in 2021: 2021 Olympics.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2021_2euro_1.jpg",
    "image_key": "pt_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2022_1cent",
    "country": "Portugal",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Cent (2022) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2022_2cent",
    "country": "Portugal",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2022) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2022_5cent",
    "country": "Portugal",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 5 Cents (2022) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2022_10cent",
    "country": "Portugal",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2022) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2022_20cent",
    "country": "Portugal",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 20 Cents (2022) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2022_50cent",
    "country": "Portugal",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2022) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2022_1euro",
    "country": "Portugal",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Euro (2022) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2022",
    "country": "Portugal",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2022) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2022_cc1",
    "country": "Portugal",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2022) - First Crossing of the South Atlantic by Plane",
    "subject": "First Crossing of the South Atlantic by Plane",
    "description": "Portugal 2 Euro Commemorative coin issued in 2022: First Crossing of the South Atlantic by Plane.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2022_2euro_0.jpg",
    "image_key": "pt_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2022_cc-common",
    "country": "Portugal",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Portugal 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2022_2euro_1.jpg",
    "image_key": "pt_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_portugal_2023_1cent",
    "country": "Portugal",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2023) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 55000000,
    "mintageFormatted": "55,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2023_2cent",
    "country": "Portugal",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2023) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2023_5cent",
    "country": "Portugal",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2023) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 44000000,
    "mintageFormatted": "44,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2023_10cent",
    "country": "Portugal",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2023) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2023_20cent",
    "country": "Portugal",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 20 Cents (2023) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2023_50cent",
    "country": "Portugal",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2023) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2023_1euro",
    "country": "Portugal",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Euro (2023) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2023",
    "country": "Portugal",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 2 Euros (2023) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2023_cc1",
    "country": "Portugal",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2023) - World Youth Day",
    "subject": "World Youth Day",
    "description": "Portugal 2 Euro Commemorative coin issued in 2023: World Youth Day.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2023_2euro_0.jpg",
    "image_key": "pt_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2023_cc2",
    "country": "Portugal",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2023) - Peace Among Nations",
    "subject": "Peace Among Nations",
    "description": "Portugal 2 Euro Commemorative coin issued in 2023: Peace Among Nations.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2023_2euro_1.jpg",
    "image_key": "pt_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2024_1cent",
    "country": "Portugal",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 1 Cent (2024) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2024_2cent",
    "country": "Portugal",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2024) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2024_5cent",
    "country": "Portugal",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2024) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2024_10cent",
    "country": "Portugal",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 10 Cents (2024) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2024_20cent",
    "country": "Portugal",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2024) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 40000000,
    "mintageFormatted": "40,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2024_50cent",
    "country": "Portugal",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 50 Cents (2024) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2024_1euro",
    "country": "Portugal",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2024) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2024",
    "country": "Portugal",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2024) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2024_cc1",
    "country": "Portugal",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2024) - Carnation Revolution (50th Ann.)",
    "subject": "Carnation Revolution (50th Ann.)",
    "description": "Portugal 2 Euro Commemorative coin issued in 2024: Carnation Revolution (50th Ann.).",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2024_2euro_0.jpg",
    "image_key": "pt_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2024_cc2",
    "country": "Portugal",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2024) - 2024 Olympics",
    "subject": "2024 Olympics",
    "description": "Portugal 2 Euro Commemorative coin issued in 2024: 2024 Olympics.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2024_2euro_1.jpg",
    "image_key": "pt_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2025_1cent",
    "country": "Portugal",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Cent (2025) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1cent_0.jpg",
    "image_key": "pt_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2025_2cent",
    "country": "Portugal",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Cents (2025) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2cent_0.jpg",
    "image_key": "pt_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2025_5cent",
    "country": "Portugal",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 5 Cents (2025) - Royal Seal of Dom Afonso Henriques (1134)",
    "subject": "Royal Seal of Dom Afonso Henriques (1134)",
    "description": "First royal seal of Dom Afonso Henriques from 1134",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_5cent_0.jpg",
    "image_key": "pt_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2025_10cent",
    "country": "Portugal",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 10 Cents (2025) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_10cent_0.jpg",
    "image_key": "pt_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2025_20cent",
    "country": "Portugal",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 20 Cents (2025) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_20cent_0.jpg",
    "image_key": "pt_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2025_50cent",
    "country": "Portugal",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 50 Cents (2025) - Royal Seal of Dom Afonso Henriques (1142)",
    "subject": "Royal Seal of Dom Afonso Henriques (1142)",
    "description": "Second royal seal of Dom Afonso Henriques from 1142",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_50cent_0.jpg",
    "image_key": "pt_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2025_1euro",
    "country": "Portugal",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Portugal 1 Euro (2025) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/pt_regular_1999_1euro_0.jpg",
    "image_key": "pt_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_portugal_2025",
    "country": "Portugal",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Portugal 2 Euros (2025) - Royal Seal of Dom Afonso Henriques (1144)",
    "subject": "Royal Seal of Dom Afonso Henriques (1144)",
    "description": "Royal seal of Dom Afonso Henriques from 1144 surrounded by castles and coats of arms",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/pt_regular_1999_2euro_0.jpg",
    "image_key": "pt_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2025_cc1",
    "country": "Portugal",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2025) - World Scouting and Youth Movements",
    "subject": "World Scouting and Youth Movements",
    "description": "Portugal 2 Euro Commemorative coin issued in 2025: World Scouting and Youth Movements.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2025_2euro_0.jpg",
    "image_key": "pt_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2025_cc2",
    "country": "Portugal",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2025) - Sustainable Development and Agenda 2030",
    "subject": "Sustainable Development and Agenda 2030",
    "description": "Portugal 2 Euro Commemorative coin issued in 2025: Sustainable Development and Agenda 2030.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/pt_commemorative_2025_2euro_1.jpg",
    "image_key": "pt_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2026_cc1",
    "country": "Portugal",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2026) - The Rotary in Portugal",
    "subject": "The Rotary in Portugal",
    "description": "Portugal 2 Euro Commemorative coin issued in 2026: The Rotary in Portugal.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_portugal_2026_cc2",
    "country": "Portugal",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Portugal 2€ Commemorative (2026) - Calouste Gulbenkian​ Foundation",
    "subject": "Calouste Gulbenkian​ Foundation",
    "description": "Portugal 2 Euro Commemorative coin issued in 2026: Calouste Gulbenkian​ Foundation.",
    "mintage": 100000,
    "mintageFormatted": "100,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2002_1cent",
    "country": "San Marino",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2002) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2002_2cent",
    "country": "San Marino",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2002) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2002_5cent",
    "country": "San Marino",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2002) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2002_10cent",
    "country": "San Marino",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2002) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2002_20cent",
    "country": "San Marino",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2002) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 147400,
    "mintageFormatted": "147,400",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2002_50cent",
    "country": "San Marino",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2002) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 75400,
    "mintageFormatted": "75,400",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2002_1euro",
    "country": "San Marino",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2002) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 205800,
    "mintageFormatted": "205,800",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2002",
    "country": "San Marino",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2002) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 100760,
    "mintageFormatted": "100,760",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2003_1cent",
    "country": "San Marino",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2003) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2003_2cent",
    "country": "San Marino",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2003) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2003_5cent",
    "country": "San Marino",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2003) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2003_10cent",
    "country": "San Marino",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2003) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2003_20cent",
    "country": "San Marino",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2003) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 220000,
    "mintageFormatted": "220,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2003_50cent",
    "country": "San Marino",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2003) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 205800,
    "mintageFormatted": "205,800",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2003_1euro",
    "country": "San Marino",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Euro (2003) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2003",
    "country": "San Marino",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2003) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2004_1cent",
    "country": "San Marino",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Cent (2004) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 1360000,
    "mintageFormatted": "1,360,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2004_2cent",
    "country": "San Marino",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Cents (2004) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 1395000,
    "mintageFormatted": "1,395,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2004_5cent",
    "country": "San Marino",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 5 Cents (2004) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2004_10cent",
    "country": "San Marino",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 10 Cents (2004) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 40000,
    "mintageFormatted": "40,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2004_20cent",
    "country": "San Marino",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2004) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2004_50cent",
    "country": "San Marino",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 50 Cents (2004) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2004_1euro",
    "country": "San Marino",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2004) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 40000,
    "mintageFormatted": "40,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2004",
    "country": "San Marino",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2004) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2004_cc1",
    "country": "San Marino",
    "year": 2004,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2004) - Bartolomeo Borghesi",
    "subject": "Bartolomeo Borghesi",
    "description": "San Marino 2 Euro Commemorative coin issued in 2004: Bartolomeo Borghesi.",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2004_2euro_0.jpg",
    "image_key": "sm_commemorative_2004_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2005_1cent",
    "country": "San Marino",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2005) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2005_2cent",
    "country": "San Marino",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2005) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2005_5cent",
    "country": "San Marino",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2005) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2005_10cent",
    "country": "San Marino",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2005) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2005_20cent",
    "country": "San Marino",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2005) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 160000,
    "mintageFormatted": "160,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2005_50cent",
    "country": "San Marino",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2005) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 179712,
    "mintageFormatted": "179,712",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2005_1euro",
    "country": "San Marino",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Euro (2005) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2005",
    "country": "San Marino",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2005) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2005_cc1",
    "country": "San Marino",
    "year": 2005,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2005) - World Year of Physics",
    "subject": "World Year of Physics",
    "description": "San Marino 2 Euro Commemorative coin issued in 2005: World Year of Physics.",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2005_2euro_0.jpg",
    "image_key": "sm_commemorative_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2006_1cent",
    "country": "San Marino",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Cent (2006) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 2730000,
    "mintageFormatted": "2,730,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2006_2cent",
    "country": "San Marino",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Cents (2006) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 2730000,
    "mintageFormatted": "2,730,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2006_5cent",
    "country": "San Marino",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 5 Cents (2006) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 2730000,
    "mintageFormatted": "2,730,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2006_10cent",
    "country": "San Marino",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2006) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2006_20cent",
    "country": "San Marino",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2006) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2006_50cent",
    "country": "San Marino",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2006) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 198880,
    "mintageFormatted": "198,880",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2006_1euro",
    "country": "San Marino",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Euro (2006) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2006",
    "country": "San Marino",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2006) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2006_cc1",
    "country": "San Marino",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2006) - Christopher Columbus",
    "subject": "Christopher Columbus",
    "description": "San Marino 2 Euro Commemorative coin issued in 2006: Christopher Columbus.",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2006_2euro_0.jpg",
    "image_key": "sm_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2007_1cent",
    "country": "San Marino",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2007) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2007_2cent",
    "country": "San Marino",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2007) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2007_5cent",
    "country": "San Marino",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2007) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2007_10cent",
    "country": "San Marino",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2007) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2007_20cent",
    "country": "San Marino",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2007) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2007_50cent",
    "country": "San Marino",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2007) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 315000,
    "mintageFormatted": "315,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2007_1euro",
    "country": "San Marino",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Euro (2007) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2007",
    "country": "San Marino",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2007) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2007_cc1",
    "country": "San Marino",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2007) - Giuseppe Garibaldi",
    "subject": "Giuseppe Garibaldi",
    "description": "San Marino 2 Euro Commemorative coin issued in 2007: Giuseppe Garibaldi.",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2007_2euro_0.jpg",
    "image_key": "sm_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2008_1cent",
    "country": "San Marino",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2008) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2008_2cent",
    "country": "San Marino",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2008) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2008_5cent",
    "country": "San Marino",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2008) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2008_10cent",
    "country": "San Marino",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2008) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2008_20cent",
    "country": "San Marino",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2008) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 1155360,
    "mintageFormatted": "1,155,360",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2008_50cent",
    "country": "San Marino",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2008) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 1337000,
    "mintageFormatted": "1,337,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2008_1euro",
    "country": "San Marino",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Euro (2008) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2008",
    "country": "San Marino",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2008) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2008_cc1",
    "country": "San Marino",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2008) - European Year of Intercultural Dialogue",
    "subject": "European Year of Intercultural Dialogue",
    "description": "San Marino 2 Euro Commemorative coin issued in 2008: European Year of Intercultural Dialogue.",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2008_2euro_0.jpg",
    "image_key": "sm_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2009_1cent",
    "country": "San Marino",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2009) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2009_2cent",
    "country": "San Marino",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2009) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2009_5cent",
    "country": "San Marino",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2009) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2009_10cent",
    "country": "San Marino",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2009) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2009_20cent",
    "country": "San Marino",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2009) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2009_50cent",
    "country": "San Marino",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 50 Cents (2009) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2009_1euro",
    "country": "San Marino",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2009) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 1083672,
    "mintageFormatted": "1,083,672",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2009",
    "country": "San Marino",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2009) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2009_cc1",
    "country": "San Marino",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2009) - European Year of Creativity and Innovation",
    "subject": "European Year of Creativity and Innovation",
    "description": "San Marino 2 Euro Commemorative coin issued in 2009: European Year of Creativity and Innovation.",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2009_2euro_0.jpg",
    "image_key": "sm_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2010_1cent",
    "country": "San Marino",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2010) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2010_2cent",
    "country": "San Marino",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2010) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2010_5cent",
    "country": "San Marino",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2010) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2010_10cent",
    "country": "San Marino",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2010) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2010_20cent",
    "country": "San Marino",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2010) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2010_50cent",
    "country": "San Marino",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 50 Cents (2010) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2010_1euro",
    "country": "San Marino",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2010) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 987534,
    "mintageFormatted": "987,534",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2010",
    "country": "San Marino",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2010) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2010_cc1",
    "country": "San Marino",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2010) - Sandro Botticelli",
    "subject": "Sandro Botticelli",
    "description": "San Marino 2 Euro Commemorative coin issued in 2010: Sandro Botticelli.",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2010_2euro_0.jpg",
    "image_key": "sm_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2011_1cent",
    "country": "San Marino",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2011) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2011_2cent",
    "country": "San Marino",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2011) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2011_5cent",
    "country": "San Marino",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2011) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2011_10cent",
    "country": "San Marino",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2011) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2011_20cent",
    "country": "San Marino",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2011) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2011_50cent",
    "country": "San Marino",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 50 Cents (2011) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2011_1euro",
    "country": "San Marino",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Euro (2011) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2011",
    "country": "San Marino",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2011) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 624431,
    "mintageFormatted": "624,431",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2011_cc1",
    "country": "San Marino",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2011) - Giorgio Vasari",
    "subject": "Giorgio Vasari",
    "description": "San Marino 2 Euro Commemorative coin issued in 2011: Giorgio Vasari.",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2011_2euro_0.jpg",
    "image_key": "sm_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2012_1cent",
    "country": "San Marino",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2012) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2012_2cent",
    "country": "San Marino",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2012) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2012_5cent",
    "country": "San Marino",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2012) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2012_10cent",
    "country": "San Marino",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2012) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2012_20cent",
    "country": "San Marino",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2012) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2012_50cent",
    "country": "San Marino",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 50 Cents (2012) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2012_1euro",
    "country": "San Marino",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Euro (2012) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2012",
    "country": "San Marino",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2012) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 616249,
    "mintageFormatted": "616,249",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2012_cc1",
    "country": "San Marino",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2012) - Ten Years of Euro Cash",
    "subject": "Ten Years of Euro Cash",
    "description": "San Marino 2 Euro Commemorative coin issued in 2012: Ten Years of Euro Cash.",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2012_2euro_0.jpg",
    "image_key": "sm_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2013_1cent",
    "country": "San Marino",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2013) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2013_2cent",
    "country": "San Marino",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2013) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2013_5cent",
    "country": "San Marino",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2013) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2013_10cent",
    "country": "San Marino",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2013) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2013_20cent",
    "country": "San Marino",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2013) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2013_50cent",
    "country": "San Marino",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2013) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 95000,
    "mintageFormatted": "95,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2013_1euro",
    "country": "San Marino",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2013) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 419205,
    "mintageFormatted": "419,205",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2013",
    "country": "San Marino",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2013) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 567624,
    "mintageFormatted": "567,624",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2013_cc1",
    "country": "San Marino",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2013) - Pinturicchio",
    "subject": "Pinturicchio",
    "description": "San Marino 2 Euro Commemorative coin issued in 2013: Pinturicchio.",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2013_2euro_0.jpg",
    "image_key": "sm_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2014_1cent",
    "country": "San Marino",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2014) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2014_2cent",
    "country": "San Marino",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2014) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2014_5cent",
    "country": "San Marino",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2014) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2014_10cent",
    "country": "San Marino",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2014) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2014_20cent",
    "country": "San Marino",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2014) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2014_50cent",
    "country": "San Marino",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2014) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 719275,
    "mintageFormatted": "719,275",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2014_1euro",
    "country": "San Marino",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2014) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 1513500,
    "mintageFormatted": "1,513,500",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2014",
    "country": "San Marino",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2014) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2014_cc1",
    "country": "San Marino",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2014) - Bramante Lazzari",
    "subject": "Bramante Lazzari",
    "description": "San Marino 2 Euro Commemorative coin issued in 2014: Bramante Lazzari.",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2014_2euro_1.jpg",
    "image_key": "sm_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2014_cc2",
    "country": "San Marino",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2014) - Giacomo Puccini",
    "subject": "Giacomo Puccini",
    "description": "San Marino 2 Euro Commemorative coin issued in 2014: Giacomo Puccini.",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2014_2euro_0.jpg",
    "image_key": "sm_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2015_1cent",
    "country": "San Marino",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2015) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2015_2cent",
    "country": "San Marino",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2015) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2015_5cent",
    "country": "San Marino",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2015) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2015_10cent",
    "country": "San Marino",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2015) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2015_20cent",
    "country": "San Marino",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2015) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 47600,
    "mintageFormatted": "47,600",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2015_50cent",
    "country": "San Marino",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2015) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 747601,
    "mintageFormatted": "747,601",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2015_1euro",
    "country": "San Marino",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2015) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 1673200,
    "mintageFormatted": "1,673,200",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2015",
    "country": "San Marino",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2015) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2015_cc1",
    "country": "San Marino",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2015) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "San Marino 2 Euro Commemorative coin issued in 2015: Dante Alighieri.",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2015_2euro_1.jpg",
    "image_key": "sm_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2015_cc2",
    "country": "San Marino",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2015) - German Unity",
    "subject": "German Unity",
    "description": "San Marino 2 Euro Commemorative coin issued in 2015: German Unity.",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2015_2euro_0.jpg",
    "image_key": "sm_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2016_1cent",
    "country": "San Marino",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2016) - Third Tower (Il Montale)",
    "subject": "Third Tower (Il Montale)",
    "description": "Montale, the third tower on Mount Titano",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1cent_0.jpg",
    "image_key": "sm_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2016_2cent",
    "country": "San Marino",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2016) - Statue of Liberty (San Marino)",
    "subject": "Statue of Liberty (San Marino)",
    "description": "Statue of Liberty (Statua della Libertà) by Stefano Galletti",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_2cent_0.jpg",
    "image_key": "sm_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2016_5cent",
    "country": "San Marino",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2016) - First Tower (Guaita)",
    "subject": "First Tower (Guaita)",
    "description": "Guaita tower fortress, the oldest of the three towers on Mount Titano",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_5cent_0.jpg",
    "image_key": "sm_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2016_10cent",
    "country": "San Marino",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2016) - Basilica di San Marino",
    "subject": "Basilica di San Marino",
    "description": "Neoclassical Basilica of Saint Marinus",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_10cent_0.jpg",
    "image_key": "sm_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2016_20cent",
    "country": "San Marino",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2016) - Saint Marinus (Retablo painting)",
    "subject": "Saint Marinus (Retablo painting)",
    "description": "Saint Marinus holding the city, after the painting by Guercino",
    "mintage": 197600,
    "mintageFormatted": "197,600",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_20cent_0.jpg",
    "image_key": "sm_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2016_50cent",
    "country": "San Marino",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 50 Cents (2016) - The Three Towers of San Marino",
    "subject": "The Three Towers of San Marino",
    "description": "The Three Towers of San Marino (Guaita, Cesta, and Montale)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_50cent_0.jpg",
    "image_key": "sm_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2016_1euro",
    "country": "San Marino",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Euro (2016) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2002_1euro_0.jpg",
    "image_key": "sm_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2016",
    "country": "San Marino",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2016) - Palazzo Pubblico",
    "subject": "Palazzo Pubblico",
    "description": "Town hall and official government building Palazzo Pubblico",
    "mintage": 871667,
    "mintageFormatted": "871,667",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2002_2euro_0.jpg",
    "image_key": "sm_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2016_cc1",
    "country": "San Marino",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2016) - Donatello",
    "subject": "Donatello",
    "description": "San Marino 2 Euro Commemorative coin issued in 2016: Donatello.",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2016_2euro_1.jpg",
    "image_key": "sm_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2016_cc2",
    "country": "San Marino",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2016) - William Shakespeare",
    "subject": "William Shakespeare",
    "description": "San Marino 2 Euro Commemorative coin issued in 2016: William Shakespeare.",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2016_2euro_0.jpg",
    "image_key": "sm_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2017_1cent",
    "country": "San Marino",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2017) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2017_2cent",
    "country": "San Marino",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2017) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2017_5cent",
    "country": "San Marino",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2017) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2017_10cent",
    "country": "San Marino",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2017) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2017_20cent",
    "country": "San Marino",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2017) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 1661415,
    "mintageFormatted": "1,661,415",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2017_50cent",
    "country": "San Marino",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 50 Cents (2017) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2017_1euro",
    "country": "San Marino",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2017) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 497400,
    "mintageFormatted": "497,400",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2017",
    "country": "San Marino",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2017) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 597400,
    "mintageFormatted": "597,400",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2017_cc1",
    "country": "San Marino",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2017) - Giotto",
    "subject": "Giotto",
    "description": "San Marino 2 Euro Commemorative coin issued in 2017: Giotto.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2017_2euro_1.jpg",
    "image_key": "sm_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2017_cc2",
    "country": "San Marino",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2017) - International Year of Sustainable Tourism",
    "subject": "International Year of Sustainable Tourism",
    "description": "San Marino 2 Euro Commemorative coin issued in 2017: International Year of Sustainable Tourism.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2017_2euro_0.jpg",
    "image_key": "sm_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2018_1cent",
    "country": "San Marino",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2018) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2018_2cent",
    "country": "San Marino",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2018) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2018_5cent",
    "country": "San Marino",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2018) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2018_10cent",
    "country": "San Marino",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2018) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2018_20cent",
    "country": "San Marino",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2018) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 597400,
    "mintageFormatted": "597,400",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2018_50cent",
    "country": "San Marino",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2018) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 1097400,
    "mintageFormatted": "1,097,400",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2018_1euro",
    "country": "San Marino",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2018) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 1097400,
    "mintageFormatted": "1,097,400",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2018",
    "country": "San Marino",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Euros (2018) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2018_cc1",
    "country": "San Marino",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2018) - Tintoretto",
    "subject": "Tintoretto",
    "description": "San Marino 2 Euro Commemorative coin issued in 2018: Tintoretto.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2018_2euro_1.jpg",
    "image_key": "sm_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2018_cc2",
    "country": "San Marino",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2018) - Gian Lorenzo Bernini",
    "subject": "Gian Lorenzo Bernini",
    "description": "San Marino 2 Euro Commemorative coin issued in 2018: Gian Lorenzo Bernini.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2018_2euro_0.jpg",
    "image_key": "sm_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2019_1cent",
    "country": "San Marino",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2019) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2019_2cent",
    "country": "San Marino",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2019) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2019_5cent",
    "country": "San Marino",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2019) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2019_10cent",
    "country": "San Marino",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2019) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2019_20cent",
    "country": "San Marino",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2019) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2019_50cent",
    "country": "San Marino",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2019) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 796500,
    "mintageFormatted": "796,500",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2019_1euro",
    "country": "San Marino",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2019) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 496500,
    "mintageFormatted": "496,500",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2019",
    "country": "San Marino",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2019) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 356500,
    "mintageFormatted": "356,500",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2019_cc1",
    "country": "San Marino",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2019) - Leonardo da Vinci",
    "subject": "Leonardo da Vinci",
    "description": "San Marino 2 Euro Commemorative coin issued in 2019: Leonardo da Vinci.",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2019_2euro_1.jpg",
    "image_key": "sm_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2019_cc2",
    "country": "San Marino",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2019) - Filippo Lippi",
    "subject": "Filippo Lippi",
    "description": "San Marino 2 Euro Commemorative coin issued in 2019: Filippo Lippi.",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2019_2euro_0.jpg",
    "image_key": "sm_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2020_1cent",
    "country": "San Marino",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2020) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2020_2cent",
    "country": "San Marino",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2020) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2020_5cent",
    "country": "San Marino",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2020) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2020_10cent",
    "country": "San Marino",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2020) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2020_20cent",
    "country": "San Marino",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 20 Cents (2020) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2020_50cent",
    "country": "San Marino",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2020) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2020_1euro",
    "country": "San Marino",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2020) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2020",
    "country": "San Marino",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2020) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 621257,
    "mintageFormatted": "621,257",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2020_cc1",
    "country": "San Marino",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2020) - Raffaello Sanzio",
    "subject": "Raffaello Sanzio",
    "description": "San Marino 2 Euro Commemorative coin issued in 2020: Raffaello Sanzio.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2020_2euro_0.jpg",
    "image_key": "sm_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2020_cc2",
    "country": "San Marino",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2020) - Giambattista Tiepolo",
    "subject": "Giambattista Tiepolo",
    "description": "San Marino 2 Euro Commemorative coin issued in 2020: Giambattista Tiepolo.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2020_2euro_1.jpg",
    "image_key": "sm_commemorative_2020_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2021_1cent",
    "country": "San Marino",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2021) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2021_2cent",
    "country": "San Marino",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2021) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2021_5cent",
    "country": "San Marino",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2021) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2021_10cent",
    "country": "San Marino",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2021) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2021_20cent",
    "country": "San Marino",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2021) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2021_50cent",
    "country": "San Marino",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2021) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 200000,
    "mintageFormatted": "200,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2021_1euro",
    "country": "San Marino",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2021) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2021",
    "country": "San Marino",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2021) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 785355,
    "mintageFormatted": "785,355",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2021_cc1",
    "country": "San Marino",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2021) - Caravaggio",
    "subject": "Caravaggio",
    "description": "San Marino 2 Euro Commemorative coin issued in 2021: Caravaggio.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2021_2euro_0.jpg",
    "image_key": "sm_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2021_cc2",
    "country": "San Marino",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2021) - Albrecht Dürer",
    "subject": "Albrecht Dürer",
    "description": "San Marino 2 Euro Commemorative coin issued in 2021: Albrecht Dürer.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2021_2euro_1.jpg",
    "image_key": "sm_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2022_1cent",
    "country": "San Marino",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2022) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2022_2cent",
    "country": "San Marino",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2022) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2022_5cent",
    "country": "San Marino",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2022) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2022_10cent",
    "country": "San Marino",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2022) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2022_20cent",
    "country": "San Marino",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2022) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 62000,
    "mintageFormatted": "62,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2022_50cent",
    "country": "San Marino",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2022) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2022_1euro",
    "country": "San Marino",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2022) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 818000,
    "mintageFormatted": "818,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2022",
    "country": "San Marino",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2022) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 450366,
    "mintageFormatted": "450,366",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2022_cc1",
    "country": "San Marino",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2022) - Piero della Francesca",
    "subject": "Piero della Francesca",
    "description": "San Marino 2 Euro Commemorative coin issued in 2022: Piero della Francesca.",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2022_2euro_0.jpg",
    "image_key": "sm_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2022_cc2",
    "country": "San Marino",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2022) - Antonio Canova",
    "subject": "Antonio Canova",
    "description": "San Marino 2 Euro Commemorative coin issued in 2022: Antonio Canova.",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2022_2euro_1.jpg",
    "image_key": "sm_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2023_1cent",
    "country": "San Marino",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2023) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2023_2cent",
    "country": "San Marino",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2023) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2023_5cent",
    "country": "San Marino",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2023) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2023_10cent",
    "country": "San Marino",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2023) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2023_20cent",
    "country": "San Marino",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2023) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 478680,
    "mintageFormatted": "478,680",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2023_50cent",
    "country": "San Marino",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2023) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 580000,
    "mintageFormatted": "580,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2023_1euro",
    "country": "San Marino",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2023) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 720000,
    "mintageFormatted": "720,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2023",
    "country": "San Marino",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2023) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 664173,
    "mintageFormatted": "664,173",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2023_cc1",
    "country": "San Marino",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2023) - Pietro Perugino",
    "subject": "Pietro Perugino",
    "description": "San Marino 2 Euro Commemorative coin issued in 2023: Pietro Perugino.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2023_2euro_0.jpg",
    "image_key": "sm_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2023_cc2",
    "country": "San Marino",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2023) - Luca Signorelli",
    "subject": "Luca Signorelli",
    "description": "San Marino 2 Euro Commemorative coin issued in 2023: Luca Signorelli.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2023_2euro_1.jpg",
    "image_key": "sm_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2024_1cent",
    "country": "San Marino",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2024) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2024_2cent",
    "country": "San Marino",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2024) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2024_5cent",
    "country": "San Marino",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2024) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2024_10cent",
    "country": "San Marino",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2024) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2024_20cent",
    "country": "San Marino",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2024) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 619428,
    "mintageFormatted": "619,428",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2024_50cent",
    "country": "San Marino",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2024) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 680000,
    "mintageFormatted": "680,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2024_1euro",
    "country": "San Marino",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2024) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 780000,
    "mintageFormatted": "780,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2024",
    "country": "San Marino",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2024) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2024_cc1",
    "country": "San Marino",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2024) - Ghirlandaio",
    "subject": "Ghirlandaio",
    "description": "San Marino 2 Euro Commemorative coin issued in 2024: Ghirlandaio.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2024_2euro_0.jpg",
    "image_key": "sm_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2024_cc2",
    "country": "San Marino",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2024) - Declaration of Citizen's Rights",
    "subject": "Declaration of Citizen's Rights",
    "description": "San Marino 2 Euro Commemorative coin issued in 2024: Declaration of Citizen's Rights.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2024_2euro_1.jpg",
    "image_key": "sm_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2025_1cent",
    "country": "San Marino",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2025) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2025_2cent",
    "country": "San Marino",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2025) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2025_5cent",
    "country": "San Marino",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2025) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2025_10cent",
    "country": "San Marino",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2025) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2025_20cent",
    "country": "San Marino",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2025) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2025_50cent",
    "country": "San Marino",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2025) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2025_1euro",
    "country": "San Marino",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2025) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2025",
    "country": "San Marino",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2025) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 600000,
    "mintageFormatted": "600,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2025_cc1",
    "country": "San Marino",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2025) - Holy Year 2025",
    "subject": "Holy Year 2025",
    "description": "San Marino 2 Euro Commemorative coin issued in 2025: Holy Year 2025.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2025_2euro_0.jpg",
    "image_key": "sm_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2025_cc2",
    "country": "San Marino",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2025) - Michelangelo",
    "subject": "Michelangelo",
    "description": "San Marino 2 Euro Commemorative coin issued in 2025: Michelangelo.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_commemorative_2025_2euro_1.jpg",
    "image_key": "sm_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2026_1cent",
    "country": "San Marino",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 1 Cent (2026) - Official Coat of Arms of San Marino",
    "subject": "Official Coat of Arms of San Marino",
    "description": "Coat of arms of the Republic of San Marino",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_1cent_0.jpg",
    "image_key": "sm_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2026_2cent",
    "country": "San Marino",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2 Cents (2026) - City Gate (Porta San Francesco)",
    "subject": "City Gate (Porta San Francesco)",
    "description": "Porta San Francesco, historic city gate of San Marino",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_2cent_0.jpg",
    "image_key": "sm_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2026_5cent",
    "country": "San Marino",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 5 Cents (2026) - Church of San Quirino",
    "subject": "Church of San Quirino",
    "description": "Capuchin Church of San Quirino",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_5cent_0.jpg",
    "image_key": "sm_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2026_10cent",
    "country": "San Marino",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 10 Cents (2026) - Church of San Francesco",
    "subject": "Church of San Francesco",
    "description": "Church of Saint Francis in San Marino",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sm_regular_2017_10cent_0.jpg",
    "image_key": "sm_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2026_20cent",
    "country": "San Marino",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 20 Cents (2026) - Mount Titano and the Three Towers",
    "subject": "Mount Titano and the Three Towers",
    "description": "Panoramic view of Mount Titano with its three towers (Guaita, Cesta, Montale)",
    "mintage": 750000,
    "mintageFormatted": "750,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_20cent_0.jpg",
    "image_key": "sm_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2026_50cent",
    "country": "San Marino",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 50 Cents (2026) - Portrait of Saint Marinus (Emilio Retrosi)",
    "subject": "Portrait of Saint Marinus (Emilio Retrosi)",
    "description": "Detail of Saint Marinus from a painting by Emilio Retrosi",
    "mintage": 800000,
    "mintageFormatted": "800,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_50cent_0.jpg",
    "image_key": "sm_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2026_1euro",
    "country": "San Marino",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 1 Euro (2026) - Second Tower (Cesta)",
    "subject": "Second Tower (Cesta)",
    "description": "Cesta tower fortress on the highest peak of Mount Titano",
    "mintage": 850000,
    "mintageFormatted": "850,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_1euro_0.jpg",
    "image_key": "sm_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_san-marino_2026",
    "country": "San Marino",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "San Marino 2 Euros (2026) - Saint Marinus (Urbinelli painting)",
    "subject": "Saint Marinus (Urbinelli painting)",
    "description": "Portrait of Saint Marinus from a painting by Girolamo Batoni / Urbinelli school",
    "mintage": 815000,
    "mintageFormatted": "815,000",
    "status": "circulating",
    "imagePath": "coins/sm_regular_2017_2euro_0.jpg",
    "image_key": "sm_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2026_cc1",
    "country": "San Marino",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2026) - Titian",
    "subject": "Titian",
    "description": "San Marino 2 Euro Commemorative coin issued in 2026: Titian.",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_san-marino_2026_cc2",
    "country": "San Marino",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "San Marino 2€ Commemorative (2026) - Francesco d'Assisi",
    "subject": "Francesco d'Assisi",
    "description": "San Marino 2 Euro Commemorative coin issued in 2026: Francesco d'Assisi.",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2009_1cent",
    "country": "Slovakia",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2009) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 90718225,
    "mintageFormatted": "90,718,225",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2009_2cent",
    "country": "Slovakia",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2009) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 80795225,
    "mintageFormatted": "80,795,225",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2009_5cent",
    "country": "Slovakia",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2009) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 84847225,
    "mintageFormatted": "84,847,225",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2009_10cent",
    "country": "Slovakia",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2009) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 74689875,
    "mintageFormatted": "74,689,875",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2009_20cent",
    "country": "Slovakia",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 20 Cents (2009) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 66492225,
    "mintageFormatted": "66,492,225",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2009_50cent",
    "country": "Slovakia",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 50 Cents (2009) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 59289875,
    "mintageFormatted": "59,289,875",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2009_1euro",
    "country": "Slovakia",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Euro (2009) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 46749875,
    "mintageFormatted": "46,749,875",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2009",
    "country": "Slovakia",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2009) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 35639863,
    "mintageFormatted": "35,639,863",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2009_cc1",
    "country": "Slovakia",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2009) - Velvet Revolution",
    "subject": "Velvet Revolution",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2009: Velvet Revolution.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2009_2euro_0.jpg",
    "image_key": "sk_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2009_cc-common",
    "country": "Slovakia",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 2500000,
    "mintageFormatted": "2,500,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2009_2euro_1.jpg",
    "image_key": "sk_commemorative_2009_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovakia_2010_1cent",
    "country": "Slovakia",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2010) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 30000000,
    "mintageFormatted": "30,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2010_2cent",
    "country": "Slovakia",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2010) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 50000000,
    "mintageFormatted": "50,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2010_5cent",
    "country": "Slovakia",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 5 Cents (2010) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2010_10cent",
    "country": "Slovakia",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2010) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2010_20cent",
    "country": "Slovakia",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2010) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2010_50cent",
    "country": "Slovakia",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2010) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2010_1euro",
    "country": "Slovakia",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2010) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2010",
    "country": "Slovakia",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Euros (2010) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2011_1cent",
    "country": "Slovakia",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2011) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 20400000,
    "mintageFormatted": "20,400,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2011_2cent",
    "country": "Slovakia",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2011) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2011_5cent",
    "country": "Slovakia",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 5 Cents (2011) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2011_10cent",
    "country": "Slovakia",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2011) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2011_20cent",
    "country": "Slovakia",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2011) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2011_50cent",
    "country": "Slovakia",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2011) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2011_1euro",
    "country": "Slovakia",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2011) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2011",
    "country": "Slovakia",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2011) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2011_cc1",
    "country": "Slovakia",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2011) - Visegrad Group",
    "subject": "Visegrad Group",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2011: Visegrad Group.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2011_2euro_0.jpg",
    "image_key": "sk_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2012_1cent",
    "country": "Slovakia",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2012) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 10500000,
    "mintageFormatted": "10,500,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2012_2cent",
    "country": "Slovakia",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Cents (2012) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2012_5cent",
    "country": "Slovakia",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 5 Cents (2012) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2012_10cent",
    "country": "Slovakia",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2012) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2012_20cent",
    "country": "Slovakia",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2012) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2012_50cent",
    "country": "Slovakia",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2012) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2012_1euro",
    "country": "Slovakia",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2012) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2012",
    "country": "Slovakia",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Euros (2012) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2012_cc-common",
    "country": "Slovakia",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2012_2euro_0.jpg",
    "image_key": "sk_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovakia_2013_1cent",
    "country": "Slovakia",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2013) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 26030000,
    "mintageFormatted": "26,030,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2013_2cent",
    "country": "Slovakia",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Cents (2013) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2013_5cent",
    "country": "Slovakia",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 5 Cents (2013) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2013_10cent",
    "country": "Slovakia",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2013) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2013_20cent",
    "country": "Slovakia",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2013) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2013_50cent",
    "country": "Slovakia",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2013) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2013_1euro",
    "country": "Slovakia",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2013) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2013",
    "country": "Slovakia",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Euros (2013) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2013_cc1",
    "country": "Slovakia",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2013) - Mission of Constantine and Methodius",
    "subject": "Mission of Constantine and Methodius",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2013: Mission of Constantine and Methodius.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2013_2euro_0.jpg",
    "image_key": "sk_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2014_1cent",
    "country": "Slovakia",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2014) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 26250000,
    "mintageFormatted": "26,250,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2014_2cent",
    "country": "Slovakia",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2014) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2014_5cent",
    "country": "Slovakia",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 5 Cents (2014) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2014_10cent",
    "country": "Slovakia",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2014) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2014_20cent",
    "country": "Slovakia",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2014) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2014_50cent",
    "country": "Slovakia",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2014) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2014_1euro",
    "country": "Slovakia",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2014) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2014",
    "country": "Slovakia",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Euros (2014) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2014_cc1",
    "country": "Slovakia",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2014) - Slovak Admission to the EU",
    "subject": "Slovak Admission to the EU",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2014: Slovak Admission to the EU.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2014_2euro_0.jpg",
    "image_key": "sk_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2015_1cent",
    "country": "Slovakia",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2015) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 23086000,
    "mintageFormatted": "23,086,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2015_2cent",
    "country": "Slovakia",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2015) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 12539000,
    "mintageFormatted": "12,539,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2015_5cent",
    "country": "Slovakia",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 5 Cents (2015) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2015_10cent",
    "country": "Slovakia",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2015) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2015_20cent",
    "country": "Slovakia",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2015) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2015_50cent",
    "country": "Slovakia",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2015) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2015_1euro",
    "country": "Slovakia",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2015) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2015",
    "country": "Slovakia",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2015) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 7325000,
    "mintageFormatted": "7,325,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2015_cc1",
    "country": "Slovakia",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2015) - Ľudovít Štúr",
    "subject": "Ľudovít Štúr",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2015: Ľudovít Štúr.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2015_2euro_0.jpg",
    "image_key": "sk_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2015_cc-common",
    "country": "Slovakia",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2015_2euro_1.jpg",
    "image_key": "sk_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovakia_2016_1cent",
    "country": "Slovakia",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2016) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 28872500,
    "mintageFormatted": "28,872,500",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2016_2cent",
    "country": "Slovakia",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2016) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2016_5cent",
    "country": "Slovakia",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 5 Cents (2016) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2016_10cent",
    "country": "Slovakia",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2016) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2016_20cent",
    "country": "Slovakia",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2016) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2016_50cent",
    "country": "Slovakia",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2016) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2016_1euro",
    "country": "Slovakia",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2016) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2016",
    "country": "Slovakia",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2016) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2016_cc1",
    "country": "Slovakia",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2016) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2016: Presidency of the EU Council.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2016_2euro_0.jpg",
    "image_key": "sk_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2017_1cent",
    "country": "Slovakia",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2017) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 20520000,
    "mintageFormatted": "20,520,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2017_2cent",
    "country": "Slovakia",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2017) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 13650000,
    "mintageFormatted": "13,650,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2017_5cent",
    "country": "Slovakia",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2017) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 6123000,
    "mintageFormatted": "6,123,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2017_10cent",
    "country": "Slovakia",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2017) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2017_20cent",
    "country": "Slovakia",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2017) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2017_50cent",
    "country": "Slovakia",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2017) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2017_1euro",
    "country": "Slovakia",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2017) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2017",
    "country": "Slovakia",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2017) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2100000,
    "mintageFormatted": "2,100,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2017_cc1",
    "country": "Slovakia",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2017) - University Istropolitana",
    "subject": "University Istropolitana",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2017: University Istropolitana.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2017_2euro_0.jpg",
    "image_key": "sk_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2018_1cent",
    "country": "Slovakia",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2018) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 20580000,
    "mintageFormatted": "20,580,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2018_2cent",
    "country": "Slovakia",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2018) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 12104000,
    "mintageFormatted": "12,104,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2018_5cent",
    "country": "Slovakia",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2018) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2018_10cent",
    "country": "Slovakia",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 10 Cents (2018) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2018_20cent",
    "country": "Slovakia",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2018) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2018_50cent",
    "country": "Slovakia",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2018) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2018_1euro",
    "country": "Slovakia",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2018) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2018",
    "country": "Slovakia",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Euros (2018) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2018_cc1",
    "country": "Slovakia",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2018) - Establishment of the Slovak Republic",
    "subject": "Establishment of the Slovak Republic",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2018: Establishment of the Slovak Republic.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2018_2euro_0.jpg",
    "image_key": "sk_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2019_1cent",
    "country": "Slovakia",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2019) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 32000000,
    "mintageFormatted": "32,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2019_2cent",
    "country": "Slovakia",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2019) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 14450000,
    "mintageFormatted": "14,450,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2019_5cent",
    "country": "Slovakia",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2019) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2019_10cent",
    "country": "Slovakia",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2019) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2019_20cent",
    "country": "Slovakia",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2019) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2019_50cent",
    "country": "Slovakia",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2019) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2019_1euro",
    "country": "Slovakia",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2019) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2019",
    "country": "Slovakia",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Euros (2019) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2019_cc1",
    "country": "Slovakia",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2019) - Milan Rastislav Štefánik",
    "subject": "Milan Rastislav Štefánik",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2019: Milan Rastislav Štefánik.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2019_2euro_0.jpg",
    "image_key": "sk_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2020_1cent",
    "country": "Slovakia",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2020) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 57700000,
    "mintageFormatted": "57,700,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2020_2cent",
    "country": "Slovakia",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2020) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 25100000,
    "mintageFormatted": "25,100,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2020_5cent",
    "country": "Slovakia",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2020) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 16500000,
    "mintageFormatted": "16,500,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2020_10cent",
    "country": "Slovakia",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2020) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 12100000,
    "mintageFormatted": "12,100,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2020_20cent",
    "country": "Slovakia",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2020) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2020_50cent",
    "country": "Slovakia",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2020) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2020_1euro",
    "country": "Slovakia",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2020) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2020",
    "country": "Slovakia",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2020) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2020_cc1",
    "country": "Slovakia",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2020) - Slovak Admission to the OECD",
    "subject": "Slovak Admission to the OECD",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2020: Slovak Admission to the OECD.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2020_2euro_0.jpg",
    "image_key": "sk_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2021_1cent",
    "country": "Slovakia",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Cent (2021) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 14650000,
    "mintageFormatted": "14,650,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2021_2cent",
    "country": "Slovakia",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Cents (2021) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 7316000,
    "mintageFormatted": "7,316,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2021_5cent",
    "country": "Slovakia",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2021) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 6300000,
    "mintageFormatted": "6,300,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2021_10cent",
    "country": "Slovakia",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2021) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2021_20cent",
    "country": "Slovakia",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2021) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2021_50cent",
    "country": "Slovakia",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2021) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2021_1euro",
    "country": "Slovakia",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Euro (2021) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1425000,
    "mintageFormatted": "1,425,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2021",
    "country": "Slovakia",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Euros (2021) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2021_cc1",
    "country": "Slovakia",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2021) - Alexander Dubček",
    "subject": "Alexander Dubček",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2021: Alexander Dubček.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2021_2euro_0.jpg",
    "image_key": "sk_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2022_1cent",
    "country": "Slovakia",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Cent (2022) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2022_2cent",
    "country": "Slovakia",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Cents (2022) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2022_5cent",
    "country": "Slovakia",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2022) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 10500000,
    "mintageFormatted": "10,500,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2022_10cent",
    "country": "Slovakia",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2022) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 2100000,
    "mintageFormatted": "2,100,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2022_20cent",
    "country": "Slovakia",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2022) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2022_50cent",
    "country": "Slovakia",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2022) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2022_1euro",
    "country": "Slovakia",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2022) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2022",
    "country": "Slovakia",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2022) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2022_cc1",
    "country": "Slovakia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2022) - First Steam Engine in Continental Europe",
    "subject": "First Steam Engine in Continental Europe",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2022: First Steam Engine in Continental Europe.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2022_2euro_0.jpg",
    "image_key": "sk_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2022_cc-common",
    "country": "Slovakia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2022_2euro_1.jpg",
    "image_key": "sk_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovakia_2023_1cent",
    "country": "Slovakia",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Cent (2023) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2023_2cent",
    "country": "Slovakia",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Cents (2023) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2023_5cent",
    "country": "Slovakia",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2023) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2023_10cent",
    "country": "Slovakia",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2023) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2023_20cent",
    "country": "Slovakia",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2023) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2023_50cent",
    "country": "Slovakia",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2023) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2023_1euro",
    "country": "Slovakia",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2023) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2023",
    "country": "Slovakia",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Euros (2023) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2023_cc1",
    "country": "Slovakia",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2023) - First Blood Transfusion",
    "subject": "First Blood Transfusion",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2023: First Blood Transfusion.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2023_2euro_0.jpg",
    "image_key": "sk_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2023_cc2",
    "country": "Slovakia",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2023) - Vienna-Bratislava express mail",
    "subject": "Vienna-Bratislava express mail",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2023: Vienna-Bratislava express mail.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2023_2euro_1.jpg",
    "image_key": "sk_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2024_1cent",
    "country": "Slovakia",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Cent (2024) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2024_2cent",
    "country": "Slovakia",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Cents (2024) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2024_5cent",
    "country": "Slovakia",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2024) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2024_10cent",
    "country": "Slovakia",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2024) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 5700000,
    "mintageFormatted": "5,700,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2024_20cent",
    "country": "Slovakia",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2024) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2024_50cent",
    "country": "Slovakia",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2024) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2024_1euro",
    "country": "Slovakia",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Euro (2024) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2024",
    "country": "Slovakia",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2024) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 2300000,
    "mintageFormatted": "2,300,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2024_cc1",
    "country": "Slovakia",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2024) - Košice Marathon",
    "subject": "Košice Marathon",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2024: Košice Marathon.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2024_2euro_0.jpg",
    "image_key": "sk_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2025_1cent",
    "country": "Slovakia",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Cent (2025) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2025_2cent",
    "country": "Slovakia",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Cents (2025) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2025_5cent",
    "country": "Slovakia",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2025) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2025_10cent",
    "country": "Slovakia",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2025) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2025_20cent",
    "country": "Slovakia",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 20 Cents (2025) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2025_50cent",
    "country": "Slovakia",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2025) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2025_1euro",
    "country": "Slovakia",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 1 Euro (2025) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2025",
    "country": "Slovakia",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2025) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2025_cc1",
    "country": "Slovakia",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2025) - 1925 European Ice Hockey Championship",
    "subject": "1925 European Ice Hockey Championship",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2025: 1925 European Ice Hockey Championship.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_commemorative_2025_2euro_0.jpg",
    "image_key": "sk_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2026_1cent",
    "country": "Slovakia",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Cent (2026) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1cent_0.jpg",
    "image_key": "sk_regular_2009_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2026_2cent",
    "country": "Slovakia",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 2 Cents (2026) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_2cent_0.jpg",
    "image_key": "sk_regular_2009_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2026_5cent",
    "country": "Slovakia",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 5 Cents (2026) - Kriváň Peak (High Tatras)",
    "subject": "Kriváň Peak (High Tatras)",
    "description": "Kriváň mountain peak in the High Tatras, symbol of Slovak national sovereignty",
    "mintage": 10000000,
    "mintageFormatted": "10,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_5cent_0.jpg",
    "image_key": "sk_regular_2009_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2026_10cent",
    "country": "Slovakia",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 10 Cents (2026) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_10cent_0.jpg",
    "image_key": "sk_regular_2009_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2026_20cent",
    "country": "Slovakia",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 20 Cents (2026) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_20cent_0.jpg",
    "image_key": "sk_regular_2009_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2026_50cent",
    "country": "Slovakia",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 50 Cents (2026) - Bratislava Castle",
    "subject": "Bratislava Castle",
    "description": "Massive four-towered Bratislava Castle overlooking the Danube river",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_50cent_0.jpg",
    "image_key": "sk_regular_2009_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2026_1euro",
    "country": "Slovakia",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovakia 1 Euro (2026) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/sk_regular_2009_1euro_0.jpg",
    "image_key": "sk_regular_2009_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovakia_2026",
    "country": "Slovakia",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovakia 2 Euros (2026) - Coat of Arms of Slovakia",
    "subject": "Coat of Arms of Slovakia",
    "description": "Double cross on three mountains (Tatra, Matra, Fatra) from national coat of arms",
    "mintage": 11000000,
    "mintageFormatted": "11,000,000",
    "status": "circulating",
    "imagePath": "coins/sk_regular_2009_2euro_0.jpg",
    "image_key": "sk_regular_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2026_cc1",
    "country": "Slovakia",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2026) - Trenčín 2026 - European Capital of Culture",
    "subject": "Trenčín 2026 - European Capital of Culture",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2026: Trenčín 2026 - European Capital of Culture.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovakia_2026_cc2",
    "country": "Slovakia",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovakia 2€ Commemorative (2026) - Czechoslovak Victory of Euro 1976",
    "subject": "Czechoslovak Victory of Euro 1976",
    "description": "Slovakia 2 Euro Commemorative coin issued in 2026: Czechoslovak Victory of Euro 1976.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2007_1cent",
    "country": "Slovenia",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2007) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 44600000,
    "mintageFormatted": "44,600,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2007_2cent",
    "country": "Slovenia",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2007) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 44150000,
    "mintageFormatted": "44,150,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2007_5cent",
    "country": "Slovenia",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 5 Cents (2007) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 43700000,
    "mintageFormatted": "43,700,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2007_10cent",
    "country": "Slovenia",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 10 Cents (2007) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 42700000,
    "mintageFormatted": "42,700,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2007_20cent",
    "country": "Slovenia",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 20 Cents (2007) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 37150000,
    "mintageFormatted": "37,150,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2007_50cent",
    "country": "Slovenia",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 50 Cents (2007) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 32300000,
    "mintageFormatted": "32,300,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2007_1euro",
    "country": "Slovenia",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Euro (2007) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 29650000,
    "mintageFormatted": "29,650,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2007",
    "country": "Slovenia",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Euros (2007) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 21250000,
    "mintageFormatted": "21,250,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2007_cc-common",
    "country": "Slovenia",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 399010,
    "mintageFormatted": "399,010",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2007_2euro_0.jpg",
    "image_key": "si_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovenia_2008_1cent",
    "country": "Slovenia",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Cent (2008) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2008_2cent",
    "country": "Slovenia",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2008) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2008_5cent",
    "country": "Slovenia",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2008) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2008_10cent",
    "country": "Slovenia",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2008) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2008_20cent",
    "country": "Slovenia",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2008) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2008_50cent",
    "country": "Slovenia",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2008) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2008_1euro",
    "country": "Slovenia",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2008) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2008",
    "country": "Slovenia",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2008) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2008_cc1",
    "country": "Slovenia",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2008) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2008: Primož Trubar.",
    "mintage": 950000,
    "mintageFormatted": "950,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2008_2euro_0.jpg",
    "image_key": "si_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2009_1cent",
    "country": "Slovenia",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2009) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 17900000,
    "mintageFormatted": "17,900,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2009_2cent",
    "country": "Slovenia",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2009) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 12300000,
    "mintageFormatted": "12,300,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2009_5cent",
    "country": "Slovenia",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2009) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2009_10cent",
    "country": "Slovenia",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2009) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2009_20cent",
    "country": "Slovenia",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2009) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2009_50cent",
    "country": "Slovenia",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2009) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2009_1euro",
    "country": "Slovenia",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2009) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2009",
    "country": "Slovenia",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2009) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2009_cc-common",
    "country": "Slovenia",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2009_2euro_0.jpg",
    "image_key": "si_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovenia_2010_1cent",
    "country": "Slovenia",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Cent (2010) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2010_2cent",
    "country": "Slovenia",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2010) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2010_5cent",
    "country": "Slovenia",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2010) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2010_10cent",
    "country": "Slovenia",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2010) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2010_20cent",
    "country": "Slovenia",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2010) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2010_50cent",
    "country": "Slovenia",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2010) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2010_1euro",
    "country": "Slovenia",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2010) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2010",
    "country": "Slovenia",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2010) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2010_cc1",
    "country": "Slovenia",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2010) - Ljubljana Botanical Garden",
    "subject": "Ljubljana Botanical Garden",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2010: Ljubljana Botanical Garden.",
    "mintage": 910000,
    "mintageFormatted": "910,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2010_2euro_0.jpg",
    "image_key": "si_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2011_1cent",
    "country": "Slovenia",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Cent (2011) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2011_2cent",
    "country": "Slovenia",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2011) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2011_5cent",
    "country": "Slovenia",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2011) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2011_10cent",
    "country": "Slovenia",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2011) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2011_20cent",
    "country": "Slovenia",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2011) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2011_50cent",
    "country": "Slovenia",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2011) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2011_1euro",
    "country": "Slovenia",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2011) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2011",
    "country": "Slovenia",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2011) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2011_cc1",
    "country": "Slovenia",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2011) - Franc Rozman-Stane",
    "subject": "Franc Rozman-Stane",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2011: Franc Rozman-Stane.",
    "mintage": 971000,
    "mintageFormatted": "971,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2011_2euro_0.jpg",
    "image_key": "si_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2012_1cent",
    "country": "Slovenia",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Cent (2012) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2012_2cent",
    "country": "Slovenia",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2012) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2012_5cent",
    "country": "Slovenia",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2012) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2012_10cent",
    "country": "Slovenia",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2012) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2012_20cent",
    "country": "Slovenia",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2012) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2012_50cent",
    "country": "Slovenia",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2012) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2012_1euro",
    "country": "Slovenia",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2012) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2012",
    "country": "Slovenia",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2012) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2012_cc-common",
    "country": "Slovenia",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 971000,
    "mintageFormatted": "971,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2012_2euro_0.jpg",
    "image_key": "si_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovenia_2013_1cent",
    "country": "Slovenia",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Cent (2013) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2013_2cent",
    "country": "Slovenia",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2013) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2013_5cent",
    "country": "Slovenia",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2013) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2013_10cent",
    "country": "Slovenia",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2013) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2013_20cent",
    "country": "Slovenia",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2013) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2013_50cent",
    "country": "Slovenia",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2013) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2013_1euro",
    "country": "Slovenia",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2013) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2013",
    "country": "Slovenia",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2013) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2013_cc1",
    "country": "Slovenia",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2013) - Postojna Cave",
    "subject": "Postojna Cave",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2013: Postojna Cave.",
    "mintage": 975000,
    "mintageFormatted": "975,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2013_2euro_0.jpg",
    "image_key": "si_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2014_1cent",
    "country": "Slovenia",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Cent (2014) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2014_2cent",
    "country": "Slovenia",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2014) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2014_5cent",
    "country": "Slovenia",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2014) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2014_10cent",
    "country": "Slovenia",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2014) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2014_20cent",
    "country": "Slovenia",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2014) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2014_50cent",
    "country": "Slovenia",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2014) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2014_1euro",
    "country": "Slovenia",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2014) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2014",
    "country": "Slovenia",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2014) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2014_cc1",
    "country": "Slovenia",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2014) - Barbara Celjska",
    "subject": "Barbara Celjska",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2014: Barbara Celjska.",
    "mintage": 978500,
    "mintageFormatted": "978,500",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2014_2euro_0.jpg",
    "image_key": "si_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2015_1cent",
    "country": "Slovenia",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2015) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 20000000,
    "mintageFormatted": "20,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2015_2cent",
    "country": "Slovenia",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2015) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2015_5cent",
    "country": "Slovenia",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2015) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2015_10cent",
    "country": "Slovenia",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2015) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2015_20cent",
    "country": "Slovenia",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2015) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2015_50cent",
    "country": "Slovenia",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2015) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2015_1euro",
    "country": "Slovenia",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2015) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2015",
    "country": "Slovenia",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2015) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2015_cc1",
    "country": "Slovenia",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2015) - Emona-Ljubljana",
    "subject": "Emona-Ljubljana",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2015: Emona-Ljubljana.",
    "mintage": 980000,
    "mintageFormatted": "980,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2015_2euro_1.jpg",
    "image_key": "si_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2015_cc-common",
    "country": "Slovenia",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2015_2euro_0.jpg",
    "image_key": "si_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovenia_2016_1cent",
    "country": "Slovenia",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2016) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 15000000,
    "mintageFormatted": "15,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2016_2cent",
    "country": "Slovenia",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2016) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2016_5cent",
    "country": "Slovenia",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2016) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2016_10cent",
    "country": "Slovenia",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2016) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2016_20cent",
    "country": "Slovenia",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2016) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2016_50cent",
    "country": "Slovenia",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2016) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2016_1euro",
    "country": "Slovenia",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2016) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2016",
    "country": "Slovenia",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2016) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2016_cc1",
    "country": "Slovenia",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2016) - Slovene Independence",
    "subject": "Slovene Independence",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2016: Slovene Independence.",
    "mintage": 984500,
    "mintageFormatted": "984,500",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2016_2euro_0.jpg",
    "image_key": "si_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2017_1cent",
    "country": "Slovenia",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Cent (2017) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2017_2cent",
    "country": "Slovenia",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2017) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2017_5cent",
    "country": "Slovenia",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2017) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2017_10cent",
    "country": "Slovenia",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2017) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2017_20cent",
    "country": "Slovenia",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2017) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2017_50cent",
    "country": "Slovenia",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2017) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2017_1euro",
    "country": "Slovenia",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2017) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2017",
    "country": "Slovenia",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2017) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2017_cc1",
    "country": "Slovenia",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2017) - Slovene Euro Usage",
    "subject": "Slovene Euro Usage",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2017: Slovene Euro Usage.",
    "mintage": 988500,
    "mintageFormatted": "988,500",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2017_2euro_0.jpg",
    "image_key": "si_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2018_1cent",
    "country": "Slovenia",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2018) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 16000000,
    "mintageFormatted": "16,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2018_2cent",
    "country": "Slovenia",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2018) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2018_5cent",
    "country": "Slovenia",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2018) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2018_10cent",
    "country": "Slovenia",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 10 Cents (2018) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2018_20cent",
    "country": "Slovenia",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2018) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2018_50cent",
    "country": "Slovenia",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2018) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2018_1euro",
    "country": "Slovenia",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2018) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2018",
    "country": "Slovenia",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2018) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2018_cc1",
    "country": "Slovenia",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2018) - World Bee Day",
    "subject": "World Bee Day",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2018: World Bee Day.",
    "mintage": 989250,
    "mintageFormatted": "989,250",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2018_2euro_0.jpg",
    "image_key": "si_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2019_1cent",
    "country": "Slovenia",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2019) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 38000000,
    "mintageFormatted": "38,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2019_2cent",
    "country": "Slovenia",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2019) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 22000000,
    "mintageFormatted": "22,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2019_5cent",
    "country": "Slovenia",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 5 Cents (2019) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2019_10cent",
    "country": "Slovenia",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 10 Cents (2019) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 22000000,
    "mintageFormatted": "22,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2019_20cent",
    "country": "Slovenia",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 20 Cents (2019) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2019_50cent",
    "country": "Slovenia",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2019) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2019_1euro",
    "country": "Slovenia",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2019) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2019",
    "country": "Slovenia",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2019) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2019_cc1",
    "country": "Slovenia",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2019) - University of Ljubljana",
    "subject": "University of Ljubljana",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2019: University of Ljubljana.",
    "mintage": 989250,
    "mintageFormatted": "989,250",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2019_2euro_0.jpg",
    "image_key": "si_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2020_1cent",
    "country": "Slovenia",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2020) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 14000000,
    "mintageFormatted": "14,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2020_2cent",
    "country": "Slovenia",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2020) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 11000000,
    "mintageFormatted": "11,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2020_5cent",
    "country": "Slovenia",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2020) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2020_10cent",
    "country": "Slovenia",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2020) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2020_20cent",
    "country": "Slovenia",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2020) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2020_50cent",
    "country": "Slovenia",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2020) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2020_1euro",
    "country": "Slovenia",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2020) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2020",
    "country": "Slovenia",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Euros (2020) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2020_cc1",
    "country": "Slovenia",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2020) - Adam Bohorič",
    "subject": "Adam Bohorič",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2020: Adam Bohorič.",
    "mintage": 990500,
    "mintageFormatted": "990,500",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2020_2euro_0.jpg",
    "image_key": "si_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2021_1cent",
    "country": "Slovenia",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2021) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2021_2cent",
    "country": "Slovenia",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2021) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2021_5cent",
    "country": "Slovenia",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 5 Cents (2021) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 7000000,
    "mintageFormatted": "7,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2021_10cent",
    "country": "Slovenia",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2021) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2021_20cent",
    "country": "Slovenia",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2021) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2021_50cent",
    "country": "Slovenia",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 50 Cents (2021) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2021_1euro",
    "country": "Slovenia",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2021) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2021",
    "country": "Slovenia",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2021) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2021_cc1",
    "country": "Slovenia",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2021) - Regional Museum of Carniola",
    "subject": "Regional Museum of Carniola",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2021: Regional Museum of Carniola.",
    "mintage": 991000,
    "mintageFormatted": "991,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2021_2euro_0.jpg",
    "image_key": "si_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2022_1cent",
    "country": "Slovenia",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2022) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2022_2cent",
    "country": "Slovenia",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2022) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2022_5cent",
    "country": "Slovenia",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 5 Cents (2022) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2022_10cent",
    "country": "Slovenia",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 10 Cents (2022) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2022_20cent",
    "country": "Slovenia",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 20 Cents (2022) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2022_50cent",
    "country": "Slovenia",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2022) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2022_1euro",
    "country": "Slovenia",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2022) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2022",
    "country": "Slovenia",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Euros (2022) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2022_cc1",
    "country": "Slovenia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2022) - Jože Plečnik",
    "subject": "Jože Plečnik",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2022: Jože Plečnik.",
    "mintage": 991000,
    "mintageFormatted": "991,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2022_2euro_0.jpg",
    "image_key": "si_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2022_cc-common",
    "country": "Slovenia",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 997500,
    "mintageFormatted": "997,500",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2022_2euro_1.jpg",
    "image_key": "si_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_slovenia_2023_1cent",
    "country": "Slovenia",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2023) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2023_2cent",
    "country": "Slovenia",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2023) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2023_5cent",
    "country": "Slovenia",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 5 Cents (2023) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2023_10cent",
    "country": "Slovenia",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 10 Cents (2023) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 5000000,
    "mintageFormatted": "5,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2023_20cent",
    "country": "Slovenia",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 20 Cents (2023) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 17000000,
    "mintageFormatted": "17,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2023_50cent",
    "country": "Slovenia",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2023) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2023_1euro",
    "country": "Slovenia",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2023) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2023",
    "country": "Slovenia",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Euros (2023) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2023_cc1",
    "country": "Slovenia",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2023) - Josip Plemelj",
    "subject": "Josip Plemelj",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2023: Josip Plemelj.",
    "mintage": 990250,
    "mintageFormatted": "990,250",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2023_2euro_0.jpg",
    "image_key": "si_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2024_1cent",
    "country": "Slovenia",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2024) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 12000000,
    "mintageFormatted": "12,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2024_2cent",
    "country": "Slovenia",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2024) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 11000000,
    "mintageFormatted": "11,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2024_5cent",
    "country": "Slovenia",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 5 Cents (2024) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2024_10cent",
    "country": "Slovenia",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 10 Cents (2024) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2024_20cent",
    "country": "Slovenia",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 20 Cents (2024) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2024_50cent",
    "country": "Slovenia",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 50 Cents (2024) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2024_1euro",
    "country": "Slovenia",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2024) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2024",
    "country": "Slovenia",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Euros (2024) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2024_cc1",
    "country": "Slovenia",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2024) - National and University Library",
    "subject": "National and University Library",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2024: National and University Library.",
    "mintage": 990250,
    "mintageFormatted": "990,250",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2024_2euro_0.jpg",
    "image_key": "si_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2025_1cent",
    "country": "Slovenia",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2025) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 14000000,
    "mintageFormatted": "14,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2025_2cent",
    "country": "Slovenia",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Cents (2025) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 9000000,
    "mintageFormatted": "9,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2025_5cent",
    "country": "Slovenia",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 5 Cents (2025) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2025_10cent",
    "country": "Slovenia",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 10 Cents (2025) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2025_20cent",
    "country": "Slovenia",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2025) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2025_50cent",
    "country": "Slovenia",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2025) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2025_1euro",
    "country": "Slovenia",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2025) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2025",
    "country": "Slovenia",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Euros (2025) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2025_cc1",
    "country": "Slovenia",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2025) - Miki Muster",
    "subject": "Miki Muster",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2025: Miki Muster.",
    "mintage": 990000,
    "mintageFormatted": "990,000",
    "status": "circulating",
    "imagePath": "coins/si_commemorative_2025_2euro_0.jpg",
    "image_key": "si_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2026_1cent",
    "country": "Slovenia",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 1 Cent (2026) - A Stork",
    "subject": "A Stork",
    "description": "Stork motif taken from the former 20 tolar coin by Janez Boljka",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_1cent_0.jpg",
    "image_key": "si_regular_2007_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2026_2cent",
    "country": "Slovenia",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 2 Cents (2026) - The Prince's Stone (Knežji kamen)",
    "subject": "The Prince's Stone (Knežji kamen)",
    "description": "Ancient stone column capital used in enthroning the Dukes of Carantania",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_2cent_0.jpg",
    "image_key": "si_regular_2007_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2026_5cent",
    "country": "Slovenia",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 5 Cents (2026) - The Sower (Ivan Grohar)",
    "subject": "The Sower (Ivan Grohar)",
    "description": "Sower sowing seeds, after the famous Impressionist painting by Ivan Grohar",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_5cent_0.jpg",
    "image_key": "si_regular_2007_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2026_10cent",
    "country": "Slovenia",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 10 Cents (2026) - Plečnik's Cathedral of Freedom",
    "subject": "Plečnik's Cathedral of Freedom",
    "description": "Unrealized Slovenian parliament building 'Cathedral of Freedom' by architect Jože Plečnik",
    "mintage": 13000000,
    "mintageFormatted": "13,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_10cent_0.jpg",
    "image_key": "si_regular_2007_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2026_20cent",
    "country": "Slovenia",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 20 Cents (2026) - Lipizzaner Horses",
    "subject": "Lipizzaner Horses",
    "description": "Pair of Lipizzaner horses from the historic Lipica Stud Farm",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_20cent_0.jpg",
    "image_key": "si_regular_2007_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2026_50cent",
    "country": "Slovenia",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 50 Cents (2026) - Mount Triglav and Cancer Constellation",
    "subject": "Mount Triglav and Cancer Constellation",
    "description": "Triglav mountain peak with the constellation of Cancer and verse 'Oj Triglav moj dom'",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_50cent_0.jpg",
    "image_key": "si_regular_2007_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2026_1euro",
    "country": "Slovenia",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Slovenia 1 Euro (2026) - Primož Trubar",
    "subject": "Primož Trubar",
    "description": "Portrait of Protestant reformer Primož Trubar, author of first printed books in Slovenian",
    "mintage": 200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/si_regular_2007_1euro_0.jpg",
    "image_key": "si_regular_2007_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_slovenia_2026",
    "country": "Slovenia",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Slovenia 2 Euros (2026) - France Prešeren",
    "subject": "France Prešeren",
    "description": "Profile of national romantic poet France Prešeren with inscribed line from 'Zdravljica'",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/si_regular_2007_2euro_0.jpg",
    "image_key": "si_regular_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_slovenia_2026_cc1",
    "country": "Slovenia",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Slovenia 2€ Commemorative (2026) - Ivan Cankar",
    "subject": "Ivan Cankar",
    "description": "Slovenia 2 Euro Commemorative coin issued in 2026: Ivan Cankar.",
    "mintage": 991000,
    "mintageFormatted": "991,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_1999_1cent",
    "country": "Spain",
    "year": 1999,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (1999) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 721005385,
    "mintageFormatted": "721,005,385",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_1999_2cent",
    "country": "Spain",
    "year": 1999,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (1999) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 291652000,
    "mintageFormatted": "291,652,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_1999_5cent",
    "country": "Spain",
    "year": 1999,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (1999) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 483492385,
    "mintageFormatted": "483,492,385",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_1999_10cent",
    "country": "Spain",
    "year": 1999,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (1999) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 588112385,
    "mintageFormatted": "588,112,385",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_1999_20cent",
    "country": "Spain",
    "year": 1999,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (1999) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 762304385,
    "mintageFormatted": "762,304,385",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_1999_50cent",
    "country": "Spain",
    "year": 1999,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (1999) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 370988000,
    "mintageFormatted": "370,988,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_1999_1euro",
    "country": "Spain",
    "year": 1999,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (1999) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 100204000,
    "mintageFormatted": "100,204,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_1999",
    "country": "Spain",
    "year": 1999,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (1999) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 60483000,
    "mintageFormatted": "60,483,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2000_1cent",
    "country": "Spain",
    "year": 2000,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2000) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 83375000,
    "mintageFormatted": "83,375,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2000_2cent",
    "country": "Spain",
    "year": 2000,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2000) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 711319000,
    "mintageFormatted": "711,319,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2000_5cent",
    "country": "Spain",
    "year": 2000,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2000) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 399890000,
    "mintageFormatted": "399,890,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2000_10cent",
    "country": "Spain",
    "year": 2000,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2000) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 24394000,
    "mintageFormatted": "24,394,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2000_20cent",
    "country": "Spain",
    "year": 2000,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2000) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 29276000,
    "mintageFormatted": "29,276,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2000_50cent",
    "country": "Spain",
    "year": 2000,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2000) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 519626000,
    "mintageFormatted": "519,626,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2000_1euro",
    "country": "Spain",
    "year": 2000,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2000) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 89306000,
    "mintageFormatted": "89,306,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2000",
    "country": "Spain",
    "year": 2000,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2000) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 36618000,
    "mintageFormatted": "36,618,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2001_1cent",
    "country": "Spain",
    "year": 2001,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2001) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 130908000,
    "mintageFormatted": "130,908,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2001_2cent",
    "country": "Spain",
    "year": 2001,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2001) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 463123000,
    "mintageFormatted": "463,123,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2001_5cent",
    "country": "Spain",
    "year": 2001,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2001) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 216132500,
    "mintageFormatted": "216,132,500",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2001_10cent",
    "country": "Spain",
    "year": 2001,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2001) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 160058000,
    "mintageFormatted": "160,058,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2001_20cent",
    "country": "Spain",
    "year": 2001,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2001) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 146568000,
    "mintageFormatted": "146,568,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2001_50cent",
    "country": "Spain",
    "year": 2001,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2001) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 351087500,
    "mintageFormatted": "351,087,500",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2001_1euro",
    "country": "Spain",
    "year": 2001,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2001) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 259102500,
    "mintageFormatted": "259,102,500",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2001",
    "country": "Spain",
    "year": 2001,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2001) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 140156500,
    "mintageFormatted": "140,156,500",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2002_1cent",
    "country": "Spain",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2002) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 141132000,
    "mintageFormatted": "141,132,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2002_2cent",
    "country": "Spain",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2002) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 4108000,
    "mintageFormatted": "4,108,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2002_5cent",
    "country": "Spain",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2002) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 8258000,
    "mintageFormatted": "8,258,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2002_10cent",
    "country": "Spain",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2002) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 113100000,
    "mintageFormatted": "113,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2002_20cent",
    "country": "Spain",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2002) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 91534000,
    "mintageFormatted": "91,534,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2002_50cent",
    "country": "Spain",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2002) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 9796000,
    "mintageFormatted": "9,796,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2002_1euro",
    "country": "Spain",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2002) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 335578000,
    "mintageFormatted": "335,578,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2002",
    "country": "Spain",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2002) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 164039000,
    "mintageFormatted": "164,039,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2003_1cent",
    "country": "Spain",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2003) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 670500000,
    "mintageFormatted": "670,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2003_2cent",
    "country": "Spain",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2003) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 31600000,
    "mintageFormatted": "31,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2003_5cent",
    "country": "Spain",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2003) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 327600000,
    "mintageFormatted": "327,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2003_10cent",
    "country": "Spain",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2003) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 292500000,
    "mintageFormatted": "292,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2003_20cent",
    "country": "Spain",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2003) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2003_50cent",
    "country": "Spain",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2003) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 6000000,
    "mintageFormatted": "6,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2003_1euro",
    "country": "Spain",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2003) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 297400000,
    "mintageFormatted": "297,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2003",
    "country": "Spain",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2003) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 44500000,
    "mintageFormatted": "44,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2004_1cent",
    "country": "Spain",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2004) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 206700000,
    "mintageFormatted": "206,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2004_2cent",
    "country": "Spain",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2004) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 206700000,
    "mintageFormatted": "206,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2004_5cent",
    "country": "Spain",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2004) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 258700000,
    "mintageFormatted": "258,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2004_10cent",
    "country": "Spain",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2004) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 121900000,
    "mintageFormatted": "121,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2004_20cent",
    "country": "Spain",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2004) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 3900000,
    "mintageFormatted": "3,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2004_50cent",
    "country": "Spain",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2004) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 4400000,
    "mintageFormatted": "4,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2004_1euro",
    "country": "Spain",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2004) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 98700000,
    "mintageFormatted": "98,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2004",
    "country": "Spain",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2004) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2005_1cent",
    "country": "Spain",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2005) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 444200000,
    "mintageFormatted": "444,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2005_2cent",
    "country": "Spain",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2005) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 275100000,
    "mintageFormatted": "275,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2005_5cent",
    "country": "Spain",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2005) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 411400000,
    "mintageFormatted": "411,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2005_10cent",
    "country": "Spain",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2005) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 321300000,
    "mintageFormatted": "321,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2005_20cent",
    "country": "Spain",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2005) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2005_50cent",
    "country": "Spain",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2005) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 3900000,
    "mintageFormatted": "3,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2005_1euro",
    "country": "Spain",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2005) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 77800000,
    "mintageFormatted": "77,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2005",
    "country": "Spain",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2005) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2005_cc1",
    "country": "Spain",
    "year": 2005,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2005) - Don Quixote de la Mancha",
    "subject": "Don Quixote de la Mancha",
    "description": "Spain 2 Euro Commemorative coin issued in 2005: Don Quixote de la Mancha.",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2005_2euro_0.jpg",
    "image_key": "es_commemorative_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2006_1cent",
    "country": "Spain",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2006) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 383900000,
    "mintageFormatted": "383,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2006_2cent",
    "country": "Spain",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2006) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 262200000,
    "mintageFormatted": "262,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2006_5cent",
    "country": "Spain",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2006) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 142800000,
    "mintageFormatted": "142,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2006_10cent",
    "country": "Spain",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2006) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 91800000,
    "mintageFormatted": "91,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2006_20cent",
    "country": "Spain",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2006) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 102000000,
    "mintageFormatted": "102,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2006_50cent",
    "country": "Spain",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2006) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2006_1euro",
    "country": "Spain",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2006) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 101600000,
    "mintageFormatted": "101,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2006",
    "country": "Spain",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2006) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2007_1cent",
    "country": "Spain",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2007) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 384000000,
    "mintageFormatted": "384,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2007_2cent",
    "country": "Spain",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2007) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 185300000,
    "mintageFormatted": "185,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2007_5cent",
    "country": "Spain",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2007) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 247100000,
    "mintageFormatted": "247,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2007_10cent",
    "country": "Spain",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2007) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 132100000,
    "mintageFormatted": "132,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2007_20cent",
    "country": "Spain",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2007) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 46500000,
    "mintageFormatted": "46,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2007_50cent",
    "country": "Spain",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2007) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2007_1euro",
    "country": "Spain",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2007) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 150600000,
    "mintageFormatted": "150,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2007",
    "country": "Spain",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2007) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2007_cc-common",
    "country": "Spain",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2007) - Treaty of Rome (ToR)",
    "subject": "Treaty of Rome (ToR)",
    "description": "Spain 2 Euro Commemorative coin issued in 2007: Treaty of Rome (ToR).",
    "mintage": 8000000,
    "mintageFormatted": "8,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2007_2euro_0.jpg",
    "image_key": "es_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_spain_2008_1cent",
    "country": "Spain",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2008) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 374600000,
    "mintageFormatted": "374,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2008_2cent",
    "country": "Spain",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2008) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 191300000,
    "mintageFormatted": "191,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2008_5cent",
    "country": "Spain",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2008) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 239100000,
    "mintageFormatted": "239,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2008_10cent",
    "country": "Spain",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2008) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 142300000,
    "mintageFormatted": "142,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2008_20cent",
    "country": "Spain",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2008) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 102300000,
    "mintageFormatted": "102,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2008_50cent",
    "country": "Spain",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2008) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2008_1euro",
    "country": "Spain",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2008) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 154400000,
    "mintageFormatted": "154,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2008",
    "country": "Spain",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2008) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 19500000,
    "mintageFormatted": "19,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2009_1cent",
    "country": "Spain",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2009) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 131500000,
    "mintageFormatted": "131,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1cent_0.jpg",
    "image_key": "es_regular_1999_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2009_2cent",
    "country": "Spain",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2009) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 164100000,
    "mintageFormatted": "164,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2cent_0.jpg",
    "image_key": "es_regular_1999_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2009_5cent",
    "country": "Spain",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2009) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela, jewel of Spanish Baroque",
    "mintage": 219800000,
    "mintageFormatted": "219,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_5cent_0.jpg",
    "image_key": "es_regular_1999_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2009_10cent",
    "country": "Spain",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2009) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 151400000,
    "mintageFormatted": "151,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_10cent_0.jpg",
    "image_key": "es_regular_1999_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2009_20cent",
    "country": "Spain",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2009) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 75400000,
    "mintageFormatted": "75,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_20cent_0.jpg",
    "image_key": "es_regular_1999_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2009_50cent",
    "country": "Spain",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2009) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra, author of Don Quixote",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_50cent_0.jpg",
    "image_key": "es_regular_1999_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2009_1euro",
    "country": "Spain",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2009) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 60600000,
    "mintageFormatted": "60,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_1euro_0.jpg",
    "image_key": "es_regular_1999_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2009",
    "country": "Spain",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2009) - King Juan Carlos I (1st Portrait)",
    "subject": "King Juan Carlos I (1st Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain",
    "mintage": 17500000,
    "mintageFormatted": "17,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_1999_2euro_0.jpg",
    "image_key": "es_regular_1999_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2009_cc-common",
    "country": "Spain",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2009) - Economic and Monetary Union (EMU)",
    "subject": "Economic and Monetary Union (EMU)",
    "description": "Spain 2 Euro Commemorative coin issued in 2009: Economic and Monetary Union (EMU).",
    "mintage": 7900000,
    "mintageFormatted": "7,900,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2009_2euro_0.jpg",
    "image_key": "es_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_spain_2010_1cent",
    "country": "Spain",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2010) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 227400000,
    "mintageFormatted": "227,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2010_2cent",
    "country": "Spain",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2010) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 153200000,
    "mintageFormatted": "153,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2010_5cent",
    "country": "Spain",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2010) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 203200000,
    "mintageFormatted": "203,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2010_10cent",
    "country": "Spain",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2010) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 105000000,
    "mintageFormatted": "105,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2010_20cent",
    "country": "Spain",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2010) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 3900000,
    "mintageFormatted": "3,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2010_50cent",
    "country": "Spain",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2010) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2010_1euro",
    "country": "Spain",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2010) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 40100000,
    "mintageFormatted": "40,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1euro_0.jpg",
    "image_key": "es_regular_2010_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2010",
    "country": "Spain",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2010) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2euro_0.jpg",
    "image_key": "es_regular_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2010_cc1",
    "country": "Spain",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2010) - Mezquita of Córdoba",
    "subject": "Mezquita of Córdoba",
    "description": "Spain 2 Euro Commemorative coin issued in 2010: Mezquita of Córdoba.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2010_2euro_0.jpg",
    "image_key": "es_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2011_1cent",
    "country": "Spain",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2011) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 339400000,
    "mintageFormatted": "339,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2011_2cent",
    "country": "Spain",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2011) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 96600000,
    "mintageFormatted": "96,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2011_5cent",
    "country": "Spain",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2011) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 97200000,
    "mintageFormatted": "97,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2011_10cent",
    "country": "Spain",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2011) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4500000,
    "mintageFormatted": "4,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2011_20cent",
    "country": "Spain",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2011) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2011_50cent",
    "country": "Spain",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2011) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2011_1euro",
    "country": "Spain",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2011) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 100600000,
    "mintageFormatted": "100,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1euro_0.jpg",
    "image_key": "es_regular_2010_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2011",
    "country": "Spain",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2011) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2euro_0.jpg",
    "image_key": "es_regular_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2011_cc1",
    "country": "Spain",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2011) - Alhambra of Granada",
    "subject": "Alhambra of Granada",
    "description": "Spain 2 Euro Commemorative coin issued in 2011: Alhambra of Granada.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2011_2euro_0.jpg",
    "image_key": "es_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2012_1cent",
    "country": "Spain",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2012) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 400600000,
    "mintageFormatted": "400,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2012_2cent",
    "country": "Spain",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2012) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 99600000,
    "mintageFormatted": "99,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2012_5cent",
    "country": "Spain",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2012) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 49700000,
    "mintageFormatted": "49,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2012_10cent",
    "country": "Spain",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2012) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 3700000,
    "mintageFormatted": "3,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2012_20cent",
    "country": "Spain",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2012) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 26300000,
    "mintageFormatted": "26,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2012_50cent",
    "country": "Spain",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2012) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2012_1euro",
    "country": "Spain",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2012) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 3400000,
    "mintageFormatted": "3,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1euro_0.jpg",
    "image_key": "es_regular_2010_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2012",
    "country": "Spain",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2012) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2euro_0.jpg",
    "image_key": "es_regular_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2012_cc1",
    "country": "Spain",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2012) - Burgos Cathedral",
    "subject": "Burgos Cathedral",
    "description": "Spain 2 Euro Commemorative coin issued in 2012: Burgos Cathedral.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2012_2euro_1.jpg",
    "image_key": "es_commemorative_2012_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2012_cc-common",
    "country": "Spain",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2012) - Ten Years of Euro (TYE)",
    "subject": "Ten Years of Euro (TYE)",
    "description": "Spain 2 Euro Commemorative coin issued in 2012: Ten Years of Euro (TYE).",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2012_2euro_0.jpg",
    "image_key": "es_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_spain_2013_1cent",
    "country": "Spain",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2013) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 297500000,
    "mintageFormatted": "297,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2013_2cent",
    "country": "Spain",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2013) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 200600000,
    "mintageFormatted": "200,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2013_5cent",
    "country": "Spain",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2013) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 9800000,
    "mintageFormatted": "9,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2013_10cent",
    "country": "Spain",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2013) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 3300000,
    "mintageFormatted": "3,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2013_20cent",
    "country": "Spain",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2013) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2013_50cent",
    "country": "Spain",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2013) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2013_1euro",
    "country": "Spain",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2013) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1euro_0.jpg",
    "image_key": "es_regular_2010_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2013",
    "country": "Spain",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2013) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2euro_0.jpg",
    "image_key": "es_regular_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2013_cc1",
    "country": "Spain",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2013) - El Escorial",
    "subject": "El Escorial",
    "description": "Spain 2 Euro Commemorative coin issued in 2013: El Escorial.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2013_2euro_0.jpg",
    "image_key": "es_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2014_1cent",
    "country": "Spain",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2014) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 65000000,
    "mintageFormatted": "65,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2014_2cent",
    "country": "Spain",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2014) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 19400000,
    "mintageFormatted": "19,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2014_5cent",
    "country": "Spain",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2014) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 119900000,
    "mintageFormatted": "119,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2014_10cent",
    "country": "Spain",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2014) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 80100000,
    "mintageFormatted": "80,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2014_20cent",
    "country": "Spain",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2014) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 29600000,
    "mintageFormatted": "29,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2014_50cent",
    "country": "Spain",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2014) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 3800000,
    "mintageFormatted": "3,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2014_1euro",
    "country": "Spain",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2014) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 15300000,
    "mintageFormatted": "15,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1euro_0.jpg",
    "image_key": "es_regular_2010_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2014",
    "country": "Spain",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2014) - King Juan Carlos I (2nd Portrait)",
    "subject": "King Juan Carlos I (2nd Portrait)",
    "description": "Effigy of King Juan Carlos I of Spain (updated EU stars)",
    "mintage": 3600000,
    "mintageFormatted": "3,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2euro_0.jpg",
    "image_key": "es_regular_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2014_cc1",
    "country": "Spain",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2014) - Park Güell",
    "subject": "Park Güell",
    "description": "Spain 2 Euro Commemorative coin issued in 2014: Park Güell.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2014_2euro_1.jpg",
    "image_key": "es_commemorative_2014_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2014_cc2",
    "country": "Spain",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2014) - Accession of Felipe VI",
    "subject": "Accession of Felipe VI",
    "description": "Spain 2 Euro Commemorative coin issued in 2014: Accession of Felipe VI.",
    "mintage": 8100000,
    "mintageFormatted": "8,100,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2014_2euro_0.jpg",
    "image_key": "es_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2015_1cent",
    "country": "Spain",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2015) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 476800000,
    "mintageFormatted": "476,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2015_2cent",
    "country": "Spain",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2015) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 162800000,
    "mintageFormatted": "162,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2015_5cent",
    "country": "Spain",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2015) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 55300000,
    "mintageFormatted": "55,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2015_10cent",
    "country": "Spain",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2015) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2015_20cent",
    "country": "Spain",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2015) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2015_50cent",
    "country": "Spain",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2015) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 4100000,
    "mintageFormatted": "4,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2015_1euro",
    "country": "Spain",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2015) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 4300000,
    "mintageFormatted": "4,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2015",
    "country": "Spain",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2015) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 3900000,
    "mintageFormatted": "3,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2015_cc1",
    "country": "Spain",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2015) - Cave of Altamira",
    "subject": "Cave of Altamira",
    "description": "Spain 2 Euro Commemorative coin issued in 2015: Cave of Altamira.",
    "mintage": 4200000,
    "mintageFormatted": "4,200,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2015_2euro_1.jpg",
    "image_key": "es_commemorative_2015_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2015_cc-common",
    "country": "Spain",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2015) - EU Flag",
    "subject": "EU Flag",
    "description": "Spain 2 Euro Commemorative coin issued in 2015: EU Flag.",
    "mintage": 4300000,
    "mintageFormatted": "4,300,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2015_2euro_0.jpg",
    "image_key": "es_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_spain_2016_1cent",
    "country": "Spain",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2016) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 437900000,
    "mintageFormatted": "437,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2016_2cent",
    "country": "Spain",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2016) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 230100000,
    "mintageFormatted": "230,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2016_5cent",
    "country": "Spain",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2016) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 310200000,
    "mintageFormatted": "310,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2016_10cent",
    "country": "Spain",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2016) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 77200000,
    "mintageFormatted": "77,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2016_20cent",
    "country": "Spain",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2016) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 79100000,
    "mintageFormatted": "79,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2016_50cent",
    "country": "Spain",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2016) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 72800000,
    "mintageFormatted": "72,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2016_1euro",
    "country": "Spain",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2016) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 111100000,
    "mintageFormatted": "111,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2016",
    "country": "Spain",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2016) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 4700000,
    "mintageFormatted": "4,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2016_cc1",
    "country": "Spain",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2016) - Aqueduct of Segovia",
    "subject": "Aqueduct of Segovia",
    "description": "Spain 2 Euro Commemorative coin issued in 2016: Aqueduct of Segovia.",
    "mintage": 3400000,
    "mintageFormatted": "3,400,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2016_2euro_0.jpg",
    "image_key": "es_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2017_1cent",
    "country": "Spain",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2017) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 519600000,
    "mintageFormatted": "519,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2017_2cent",
    "country": "Spain",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2017) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 311800000,
    "mintageFormatted": "311,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2017_5cent",
    "country": "Spain",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2017) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 249800000,
    "mintageFormatted": "249,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2017_10cent",
    "country": "Spain",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2017) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 134600000,
    "mintageFormatted": "134,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2017_20cent",
    "country": "Spain",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2017) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 112500000,
    "mintageFormatted": "112,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2017_50cent",
    "country": "Spain",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2017) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 19000000,
    "mintageFormatted": "19,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2017_1euro",
    "country": "Spain",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2017) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 122700000,
    "mintageFormatted": "122,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2017",
    "country": "Spain",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2017) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2017_cc1",
    "country": "Spain",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2017) - Churches of the Asturias",
    "subject": "Churches of the Asturias",
    "description": "Spain 2 Euro Commemorative coin issued in 2017: Churches of the Asturias.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2017_2euro_0.jpg",
    "image_key": "es_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2018_1cent",
    "country": "Spain",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2018) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 317900000,
    "mintageFormatted": "317,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2018_2cent",
    "country": "Spain",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2018) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 233100000,
    "mintageFormatted": "233,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2018_5cent",
    "country": "Spain",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2018) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 222000000,
    "mintageFormatted": "222,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2018_10cent",
    "country": "Spain",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2018) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 71100000,
    "mintageFormatted": "71,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2018_20cent",
    "country": "Spain",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2018) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 119500000,
    "mintageFormatted": "119,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2018_50cent",
    "country": "Spain",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2018) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 19500000,
    "mintageFormatted": "19,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2018_1euro",
    "country": "Spain",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2018) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 107200000,
    "mintageFormatted": "107,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2018",
    "country": "Spain",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2018) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2018_cc1",
    "country": "Spain",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2018) - 50th Birthday of Felipe VI",
    "subject": "50th Birthday of Felipe VI",
    "description": "Spain 2 Euro Commemorative coin issued in 2018: 50th Birthday of Felipe VI.",
    "mintage": 400000,
    "mintageFormatted": "400,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2018_2euro_0.jpg",
    "image_key": "es_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2018_cc2",
    "country": "Spain",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2018) - Santiago de Compostela",
    "subject": "Santiago de Compostela",
    "description": "Spain 2 Euro Commemorative coin issued in 2018: Santiago de Compostela.",
    "mintage": 300000,
    "mintageFormatted": "300,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2018_2euro_1.jpg",
    "image_key": "es_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2019_1cent",
    "country": "Spain",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2019) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 324900000,
    "mintageFormatted": "324,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2019_2cent",
    "country": "Spain",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2019) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 210200000,
    "mintageFormatted": "210,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2019_5cent",
    "country": "Spain",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2019) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 236200000,
    "mintageFormatted": "236,200,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2019_10cent",
    "country": "Spain",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2019) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 56000000,
    "mintageFormatted": "56,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2019_20cent",
    "country": "Spain",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2019) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 137000000,
    "mintageFormatted": "137,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2019_50cent",
    "country": "Spain",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2019) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 68000000,
    "mintageFormatted": "68,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2019_1euro",
    "country": "Spain",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2019) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 122000000,
    "mintageFormatted": "122,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2019",
    "country": "Spain",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2019) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2019_cc1",
    "country": "Spain",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2019) - Old Town of Ávila",
    "subject": "Old Town of Ávila",
    "description": "Spain 2 Euro Commemorative coin issued in 2019: Old Town of Ávila.",
    "mintage": 500000,
    "mintageFormatted": "500,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2019_2euro_0.jpg",
    "image_key": "es_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2020_1cent",
    "country": "Spain",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2020) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 205000000,
    "mintageFormatted": "205,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2020_2cent",
    "country": "Spain",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2020) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 244400000,
    "mintageFormatted": "244,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2020_5cent",
    "country": "Spain",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2020) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 221800000,
    "mintageFormatted": "221,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2020_10cent",
    "country": "Spain",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2020) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 47100000,
    "mintageFormatted": "47,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2020_20cent",
    "country": "Spain",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2020) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 52100000,
    "mintageFormatted": "52,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2020_50cent",
    "country": "Spain",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2020) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 20900000,
    "mintageFormatted": "20,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2020_1euro",
    "country": "Spain",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2020) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 100900000,
    "mintageFormatted": "100,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2020",
    "country": "Spain",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2020) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 4300000,
    "mintageFormatted": "4,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2020_cc1",
    "country": "Spain",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2020) - Mudejar Architecture of Aragón",
    "subject": "Mudejar Architecture of Aragón",
    "description": "Spain 2 Euro Commemorative coin issued in 2020: Mudejar Architecture of Aragón.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2020_2euro_0.jpg",
    "image_key": "es_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2021_1cent",
    "country": "Spain",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2021) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 96800000,
    "mintageFormatted": "96,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2021_2cent",
    "country": "Spain",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2021) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 78500000,
    "mintageFormatted": "78,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2021_5cent",
    "country": "Spain",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2021) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 94900000,
    "mintageFormatted": "94,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2021_10cent",
    "country": "Spain",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2021) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 29100000,
    "mintageFormatted": "29,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2021_20cent",
    "country": "Spain",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2021) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 26100000,
    "mintageFormatted": "26,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2021_50cent",
    "country": "Spain",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2021) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 10700000,
    "mintageFormatted": "10,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2021_1euro",
    "country": "Spain",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2021) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 26400000,
    "mintageFormatted": "26,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2021",
    "country": "Spain",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2021) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 3800000,
    "mintageFormatted": "3,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2021_cc1",
    "country": "Spain",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2021) - Historic City of Toledo",
    "subject": "Historic City of Toledo",
    "description": "Spain 2 Euro Commemorative coin issued in 2021: Historic City of Toledo.",
    "mintage": 4000000,
    "mintageFormatted": "4,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2021_2euro_0.jpg",
    "image_key": "es_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2022_1cent",
    "country": "Spain",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2022) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 152000000,
    "mintageFormatted": "152,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2022_2cent",
    "country": "Spain",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2022) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 108900000,
    "mintageFormatted": "108,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2022_5cent",
    "country": "Spain",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2022) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 94300000,
    "mintageFormatted": "94,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2022_10cent",
    "country": "Spain",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2022) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 10800000,
    "mintageFormatted": "10,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2022_20cent",
    "country": "Spain",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2022) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 17500000,
    "mintageFormatted": "17,500,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2022_50cent",
    "country": "Spain",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2022) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 3900000,
    "mintageFormatted": "3,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2022_1euro",
    "country": "Spain",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2022) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 3000000,
    "mintageFormatted": "3,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2022",
    "country": "Spain",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2022) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2022_cc1",
    "country": "Spain",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2022) - National Park of Garajonay",
    "subject": "National Park of Garajonay",
    "description": "Spain 2 Euro Commemorative coin issued in 2022: National Park of Garajonay.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2022_2euro_0.jpg",
    "image_key": "es_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2022_cc2",
    "country": "Spain",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2022) - Elcano's circumnavigation",
    "subject": "Elcano's circumnavigation",
    "description": "Spain 2 Euro Commemorative coin issued in 2022: Elcano's circumnavigation.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2022_2euro_1.jpg",
    "image_key": "es_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2022_cc-common",
    "country": "Spain",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2022) - Erasmus Programme",
    "subject": "Erasmus Programme",
    "description": "Spain 2 Euro Commemorative coin issued in 2022: Erasmus Programme.",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2022_2euro_2.jpg",
    "image_key": "es_commemorative_2022_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": true
  },
  {
    "id": "std_spain_2023_1cent",
    "country": "Spain",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2023) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 77700000,
    "mintageFormatted": "77,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2023_2cent",
    "country": "Spain",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2023) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 178800000,
    "mintageFormatted": "178,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2023_5cent",
    "country": "Spain",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2023) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 137000000,
    "mintageFormatted": "137,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2023_10cent",
    "country": "Spain",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2023) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 114100000,
    "mintageFormatted": "114,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2023_20cent",
    "country": "Spain",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2023) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 60800000,
    "mintageFormatted": "60,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2023_50cent",
    "country": "Spain",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2023) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 19600000,
    "mintageFormatted": "19,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2023_1euro",
    "country": "Spain",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2023) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 118400000,
    "mintageFormatted": "118,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2023",
    "country": "Spain",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2023) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 1000000,
    "mintageFormatted": "1,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2023_cc1",
    "country": "Spain",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2023) - Old Town of Cáceres",
    "subject": "Old Town of Cáceres",
    "description": "Spain 2 Euro Commemorative coin issued in 2023: Old Town of Cáceres.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2023_2euro_0.jpg",
    "image_key": "es_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2023_cc2",
    "country": "Spain",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2023) - Presidency of the EU Council",
    "subject": "Presidency of the EU Council",
    "description": "Spain 2 Euro Commemorative coin issued in 2023: Presidency of the EU Council.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2023_2euro_1.jpg",
    "image_key": "es_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2024_1cent",
    "country": "Spain",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2024) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 235400000,
    "mintageFormatted": "235,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2024_2cent",
    "country": "Spain",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2024) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 117900000,
    "mintageFormatted": "117,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2024_5cent",
    "country": "Spain",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2024) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 93800000,
    "mintageFormatted": "93,800,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2024_10cent",
    "country": "Spain",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2024) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 70700000,
    "mintageFormatted": "70,700,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2024_20cent",
    "country": "Spain",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2024) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 74000000,
    "mintageFormatted": "74,000,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2024_50cent",
    "country": "Spain",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2024) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 44400000,
    "mintageFormatted": "44,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2024_1euro",
    "country": "Spain",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2024) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 155100000,
    "mintageFormatted": "155,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2024",
    "country": "Spain",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2024) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 900000,
    "mintageFormatted": "900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2024_cc1",
    "country": "Spain",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2024) - Sevilla Cathedral",
    "subject": "Sevilla Cathedral",
    "description": "Spain 2 Euro Commemorative coin issued in 2024: Sevilla Cathedral.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2024_2euro_0.jpg",
    "image_key": "es_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2024_cc2",
    "country": "Spain",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2024) - National Police",
    "subject": "National Police",
    "description": "Spain 2 Euro Commemorative coin issued in 2024: National Police.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2024_2euro_1.jpg",
    "image_key": "es_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2025_1cent",
    "country": "Spain",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2025) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 243100000,
    "mintageFormatted": "243,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2025_2cent",
    "country": "Spain",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2025) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 195400000,
    "mintageFormatted": "195,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2025_5cent",
    "country": "Spain",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2025) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 122300000,
    "mintageFormatted": "122,300,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2025_10cent",
    "country": "Spain",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2025) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 19100000,
    "mintageFormatted": "19,100,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2025_20cent",
    "country": "Spain",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2025) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 89600000,
    "mintageFormatted": "89,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2025_50cent",
    "country": "Spain",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2025) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 33600000,
    "mintageFormatted": "33,600,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2025_1euro",
    "country": "Spain",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2025) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 72400000,
    "mintageFormatted": "72,400,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2025",
    "country": "Spain",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2025) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 1900000,
    "mintageFormatted": "1,900,000",
    "status": "circulating",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2025_cc1",
    "country": "Spain",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2025) - Old Town of Salamanca",
    "subject": "Old Town of Salamanca",
    "description": "Spain 2 Euro Commemorative coin issued in 2025: Old Town of Salamanca.",
    "mintage": 2000000,
    "mintageFormatted": "2,000,000",
    "status": "circulating",
    "imagePath": "coins/es_commemorative_2025_2euro_0.jpg",
    "image_key": "es_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2026_1cent",
    "country": "Spain",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Cent (2026) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/es_regular_2010_1cent_0.jpg",
    "image_key": "es_regular_2010_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2026_2cent",
    "country": "Spain",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Cents (2026) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/es_regular_2010_2cent_0.jpg",
    "image_key": "es_regular_2010_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2026_5cent",
    "country": "Spain",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 5 Cents (2026) - Cathedral of Santiago de Compostela",
    "subject": "Cathedral of Santiago de Compostela",
    "description": "Obradoiro facade of the Cathedral of Santiago de Compostela (updated EU design standard)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/es_regular_2010_5cent_0.jpg",
    "image_key": "es_regular_2010_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2026_10cent",
    "country": "Spain",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 10 Cents (2026) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/es_regular_2010_10cent_0.jpg",
    "image_key": "es_regular_2010_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2026_20cent",
    "country": "Spain",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 20 Cents (2026) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/es_regular_2010_20cent_0.jpg",
    "image_key": "es_regular_2010_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2026_50cent",
    "country": "Spain",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 50 Cents (2026) - Miguel de Cervantes",
    "subject": "Miguel de Cervantes",
    "description": "Portrait of Miguel de Cervantes Saavedra (updated EU design standard)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/es_regular_2010_50cent_0.jpg",
    "image_key": "es_regular_2010_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2026_1euro",
    "country": "Spain",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 1 Euro (2026) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/es_regular_2015_1euro_0.jpg",
    "image_key": "es_regular_2015_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_spain_2026",
    "country": "Spain",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Spain 2 Euros (2026) - King Felipe VI",
    "subject": "King Felipe VI",
    "description": "Effigy of King Felipe VI of Spain",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/es_regular_2015_2euro_0.jpg",
    "image_key": "es_regular_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2026_cc1",
    "country": "Spain",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2026) - Poblet Monestary",
    "subject": "Poblet Monestary",
    "description": "Spain 2 Euro Commemorative coin issued in 2026: Poblet Monestary.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_spain_2026_cc2",
    "country": "Spain",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Commemorative Circulation",
    "name": "Spain 2€ Commemorative (2026) - Spain and Disability",
    "subject": "Spain and Disability",
    "description": "Spain 2 Euro Commemorative coin issued in 2026: Spain and Disability.",
    "mintage": 1500000,
    "mintageFormatted": "1,500,000",
    "status": "circulating",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2002_1cent",
    "country": "Vatican City",
    "year": 2002,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2002) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_1cent_0.jpg",
    "image_key": "va_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2002_2cent",
    "country": "Vatican City",
    "year": 2002,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2002) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_2cent_0.jpg",
    "image_key": "va_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2002_5cent",
    "country": "Vatican City",
    "year": 2002,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2002) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_5cent_0.jpg",
    "image_key": "va_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2002_10cent",
    "country": "Vatican City",
    "year": 2002,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2002) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_10cent_0.jpg",
    "image_key": "va_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2002_20cent",
    "country": "Vatican City",
    "year": 2002,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2002) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_20cent_0.jpg",
    "image_key": "va_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2002_50cent",
    "country": "Vatican City",
    "year": 2002,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2002) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_50cent_0.jpg",
    "image_key": "va_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2002_1euro",
    "country": "Vatican City",
    "year": 2002,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2002) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_1euro_0.jpg",
    "image_key": "va_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2002",
    "country": "Vatican City",
    "year": 2002,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2002) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 5000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_2euro_0.jpg",
    "image_key": "va_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2003_1cent",
    "country": "Vatican City",
    "year": 2003,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2003) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_1cent_0.jpg",
    "image_key": "va_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2003_2cent",
    "country": "Vatican City",
    "year": 2003,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2003) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_2cent_0.jpg",
    "image_key": "va_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2003_5cent",
    "country": "Vatican City",
    "year": 2003,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2003) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_5cent_0.jpg",
    "image_key": "va_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2003_10cent",
    "country": "Vatican City",
    "year": 2003,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2003) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_10cent_0.jpg",
    "image_key": "va_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2003_20cent",
    "country": "Vatican City",
    "year": 2003,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2003) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_20cent_0.jpg",
    "image_key": "va_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2003_50cent",
    "country": "Vatican City",
    "year": 2003,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2003) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_50cent_0.jpg",
    "image_key": "va_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2003_1euro",
    "country": "Vatican City",
    "year": 2003,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2003) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_1euro_0.jpg",
    "image_key": "va_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2003",
    "country": "Vatican City",
    "year": 2003,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2003) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_2euro_0.jpg",
    "image_key": "va_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2004_1cent",
    "country": "Vatican City",
    "year": 2004,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2004) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_1cent_0.jpg",
    "image_key": "va_regular_2002_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2004_2cent",
    "country": "Vatican City",
    "year": 2004,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2004) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_2cent_0.jpg",
    "image_key": "va_regular_2002_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2004_5cent",
    "country": "Vatican City",
    "year": 2004,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2004) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_5cent_0.jpg",
    "image_key": "va_regular_2002_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2004_10cent",
    "country": "Vatican City",
    "year": 2004,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2004) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_10cent_0.jpg",
    "image_key": "va_regular_2002_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2004_20cent",
    "country": "Vatican City",
    "year": 2004,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2004) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_20cent_0.jpg",
    "image_key": "va_regular_2002_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2004_50cent",
    "country": "Vatican City",
    "year": 2004,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2004) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_50cent_0.jpg",
    "image_key": "va_regular_2002_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2004_1euro",
    "country": "Vatican City",
    "year": 2004,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2004) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_1euro_0.jpg",
    "image_key": "va_regular_2002_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2004",
    "country": "Vatican City",
    "year": 2004,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2004) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Effigy of Pope John Paul II (Series 1)",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2002_2euro_0.jpg",
    "image_key": "va_regular_2002_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2004_cc1",
    "country": "Vatican City",
    "year": 2004,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2004) - Lateran Treaty (75th Ann.)",
    "subject": "Lateran Treaty (75th Ann.)",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2004: Lateran Treaty (75th Ann.).",
    "mintage": 4600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2004_2euro_0.jpg",
    "image_key": "va_commemorative_2004_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2005_1cent",
    "country": "Vatican City",
    "year": 2005,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2005) - Sede Vacante MMV",
    "subject": "Sede Vacante MMV",
    "description": "Coat of arms of the Cardinal Chamberlain and Apostolic Camera (Sede Vacante 2005)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2005_1cent_0.jpg",
    "image_key": "va_regular_2005_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2005_2cent",
    "country": "Vatican City",
    "year": 2005,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2005) - Sede Vacante MMV",
    "subject": "Sede Vacante MMV",
    "description": "Coat of arms of the Cardinal Chamberlain and Apostolic Camera (Sede Vacante 2005)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2005_2cent_0.jpg",
    "image_key": "va_regular_2005_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2005_5cent",
    "country": "Vatican City",
    "year": 2005,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2005) - Sede Vacante MMV",
    "subject": "Sede Vacante MMV",
    "description": "Coat of arms of the Cardinal Chamberlain and Apostolic Camera (Sede Vacante 2005)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2005_5cent_0.jpg",
    "image_key": "va_regular_2005_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2005_10cent",
    "country": "Vatican City",
    "year": 2005,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2005) - Sede Vacante MMV",
    "subject": "Sede Vacante MMV",
    "description": "Coat of arms of the Cardinal Chamberlain and Apostolic Camera (Sede Vacante 2005)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2005_10cent_0.jpg",
    "image_key": "va_regular_2005_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2005_20cent",
    "country": "Vatican City",
    "year": 2005,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2005) - Sede Vacante MMV",
    "subject": "Sede Vacante MMV",
    "description": "Coat of arms of the Cardinal Chamberlain and Apostolic Camera (Sede Vacante 2005)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2005_20cent_0.jpg",
    "image_key": "va_regular_2005_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2005_50cent",
    "country": "Vatican City",
    "year": 2005,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2005) - Sede Vacante MMV",
    "subject": "Sede Vacante MMV",
    "description": "Coat of arms of the Cardinal Chamberlain and Apostolic Camera (Sede Vacante 2005)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2005_50cent_0.jpg",
    "image_key": "va_regular_2005_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2005_1euro",
    "country": "Vatican City",
    "year": 2005,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2005) - Sede Vacante MMV",
    "subject": "Sede Vacante MMV",
    "description": "Coat of arms of the Cardinal Chamberlain and Apostolic Camera (Sede Vacante 2005)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2005_1euro_0.jpg",
    "image_key": "va_regular_2005_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2005",
    "country": "Vatican City",
    "year": 2005,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2005) - Sede Vacante MMV",
    "subject": "Sede Vacante MMV",
    "description": "Coat of arms of the Cardinal Chamberlain and Apostolic Camera (Sede Vacante 2005)",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2005_2euro_0.jpg",
    "image_key": "va_regular_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2005_cc1",
    "country": "Vatican City",
    "year": 2005,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2005) - World Youth Day in Cologne",
    "subject": "World Youth Day in Cologne",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2005: World Youth Day in Cologne.",
    "mintage": 4400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2005_2euro_0.jpg",
    "image_key": "va_commemorative_2005_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2006_1cent",
    "country": "Vatican City",
    "year": 2006,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2006) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1cent_0.jpg",
    "image_key": "va_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2006_2cent",
    "country": "Vatican City",
    "year": 2006,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2006) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2cent_0.jpg",
    "image_key": "va_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2006_5cent",
    "country": "Vatican City",
    "year": 2006,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2006) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_5cent_0.jpg",
    "image_key": "va_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2006_10cent",
    "country": "Vatican City",
    "year": 2006,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2006) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_10cent_0.jpg",
    "image_key": "va_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2006_20cent",
    "country": "Vatican City",
    "year": 2006,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2006) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_20cent_0.jpg",
    "image_key": "va_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2006_50cent",
    "country": "Vatican City",
    "year": 2006,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2006) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_50cent_0.jpg",
    "image_key": "va_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2006_1euro",
    "country": "Vatican City",
    "year": 2006,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2006) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1euro_0.jpg",
    "image_key": "va_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2006",
    "country": "Vatican City",
    "year": 2006,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2006) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2euro_0.jpg",
    "image_key": "va_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2006_cc1",
    "country": "Vatican City",
    "year": 2006,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2006) - Swiss Pontifical Guard",
    "subject": "Swiss Pontifical Guard",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2006: Swiss Pontifical Guard.",
    "mintage": 4200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2006_2euro_0.jpg",
    "image_key": "va_commemorative_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2007_1cent",
    "country": "Vatican City",
    "year": 2007,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2007) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1cent_0.jpg",
    "image_key": "va_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2007_2cent",
    "country": "Vatican City",
    "year": 2007,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2007) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2cent_0.jpg",
    "image_key": "va_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2007_5cent",
    "country": "Vatican City",
    "year": 2007,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2007) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_5cent_0.jpg",
    "image_key": "va_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2007_10cent",
    "country": "Vatican City",
    "year": 2007,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2007) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_10cent_0.jpg",
    "image_key": "va_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2007_20cent",
    "country": "Vatican City",
    "year": 2007,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2007) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_20cent_0.jpg",
    "image_key": "va_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2007_50cent",
    "country": "Vatican City",
    "year": 2007,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2007) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_50cent_0.jpg",
    "image_key": "va_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2007_1euro",
    "country": "Vatican City",
    "year": 2007,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2007) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1euro_0.jpg",
    "image_key": "va_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2007",
    "country": "Vatican City",
    "year": 2007,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2007) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2euro_0.jpg",
    "image_key": "va_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2007_cc1",
    "country": "Vatican City",
    "year": 2007,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2007) - 80th Birthday of Benedict XVI",
    "subject": "80th Birthday of Benedict XVI",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2007: 80th Birthday of Benedict XVI.",
    "mintage": 4000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2007_2euro_0.jpg",
    "image_key": "va_commemorative_2007_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2008_1cent",
    "country": "Vatican City",
    "year": 2008,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2008) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1cent_0.jpg",
    "image_key": "va_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2008_2cent",
    "country": "Vatican City",
    "year": 2008,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2008) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2cent_0.jpg",
    "image_key": "va_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2008_5cent",
    "country": "Vatican City",
    "year": 2008,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2008) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_5cent_0.jpg",
    "image_key": "va_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2008_10cent",
    "country": "Vatican City",
    "year": 2008,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2008) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_10cent_0.jpg",
    "image_key": "va_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2008_20cent",
    "country": "Vatican City",
    "year": 2008,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2008) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_20cent_0.jpg",
    "image_key": "va_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2008_50cent",
    "country": "Vatican City",
    "year": 2008,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2008) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_50cent_0.jpg",
    "image_key": "va_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2008_1euro",
    "country": "Vatican City",
    "year": 2008,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2008) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1euro_0.jpg",
    "image_key": "va_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2008",
    "country": "Vatican City",
    "year": 2008,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2008) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2euro_0.jpg",
    "image_key": "va_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2008_cc1",
    "country": "Vatican City",
    "year": 2008,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2008) - Year of St. Paul the Apostle",
    "subject": "Year of St. Paul the Apostle",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2008: Year of St. Paul the Apostle.",
    "mintage": 3800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2008_2euro_0.jpg",
    "image_key": "va_commemorative_2008_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2009_1cent",
    "country": "Vatican City",
    "year": 2009,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2009) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1cent_0.jpg",
    "image_key": "va_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2009_2cent",
    "country": "Vatican City",
    "year": 2009,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2009) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2cent_0.jpg",
    "image_key": "va_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2009_5cent",
    "country": "Vatican City",
    "year": 2009,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2009) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_5cent_0.jpg",
    "image_key": "va_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2009_10cent",
    "country": "Vatican City",
    "year": 2009,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2009) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_10cent_0.jpg",
    "image_key": "va_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2009_20cent",
    "country": "Vatican City",
    "year": 2009,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2009) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_20cent_0.jpg",
    "image_key": "va_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2009_50cent",
    "country": "Vatican City",
    "year": 2009,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2009) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_50cent_0.jpg",
    "image_key": "va_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2009_1euro",
    "country": "Vatican City",
    "year": 2009,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2009) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1euro_0.jpg",
    "image_key": "va_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2009",
    "country": "Vatican City",
    "year": 2009,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2009) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2euro_0.jpg",
    "image_key": "va_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2009_cc1",
    "country": "Vatican City",
    "year": 2009,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2009) - International Year of Astronomy",
    "subject": "International Year of Astronomy",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2009: International Year of Astronomy.",
    "mintage": 3600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2009_2euro_0.jpg",
    "image_key": "va_commemorative_2009_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2010_1cent",
    "country": "Vatican City",
    "year": 2010,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2010) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1cent_0.jpg",
    "image_key": "va_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2010_2cent",
    "country": "Vatican City",
    "year": 2010,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2010) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2cent_0.jpg",
    "image_key": "va_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2010_5cent",
    "country": "Vatican City",
    "year": 2010,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2010) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_5cent_0.jpg",
    "image_key": "va_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2010_10cent",
    "country": "Vatican City",
    "year": 2010,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2010) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_10cent_0.jpg",
    "image_key": "va_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2010_20cent",
    "country": "Vatican City",
    "year": 2010,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2010) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_20cent_0.jpg",
    "image_key": "va_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2010_50cent",
    "country": "Vatican City",
    "year": 2010,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2010) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2184704,
    "mintageFormatted": "2,184,704",
    "status": "circulating",
    "imagePath": "coins/va_regular_2006_50cent_0.jpg",
    "image_key": "va_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2010_1euro",
    "country": "Vatican City",
    "year": 2010,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2010) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1euro_0.jpg",
    "image_key": "va_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2010",
    "country": "Vatican City",
    "year": 2010,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2010) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2euro_0.jpg",
    "image_key": "va_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2010_cc1",
    "country": "Vatican City",
    "year": 2010,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2010) - Year for Priests",
    "subject": "Year for Priests",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2010: Year for Priests.",
    "mintage": 3400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2010_2euro_0.jpg",
    "image_key": "va_commemorative_2010_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2011_1cent",
    "country": "Vatican City",
    "year": 2011,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2011) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1cent_0.jpg",
    "image_key": "va_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2011_2cent",
    "country": "Vatican City",
    "year": 2011,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2011) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2cent_0.jpg",
    "image_key": "va_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2011_5cent",
    "country": "Vatican City",
    "year": 2011,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2011) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_5cent_0.jpg",
    "image_key": "va_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2011_10cent",
    "country": "Vatican City",
    "year": 2011,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2011) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_10cent_0.jpg",
    "image_key": "va_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2011_20cent",
    "country": "Vatican City",
    "year": 2011,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2011) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_20cent_0.jpg",
    "image_key": "va_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2011_50cent",
    "country": "Vatican City",
    "year": 2011,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2011) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2168197,
    "mintageFormatted": "2,168,197",
    "status": "circulating",
    "imagePath": "coins/va_regular_2006_50cent_0.jpg",
    "image_key": "va_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2011_1euro",
    "country": "Vatican City",
    "year": 2011,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2011) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1euro_0.jpg",
    "image_key": "va_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2011",
    "country": "Vatican City",
    "year": 2011,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2011) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2euro_0.jpg",
    "image_key": "va_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2011_cc1",
    "country": "Vatican City",
    "year": 2011,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2011) - World Youth Day in Madrid",
    "subject": "World Youth Day in Madrid",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2011: World Youth Day in Madrid.",
    "mintage": 3200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2011_2euro_0.jpg",
    "image_key": "va_commemorative_2011_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2012_1cent",
    "country": "Vatican City",
    "year": 2012,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2012) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1cent_0.jpg",
    "image_key": "va_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2012_2cent",
    "country": "Vatican City",
    "year": 2012,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2012) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2cent_0.jpg",
    "image_key": "va_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2012_5cent",
    "country": "Vatican City",
    "year": 2012,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2012) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_5cent_0.jpg",
    "image_key": "va_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2012_10cent",
    "country": "Vatican City",
    "year": 2012,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2012) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_10cent_0.jpg",
    "image_key": "va_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2012_20cent",
    "country": "Vatican City",
    "year": 2012,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2012) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_20cent_0.jpg",
    "image_key": "va_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2012_50cent",
    "country": "Vatican City",
    "year": 2012,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2012) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 1604690,
    "mintageFormatted": "1,604,690",
    "status": "circulating",
    "imagePath": "coins/va_regular_2006_50cent_0.jpg",
    "image_key": "va_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2012_1euro",
    "country": "Vatican City",
    "year": 2012,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2012) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1euro_0.jpg",
    "image_key": "va_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2012",
    "country": "Vatican City",
    "year": 2012,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2012) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2euro_0.jpg",
    "image_key": "va_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2012_cc1",
    "country": "Vatican City",
    "year": 2012,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2012) - World Families’ Meeting",
    "subject": "World Families’ Meeting",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2012: World Families’ Meeting.",
    "mintage": 3000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2012_2euro_0.jpg",
    "image_key": "va_commemorative_2012_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2013_1cent",
    "country": "Vatican City",
    "year": 2013,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2013) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1cent_0.jpg",
    "image_key": "va_regular_2006_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2013_2cent",
    "country": "Vatican City",
    "year": 2013,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2013) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2cent_0.jpg",
    "image_key": "va_regular_2006_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2013_5cent",
    "country": "Vatican City",
    "year": 2013,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2013) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_5cent_0.jpg",
    "image_key": "va_regular_2006_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2013_10cent",
    "country": "Vatican City",
    "year": 2013,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2013) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_10cent_0.jpg",
    "image_key": "va_regular_2006_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2013_20cent",
    "country": "Vatican City",
    "year": 2013,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2013) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_20cent_0.jpg",
    "image_key": "va_regular_2006_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2013_50cent",
    "country": "Vatican City",
    "year": 2013,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2013) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 1935484,
    "mintageFormatted": "1,935,484",
    "status": "circulating",
    "imagePath": "coins/va_regular_2006_50cent_0.jpg",
    "image_key": "va_regular_2006_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2013_1euro",
    "country": "Vatican City",
    "year": 2013,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2013) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_1euro_0.jpg",
    "image_key": "va_regular_2006_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2013",
    "country": "Vatican City",
    "year": 2013,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2013) - Pope Benedict XVI",
    "subject": "Pope Benedict XVI",
    "description": "Effigy of Pope Benedict XVI (Series 3)",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2006_2euro_0.jpg",
    "image_key": "va_regular_2006_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2013_cc1",
    "country": "Vatican City",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2013) - Sede Vacante MMXIII",
    "subject": "Sede Vacante MMXIII",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2013: Sede Vacante MMXIII.",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2013_2euro_0.jpg",
    "image_key": "va_commemorative_2013_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2013_cc2",
    "country": "Vatican City",
    "year": 2013,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2013) - World Youth Day in Rio de Janeiro",
    "subject": "World Youth Day in Rio de Janeiro",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2013: World Youth Day in Rio de Janeiro.",
    "mintage": 2800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2013_2euro_1.jpg",
    "image_key": "va_commemorative_2013_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2014_1cent",
    "country": "Vatican City",
    "year": 2014,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2014) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_1cent_0.jpg",
    "image_key": "va_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2014_2cent",
    "country": "Vatican City",
    "year": 2014,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2014) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_2cent_0.jpg",
    "image_key": "va_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2014_5cent",
    "country": "Vatican City",
    "year": 2014,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2014) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_5cent_0.jpg",
    "image_key": "va_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2014_10cent",
    "country": "Vatican City",
    "year": 2014,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2014) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_10cent_0.jpg",
    "image_key": "va_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2014_20cent",
    "country": "Vatican City",
    "year": 2014,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2014) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_20cent_0.jpg",
    "image_key": "va_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2014_50cent",
    "country": "Vatican City",
    "year": 2014,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2014) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 1488376,
    "mintageFormatted": "1,488,376",
    "status": "circulating",
    "imagePath": "coins/va_regular_2014_50cent_0.jpg",
    "image_key": "va_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2014_1euro",
    "country": "Vatican City",
    "year": 2014,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2014) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_1euro_0.jpg",
    "image_key": "va_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2014",
    "country": "Vatican City",
    "year": 2014,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2014) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_2euro_0.jpg",
    "image_key": "va_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2014_cc1",
    "country": "Vatican City",
    "year": 2014,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2014) - Fall of the Berlin Wall",
    "subject": "Fall of the Berlin Wall",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2014: Fall of the Berlin Wall.",
    "mintage": 2600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2014_2euro_0.jpg",
    "image_key": "va_commemorative_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2015_1cent",
    "country": "Vatican City",
    "year": 2015,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2015) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_1cent_0.jpg",
    "image_key": "va_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2015_2cent",
    "country": "Vatican City",
    "year": 2015,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2015) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_2cent_0.jpg",
    "image_key": "va_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2015_5cent",
    "country": "Vatican City",
    "year": 2015,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2015) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_5cent_0.jpg",
    "image_key": "va_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2015_10cent",
    "country": "Vatican City",
    "year": 2015,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2015) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_10cent_0.jpg",
    "image_key": "va_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2015_20cent",
    "country": "Vatican City",
    "year": 2015,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2015) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_20cent_0.jpg",
    "image_key": "va_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2015_50cent",
    "country": "Vatican City",
    "year": 2015,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2015) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2021682,
    "mintageFormatted": "2,021,682",
    "status": "circulating",
    "imagePath": "coins/va_regular_2014_50cent_0.jpg",
    "image_key": "va_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2015_1euro",
    "country": "Vatican City",
    "year": 2015,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2015) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_1euro_0.jpg",
    "image_key": "va_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2015",
    "country": "Vatican City",
    "year": 2015,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2015) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_2euro_0.jpg",
    "image_key": "va_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2015_cc1",
    "country": "Vatican City",
    "year": 2015,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2015) - World Meeting of Families",
    "subject": "World Meeting of Families",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2015: World Meeting of Families.",
    "mintage": 2400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2015_2euro_0.jpg",
    "image_key": "va_commemorative_2015_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2016_1cent",
    "country": "Vatican City",
    "year": 2016,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2016) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_1cent_0.jpg",
    "image_key": "va_regular_2014_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2016_2cent",
    "country": "Vatican City",
    "year": 2016,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2016) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_2cent_0.jpg",
    "image_key": "va_regular_2014_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2016_5cent",
    "country": "Vatican City",
    "year": 2016,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2016) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_5cent_0.jpg",
    "image_key": "va_regular_2014_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2016_10cent",
    "country": "Vatican City",
    "year": 2016,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2016) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_10cent_0.jpg",
    "image_key": "va_regular_2014_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2016_20cent",
    "country": "Vatican City",
    "year": 2016,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2016) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_20cent_0.jpg",
    "image_key": "va_regular_2014_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2016_50cent",
    "country": "Vatican City",
    "year": 2016,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2016) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2200676,
    "mintageFormatted": "2,200,676",
    "status": "circulating",
    "imagePath": "coins/va_regular_2014_50cent_0.jpg",
    "image_key": "va_regular_2014_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2016_1euro",
    "country": "Vatican City",
    "year": 2016,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2016) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_1euro_0.jpg",
    "image_key": "va_regular_2014_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2016",
    "country": "Vatican City",
    "year": 2016,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2016) - Pope Francis",
    "subject": "Pope Francis",
    "description": "Effigy of Pope Francis (Series 4)",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2014_2euro_0.jpg",
    "image_key": "va_regular_2014_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2016_cc1",
    "country": "Vatican City",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2016) - Vatican Gendarmerie",
    "subject": "Vatican Gendarmerie",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2016: Vatican Gendarmerie.",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2016_2euro_1.jpg",
    "image_key": "va_commemorative_2016_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2016_cc2",
    "country": "Vatican City",
    "year": 2016,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2016) - Jubliee of Mercy",
    "subject": "Jubliee of Mercy",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2016: Jubliee of Mercy.",
    "mintage": 2200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2016_2euro_0.jpg",
    "image_key": "va_commemorative_2016_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2017_1cent",
    "country": "Vatican City",
    "year": 2017,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2017) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2017_2cent",
    "country": "Vatican City",
    "year": 2017,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2017) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2017_5cent",
    "country": "Vatican City",
    "year": 2017,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2017) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2017_10cent",
    "country": "Vatican City",
    "year": 2017,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2017) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2017_20cent",
    "country": "Vatican City",
    "year": 2017,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2017) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2017_50cent",
    "country": "Vatican City",
    "year": 2017,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2017) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2206411,
    "mintageFormatted": "2,206,411",
    "status": "circulating",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2017_1euro",
    "country": "Vatican City",
    "year": 2017,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2017) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2017",
    "country": "Vatican City",
    "year": 2017,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2017) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2017_cc1",
    "country": "Vatican City",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2017) - Martyrdom of Saint Peter and Saint Paul",
    "subject": "Martyrdom of Saint Peter and Saint Paul",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2017: Martyrdom of Saint Peter and Saint Paul.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2017_2euro_1.jpg",
    "image_key": "va_commemorative_2017_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2017_cc2",
    "country": "Vatican City",
    "year": 2017,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2017) - Fátima apparitions",
    "subject": "Fátima apparitions",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2017: Fátima apparitions.",
    "mintage": 2000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2017_2euro_0.jpg",
    "image_key": "va_commemorative_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2018_1cent",
    "country": "Vatican City",
    "year": 2018,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2018) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2018_2cent",
    "country": "Vatican City",
    "year": 2018,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2018) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2018_5cent",
    "country": "Vatican City",
    "year": 2018,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2018) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2018_10cent",
    "country": "Vatican City",
    "year": 2018,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2018) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2018_20cent",
    "country": "Vatican City",
    "year": 2018,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2018) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2018_50cent",
    "country": "Vatican City",
    "year": 2018,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2018) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2147169,
    "mintageFormatted": "2,147,169",
    "status": "circulating",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2018_1euro",
    "country": "Vatican City",
    "year": 2018,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2018) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2018",
    "country": "Vatican City",
    "year": 2018,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2018) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2018_cc1",
    "country": "Vatican City",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2018) - European Year of Cultural Heritage",
    "subject": "European Year of Cultural Heritage",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2018: European Year of Cultural Heritage.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2018_2euro_1.jpg",
    "image_key": "va_commemorative_2018_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2018_cc2",
    "country": "Vatican City",
    "year": 2018,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2018) - Padre Pio",
    "subject": "Padre Pio",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2018: Padre Pio.",
    "mintage": 1800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2018_2euro_0.jpg",
    "image_key": "va_commemorative_2018_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2019_1cent",
    "country": "Vatican City",
    "year": 2019,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2019) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2019_2cent",
    "country": "Vatican City",
    "year": 2019,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2019) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2019_5cent",
    "country": "Vatican City",
    "year": 2019,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2019) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2019_10cent",
    "country": "Vatican City",
    "year": 2019,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2019) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2019_20cent",
    "country": "Vatican City",
    "year": 2019,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2019) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2019_50cent",
    "country": "Vatican City",
    "year": 2019,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2019) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 2157248,
    "mintageFormatted": "2,157,248",
    "status": "circulating",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2019_1euro",
    "country": "Vatican City",
    "year": 2019,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2019) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2019",
    "country": "Vatican City",
    "year": 2019,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2019) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2019_cc1",
    "country": "Vatican City",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2019) - Lateran Treaty (90th Ann.)",
    "subject": "Lateran Treaty (90th Ann.)",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2019: Lateran Treaty (90th Ann.).",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2019_2euro_1.jpg",
    "image_key": "va_commemorative_2019_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2019_cc2",
    "country": "Vatican City",
    "year": 2019,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2019) - Sistine Chapel Restoration",
    "subject": "Sistine Chapel Restoration",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2019: Sistine Chapel Restoration.",
    "mintage": 1600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2019_2euro_0.jpg",
    "image_key": "va_commemorative_2019_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2020_1cent",
    "country": "Vatican City",
    "year": 2020,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2020) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2020_2cent",
    "country": "Vatican City",
    "year": 2020,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2020) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2020_5cent",
    "country": "Vatican City",
    "year": 2020,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2020) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2020_10cent",
    "country": "Vatican City",
    "year": 2020,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2020) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2020_20cent",
    "country": "Vatican City",
    "year": 2020,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2020) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2020_50cent",
    "country": "Vatican City",
    "year": 2020,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2020) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1821540,
    "mintageFormatted": "1,821,540",
    "status": "circulating",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2020_1euro",
    "country": "Vatican City",
    "year": 2020,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2020) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2020",
    "country": "Vatican City",
    "year": 2020,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2020) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2020_cc1",
    "country": "Vatican City",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2020) - Pope John Paul II",
    "subject": "Pope John Paul II",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2020: Pope John Paul II.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2020_2euro_0.jpg",
    "image_key": "va_commemorative_2020_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2020_cc2",
    "country": "Vatican City",
    "year": 2020,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2020) - Raphael Sanzio",
    "subject": "Raphael Sanzio",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2020: Raphael Sanzio.",
    "mintage": 1400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2021_1cent",
    "country": "Vatican City",
    "year": 2021,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2021) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2021_2cent",
    "country": "Vatican City",
    "year": 2021,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2021) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2021_5cent",
    "country": "Vatican City",
    "year": 2021,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2021) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2021_10cent",
    "country": "Vatican City",
    "year": 2021,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2021) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2021_20cent",
    "country": "Vatican City",
    "year": 2021,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2021) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2021_50cent",
    "country": "Vatican City",
    "year": 2021,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2021) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1652133,
    "mintageFormatted": "1,652,133",
    "status": "circulating",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2021_1euro",
    "country": "Vatican City",
    "year": 2021,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2021) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2021",
    "country": "Vatican City",
    "year": 2021,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2021) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2021_cc1",
    "country": "Vatican City",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2021) - Caravaggio",
    "subject": "Caravaggio",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2021: Caravaggio.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2021_2euro_1.jpg",
    "image_key": "va_commemorative_2021_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2021_cc2",
    "country": "Vatican City",
    "year": 2021,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2021) - Dante Alighieri",
    "subject": "Dante Alighieri",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2021: Dante Alighieri.",
    "mintage": 1200,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2021_2euro_0.jpg",
    "image_key": "va_commemorative_2021_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2022_1cent",
    "country": "Vatican City",
    "year": 2022,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2022) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2022_2cent",
    "country": "Vatican City",
    "year": 2022,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2022) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2022_5cent",
    "country": "Vatican City",
    "year": 2022,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2022) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2022_10cent",
    "country": "Vatican City",
    "year": 2022,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2022) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2022_20cent",
    "country": "Vatican City",
    "year": 2022,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2022) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2022_50cent",
    "country": "Vatican City",
    "year": 2022,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2022) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1896441,
    "mintageFormatted": "1,896,441",
    "status": "circulating",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2022_1euro",
    "country": "Vatican City",
    "year": 2022,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2022) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2022",
    "country": "Vatican City",
    "year": 2022,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2022) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2022_cc1",
    "country": "Vatican City",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2022) - Pope Paul VI",
    "subject": "Pope Paul VI",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2022: Pope Paul VI.",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2022_2euro_0.jpg",
    "image_key": "va_commemorative_2022_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2022_cc2",
    "country": "Vatican City",
    "year": 2022,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2022) - Mother Teresa of Calcutta",
    "subject": "Mother Teresa of Calcutta",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2022: Mother Teresa of Calcutta.",
    "mintage": 1000,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2022_2euro_1.jpg",
    "image_key": "va_commemorative_2022_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2023_1cent",
    "country": "Vatican City",
    "year": 2023,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2023) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2023_2cent",
    "country": "Vatican City",
    "year": 2023,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2023) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2023_5cent",
    "country": "Vatican City",
    "year": 2023,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2023) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2023_10cent",
    "country": "Vatican City",
    "year": 2023,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2023) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2023_20cent",
    "country": "Vatican City",
    "year": 2023,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2023) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2023_50cent",
    "country": "Vatican City",
    "year": 2023,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2023) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 1869916,
    "mintageFormatted": "1,869,916",
    "status": "circulating",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2023_1euro",
    "country": "Vatican City",
    "year": 2023,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2023) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2023",
    "country": "Vatican City",
    "year": 2023,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2023) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2023_cc1",
    "country": "Vatican City",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2023) - Alessandro Manzoni",
    "subject": "Alessandro Manzoni",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2023: Alessandro Manzoni.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2023_2euro_0.jpg",
    "image_key": "va_commemorative_2023_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2023_cc2",
    "country": "Vatican City",
    "year": 2023,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2023) - Pietro Perugino",
    "subject": "Pietro Perugino",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2023: Pietro Perugino.",
    "mintage": 800,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2023_2euro_1.jpg",
    "image_key": "va_commemorative_2023_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2024_1cent",
    "country": "Vatican City",
    "year": 2024,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2024) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 600,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2024_2cent",
    "country": "Vatican City",
    "year": 2024,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2024) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 600,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2024_5cent",
    "country": "Vatican City",
    "year": 2024,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2024) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 600,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2024_10cent",
    "country": "Vatican City",
    "year": 2024,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2024) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 600,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2024_20cent",
    "country": "Vatican City",
    "year": 2024,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2024) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 600,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2024_50cent",
    "country": "Vatican City",
    "year": 2024,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2024) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2024_1euro",
    "country": "Vatican City",
    "year": 2024,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2024) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2024",
    "country": "Vatican City",
    "year": 2024,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2024) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 600,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2024_cc1",
    "country": "Vatican City",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2024) - Gugliemo Marconi",
    "subject": "Gugliemo Marconi",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2024: Gugliemo Marconi.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2024_2euro_0.jpg",
    "image_key": "va_commemorative_2024_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2024_cc2",
    "country": "Vatican City",
    "year": 2024,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2024) - St. Thomas Aquinas",
    "subject": "St. Thomas Aquinas",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2024: St. Thomas Aquinas.",
    "mintage": 600,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2024_2euro_1.jpg",
    "image_key": "va_commemorative_2024_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2025_1cent",
    "country": "Vatican City",
    "year": 2025,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2025) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2025_2cent",
    "country": "Vatican City",
    "year": 2025,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2025) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2025_5cent",
    "country": "Vatican City",
    "year": 2025,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2025) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2025_10cent",
    "country": "Vatican City",
    "year": 2025,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2025) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2025_20cent",
    "country": "Vatican City",
    "year": 2025,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2025) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2025_50cent",
    "country": "Vatican City",
    "year": 2025,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 50 Cents (2025) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2025_1euro",
    "country": "Vatican City",
    "year": 2025,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 1 Euro (2025) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2025",
    "country": "Vatican City",
    "year": 2025,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "Standard Circulation",
    "name": "Vatican City 2 Euros (2025) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 10000000,
    "mintageFormatted": "CIRC",
    "status": "CIRC",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2025_cc1",
    "country": "Vatican City",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2025) - Sede Vacante MMXXV",
    "subject": "Sede Vacante MMXXV",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2025: Sede Vacante MMXXV.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2025_2euro_0.jpg",
    "image_key": "va_commemorative_2025_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2025_cc2",
    "country": "Vatican City",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2025) - Michelangelo",
    "subject": "Michelangelo",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2025: Michelangelo.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2025_2euro_1.jpg",
    "image_key": "va_commemorative_2025_2euro_1.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2025_cc3",
    "country": "Vatican City",
    "year": 2025,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2025) - 2025 Jubilee",
    "subject": "2025 Jubilee",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2025: 2025 Jubilee.",
    "mintage": 400,
    "mintageFormatted": "NIFC",
    "status": "NIFC",
    "imagePath": "coins/va_commemorative_2025_2euro_2.jpg",
    "image_key": "va_commemorative_2025_2euro_2.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2026_1cent",
    "country": "Vatican City",
    "year": 2026,
    "type": "standard",
    "denomination": "1cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Cent (2026) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_1cent_0.jpg",
    "image_key": "va_regular_2017_1cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2026_2cent",
    "country": "Vatican City",
    "year": 2026,
    "type": "standard",
    "denomination": "2cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Cents (2026) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_2cent_0.jpg",
    "image_key": "va_regular_2017_2cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2026_5cent",
    "country": "Vatican City",
    "year": 2026,
    "type": "standard",
    "denomination": "5cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 5 Cents (2026) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_5cent_0.jpg",
    "image_key": "va_regular_2017_5cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2026_10cent",
    "country": "Vatican City",
    "year": 2026,
    "type": "standard",
    "denomination": "10cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 10 Cents (2026) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_10cent_0.jpg",
    "image_key": "va_regular_2017_10cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2026_20cent",
    "country": "Vatican City",
    "year": 2026,
    "type": "standard",
    "denomination": "20cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 20 Cents (2026) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_20cent_0.jpg",
    "image_key": "va_regular_2017_20cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2026_50cent",
    "country": "Vatican City",
    "year": 2026,
    "type": "standard",
    "denomination": "50cent",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 50 Cents (2026) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_50cent_0.jpg",
    "image_key": "va_regular_2017_50cent_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2026_1euro",
    "country": "Vatican City",
    "year": 2026,
    "type": "standard",
    "denomination": "1euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 1 Euro (2026) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_1euro_0.jpg",
    "image_key": "va_regular_2017_1euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "std_vatican-city_2026",
    "country": "Vatican City",
    "year": 2026,
    "type": "standard",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2 Euros (2026) - Papal Coat of Arms of Pope Francis",
    "subject": "Papal Coat of Arms of Pope Francis",
    "description": "Official coat of arms of Pope Francis (Series 5)",
    "mintage": 0,
    "mintageFormatted": "???",
    "status": "???",
    "imagePath": "coins/va_regular_2017_2euro_0.jpg",
    "image_key": "va_regular_2017_2euro_0.webp",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2026_cc1",
    "country": "Vatican City",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2026) - Magistrate of Leo XIV",
    "subject": "Magistrate of Leo XIV",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2026: Magistrate of Leo XIV.",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  },
  {
    "id": "comm_vatican-city_2026_cc2",
    "country": "Vatican City",
    "year": 2026,
    "type": "commemorative",
    "denomination": "2euro",
    "mintmark": null,
    "strikeType": "In Sets / Collector",
    "name": "Vatican City 2€ Commemorative (2026) - St. Peter's Cathedral",
    "subject": "St. Peter's Cathedral",
    "description": "Vatican City 2 Euro Commemorative coin issued in 2026: St. Peter's Cathedral.",
    "mintage": 200,
    "mintageFormatted": "Likely NIFC",
    "status": "Likely NIFC",
    "imagePath": "",
    "image_key": "",
    "imageAltPaths": [],
    "dateIssued": null,
    "isJointIssue": false
  }
]